import { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { 
  ArrowLeft, 
  Settings as SettingsIcon, 
  Plus, 
  Edit, 
  Edit3,
  Trash2,
  LayoutGrid,
  List,
  Users,
  UserCheck,
  X,
  Bell,
  History,
  Check,
  CalendarDays,
  ChevronLeft,
  ChevronRight,
  ListTodo,
  CheckCircle2,
  Circle,
  User,
  ListOrdered,
  Phone,
  ArrowUpDown,
  FileText,
  Users2
} from "lucide-react";
import Warteliste from "../components/Warteliste";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import InteractiveTour from "@/components/InteractiveTour";
import ZuErledigienModal from "@/components/ZuErledigienModal";
import { downloadErspanisPdf, hasErspanis, generateErspanisPdf } from "@/utils/schuldenPdf";
import KontaktTaskList from "@/components/KontaktTaskList";
import FieldEditModal from "@/components/kunden/FieldEditModal";
import TreeNode from "@/components/kunden/TreeNode";
import TeampartnerCard from "@/components/kunden/TeampartnerCard";
import TeampartnerTable from "@/components/kunden/TeampartnerTable";
import {
  normalizeNochZuErledigen,
  countTPs,
  STUFEN,
  DEFAULT_THEMATIK_OPTIONEN,
  DEFAULT_VERANSTALTUNG_OPTIONEN,
  deleteTodoFromLocalStorage,
  deleteCalendarEntriesByTaskId,
  calculateNextPackage,
} from "@/utils/kundenUtils";
import { APPOINTMENT_COLORS, COLOR_KEYS } from "@/utils/calendarConstants";
import { userStorage } from '../utils/userStorage';
const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";


export default function Kunden() {
  const location = useLocation();
  const navigate = useNavigate();
  const notificationOpenedRef = useRef(false);
  const [user, setUser] = useState(null); // Für InteractiveTour
  const [showTourManual, setShowTourManual] = useState(false); // Für manuellen Tour-Start
  const [activeTab, setActiveTab] = useState("daten"); // daten, suche, schulden
  const [viewMode, setViewMode] = useState("kachel"); // kachel, list
  const [schuldenViewMode, setSchuldenViewMode] = useState("grid"); // grid, list
  const [schuldenSortMode, setSchuldenSortMode] = useState("default"); // "default" | "faelligkeit"
  // Group-Edit Modal (Name + Fälligkeit ändern)
  const [showGroupEditModal, setShowGroupEditModal] = useState(false);
  const [groupEditData, setGroupEditData] = useState({ name: "", faelligkeitsdatum: "", ids: [] });
  // Teilzahlung / Bezahlt Modal
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentTarget, setPaymentTarget] = useState(null); // { type: 'group'|'single'|'person', posten: [...], name, total, bezahlt }
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentNotiz, setPaymentNotiz] = useState("");
  const [paymentMode, setPaymentMode] = useState("full"); // 'full' | 'partial'
  // Teilzahlungs-Historie Modal
  const [showTeilzahlungHistorie, setShowTeilzahlungHistorie] = useState(false);
  const [teilzahlungHistorieTarget, setTeilzahlungHistorieTarget] = useState(null); // { name, posten: [...] }
  // PDF-Success-Modal nach neuer Schuld mit Ersparnis
  const [showPdfSuccessModal, setShowPdfSuccessModal] = useState(false);
  const [pdfSuccessData, setPdfSuccessData] = useState(null); // { posten, kundenName }
  // Schritt 1: Rechnung aus Inventory (optional) - Auswahl-ID
  const [selectedRechnungForSchulden, setSelectedRechnungForSchulden] = useState("");
  // Bei Aufruf aus Inventory: Einzelpositionen der Rechnung (wird beim Speichern expandiert)
  const [invoiceItemsForSchulden, setInvoiceItemsForSchulden] = useState(null);
  // Wurde der Schulden-Flow aus Inventory gestartet? (→ Name in Schritt 2 editierbar)
  const [schuldenFromInventory, setSchuldenFromInventory] = useState(false);
  // Single-Posten Edit (Beschreibung / Produkt-Name ändern)
  const [showPostenEditModal, setShowPostenEditModal] = useState(false);
  const [postenEditData, setPostenEditData] = useState({ id: "", produkt_name: "", beschreibung: "" });
  const [datenSortMode, setDatenSortMode] = useState("id"); // id, name, termin, kontaktiert_neu, kontaktiert_alt, nicht_kontaktiert, schulden
  const [datenFilterMode, setDatenFilterMode] = useState("alle"); // alle, kaltkontakt, teampartner, kunde, ich
  const [kundenSuche, setKundenSuche] = useState(""); // Suchfeld für Kunden
  const [showErweiterteSuche, setShowErweiterteSuche] = useState(false);
  const [suchFilterCollapsed, setSuchFilterCollapsed] = useState(true);
  const [erweiterteSucheFilter, setErweiterteSucheFilter] = useState({
    name: "",
    typen: [], // kontakt, teampartner, kunde
    stufen: [], // TP, M, SM, etc.
    linie: "",
    thematik: [],
    produkte_im_abo: [],
    veranstaltungen: [],
    termin_status: "alle", // alle, ueberfaellig, heute, zukuenftig
    kontakt_status: "alle", // alle, kritisch, warnung, aktuell
    actionpack: [], // ja, nein, interesse
    cellreset: [], // ja, nein, nicht_beendet
    noch_nicht_kontaktiert: false // Checkbox für noch nicht kontaktierte Kontakte
  });
  
  // Kaltkontakt Termin Follow-up Modal
  const [showKaltkontaktModal, setShowKaltkontaktModal] = useState(false);
  const [kaltkontaktAction, setKaltkontaktAction] = useState(null); // 'tp', 'kunde', 'nein'
  const [showKaltkontaktSubModal, setShowKaltkontaktSubModal] = useState(false);
  const [showKaltkontaktFrageModal, setShowKaltkontaktFrageModal] = useState(false);
  const [showKaltkontaktDetailsModal, setShowKaltkontaktDetailsModal] = useState(false);
  const [selectedKaltkontakt, setSelectedKaltkontakt] = useState(null);
  const [selectedKaltkontaktTyp, setSelectedKaltkontaktTyp] = useState(null); // 'tp' oder 'kunde'
  const [neuerTerminDatum, setNeuerTerminDatum] = useState("");
  const [neuerTerminUhrzeit, setNeuerTerminUhrzeit] = useState("10:00");
  const [kkSubStep, setKkSubStep] = useState(1); // 1=Datum, 2=Uhrzeit, 3=Zuletzt, 4=Gesprächsverlauf, 5=Thema
  const [kkLetzterOption, setKkLetzterOption] = useState("heute");
  const [kkLetzterCustom, setKkLetzterCustom] = useState("");
  const [kkThemaUhrzeitMode, setKkThemaUhrzeitMode] = useState("aktuell");
  const [kkThemaManuelleUhrzeit, setKkThemaManuelleUhrzeit] = useState("");
  const [kkNeuesThema, setKkNeuesThema] = useState("");
  const [kkGespraechsFreitext, setKkGespraechsFreitext] = useState(""); // Freies Textfeld in Gesprächsverlauf wenn kein altes Thema
  const [showWeekModal, setShowWeekModal] = useState(false);
  const [showWarteliste, setShowWarteliste] = useState(false);
  const [weekModalDate, setWeekModalDate] = useState(new Date());
  const [showTodosPanel, setShowTodosPanel] = useState(false);
  const [todosTab, setTodosTab] = useState('daily');
  const [todosDayDate, setTodosDayDate] = useState(new Date());
  const [todosWeekDate, setTodosWeekDate] = useState(new Date());
  const [todosPanelRefreshKey, setTodosPanelRefreshKey] = useState(0);
  const [focusPopupText, setFocusPopupText] = useState(null);
  const weekModalTodayRef = useRef(null);
  const [selectedTeampartner, setSelectedTeampartner] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const [isNotificationMode, setIsNotificationMode] = useState(false); // Für Navigation durch Nachrichten
  const [notificationList, setNotificationList] = useState([]); // Liste der Personen mit Benachrichtigungen
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [currentSwipeDistance, setCurrentSwipeDistance] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [skipTransition, setSkipTransition] = useState(false); // Transition temporär deaktivieren
  // Ref für Wochenkalender-Swipe (kein State → kein Re-Render während Drag)
  const weekSwipeStartX = useRef(null);
  const weekSwipeDeltaX = useRef(0);
  // Ref für Aufgaben-Tab-Swipe (Heute/Woche/Monat)
  const todosSwipeStartX = useRef(null);
  const todosSwipeDeltaX = useRef(0);
  const [teampartner, setTeampartner] = useState([]);
  const [filteredTeampartner, setFilteredTeampartner] = useState([]);
  const [loading, setLoading] = useState(false);

  // Zu-erledigen Modal
  const [showZuErledigienModal, setShowZuErledigienModal] = useState(false);
  const [zuErledigienTarget, setZuErledigienTarget] = useState(null); // { id, name, typ, useFormData }

  const handleOpenZuErledigienModal = (id, name, typ, useFormData = false) => {
    setZuErledigienTarget({ id, name, typ, useFormData });
    setShowZuErledigienModal(true);
  };

  const handleSaveZuErledigienTask = async (task) => {
    if (!zuErledigienTarget) return;
    const { id, typ, useFormData } = zuErledigienTarget;

    // 'ich' always saves directly to API (never to formData)
    if (typ === 'ich') {
      try {
        const res = await axios.post(`${API}/api/auth/me/tasks`, task);
        setUser(prev => ({ ...prev, noch_zu_erledigen: res.data.tasks }));
        // Also update tempIchData if in ich-edit mode
        setTempIchData(prev => prev ? { ...prev, noch_zu_erledigen: res.data.tasks } : prev);
        toast.success('Aufgabe gespeichert');
      } catch { toast.error('Fehler beim Speichern'); }
      setShowZuErledigienModal(false);
      setZuErledigienTarget(null);
      return;
    }

    try {
      if (useFormData) {
        // Add-Modus: id ist null/undefined → NICHT an API senden.
        // Task nur in formData sammeln; wird beim Submit (POST /teampartner)
        // als Teil von noch_zu_erledigen mit-gesendet.
        // Edit-Modus: id ist gesetzt → beides tun (formData + API).
        setFormData(prev => ({ ...prev, noch_zu_erledigen: [...normalizeNochZuErledigen(prev.noch_zu_erledigen), task] }));
        if (id) {
          const res = await axios.post(`${API}/api/teampartner/${id}/tasks`, task);
          setTeampartner(prev => prev.map(t => t.id === id ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
          setFilteredTeampartner(prev => prev.map(t => t.id === id ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
        }
      } else {
        // Direct API save (detail edit mode / tile view)
        const res = await axios.post(`${API}/api/teampartner/${id}/tasks`, task);
        setTeampartner(prev => prev.map(t => t.id === id ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
        setFilteredTeampartner(prev => prev.map(t => t.id === id ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
        setSelectedTeampartner(prev => prev?.id === id ? { ...prev, noch_zu_erledigen: res.data.tasks } : prev);
        setTempEditData(prev => prev?.id === id ? { ...prev, noch_zu_erledigen: res.data.tasks } : prev);
      }
      toast.success('Aufgabe gespeichert');
    } catch { toast.error('Fehler beim Speichern'); }
    setShowZuErledigienModal(false);
    setZuErledigienTarget(null);
  };

  const handleToggleKontaktTask = async (contactId, contactTyp, taskId) => {
    try {
      // Find current done state to use explicit set-done (more reliable than toggle)
      let currentTasks = [];
      if (contactTyp === 'ich') {
        currentTasks = normalizeNochZuErledigen(user?.noch_zu_erledigen);
      } else {
        const tpState = tempEditData?.id === contactId ? tempEditData : teampartner.find(t => t.id === contactId);
        currentTasks = normalizeNochZuErledigen(tpState?.noch_zu_erledigen);
      }
      const currentTask = currentTasks.find(t => t.id === taskId);
      const newDone = currentTask ? !currentTask.done : true;

      if (contactTyp === 'ich') {
        const res = await axios.patch(`${API}/api/auth/me/tasks/${taskId}`, { done: newDone });
        setUser(prev => ({ ...prev, noch_zu_erledigen: res.data.tasks }));
        syncTodoFromContact(taskId, res.data.tasks);
      } else {
        const res = await axios.patch(`${API}/api/teampartner/${contactId}/tasks/${taskId}`, { done: newDone });
        setTeampartner(prev => prev.map(t => t.id === contactId ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
        setFilteredTeampartner(prev => prev.map(t => t.id === contactId ? { ...t, noch_zu_erledigen: res.data.tasks } : t));
        setSelectedTeampartner(prev => prev?.id === contactId ? { ...prev, noch_zu_erledigen: res.data.tasks } : prev);
        setTempEditData(prev => prev?.id === contactId ? { ...prev, noch_zu_erledigen: res.data.tasks } : prev);
        syncTodoFromContact(taskId, res.data.tasks);
      }
    } catch { toast.error('Fehler'); }
  };

  // Sync the corresponding todo in localStorage when a contact task is toggled
  const syncTodoFromContact = (taskId, updatedTasks) => {
    const toggledTask = updatedTasks.find(t => t.id === taskId);
    const newDone = toggledTask?.done ?? false;

    // Sync Todo-Listen (daily, weekly, monthly, backlog)
    if (toggledTask?.todoRef) {
      const todoId = toggledTask.todoRef;
      const TODO_KEYS = {
        daily: 'zielplanung_daily_todos',
        weekly: 'zielplanung_weekly_todos',
        monthly: 'zielplanung_monthly_todos',
        open: 'zielplanung_backlog_todos',
      };
      Object.entries(TODO_KEYS).forEach(([, key]) => {
        try {
          const stored = JSON.parse(userStorage.getItem(key));
          if (!stored) return;
          let updated = false;
          if (Array.isArray(stored)) {
            const newArr = stored.map(t => t.id === todoId ? ((updated = true), { ...t, done: newDone }) : t);
            if (updated) userStorage.setItem(key, JSON.stringify(newArr));
          } else if (typeof stored === 'object') {
            const newObj = Object.fromEntries(
              Object.entries(stored).map(([k, arr]) => [k, Array.isArray(arr) ? arr.map(t => t.id === todoId ? ((updated = true), { ...t, done: newDone }) : t) : arr])
            );
            if (updated) userStorage.setItem(key, JSON.stringify(newObj));
          }
        } catch {}
      });
      window.dispatchEvent(new CustomEvent('burningteam-todos-sync'));
    }

    // Sync Kalender-Ansichten (Woche, Monat, Jahr) über contactRef.taskId
    // taskId hier ist die Kontakt-Aufgaben-ID, die in contactRef.taskId der Kalendereinträge gespeichert ist
    try {
      const weekData = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
      const updatedWeek = weekData.map(a => a.contactRef?.taskId === taskId ? { ...a, done: newDone } : a);
      userStorage.setItem('zielplanung_appointments', JSON.stringify(updatedWeek));
    } catch {}
    try {
      const monthData = JSON.parse(userStorage.getItem('zielplanung_month_appointments') || '{}');
      let changed = false;
      Object.keys(monthData).forEach(key => {
        monthData[key] = (monthData[key] || []).map(a => {
          if (a.contactRef?.taskId === taskId) { changed = true; return { ...a, done: newDone }; }
          return a;
        });
      });
      if (changed) userStorage.setItem('zielplanung_month_appointments', JSON.stringify(monthData));
    } catch {}
    try {
      const yearData = JSON.parse(userStorage.getItem('zielplanung_year_planning') || '{}');
      let changed = false;
      Object.keys(yearData).forEach(key => {
        yearData[key] = (yearData[key] || []).map(a => {
          if (a.contactRef?.taskId === taskId) { changed = true; return { ...a, done: newDone }; }
          return a;
        });
      });
      if (changed) userStorage.setItem('zielplanung_year_planning', JSON.stringify(yearData));
    } catch {}
  };

  const handleDeleteKontaktTask = async (contactId, contactTyp, taskId) => {
    try {
      let deletedTask = null;
      if (contactTyp === 'ich') {
        const me = await axios.get(`${API}/api/auth/me`);
        const all = normalizeNochZuErledigen(me.data.noch_zu_erledigen);
        deletedTask = all.find(t => t.id === taskId);
        const updated = all.filter(t => t.id !== taskId);
        await axios.put(`${API}/api/auth/me/profile`, { noch_zu_erledigen: updated });
        setUser(prev => ({ ...prev, noch_zu_erledigen: updated }));
        setTempIchData(prev => prev ? { ...prev, noch_zu_erledigen: updated } : prev);
      } else {
        const tp = teampartner.find(t => t.id === contactId) || tempEditData;
        const all = normalizeNochZuErledigen(tp?.noch_zu_erledigen);
        deletedTask = all.find(t => t.id === taskId);
        const updated = all.filter(t => t.id !== taskId);
        await axios.put(`${API}/api/teampartner/${contactId}`, { noch_zu_erledigen: updated });
        setTeampartner(prev => prev.map(t => t.id === contactId ? { ...t, noch_zu_erledigen: updated } : t));
        setFilteredTeampartner(prev => prev.map(t => t.id === contactId ? { ...t, noch_zu_erledigen: updated } : t));
        setSelectedTeampartner(prev => prev?.id === contactId ? { ...prev, noch_zu_erledigen: updated } : prev);
        setTempEditData(prev => prev?.id === contactId ? { ...prev, noch_zu_erledigen: updated } : prev);
      }
      // Bidirektionale Sync: Verknüpftes Todo aus localStorage löschen
      if (deletedTask?.todoRef) {
        deleteTodoFromLocalStorage(deletedTask.todoRef);
        window.dispatchEvent(new CustomEvent('burningteam-todos-sync'));
      }
      // Bidirektionale Sync: Alle verknüpften Kalender-Einträge löschen (Woche/Monat/Jahr)
      if (deletedTask?.id) {
        deleteCalendarEntriesByTaskId(deletedTask.id);
      }
    } catch { toast.error('Fehler'); }
  };

  // Hilfsfunktion: Todo aus localStorage löschen (alle Speicher durchsuchen)
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [localPhone, setLocalPhone] = useState(""); // Lokale Telefonnummer (nur localStorage)
  const [showLocalPhoneModal, setShowLocalPhoneModal] = useState(false);

  // Telefonbuch-Picker (verwendet die Chrome/Android Contact Picker API)
  const pickPhoneFromContactBook = async () => {
    if (!('contacts' in navigator) || !('ContactsManager' in window)) {
      toast.info("Aus Telefonbuch auswählen ist nur in Chrome / Android verfügbar.");
      return;
    }
    try {
      const contacts = await navigator.contacts.select(['name', 'tel'], { multiple: false });
      if (!contacts || !contacts.length) return;
      const c = contacts[0];
      const phone = (c.tel && c.tel[0]) || "";
      const name = (c.name && c.name[0]) || "";
      if (phone) {
        setLocalPhone(phone);
        // Wenn der Name-Feld noch leer ist, auch übernehmen (nur beim Add-Form)
        setFormData(prev => (prev && !prev.name && name) ? { ...prev, name } : prev);
        toast.success("Kontakt aus Telefonbuch übernommen");
      } else {
        toast.warning("Dieser Kontakt hat keine Telefonnummer.");
      }
    } catch {
      // User hat den Picker abgebrochen
    }
  };
  const [linieSearch, setLinieSearch] = useState("");
  const [showLinieDropdown, setShowLinieDropdown] = useState(false);
  const [showPromoteModal, setShowPromoteModal] = useState(false);
  const [promotingTeampartner, setPromotingTeampartner] = useState(null);
  const [showDateTimePicker, setShowDateTimePicker] = useState(false);
  const [dateTimeStep, setDateTimeStep] = useState(1); // 1=Datum, 2=Uhrzeit, 3=Zuletzt kontaktiert, 4=Thema archivieren, 5=Nächstes Thema
  const [tempDate, setTempDate] = useState("");
  const [tempTime, setTempTime] = useState("");
  // Wizard Schritt 3: Zuletzt kontaktiert
  const [dtLetzterOption, setDtLetzterOption] = useState("heute"); // "heute"|"custom"|"nein"
  const [dtLetzterCustom, setDtLetzterCustom] = useState("");
  // Wizard Schritt 4: Altes Thema archivieren
  const [dtAltesThema, setDtAltesThema] = useState("");
  const [dtThemaUhrzeitMode, setDtThemaUhrzeitMode] = useState("aktuell");
  const [dtThemaManuelleUhrzeit, setDtThemaManuelleUhrzeit] = useState("");
  // Wizard Schritt 3 (neu): Wurde Kontakt hergestellt? (nur bei kontaktiert=false)
  const [dtWurdeKontaktiert, setDtWurdeKontaktiert] = useState(null); // null | "ja" | "nein"
  // Wizard Schritt 5: Nächstes Thema
  const [dtNeuesThema, setDtNeuesThema] = useState("");
  // Wizard: Kalender-Termin Felder (verzögertes Speichern)
  const [dtStartTime, setDtStartTime] = useState("10:00");
  const [dtEndTime, setDtEndTime] = useState("11:00");
  const [dtOverlapError, setDtOverlapError] = useState("");
  const [dtColor, setDtColor] = useState("yellow");
  const [dtPriority, setDtPriority] = useState(5);
  const [dtNote, setDtNote] = useState("");
  const [dtShowColorPicker, setDtShowColorPicker] = useState(false);
  const [pendingCalendarAppointment, setPendingCalendarAppointment] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Warn-Modal: Bestehenden zukünftigen Kalender-Termin ersetzen?
  const [showReplaceApptWarning, setShowReplaceApptWarning] = useState(false);
  const [existingApptToReplace, setExistingApptToReplace] = useState(null);
  const [produkte, setProdukte] = useState([]);
  const [showThematikManager, setShowThematikManager] = useState(false);
  const [showVeranstaltungManager, setShowVeranstaltungManager] = useState(false);
  const [customThematikOptionen, setCustomThematikOptionen] = useState([]);
  const [customVeranstaltungOptionen, setCustomVeranstaltungOptionen] = useState([]);
  const [neueGlobaleThematik, setNeueGlobaleThematik] = useState("");
  const [neuesThema, setNeuesThema] = useState("");
  const [showNachrichten, setShowNachrichten] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showPromotionCelebration, setShowPromotionCelebration] = useState(false);
  const [promotionData, setPromotionData] = useState(null);
  const [showWelcomeCelebration, setShowWelcomeCelebration] = useState(false);
  const [welcomeData, setWelcomeData] = useState(null);
  const [showPausierungModal, setShowPausierungModal] = useState(false);
  const [pausierterKontakt, setPausierterKontakt] = useState(null);
  const [showUnpauseModal, setShowUnpauseModal] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  // Pause-Modal Option: Nächster Termin & Thema beibehalten (für Kundenrückgewinnung)
  const [pauseKeepTermin, setPauseKeepTermin] = useState(true);
  const [showLetzterTerminModal, setShowLetzterTerminModal] = useState(false);
  // Pending Thema-Archivierung (wird in executeSubmit verarbeitet)
  const [pendingThemaArchiv, setPendingThemaArchiv] = useState(null);
  const [letzterTerminModalData, setLetzterTerminModalData] = useState(null);
  const [customLetzterTerminDatum, setCustomLetzterTerminDatum] = useState("");
  const [originalNaechsterTermin, setOriginalNaechsterTermin] = useState(null);
  const [showKontaktaufnahmeModal, setShowKontaktaufnahmeModal] = useState(false);

  // Kombiniertes Nächster-Termin-Modal
  const [showNaechsterTerminModal, setShowNaechsterTerminModal] = useState(false);
  const [naechsterTerminModalIsDetail, setNaechsterTerminModalIsDetail] = useState(false);
  const [dtIsErsterTermin, setDtIsErsterTermin] = useState(false); // Flag: Wizard aus "Kontakt hinzufügen"
  const [ntmDatum, setNtmDatum] = useState("");
  const [ntmUhrzeit, setNtmUhrzeit] = useState("");
  const [ntmLetzterOption, setNtmLetzterOption] = useState("heute"); // "heute" | "custom" | "nein"
  const [ntmLetzterCustom, setNtmLetzterCustom] = useState("");
  
  // Neue States für vergangene Themen
  const [showThemaSpeichernModal, setShowThemaSpeichernModal] = useState(false);
  const [themaSpeichernData, setThemaSpeichernData] = useState(null);
  const [themaSpeichernUhrzeitMode, setThemaSpeichernUhrzeitMode] = useState("aktuell"); // "aktuell" oder "manuell"
  const [themaSpeichernManuelleUhrzeit, setThemaSpeichernManuelleUhrzeit] = useState("");
  const [showVergangeneThemenModal, setShowVergangeneThemenModal] = useState(false);
  const [vergangeneThemenData, setVergangeneThemenData] = useState([]);
  const [vergangeneThemenKontaktName, setVergangeneThemenKontaktName] = useState("");
  
  // State für "Neues Thema eingeben?" Modal nach Speichern
  const [showNeuesThemaModal, setShowNeuesThemaModal] = useState(false);
  const [neuesThemaKontaktId, setNeuesThemaKontaktId] = useState(null);
  const [neuesThemaText, setNeuesThemaText] = useState("");
  
  const formRef = useRef(null);

  // Aufgabe im Mini-Kalender-Panel abhaken + bidirektionale Sync
  const handleTogglePanelTodo = async (todo) => {
    const { _storageKey, _subKey, id: todoId, done: wasDone, contactRef } = todo;
    const newDone = !wasDone;
    try {
      const raw = JSON.parse(userStorage.getItem(_storageKey) || '{}');
      if (Array.isArray(raw)) {
        // Altes flaches Array-Format
        userStorage.setItem(_storageKey, JSON.stringify(raw.map(t => t.id === todoId ? { ...t, done: newDone } : t)));
      } else if (_subKey) {
        // Objekt mit Datum/Woche/Monat-Key
        raw[_subKey] = (raw[_subKey] || []).map(t => t.id === todoId ? { ...t, done: newDone } : t);
        userStorage.setItem(_storageKey, JSON.stringify(raw));
      }
      if (contactRef?.id && contactRef?.taskId) {
        if (contactRef.typ === 'ich') await axios.patch(`${API}/api/auth/me/tasks/${contactRef.taskId}`, { done: newDone });
        else await axios.patch(`${API}/api/teampartner/${contactRef.id}/tasks/${contactRef.taskId}`, { done: newDone });
      }
      window.dispatchEvent(new CustomEvent('burningteam-todos-sync'));
      setTodosPanelRefreshKey(k => k + 1);
    } catch (e) { console.error('Toggle Panel Todo error:', e); }
  };

  // Auto-Scroll: Heute ganz oben
  useEffect(() => {
    if (showWeekModal && !showTodosPanel && weekModalTodayRef.current) {
      setTimeout(() => {
        weekModalTodayRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, 100);
    }
  }, [showWeekModal, showTodosPanel, weekModalDate]);
  
  // User laden für InteractiveTour
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API}/api/auth/me`);
        setUser(response.data);
      } catch (error) {
        console.error("Fehler beim Laden des Users:", error);
      }
    };
    fetchUser();
  }, []);
  
  // Phase 7: Schulden-System States
  const [showSchuldenModal, setShowSchuldenModal] = useState(false);
  const [showBezahlteSchulden, setShowBezahlteSchulden] = useState(false);
  const [showBetreuungsModal, setShowBetreuungsModal] = useState(false);
  const [betreuungsContact, setBetreuungsContact] = useState(null);
  const savedScrollYRef = useRef(0);
  const [alleSchulden, setAlleSchulden] = useState([]);
  const [rechnungen, setRechnungen] = useState([]); // Rechnungen für Dropdown
  const [sortBezahlteBy, setSortBezahlteBy] = useState("bezahlt_am"); // "bezahlt_am" oder "name"
  const [bezahlteSchuldenSearch, setBezahlteSchuldenSearch] = useState(""); // Suchfeld für vergangene Schulden
  const [schuldenModalSchritt, setSchuldenModalSchritt] = useState(1); // 1 = Person & Richtung, 2 = Details
  
  // Downline-Tree States (für Detail-Modal)
  const [showDownlineTreeModal, setShowDownlineTreeModal] = useState(false);
  const [downlineTree, setDownlineTree] = useState(null);
  const [downlineTreeLoading, setDownlineTreeLoading] = useState(false);
  const [selectedTPForDownline, setSelectedTPForDownline] = useState(null);
  const [downlineZoom, setDownlineZoom] = useState(1);
  const downlineScrollRef = useRef(null);
  const initialPinchDistance = useRef(null);
  
  // Inline-Edit States (Detail-Modal Bearbeitungsmodus)
  const [isDetailEditMode, setIsDetailEditMode] = useState(false);
  const [isDetailFromSearch, setIsDetailFromSearch] = useState(false); // Flag: aus Suche-Tab geöffnet
  const [tempEditData, setTempEditData] = useState(null);
  const [showFieldEditModal, setShowFieldEditModal] = useState(false);
  const [currentEditField, setCurrentEditField] = useState(null);
  const [showSchuldenBezahlenModal, setShowSchuldenBezahlenModal] = useState(false);
  const [schuldenZumBezahlen, setSchuldenZumBezahlen] = useState([]);
  const [schuldenModalFromEditMode, setSchuldenModalFromEditMode] = useState(false);
  const [isSubmittingSchuld, setIsSubmittingSchuld] = useState(false);
  
  // "Ich" Tab Edit States
  const [isIchEditMode, setIsIchEditMode] = useState(false);
  const [tempIchData, setTempIchData] = useState(null);
  const [showIchFieldEditModal, setShowIchFieldEditModal] = useState(false);
  const [currentIchEditField, setCurrentIchEditField] = useState(null);
  
  const [schuldenFormData, setSchuldenFormData] = useState({
    name: "",
    teampartner_id: "",
    use_custom_name: false,
    richtung: "erhalten_von",
    beschreibung: "",
    betrag: "",
    menge: 1,
    einzelpreis: "",
    zuschlag_prozent: 15, // Standard 15% Zuschlag
    produkt_id: "",
    produkt_name: "",
    price_category: "",
    rechnung_id: "",
    rechnung_nummer: "",
    schulden_datum: new Date().toISOString().split('T')[0],
    faelligkeitsdatum: ""
  });
  // Gesammelte Posten einer Schulden-Gruppe (wird beim finalen Speichern gemeinsam mit Fälligkeit gesichert)
  const [pendingSchuldenGroup, setPendingSchuldenGroup] = useState([]);
  // Modal-Schritt 3: Fälligkeit für Gruppe festlegen
  const [showFaelligkeitModal, setShowFaelligkeitModal] = useState(false);
  const [gruppenFaelligkeit, setGruppenFaelligkeit] = useState("");
  
  const [formData, setFormData] = useState({
    name: "",
    typ: "kaltkontakt", // kaltkontakt, teampartner, kunde
    linie: "erstlinie",
    naechster_termin: "", // datetime-local: Browser zeigt Datum und Uhrzeit nacheinander
    naechstes_thema: "",
    letzter_termin: "", // Wird als "Zuletzt kontaktiert" angezeigt
    kontaktiert: false,
    termin_hatte: false,
    noch_zu_erledigen: "",
    notizen: "",
    // Phase 4: Thematik & Produkte
    thematik: [],
    im_abo: [],
    produktempfehlung: [],
    actionpack: "nein",
    // Phase 5: Betreuungssystem
    befoerderungs_datum: "",
    cellreset_gemacht: "nein",
    einnahmegespraech_erledigt: false,
    einnahmegespraech_datum: "",
    followup_3_5_erledigt: false,
    followup_14_erledigt: false,
    followup_30_erledigt: false,
    followup_28_erledigt: false,
    paket_erinnerung_erledigt: false,
    tp_kunde_geworden: null,
    online_live_veranstaltungen: [],
    pausiert: false,
    pausiert_datum: null
  });

  useEffect(() => {
    fetchTeampartner();
    fetchProdukte();
    loadThematikOptionen();
    loadVeranstaltungOptionen();
    loadNotifications();
    loadSchulden();
    loadRechnungen();
    loadUserSettings();
  }, []);

  // Navigation aus Warteliste → Formular vorausfüllen
  const wartelisteOpenedRef = useRef(false);
  useEffect(() => {
    if (location.state?.openNewKontakt && location.state?.prefill && !wartelisteOpenedRef.current) {
      wartelisteOpenedRef.current = true;
      const { name, phone, note } = location.state.prefill;
      setEditingId(null);
      setFormData(prev => ({
        ...prev,
        name: name || '',
        kontaktiert: true,
        typ: 'kaltkontakt',
        notizen: note || prev.notizen || '',
      }));
      if (phone) setLocalPhone(phone);
      setShowForm(true);
      setTimeout(() => {
        formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    }
    // Navigation aus Warteliste (DB-Kaltkontakt) → bestehenden Kontakt editieren mit kontaktiert=true
    if (location.state?.openEditKontakt && location.state?.editId && !wartelisteOpenedRef.current && teampartner.length > 0) {
      const tp = teampartner.find(t => t.id === location.state.editId);
      if (tp) {
        wartelisteOpenedRef.current = true;
        handleEdit(tp);
        // kontaktiert=true forcieren (Häkchen-Absicht)
        if (location.state.prefillKontaktiert) {
          setTimeout(() => {
            setFormData(prev => ({ ...prev, kontaktiert: true }));
          }, 100);
        }
        setTimeout(() => {
          formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 400);
      }
    }
  }, [location.state, teampartner]);

  // Separater useEffect für Nachrichten-Center Navigation
  useEffect(() => {
    const pendingOpen = userStorage.getItem('pendingNotificationOpen');
    if (pendingOpen && teampartner.length > 0 && !notificationOpenedRef.current) {
      notificationOpenedRef.current = true; // Verhindere mehrfache Ausführung
      
      try {
        const data = JSON.parse(pendingOpen);
        
        // Warte kurz, damit alle Daten geladen sind
        setTimeout(() => {
          const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
          const tp = allItems.find(t => t.id === data.teampartnerId);
          
          if (tp && data.notificationIds && data.notificationIds.length > 0) {
            // Erstelle Liste der Personen
            const personenMitBenachrichtigungen = data.notificationIds
              .map(id => allItems.find(t => t.id === id))
              .filter(t => t);
            
            if (personenMitBenachrichtigungen.length > 0) {
              setNotificationList(personenMitBenachrichtigungen);
              const index = personenMitBenachrichtigungen.findIndex(item => item.id === tp.id);
              setModalIndex(index >= 0 ? index : 0);
              setSelectedTeampartner(tp);
              setIsNotificationMode(true);
              setShowDetailModal(true);
            }
          }
          
          // localStorage aufräumen
          userStorage.removeItem('pendingNotificationOpen');
          notificationOpenedRef.current = false; // Reset für nächstes Mal
        }, 800);
      } catch (error) {
        console.error("Fehler beim Öffnen der Benachrichtigung:", error);
        userStorage.removeItem('pendingNotificationOpen');
        notificationOpenedRef.current = false;
      }
    }
  }, [teampartner.length]); // Nur auf Länge prüfen, nicht auf das Array selbst

  useEffect(() => {
    // Prüfe ob Rechnung als Schuld hinzugefügt werden soll (aus Inventory)
    const pendingSchuld = userStorage.getItem('pendingSchuldFromInvoice');
    if (pendingSchuld) {
      try {
        const data = JSON.parse(pendingSchuld);
        setTimeout(async () => {
          // Rechnung mit allen Positionen vom Backend holen
          let invoice = null;
          try {
            const resp = await axios.get(`${API}/api/invoices`);
            invoice = (resp.data || []).find(r => r.id === data.rechnung_id);
          } catch (e) {
            console.error("Rechnung nicht gefunden:", e);
          }

          // Fälligkeitsdatum: Rechnungsdatum + 14 Tage
          const rechnungsDatum = invoice?.date || data.rechnungs_datum;
          const faelligkeitsDatum = new Date(rechnungsDatum);
          faelligkeitsDatum.setDate(faelligkeitsDatum.getDate() + 14);

          setSchuldenFormData({
            name: (invoice?.customer_name || data.customer_name || "").trim(),
            teampartner_id: "",
            use_custom_name: true,
            richtung: "erhalten_von",
            beschreibung: `Rechnung ${data.rechnung_nummer}`,
            betrag: (invoice?.total_brutto || data.betrag).toFixed(2),
            menge: 1,
            zuschlag_prozent: 15,
            produkt_id: "",
            produkt_name: "",
            price_category: "",
            rechnung_id: data.rechnung_id,
            rechnung_nummer: data.rechnung_nummer,
            schulden_datum: rechnungsDatum,
            faelligkeitsdatum: faelligkeitsDatum.toISOString().split('T')[0]
          });

          // Items für spätere Expansion speichern (beim Speichern werden alle Positionen zu Posten)
          if (invoice && invoice.items && invoice.items.length > 0) {
            setInvoiceItemsForSchulden({
              items: invoice.items,
              rechnung_id: invoice.id,
              rechnung_nummer: invoice.invoice_number,
              schulden_datum: rechnungsDatum,
            });
          }

          setActiveTab("schulden");
          setSchuldenModalSchritt(2);
          setSchuldenFromInventory(true);
          setShowSchuldenModal(true);

          if (invoice?.customer_name && invoice.customer_name.trim()) {
            toast.success(`Rechnung ${data.rechnung_nummer} mit ${invoice.items?.length || 0} Positionen geladen`);
          } else {
            toast.info(`Rechnung ${data.rechnung_nummer} geladen — bitte Kundennamen eingeben`);
          }
        }, 800);
      } catch (error) {
        console.error("Fehler beim Laden der Rechnung:", error);
      } finally {
        userStorage.removeItem('pendingSchuldFromInvoice');
      }
    }
  }, []);

  const loadSchulden = async () => {
    try {
      const response = await axios.get(`${API}/api/schulden`);
      setAlleSchulden(response.data.schulden || []);
    } catch (error) {
      console.error("Fehler beim Laden der Schulden:", error);
    }
  };

  const [userCompanyName, setUserCompanyName] = useState("");
  const loadUserSettings = async () => {
    try {
      const response = await axios.get(`${API}/api/settings`);
      setUserCompanyName(response.data?.company_name || "");
    } catch (error) {
      // 404 = keine Settings - kein Firmenname, dann eben leer
      setUserCompanyName("");
    }
  };

  // Shared handler: Bezahlen-Button (aus TP-Card) -> PaymentModal öffnen
  const handlePayPerson = (personSchulden, personName) => {
    const offenePosten = (personSchulden || []).filter(p => !p.isTemp && p.status !== "bezahlt");
    if (offenePosten.length === 0) return;
    const total = offenePosten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
    const bezahlt = offenePosten.reduce((s, p) => {
      const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
      return s + tz;
    }, 0);
    setPaymentTarget({ type: 'person', posten: offenePosten, name: personName, total, bezahlt });
    setPaymentAmount("");
    setPaymentNotiz("");
    setPaymentMode("full");
    setShowPaymentModal(true);
  };

  // Shared handler: Teilzahlungs-Historie öffnen
  const handleShowTeilzahlungHistorie = (personSchulden, personName) => {
    setTeilzahlungHistorieTarget({ name: personName, posten: (personSchulden || []).filter(p => !p.isTemp) });
    setShowTeilzahlungHistorie(true);
  };

  const loadRechnungen = async () => {
    try {
      const response = await axios.get(`${API}/api/invoices`);
      setRechnungen(response.data || []);
    } catch (error) {
      console.error("Fehler beim Laden der Rechnungen:", error);
    }
  };

  const loadThematikOptionen = async () => {
    try {
      const response = await axios.get(`${API}/api/thematik`);
      setCustomThematikOptionen(response.data.custom_thematik || []);
    } catch (error) {
      console.error("Fehler beim Laden der Thematiken:", error);
    }
  };

  const loadVeranstaltungOptionen = () => {
    try {
      const saved = userStorage.getItem('customVeranstaltungOptionen');
      if (saved) {
        const parsed = JSON.parse(saved);
        setCustomVeranstaltungOptionen(parsed);
      }
    } catch (error) {
      console.error("Fehler beim Laden der Veranstaltungen aus localStorage:", error);
    }
  };

  const loadNotifications = async () => {
    try {
      const params = {};
      try {
        const ct = JSON.parse(userStorage.getItem('burningteam_contact_thresholds') || '{}');
        if (ct.yellowEnabled === false) params.yellow_enabled = false;
        else params.yellow_days = ct.yellowDays ?? 30;
        if (ct.redEnabled === false) params.red_enabled = false;
        else params.red_days = ct.redDays ?? 60;
      } catch {}
      const response = await axios.get(`${API}/api/nachrichten`, { params });
      setNotifications(response.data.notifications);
      setUnreadCount(response.data.unread_count);
    } catch (error) {
      console.error("Fehler beim Laden der Benachrichtigungen:", error);
    }
  };

  const THEMATIK_OPTIONEN = [...DEFAULT_THEMATIK_OPTIONEN, ...customThematikOptionen].sort();
  const VERANSTALTUNG_OPTIONEN = [...DEFAULT_VERANSTALTUNG_OPTIONEN, ...customVeranstaltungOptionen].sort();

  const fetchProdukte = async () => {
    try {
      const response = await axios.get(`${API}/api/products`);
      setProdukte(response.data);
    } catch (error) {
      console.error("Fehler beim Laden der Produkte:", error);
    }
  };

  useEffect(() => {
    // Filter and assign client-side numbering
    const withNumbers = teampartner.map((tp, index) => {
      let displayNummer;
      
      if (tp.typ === "kaltkontakt") {
        // Kaltkontakt: separate counting
        const sameTypBefore = teampartner
          .slice(0, index)
          .filter(item => item.typ === "kaltkontakt").length;
        displayNummer = sameTypBefore + 1;
      } else {
        // Teampartner & Kunde: GEMEINSAME Zählung
        const combinedBefore = teampartner
          .slice(0, index)
          .filter(item => item.typ === "teampartner" || item.typ === "kunde").length;
        displayNummer = combinedBefore + 1;
      }
      
      return {
        ...tp,
        displayNummer
      };
    });
    
    setFilteredTeampartner(withNumbers);
  }, [teampartner]);

  const fetchTeampartner = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/api/teampartner`);
      setTeampartner(response.data);
    } catch (error) {
      toast.error("Fehler beim Laden der Teampartner");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Doppel-Klick-Schutz: Verhindert dass durch versehentliches mehrfaches Klicken mehrere POSTs rausgehen
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await executeSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const executeSubmit = async (additionalData = {}) => {
    try {
      // Altes Thema archivieren (wenn via Wizard gesammelt)
      if (editingId && pendingThemaArchiv?.thema) {
        try {
          const res = await axios.get(`${API}/api/teampartner/${editingId}`);
          const vergangeneThemen = res.data.vergangene_themen || [];
          const datumPart = pendingThemaArchiv.datum;
          let uhrzeitPart;
          if (pendingThemaArchiv.uhrzeitMode === "aktuell") {
            const now = new Date();
            uhrzeitPart = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
          } else {
            uhrzeitPart = pendingThemaArchiv.manuelleUhrzeit || "12:00";
          }
          vergangeneThemen.push({ datum: `${datumPart}T${uhrzeitPart}`, thema: pendingThemaArchiv.thema });
          await axios.put(`${API}/api/teampartner/${editingId}`, { vergangene_themen: vergangeneThemen });
          setPendingThemaArchiv(null);
        } catch (e) {
          console.error("Fehler beim Archivieren des Themas:", e);
        }
      }
      if (editingId) {
        // Update - bei Typ-Änderung zu TP/Kunde automatisch Beförderungsdatum setzen
        const { tp_kunde_geworden, ...dataToSubmit } = { ...formData, ...additionalData }; // Entferne UI-Hilfsfeld und merge zusätzliche Daten
        console.log("dataToSubmit (merged):", dataToSubmit);
        if ((formData.typ === "teampartner" || formData.typ === "kunde") && !formData.befoerderungs_datum) {
          dataToSubmit.befoerderungs_datum = new Date().toISOString().split('T')[0];
        }
        const response = await axios.put(`${API}/api/teampartner/${editingId}`, dataToSubmit);
        // Lokale Telefonnummer speichern
        if (localPhone.trim()) {
          const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
          phones[editingId] = localPhone.trim();
          userStorage.setItem('burningteam_contact_phones', JSON.stringify(phones));
        }
        
        // Check if auto-promotion occurred
        if (response.data.auto_promotion) {
          setPromotionData(response.data.auto_promotion);
          setShowPromotionCelebration(true);
        }
        
        // Check if someone became Kunde or Teampartner from Kaltkontakt (nur bei Update)
        if (editingId) {
          const originalData = teampartner.find(tp => tp.id === editingId);
          const wasKaltkontakt = originalData?.typ === 'kaltkontakt';
          const isNowKundeOrTP = dataToSubmit.typ === 'kunde' || dataToSubmit.typ === 'teampartner';
          if (wasKaltkontakt && isNowKundeOrTP) {
            setWelcomeData({
              name: dataToSubmit.name,
              typ: dataToSubmit.typ
            });
            setShowWelcomeCelebration(true);
          }
        }
        
        toast.success("Teampartner aktualisiert");
      } else {
        // Create new
        const { tp_kunde_geworden, ...dataToSubmit } = formData; // Entferne UI-Hilfsfeld
        const response = await axios.post(`${API}/api/teampartner`, dataToSubmit);
        // Backend gibt { teampartner: {...}, auto_promotion: ... } zurück
        const newId = response.data?.teampartner?.id || response.data?.id;
        // Lokale Telefonnummer speichern
        if (localPhone.trim() && newId) {
          const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
          phones[newId] = localPhone.trim();
          userStorage.setItem('burningteam_contact_phones', JSON.stringify(phones));
        }
        
        // Check if auto-promotion occurred (when adding to someone's downline)
        if (response.data.auto_promotion) {
          setPromotionData(response.data.auto_promotion);
          setShowPromotionCelebration(true);
        }
        
        // Check if created as Kunde or Teampartner (not Kaltkontakt)
        if (dataToSubmit.typ === 'kunde' || dataToSubmit.typ === 'teampartner') {
          setWelcomeData({
            name: dataToSubmit.name,
            typ: dataToSubmit.typ
          });
          setShowWelcomeCelebration(true);
        }
        
        toast.success("Teampartner erstellt");
      }
      
      resetForm();
      fetchTeampartner();
      // Kalender-Termin speichern wenn vorhanden (verzögertes Speichern)
      if (pendingCalendarAppointment) {
        const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
        // Alten verlinkten Termin für diesen Kontakt entfernen (ersetzt Datum/Zeit-Änderung)
        const contactId = pendingCalendarAppointment.contactRef?.id;
        const filtered = contactId
          ? apts.filter(a => !(a.contactRef?.id === contactId && !a.contactRef?.taskId))
          : apts;
        filtered.push(pendingCalendarAppointment);
        userStorage.setItem('zielplanung_appointments', JSON.stringify(filtered));
        window.dispatchEvent(new CustomEvent('burningteam-calendar-sync'));
        setPendingCalendarAppointment(null);
        toast.success("Termin im Kalender gespeichert!");
      }
    } catch (error) {
      console.error("Fehler beim Speichern:", error);
      console.error("Error response:", error.response?.data);
      console.error("Form data was:", formData);
      
      // Extrahiere Fehlermeldung aus verschiedenen möglichen Strukturen
      let errorMsg = "Unbekannter Fehler";
      if (error.response?.data) {
        const data = error.response.data;
        if (typeof data === 'string') {
          errorMsg = data;
        } else if (data.detail) {
          if (typeof data.detail === 'string') {
            errorMsg = data.detail;
          } else if (Array.isArray(data.detail)) {
            errorMsg = data.detail.map(d => d.msg || JSON.stringify(d)).join(', ');
          } else {
            errorMsg = JSON.stringify(data.detail);
          }
        } else if (data.message) {
          errorMsg = data.message;
        } else {
          errorMsg = JSON.stringify(data);
        }
      } else if (error.message) {
        errorMsg = error.message;
      }
      
      toast.error(`Fehler beim Speichern: ${errorMsg}`);
    }
  };

  // Hilfsfunktion: Berechne maximale Breite des Baums (Anzahl Nodes auf breitester Ebene)
  const calculateMaxWidth = (node) => {
    const levelWidths = {};
    
    const traverse = (n, level) => {
      if (!levelWidths[level]) levelWidths[level] = 0;
      levelWidths[level]++;
      
      if (n.children && n.children.length > 0) {
        n.children.forEach(child => traverse(child, level + 1));
      }
    };
    
    traverse(node, 0);
    return Math.max(...Object.values(levelWidths));
  };
  
  // Hilfsfunktion: Berechne Tiefe des Baums
  const calculateDepth = (node) => {
    if (!node.children || node.children.length === 0) return 1;
    return 1 + Math.max(...node.children.map(child => calculateDepth(child)));
  };

  // useEffect: Zentriere Ansicht auf Root-Node nach dem Laden
  useEffect(() => {
    if (downlineTree && downlineScrollRef.current && !downlineTreeLoading) {
      // Warte kurz, damit DOM gerendert ist
      setTimeout(() => {
        const container = downlineScrollRef.current;
        if (container) {
          // Zentriere horizontal und vertikal
          const scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
          const scrollTop = 0; // Root-Node ist oben
          
          container.scrollTo({
            left: scrollLeft,
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [downlineTree, downlineTreeLoading]);

  // Body-Scroll-Sperre für alle Modals (verhindert Hintergrund-Scrollen auf Handy)
  useLayoutEffect(() => {
    const anyModalOpen = showDetailModal || showZuErledigienModal || showFieldEditModal || 
      showIchFieldEditModal || showDownlineTreeModal || showVergangeneThemenModal ||
      showPauseModal || showUnpauseModal || showLetzterTerminModal || showSchuldenModal ||
      showKaltkontaktModal || showKaltkontaktSubModal || showKaltkontaktFrageModal ||
      showKaltkontaktDetailsModal || showPromotionCelebration || showPromoteModal || showBetreuungsModal;

    if (anyModalOpen) {
      if (document.body.style.position !== 'fixed') {
        savedScrollYRef.current = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${savedScrollYRef.current}px`;
        console.log('[ScrollLock] Gesperrt bei scrollY=', savedScrollYRef.current);
      }
    } else {
      if (document.body.style.position === 'fixed') {
        const topVal = document.body.style.top;
        const scrollY = Math.abs(parseInt(topVal || '0', 10)) || savedScrollYRef.current;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
        console.log('[ScrollLock] Wiederhergestellt zu scrollY=', scrollY, '(topVal=', topVal, ', ref=', savedScrollYRef.current, ')');
      }
    }

    return () => {
      if (document.body.style.position === 'fixed') {
        const topVal = document.body.style.top;
        const scrollY = Math.abs(parseInt(topVal || '0', 10)) || savedScrollYRef.current;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
        console.log('[ScrollLock] Cleanup: Wiederhergestellt zu scrollY=', scrollY);
      }
    };
  }, [showDetailModal, showZuErledigienModal, showFieldEditModal, showIchFieldEditModal,
      showDownlineTreeModal, showVergangeneThemenModal, showPauseModal, showUnpauseModal,
      showLetzterTerminModal, showSchuldenModal, showKaltkontaktModal, showKaltkontaktSubModal,
      showKaltkontaktFrageModal, showKaltkontaktDetailsModal, showPromotionCelebration, showPromoteModal, showBetreuungsModal]);

  // Downline-Tree Touch-Zoom-Handler (Pinch-to-Zoom für Smartphones)
  const handleDownlineTreeTouchStart = (e) => {
    if (e.touches.length === 2) {
      // Berechne initialen Abstand zwischen zwei Fingern
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );
      initialPinchDistance.current = distance;
    }
    // Kein preventDefault - lass alle anderen Events durch
  };

  const handleDownlineTreeTouchMove = (e) => {
    if (e.touches.length === 2 && initialPinchDistance.current) {
      // NUR bei 2 Fingern preventDefault
      e.preventDefault();
      
      // Berechne aktuellen Abstand
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );
      
      // Berechne Zoom-Änderung mit SEHR HOHER Sensitivität
      const scale = distance / initialPinchDistance.current;
      
      // VIEL stärkere Verstärkung (5x sensibler als vorher)
      const amplifiedScale = 1 + (scale - 1) * 5;
      const newZoom = downlineZoom * amplifiedScale;
      
      // Limitiere Zoom zwischen 0.2 und 2, aber KEINE Rundung mehr
      const clampedZoom = Math.max(0.2, Math.min(2, newZoom));
      setDownlineZoom(clampedZoom);
      
      // Update initiale Distanz für smooth zooming
      initialPinchDistance.current = distance;
    }
    // Bei 1 Finger: Kein preventDefault - normales Verhalten
  };

  const handleDownlineTreeTouchEnd = (e) => {
    if (e.touches.length < 2) {
      initialPinchDistance.current = null;
    }
  };

  // Handler für Inline-Edit-Modus im Detail-Modal
  const handleStartDetailEdit = async (tp) => {
    setIsDetailEditMode(true);
    
    // WICHTIG: Hole frische Daten vom Server, um sicherzustellen dass vergangene_themen aktuell sind
    try {
      const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
      setTempEditData({ ...response.data }); // Frische Daten vom Server
    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
      setTempEditData({ ...tp }); // Fallback auf lokale Kopie
    }
    
    // Scroll nach oben, damit User mit dem Badge und den oberen Feldern beginnt
    setTimeout(() => {
      const modalContent = document.querySelector('.fixed.inset-0 .overflow-y-auto');
      if (modalContent) {
        modalContent.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
  };

  const handleCancelDetailEdit = () => {
    setIsDetailEditMode(false);
    setTempEditData(null);
    setShowFieldEditModal(false);
    setCurrentEditField(null);
    // Sicherstellen dass TodosView aktualisiert ist (falls Aufgaben hinzugefügt wurden)
    window.dispatchEvent(new CustomEvent('burningteam-todos-sync'));
  };

  // Öffnet Detail-Modal direkt im Bearbeitungsmodus (nur aus Suche-Tab)
  const openDetailInEditMode = async (tp) => {
    setSelectedTeampartner(tp);
    setIsDetailFromSearch(true);
    setShowDetailModal(true);
    await handleStartDetailEdit(tp);
  };

  const handleSaveDetailEdit = async () => {
    if (!tempEditData) return;
    
    // Validierung: Nächstes Paket muss bei Kunde/TP gesetzt sein
    if ((tempEditData.typ === 'kunde' || tempEditData.typ === 'teampartner') && !tempEditData.befoerderungs_datum) {
      toast.error("Bitte 'Nächstes Paket' Datum auswählen!");
      // Scrolle zum Nächstes Paket Feld
      setTimeout(() => {
        const element = document.querySelector('[data-field="naechstes-paket"]');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.classList.add('animate-pulse');
          setTimeout(() => element.classList.remove('animate-pulse'), 2000);
        }
      }, 100);
      return;
    }
    
    try {
      // 1. Speichere die Teampartner-Änderungen (ohne temp-Felder)
      const { tempBezahlteSchulden, tempNeueSchulden, ...dataToSave } = tempEditData;
      
      // Stelle sicher, dass Arrays korrekt sind (nicht undefined)
      if (!Array.isArray(dataToSave.thematik)) dataToSave.thematik = [];
      if (!Array.isArray(dataToSave.online_live_veranstaltungen)) dataToSave.online_live_veranstaltungen = [];
      if (!Array.isArray(dataToSave.im_abo)) dataToSave.im_abo = [];
      if (!Array.isArray(dataToSave.produktempfehlung)) dataToSave.produktempfehlung = [];
      
      // WICHTIG: vergangene_themen NICHT überschreiben wenn es nicht explizit geändert wurde
      // Setze auf undefined damit das Backend es nicht überschreibt
      if (!dataToSave.vergangene_themen || dataToSave.vergangene_themen.length === 0) {
        // Hole aktuelle vergangene_themen vom Server
        try {
          const currentData = await axios.get(`${API}/api/teampartner/${tempEditData.id}`);
          if (currentData.data.vergangene_themen && currentData.data.vergangene_themen.length > 0) {
            dataToSave.vergangene_themen = currentData.data.vergangene_themen;
          } else {
            delete dataToSave.vergangene_themen; // Nicht senden, damit Backend es nicht überschreibt
          }
        } catch (e) {
          delete dataToSave.vergangene_themen;
        }
      }
      
      console.log("Saving data:", dataToSave);
      
      // pendingThemaArchiv (aus DateTimePicker Wizard) verarbeiten
      if (pendingThemaArchiv?.thema) {
        const datumPart = pendingThemaArchiv.datum;
        const now = new Date();
        const uhrzeitPart = pendingThemaArchiv.uhrzeitMode === "aktuell"
          ? `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`
          : (pendingThemaArchiv.manuelleUhrzeit || "12:00");
        if (!Array.isArray(dataToSave.vergangene_themen)) dataToSave.vergangene_themen = [];
        dataToSave.vergangene_themen.push({ datum: `${datumPart}T${uhrzeitPart}`, thema: pendingThemaArchiv.thema });
        setPendingThemaArchiv(null);
      }
      
      // Prüfe ob jemand zu Kunde oder TP wurde
      const wasKaltkontakt = selectedTeampartner?.typ === 'kaltkontakt';
      const isNowKundeOrTP = dataToSave.typ === 'kunde' || dataToSave.typ === 'teampartner';
      
      await axios.put(`${API}/api/teampartner/${tempEditData.id}`, dataToSave);
      
      // ── Kontakt → Kalender Sync ──────────────────────────────────────────
      // Verknüpften Kalender-Termin aktualisieren (Datum/Zeit/Titel/Notiz)
      try {
        const contactId = tempEditData.id;
        const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
        // Direkter Appointment-Link (kein Task-Link)
        const linkedIdx = apts.findIndex(a => a.contactRef?.id === contactId && !a.contactRef?.taskId);
        if (linkedIdx >= 0) {
          const oldAppt = apts[linkedIdx];
          let updatedAppt = { ...oldAppt };
          let calChanged = false;

          // naechster_termin geändert → Datum/Zeit im Appointment updaten, Verknüpfung ERHALTEN
          if (dataToSave.naechster_termin && dataToSave.naechster_termin !== selectedTeampartner?.naechster_termin) {
            const newDt = new Date(dataToSave.naechster_termin);
            if (!isNaN(newDt)) {
              const pad = (n) => String(n).padStart(2, '0');
              const newDate = `${newDt.getFullYear()}-${pad(newDt.getMonth() + 1)}-${pad(newDt.getDate())}`;
              const newStart = `${pad(newDt.getHours())}:${pad(newDt.getMinutes())}`;
              // Dauer des alten Termins übernehmen (default 60 min)
              let durationMin = 60;
              if (oldAppt.startTime && oldAppt.endTime) {
                const [sh, sm] = oldAppt.startTime.split(':').map(Number);
                const [eh, em] = oldAppt.endTime.split(':').map(Number);
                const diff = (eh * 60 + em) - (sh * 60 + sm);
                if (diff > 0) durationMin = diff;
              }
              const endMinutes = newDt.getHours() * 60 + newDt.getMinutes() + durationMin;
              const newEnd = `${pad(Math.floor(endMinutes / 60) % 24)}:${pad(endMinutes % 60)}`;
              updatedAppt.date = newDate;
              updatedAppt.startTime = newStart;
              updatedAppt.endTime = newEnd;
              calChanged = true;
            }
          }
          // naechstes_thema → Termin-Titel
          if (dataToSave.naechstes_thema !== undefined && dataToSave.naechstes_thema !== oldAppt.title) {
            updatedAppt.title = dataToSave.naechstes_thema || oldAppt.title;
            calChanged = true;
          }
          // notizen → Termin-Notiz
          if (dataToSave.notizen !== undefined && (dataToSave.notizen || '') !== (oldAppt.note || '')) {
            updatedAppt.note = dataToSave.notizen;
            calChanged = true;
          }
          if (calChanged) {
            apts[linkedIdx] = updatedAppt;
            userStorage.setItem('zielplanung_appointments', JSON.stringify(apts));
            window.dispatchEvent(new Event('burningteam-calendar-sync'));
            toast.info("Verknüpfter Kalender-Termin wurde aktualisiert.");
          }
        }
      } catch { /* Sync-Fehler ignorieren */ }
      
      // Zeige Willkommens-Celebration wenn von Kaltkontakt zu Kunde/TP
      if (wasKaltkontakt && isNowKundeOrTP) {
        setWelcomeData({
          name: dataToSave.name,
          typ: dataToSave.typ
        });
        setShowWelcomeCelebration(true);
      }
      
      // 2. Markiere Schulden als bezahlt
      if (tempBezahlteSchulden && tempBezahlteSchulden.length > 0) {
        await Promise.all(
          tempBezahlteSchulden.map(schuldenId => 
            axios.put(`${API}/api/schulden/${schuldenId}/bezahlt`)
          )
        );
        toast.success(`${tempBezahlteSchulden.length} Schuld(en) als bezahlt markiert`);
      }
      
      // 3. Erstelle neue Schulden
      if (tempNeueSchulden && tempNeueSchulden.length > 0) {
        await Promise.all(
          tempNeueSchulden.map(schuld => 
            axios.post(`${API}/api/schulden`, schuld)
          )
        );
        toast.success(`${tempNeueSchulden.length} neue Schuld(en) hinzugefügt`);
      }
      
      toast.success("Alle Änderungen gespeichert!");
      
      // Aktualisiere die Daten
      await fetchTeampartner();
      await loadSchulden();
      
      // Aktualisiere selectedTeampartner mit den neuen Daten
      const updatedTP = await axios.get(`${API}/api/teampartner/${tempEditData.id}`);
      setSelectedTeampartner(updatedTP.data);
      
      // Beende Edit-Mode
      setIsDetailEditMode(false);
      setTempEditData(null);
      // Kalender-Termin speichern wenn vorhanden (verzögertes Speichern)
      if (pendingCalendarAppointment) {
        const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
        // Alten verlinkten Termin für diesen Kontakt entfernen (ersetzt Datum/Zeit-Änderung)
        const contactId = pendingCalendarAppointment.contactRef?.id;
        const filtered = contactId
          ? apts.filter(a => !(a.contactRef?.id === contactId && !a.contactRef?.taskId))
          : apts;
        filtered.push(pendingCalendarAppointment);
        userStorage.setItem('zielplanung_appointments', JSON.stringify(filtered));
        window.dispatchEvent(new CustomEvent('burningteam-calendar-sync'));
        setPendingCalendarAppointment(null);
        toast.success("Termin im Kalender gespeichert!");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      console.error("Error details:", error.response?.data);
      toast.error(`Fehler beim Speichern: ${error.response?.data?.detail || error.message}`);
    }
  };

  const handleOpenFieldEdit = (fieldName, fieldLabel, fieldType, fieldOptions = null, fieldLabels = null) => {
    // Spezialbehandlung für Schulden-Modals (immer erlaubt, auch wenn pausiert)
    if (fieldType === 'schulden-bezahlen-modal') {
      // fieldOptions enthält die personSchulden
      setSchuldenZumBezahlen(fieldOptions || []);
      setShowSchuldenBezahlenModal(true);
      return;
    }
    
    if (fieldType === 'neue-schulden-modal') {
      // fieldOptions enthält { name, teampartner_id }
      const personInfo = fieldOptions || {};
      setSchuldenFormData({
        name: personInfo.name || "",
        teampartner_id: personInfo.teampartner_id || "",
        use_custom_name: false,
        richtung: "erhalten_von",
        beschreibung: "",
        betrag: "",
        zuschlag_prozent: 15,
        produkt_id: "",
        produkt_name: "",
        price_category: "",
        rechnung_id: "",
        rechnung_nummer: "",
        schulden_datum: new Date().toISOString().split('T')[0],
        faelligkeitsdatum: ""
      });
      setSchuldenModalSchritt(1);
      setSchuldenModalFromEditMode(true); // Markieren dass wir aus Edit-Modus kommen
      setShowSchuldenModal(true);
      return;
    }
    
    // Kombiniertes Nächster-Termin-Modal → öffnet neuen Wizard
    if (fieldType === 'naechster-termin-modal') {
      if (tempEditData?.pausiert === true) { setShowUnpauseModal(true); return; }
      const current = tempEditData?.[fieldName] || "";
      let initDatum = "";
      let initUhrzeit = "10:00";
      if (current) {
        const d = new Date(current);
        initDatum = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        initUhrzeit = `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
      }
      setTempDate(initDatum);
      setTempTime(initUhrzeit);
      setDtStartTime(initUhrzeit);
      const initEndH = initUhrzeit ? Math.min(parseInt(initUhrzeit.split(':')[0]) + 1, 23) : 11;
      const initEndM = initUhrzeit ? initUhrzeit.split(':')[1] : '00';
      setDtEndTime(`${String(initEndH).padStart(2, '0')}:${initEndM}`);
      setDtOverlapError("");
      setDtColor("yellow");
      setDtPriority(5);
      setDtNote("");
      setDtShowColorPicker(false);
      setDtLetzterOption("heute");
      setDtLetzterCustom("");
      setDtWurdeKontaktiert(null);
      setDtAltesThema(tempEditData?.naechstes_thema || "");
      setDtThemaUhrzeitMode("aktuell");
      setDtThemaManuelleUhrzeit("");
      setDtNeuesThema("");
      setDateTimeStep(1);
      setNaechsterTerminModalIsDetail(true);
      setShowDateTimePicker(true);
      return;
    }
    
    // Check: Wenn Kontakt pausiert ist, zeige Unpause-Modal (außer für Schulden)
    if (tempEditData?.pausiert === true) {
      setShowUnpauseModal(true);
      return;
    }
    
    // Normale Feld-Bearbeitung
    setCurrentEditField({
      name: fieldName,
      label: fieldLabel,
      type: fieldType,
      options: fieldOptions,
      labels: fieldLabels, // Separate Labels für Anzeige (z.B. Namen statt IDs)
      value: tempEditData[fieldName]
    });
    setShowFieldEditModal(true);
  };

  const handleSaveFieldEdit = (fieldName, newValue) => {
    // Wenn "naechster_termin" geändert wird, öffne Modal
    if (fieldName === 'naechster_termin') {
      setTempEditData(prev => ({ ...prev, [fieldName]: newValue }));
      setShowFieldEditModal(false);
      setCurrentEditField(null);
      
      // Prüfe ob Kontakt bereits kontaktiert wurde
      if (tempEditData?.kontaktiert === false) {
        // Zeige zuerst Kontaktaufnahme-Modal
        setShowKontaktaufnahmeModal(true);
        setLetzterTerminModalData({
          isDetailEdit: true,
          alterTermin: selectedTeampartner?.naechster_termin,
          kontaktId: selectedTeampartner?.id,
          kontaktName: selectedTeampartner?.name,
          saveCallback: async (additionalData) => {
            // Callback wird aufgerufen wenn User "Ja" wählt
          }
        });
      } else {
        // Kontakt ist bereits kontaktiert, öffne direkt Letzter-Termin-Modal
        setLetzterTerminModalData({
          isDetailEdit: true,
          alterTermin: selectedTeampartner?.naechster_termin,
          kontaktId: selectedTeampartner?.id,
          kontaktName: selectedTeampartner?.name,
          saveCallback: async (additionalData) => {
            // Callback wird aufgerufen wenn User "Ja" wählt
          }
        });
        setShowLetzterTerminModal(true);
      }
      return;
    }
    
    setTempEditData(prev => {
      const updated = { ...prev, [fieldName]: newValue };
      
      // Speziallogik: Wenn Typ von Kaltkontakt zu Kunde/TP geändert wird
      if (fieldName === 'typ' && prev.typ === 'kaltkontakt' && (newValue === 'kunde' || newValue === 'teampartner')) {
        // Setze naechster_termin auf 3-5 Tage Follow-up (4 Tage als Standard)
        const heute = new Date();
        const followupDate = new Date(heute);
        followupDate.setDate(heute.getDate() + 4);
        
        // Setze Zeit auf 10:00 Uhr
        followupDate.setHours(10, 0, 0, 0);
        
        updated.naechster_termin = followupDate.toISOString();
        
        // Setze naechstes_thema auf "Einnahmegespräch"
        updated.naechstes_thema = "Einnahmegespräch";
        
        toast.info("Nächster Termin und Thema wurden automatisch gesetzt");
      }
      
      return updated;
    });
    setShowFieldEditModal(false);
    setCurrentEditField(null);
  };

  // Handler für Downline-Tree Modal (nur aus Detail-Modal aufrufbar)
  const handleDownlineTreeClick = async (tp) => {
    setSelectedTPForDownline(tp);
    setDownlineTreeLoading(true);
    setShowDownlineTreeModal(true);
    try {
      const response = await axios.get(`${API}/api/teampartner/${tp.id}/downline-tree`);
      setDownlineTree(response.data);
      
      // Berechne optimalen Zoom basierend auf Baum-Größe
      const maxWidth = calculateMaxWidth(response.data);
      const depth = calculateDepth(response.data);
      
      // SEHR AGGRESSIVER Auto-Zoom: ALLES muss beim Öffnen sichtbar sein
      // Modal-Dimensionen (95vw = ~1400-1800px auf Desktop, 95vh = ~900-1000px)
      const availableWidth = window.innerWidth * 0.90; // 90% der Viewport-Breite minus Padding
      const availableHeight = window.innerHeight * 0.80; // 80% der Viewport-Höhe minus Header
      
      // Jeder Node braucht Platz
      const requiredWidth = maxWidth * 192; // 192px pro Node (160px + 32px gap)
      const requiredHeight = depth * 170; // 170px pro Ebene (Node + Linien + Abstand)
      
      // Berechne Zoom für Breite und Höhe
      const widthZoom = availableWidth / requiredWidth;
      const heightZoom = availableHeight / requiredHeight;
      
      // Nimm den KLEINEREN Wert (sodass ALLES reinpasst) und reduziere um 15% für Sicherheitsmarge
      let optimalZoom = Math.min(widthZoom, heightZoom) * 0.85;
      
      // Minimum 0.2 (20%), Maximum 1 (100%)
      optimalZoom = Math.max(0.2, Math.min(1, optimalZoom));
      
      // Runde auf 5% für saubere Werte
      optimalZoom = Math.round(optimalZoom * 20) / 20;
      
      console.log(`Auto-Zoom: maxWidth=${maxWidth}, depth=${depth}, viewport=${window.innerWidth}x${window.innerHeight}, zoom=${optimalZoom}`);
      
      setDownlineZoom(optimalZoom);
    } catch (error) {
      console.error("Error fetching downline tree:", error);
      toast.error("Fehler beim Laden der Downline-Struktur");
    } finally {
      setDownlineTreeLoading(false);
    }
  };

  // Spezielle Downline-Ansicht für "Ich" Tab - zeigt User als Root mit allen TP/Kunden
  const handleMyDownlineTreeClick = async () => {
    setDownlineTreeLoading(true);
    setShowDownlineTreeModal(true);
    setSelectedTPForDownline({ name: user?.name || user?.username || 'Ich', typ: 'ich' });
    
    try {
      // Erstelle Baum-Struktur mit User als Root
      const erstlinieKontakte = [...teampartnerList, ...kundenList].filter(tp => tp.linie === "erstlinie" || !tp.linie);
      
      // Rekursive Funktion um Downline zu bauen
      const buildTree = (parentId) => {
        return [...teampartnerList, ...kundenList]
          .filter(tp => tp.linie === parentId)
          .map(tp => ({
            ...tp,
            children: buildTree(tp.id)
          }));
      };
      
      // Root-Node für den User
      const myTree = {
        id: 'user-root',
        name: user?.name || user?.username || 'Ich',
        typ: (teampartnerList.length + kundenList.length) >= 5 ? 'manager' : 'teampartner',
        stufe: (teampartnerList.length + kundenList.length) >= 5 ? 'M' : 'TP',
        isCurrentUser: true,
        children: erstlinieKontakte.map(tp => ({
          ...tp,
          children: buildTree(tp.id)
        }))
      };
      
      setDownlineTree(myTree);
      
      // Berechne optimalen Zoom
      const maxWidth = calculateMaxWidth(myTree);
      const depth = calculateDepth(myTree);
      
      const availableWidth = window.innerWidth * 0.90;
      const availableHeight = window.innerHeight * 0.80;
      
      const requiredWidth = maxWidth * 192;
      const requiredHeight = depth * 170;
      
      const widthZoom = availableWidth / requiredWidth;
      const heightZoom = availableHeight / requiredHeight;
      
      let optimalZoom = Math.min(widthZoom, heightZoom) * 0.85;
      optimalZoom = Math.max(0.2, Math.min(1, optimalZoom));
      optimalZoom = Math.round(optimalZoom * 20) / 20;
      
      setDownlineZoom(optimalZoom);
    } catch (error) {
      console.error("Error building downline tree:", error);
      toast.error("Fehler beim Erstellen der Downline-Struktur");
    } finally {
      setDownlineTreeLoading(false);
    }
  };

  // "Ich" Tab - Bearbeitungsmodus Handler
  const handleStartIchEdit = () => {
    setTempIchData({
      noch_zu_erledigen: user?.noch_zu_erledigen || "",
      notizen: user?.notizen || "",
      empfehlungen: user?.empfehlungen || [],
      produkte_im_abo: user?.produkte_im_abo || [],
      online_live_veranstaltungen: user?.online_live_veranstaltungen || [],
      cellreset_gemacht: user?.cellreset_gemacht || "nein",
      actionpack: user?.actionpack || "nein",
    });
    setIsIchEditMode(true);
  };

  const handleCancelIchEdit = () => {
    setIsIchEditMode(false);
    setTempIchData(null);
  };

  const handleSaveIchEdit = async () => {
    if (!tempIchData) return;
    
    try {
      const response = await axios.put(`${API}/api/auth/me/profile`, tempIchData);
      setUser(response.data);
      setIsIchEditMode(false);
      setTempIchData(null);
      toast.success("Profil gespeichert!");
    } catch (error) {
      console.error("Error saving profile:", error);
      toast.error("Fehler beim Speichern");
    }
  };

  const handleOpenIchFieldEdit = (fieldName, fieldLabel, fieldType, options = null) => {
    setCurrentIchEditField({
      name: fieldName,
      label: fieldLabel,
      type: fieldType,
      options: options,
      value: tempIchData?.[fieldName] || ""
    });
    setShowIchFieldEditModal(true);
  };

  const handleSaveIchField = (value) => {
    if (!currentIchEditField) return;
    
    setTempIchData(prev => ({
      ...prev,
      [currentIchEditField.name]: value
    }));
    setShowIchFieldEditModal(false);
    setCurrentIchEditField(null);
  };

  const handleEdit = (tp) => {
    // Smooth scroll zum Formular mit Offset für Header
    setTimeout(() => {
      if (formRef.current) {
        const yOffset = -180; // Offset für Header/Navigation + Tabs
        const y = formRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 100);
    
    // Wenn Kontakt pausiert ist, zeige nur Pausierung-beenden Modal
    if (tp.pausiert) {
      setPausierterKontakt(tp);
      setShowPausierungModal(true);
      return;
    }
    
    // Normal: Zeige vollständiges Edit-Formular
    setOriginalNaechsterTermin(tp.naechster_termin || ""); // Speichere Original
    setFormData({
      name: tp.name,
      typ: tp.typ,
      linie: tp.linie || "erstlinie",
      naechster_termin: tp.naechster_termin || "",
      naechstes_thema: tp.naechstes_thema || "",
      letzter_termin: tp.letzter_termin || "",
      kontaktiert: tp.kontaktiert,
      termin_hatte: tp.termin_hatte,
      noch_zu_erledigen: normalizeNochZuErledigen(tp.noch_zu_erledigen),
      notizen: tp.notizen || "",
      thematik: tp.thematik || [],
      im_abo: tp.im_abo || [],
      produktempfehlung: tp.produktempfehlung || [],
      actionpack: tp.actionpack || "nein",
      befoerderungs_datum: tp.befoerderungs_datum || "",
      cellreset_gemacht: tp.cellreset_gemacht || "nein",
      einnahmegespraech_erledigt: tp.einnahmegespraech_erledigt || false,
      einnahmegespraech_datum: tp.einnahmegespraech_datum || "",
      followup_3_5_erledigt: tp.followup_3_5_erledigt || false,
      followup_14_erledigt: tp.followup_14_erledigt || false,
      followup_30_erledigt: tp.followup_30_erledigt || false,
      followup_28_erledigt: tp.followup_28_erledigt || false,
      paket_erinnerung_erledigt: tp.paket_erinnerung_erledigt || false,
      tp_kunde_geworden: tp.tp_kunde_geworden,
      online_live_veranstaltungen: tp.online_live_veranstaltungen || [],
      pausiert: false, // Default: nicht pausiert
      pausiert_datum: tp.pausiert_datum || null
    });
    setEditingId(tp.id);
    setShowForm(true);
    // Lokale Telefonnummer laden falls vorhanden
    const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
    setLocalPhone(phones[tp.id] || '');
  };

  // Betreuungs-Modal Handler
  const handleOpenBetreuungsModal = (tp) => {
    setBetreuungsContact({...tp});
    setShowBetreuungsModal(true);
  };

  // Direktes Toggle aus der Karte (für Detail-Modal, kein Popup)
  const handleBetreuungToggleDirect = async (tp, field) => {
    const newValue = !tp[field];
    const updateData = { [field]: newValue };
    if (field === 'einnahmegespraech_erledigt' && newValue && !tp.einnahmegespraech_datum) {
      updateData.einnahmegespraech_datum = new Date().toISOString().split('T')[0];
    }
    try {
      await axios.put(`${API}/api/teampartner/${tp.id}`, updateData);
      const updated = { ...tp, ...updateData };
      setTeampartner(prev => prev.map(t => t.id === tp.id ? { ...t, ...updateData } : t));
      setSelectedTeampartner(prev => prev?.id === tp.id ? { ...prev, ...updateData } : prev);
    } catch (err) {
      toast.error("Fehler beim Speichern");
    }
  };

  const handleKeineBetreuungMehrDirect = async (tp) => {
    const allDone = {
      einnahmegespraech_erledigt: true,
      einnahmegespraech_datum: tp.einnahmegespraech_datum || new Date().toISOString().split('T')[0],
      followup_3_5_erledigt: true,
      followup_14_erledigt: true,
      followup_30_erledigt: true,
      followup_28_erledigt: true,
      paket_erinnerung_erledigt: true,
    };
    try {
      await axios.put(`${API}/api/teampartner/${tp.id}`, allDone);
      setTeampartner(prev => prev.map(t => t.id === tp.id ? { ...t, ...allDone } : t));
      setSelectedTeampartner(prev => prev?.id === tp.id ? { ...prev, ...allDone } : prev);
      toast.success("Betreuung beendet");
    } catch (err) {
      toast.error("Fehler beim Speichern");
    }
  };

  const handleBetreuungToggle = async (field) => {
    if (!betreuungsContact) return;
    const newValue = !betreuungsContact[field];
    const updateData = { [field]: newValue };
    // Einnahmegespräch-Datum automatisch setzen
    if (field === 'einnahmegespraech_erledigt' && newValue && !betreuungsContact.einnahmegespraech_datum) {
      updateData.einnahmegespraech_datum = new Date().toISOString().split('T')[0];
    }
    try {
      await axios.put(`${API}/api/teampartner/${betreuungsContact.id}`, updateData);
      const updated = { ...betreuungsContact, ...updateData };
      setBetreuungsContact(updated);
      setTeampartner(prev => prev.map(tp => tp.id === betreuungsContact.id ? { ...tp, ...updateData } : tp));
      // Auch selectedTeampartner aktualisieren falls Detail-Modal offen
      setSelectedTeampartner(prev => prev?.id === betreuungsContact.id ? { ...prev, ...updateData } : prev);
    } catch (err) {
      toast.error("Fehler beim Speichern");
    }
  };

  const handleKeineBetreuungMehr = async () => {
    if (!betreuungsContact) return;
    const allDone = {
      einnahmegespraech_erledigt: true,
      einnahmegespraech_datum: betreuungsContact.einnahmegespraech_datum || new Date().toISOString().split('T')[0],
      followup_3_5_erledigt: true,
      followup_14_erledigt: true,
      followup_30_erledigt: true,
      followup_28_erledigt: true,
      paket_erinnerung_erledigt: true,
    };
    try {
      await axios.put(`${API}/api/teampartner/${betreuungsContact.id}`, allDone);
      const updated = { ...betreuungsContact, ...allDone };
      setBetreuungsContact(updated);
      setTeampartner(prev => prev.map(tp => tp.id === betreuungsContact.id ? { ...tp, ...allDone } : tp));
      // Auch selectedTeampartner aktualisieren falls Detail-Modal offen
      setSelectedTeampartner(prev => prev?.id === betreuungsContact.id ? { ...prev, ...allDone } : prev);
      toast.success("Betreuung beendet");
      setShowBetreuungsModal(false);
    } catch (err) {
      toast.error("Fehler beim Speichern");
    }
  };

  const handlePausierungBeenden = async () => {
    // ERST in der Datenbank entpausieren
    const tp = pausierterKontakt;
    
    try {
      const resp = await axios.put(`${API}/api/teampartner/${tp.id}`, { pausiert: false });
      toast.success("Pausierung beendet!");
      // Demotion-Toast (sollte beim Unpausieren selten relevant sein, aber theoretisch möglich)
      const demo = resp?.data?.auto_demotion;
      if (demo) toast.info(`📉 ${demo.name}: ${demo.from} → ${demo.to} (${demo.downline_count} aktive Downline)`);
      // Promotion-Toast: Wenn der Upline durch das Reaktivieren wieder über 5 kommt
      const promo = resp?.data?.auto_promotion;
      if (promo) toast.success(`🎉 ${promo.name} wurde von ${promo.from} auf ${promo.to} befördert!`);
      
      // Modal schließen
      setShowPausierungModal(false);
      setPausierterKontakt(null);
      
      // Daten neu laden
      await fetchTeampartner();
      
      // DANN Edit-Modal öffnen mit aktualisierten Daten
      const aktualisierterTP = { ...tp, pausiert: false };
      setFormData({
        name: aktualisierterTP.name || "",
        typ: aktualisierterTP.typ || "kaltkontakt",
        stufe: aktualisierterTP.stufe || "keine",
        linie: aktualisierterTP.linie || "erstlinie",
        thematik: aktualisierterTP.thematik || [],
        im_abo: aktualisierterTP.im_abo || [],
        produktempfehlung: aktualisierterTP.produktempfehlung || [],
        naechster_termin: aktualisierterTP.naechster_termin || "",
        thema: aktualisierterTP.thema || "",
        letzter_termin: aktualisierterTP.letzter_termin || "",
        noch_zu_erledigen: aktualisierterTP.noch_zu_erledigen || "",
        actionpack: aktualisierterTP.actionpack || "nein",
        cellreset_gemacht: aktualisierterTP.cellreset_gemacht || "nein",
        online_live_veranstaltungen: aktualisierterTP.online_live_veranstaltungen || [],
        notizen: aktualisierterTP.notizen || "",
        kontaktiert: aktualisierterTP.kontaktiert || false,
        tp_kunde_geworden: aktualisierterTP.tp_kunde_geworden || false,
        befoerderungs_datum: aktualisierterTP.befoerderungs_datum || "",
        einnahmegespraech_datum: aktualisierterTP.einnahmegespraech_datum || "",
        betreuung: aktualisierterTP.betreuung || {
          einnahmegespraech_erledigt: false,
          "10_tage_follow_up_erledigt": false,
          "30_tage_follow_up_erledigt": false,
          "60_tage_follow_up_erledigt": false,
          cellreset_antworten: "nein"
        },
        paket_erinnerung_erledigt: aktualisierterTP.paket_erinnerung_erledigt || false,
        pausiert: false,
        pausiert_datum: aktualisierterTP.pausiert_datum || null
      });
      
      // Edit-Modus aktivieren
      setEditingId(tp.id);
      setShowForm(true);
    } catch (error) {
      toast.error("Fehler beim Entpausieren");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Teampartner wirklich löschen?")) return;
    
    try {
      const resp = await axios.delete(`${API}/api/teampartner/${id}`);
      toast.success("Teampartner gelöscht");
      const demo = resp?.data?.auto_demotion;
      if (demo) toast.info(`📉 ${demo.name} wurde von ${demo.from} auf ${demo.to} zurückgestuft (nur noch ${demo.downline_count} aktive Downline).`);
      fetchTeampartner();
    } catch (error) {
      toast.error("Fehler beim Löschen");
      console.error(error);
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      typ: "kaltkontakt",
      linie: "erstlinie",
      naechster_termin: "",
      naechstes_thema: "",
      letzter_termin: "",
      kontaktiert: false,
      termin_hatte: false,
      noch_zu_erledigen: [],
      notizen: "",
      thematik: [],
      im_abo: [],
      produktempfehlung: [],
      actionpack: "nein",
      befoerderungs_datum: "",
      cellreset_gemacht: "nein",
      einnahmegespraech_erledigt: false,
      einnahmegespraech_datum: "",
      followup_3_5_erledigt: false,
      followup_14_erledigt: false,
      followup_30_erledigt: false,
      paket_erinnerung_erledigt: false,
      tp_kunde_geworden: null,
      online_live_veranstaltungen: [],
      pausiert: false,
      pausiert_datum: null
    });
    setEditingId(null);
    setShowForm(false);
    setLinieSearch("");
    setShowLinieDropdown(false);
    setLocalPhone("");
  };

  const handlePromote = (tp) => {
    setPromotingTeampartner(tp);
    setShowPromoteModal(true);
  };

  const confirmPromotion = async (newStufe) => {
    if (!promotingTeampartner) return;
    
    try {
      const response = await axios.post(`${API}/api/teampartner/${promotingTeampartner.id}/befoerdern?new_stufe=${newStufe}`);
      
      // Show celebration modal for manual promotion too
      if (response.data.promoted) {
        setPromotionData(response.data);
        setShowPromotionCelebration(true);
      }
      
      toast.success(`Erfolgreich zu ${newStufe} befördert!`);
      setShowPromoteModal(false);
      setPromotingTeampartner(null);
      fetchTeampartner();
      loadNotifications(); // Reload notifications to show new promotion
    } catch (error) {
      toast.error("Fehler bei der Beförderung");
      console.error(error);
    }
  };

  // Prüft Terminüberschneidungen in zielplanung_appointments
  const checkDtOverlap = (date, startTime, endTime) => {
    const appointments = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
    return appointments.find(apt =>
      apt.date === date && !apt.isMultiDay &&
      apt.startTime < endTime && apt.endTime > startTime
    ) || null;
  };

  const openDateTimePicker = () => {
    // WARN: Wenn bereits ein ZUKÜNFTIGER, verlinkter Kalender-Termin für diesen Kontakt existiert
    //       → Modal anzeigen bevor der Wizard startet
    const contactId = editingId || tempEditData?.id;
    if (contactId) {
      try {
        const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
        const linked = apts.find(a => a.contactRef?.id === contactId && !a.contactRef?.taskId);
        if (linked && linked.date && linked.startTime) {
          const apptDt = new Date(`${linked.date}T${linked.startTime}:00`);
          if (!isNaN(apptDt) && apptDt.getTime() > Date.now()) {
            // Zukünftiger Termin → Warnung zeigen
            setExistingApptToReplace(linked);
            setShowReplaceApptWarning(true);
            return;
          }
        }
      } catch { /* ignore */ }
    }
    openDateTimePickerInternal();
  };

  const openDateTimePickerInternal = () => {
    if (formData.naechster_termin) {
      const dt = new Date(formData.naechster_termin);
      setTempDate(dt.toISOString().split('T')[0]);
      const sh = dt.toTimeString().slice(0, 5);
      setDtStartTime(sh);
      const endH = Math.min(dt.getHours() + 1, 23);
      setDtEndTime(`${String(endH).padStart(2, '0')}:${dt.toTimeString().slice(3, 5)}`);
    } else {
      setTempDate("");
      setDtStartTime("10:00");
      setDtEndTime("11:00");
    }
    setDtOverlapError("");
    setDtColor("yellow");
    setDtPriority(5);
    setDtNote("");
    setDtShowColorPicker(false);
    setDtLetzterOption("heute");
    setDtLetzterCustom("");
    setDtWurdeKontaktiert(null);
    setDtAltesThema(formData.naechstes_thema || "");
    setDtThemaUhrzeitMode("aktuell");
    setDtThemaManuelleUhrzeit("");
    setDtNeuesThema("");
    setDateTimeStep(1);
    setDtIsErsterTermin(!editingId && formData.kontaktiert === false);
    setShowDateTimePicker(true);
  };

  const handleDateTimeNext = () => {
    if (dateTimeStep === 1 && tempDate && dtStartTime && dtEndTime) {
      if (dtEndTime <= dtStartTime) {
        setDtOverlapError("Endzeit muss nach Startzeit liegen");
        return;
      }
      const overlap = checkDtOverlap(tempDate, dtStartTime, dtEndTime);
      if (overlap) {
        setDtOverlapError(`Überschneidung mit "${overlap.title}" (${overlap.startTime}–${overlap.endTime})`);
        return;
      }
      setDtOverlapError("");
      const combined = `${tempDate}T${dtStartTime}`;
      setFormData(prev => ({ ...prev, naechster_termin: combined }));
      if (naechsterTerminModalIsDetail) {
        setTempEditData(prev => ({ ...prev, naechster_termin: combined }));
      }
      // Bei Teampartner/Kunde: "Schon kontaktiert?"-Frage überspringen
      // (ist offensichtlich – bestehende Beziehung). Auch kontaktiert=true setzen.
      const typ = naechsterTerminModalIsDetail ? tempEditData?.typ : formData.typ;
      const skipKontaktFrage = typ === 'teampartner' || typ === 'kunde';
      if (skipKontaktFrage) {
        setFormData(prev => ({ ...prev, kontaktiert: true }));
        if (naechsterTerminModalIsDetail) setTempEditData(prev => ({ ...prev, kontaktiert: true }));
        setDateTimeStep(4);
        return;
      }
      const isNichtKontaktiert = naechsterTerminModalIsDetail
        ? tempEditData?.kontaktiert === false
        : formData.kontaktiert === false;
      setDateTimeStep(isNichtKontaktiert ? 3 : 4);
    }
  };

  const handleDateTimeConfirm = () => {
    if (tempDate && tempTime) {
      const combined = `${tempDate}T${tempTime}`;
      setFormData(prev => ({ ...prev, naechster_termin: combined }));
      if (naechsterTerminModalIsDetail) {
        setTempEditData(prev => ({ ...prev, naechster_termin: combined }));
      }
      // Bei Teampartner/Kunde: Schritt 3 überspringen (siehe handleDateTimeNext)
      const typ = naechsterTerminModalIsDetail ? tempEditData?.typ : formData.typ;
      const skipKontaktFrage = typ === 'teampartner' || typ === 'kunde';
      if (skipKontaktFrage) {
        setFormData(prev => ({ ...prev, kontaktiert: true }));
        if (naechsterTerminModalIsDetail) setTempEditData(prev => ({ ...prev, kontaktiert: true }));
        setDateTimeStep(4);
        return;
      }
      // Schritt 3 nur wenn Kontakt noch nicht hergestellt (kontaktiert === false)
      const isNichtKontaktiert = naechsterTerminModalIsDetail
        ? tempEditData?.kontaktiert === false
        : formData.kontaktiert === false;
      if (isNichtKontaktiert) {
        setDateTimeStep(3);
      } else {
        setDateTimeStep(4); // direkt zu "Zuletzt kontaktiert"
      }
    }
  };

  const handleDateTimeFinish = () => {
    // Schritt 3: Zuletzt kontaktiert ins formData schreiben
    const today = new Date().toISOString().split('T')[0];
    const letzterVal = dtLetzterOption === "heute" ? today
      : dtLetzterOption === "custom" ? dtLetzterCustom
      : null;
    if (letzterVal) {
      setFormData(prev => ({ ...prev, letzter_termin: letzterVal }));
    }
    setShowDateTimePicker(false);
    setDateTimeStep(1);
  };

  const handleDateTimeCancel = () => {
    setShowDateTimePicker(false);
    setDateTimeStep(1);
    setTempDate("");
    setTempTime("");
    setDtStartTime("10:00");
    setDtEndTime("11:00");
    setDtOverlapError("");
    setDtColor("yellow");
    setDtPriority(5);
    setDtNote("");
    setDtShowColorPicker(false);
    setNaechsterTerminModalIsDetail(false);
    setDtIsErsterTermin(false);
  };

  // Thematik Handler
  const toggleThematik = (thema) => {
    setFormData(prev => ({
      ...prev,
      thematik: prev.thematik.includes(thema)
        ? prev.thematik.filter(t => t !== thema)
        : [...prev.thematik, thema]
    }));
  };

  const addEigenesThema = () => {
    if (neuesThema.trim() && !formData.thematik.includes(neuesThema.trim())) {
      setFormData(prev => ({
        ...prev,
        thematik: [...prev.thematik, neuesThema.trim()]
      }));
      setNeuesThema("");
    }
  };

  // Produkt Handler
  const toggleProduktAbo = (produktId) => {
    setFormData(prev => {
      const newImAbo = prev.im_abo.includes(produktId)
        ? prev.im_abo.filter(id => id !== produktId)
        : [...prev.im_abo, produktId];
      
      // Wenn Produkt im Abo ist, aus Empfehlungen entfernen
      const newEmpfehlungen = newImAbo.includes(produktId)
        ? prev.produktempfehlung.filter(id => id !== produktId)
        : prev.produktempfehlung;
      
      return {
        ...prev,
        im_abo: newImAbo,
        produktempfehlung: newEmpfehlungen
      };
    });
  };

  const toggleProduktEmpfehlung = (produktId) => {
    // Nur hinzufügen wenn nicht im Abo
    if (!formData.im_abo.includes(produktId)) {
      setFormData(prev => ({
        ...prev,
        produktempfehlung: prev.produktempfehlung.includes(produktId)
          ? prev.produktempfehlung.filter(id => id !== produktId)
          : [...prev.produktempfehlung, produktId]
      }));
    }
  };

  // Thematik-Manager Handler
  const addGlobaleThematik = async () => {
    if (neueGlobaleThematik.trim() && !THEMATIK_OPTIONEN.includes(neueGlobaleThematik.trim())) {
      try {
        const response = await axios.post(`${API}/api/thematik`, {
          thema: neueGlobaleThematik.trim()
        });
        setCustomThematikOptionen(response.data.custom_thematik);
        setNeueGlobaleThematik("");
        toast.success("Thematik hinzugefügt!");
      } catch (error) {
        toast.error(error.response?.data?.detail || "Fehler beim Hinzufügen");
      }
    }
  };

  const removeGlobaleThematik = async (thema) => {
    // Nur Custom-Themen können gelöscht werden, nicht die Standard-Themen
    if (DEFAULT_THEMATIK_OPTIONEN.includes(thema)) {
      toast.error("Standard-Themen können nicht gelöscht werden");
      return;
    }
    try {
      const response = await axios.delete(`${API}/api/thematik`, {
        data: { thema }
      });
      setCustomThematikOptionen(response.data.custom_thematik);
      toast.success("Thematik entfernt!");
    } catch (error) {
      toast.error("Fehler beim Entfernen");
    }
  };

  const handleCardClick = (tp) => {
    const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
    const index = allItems.findIndex(item => item.id === tp.id);
    setModalIndex(index);
    setSelectedTeampartner(tp);
    setIsNotificationMode(false); // Deaktiviere Nachrichten-Modus
    setShowDetailModal(true);
  };

  const navigateModal = (direction) => {
    const allItems = isNotificationMode ? notificationList : [...kaltkontakte, ...teampartnerList, ...kundenList];
    let newIndex = modalIndex + direction;
    
    if (newIndex < 0) newIndex = 0;
    if (newIndex >= allItems.length) newIndex = allItems.length - 1;
    
    setModalIndex(newIndex);
    setSelectedTeampartner(allItems[newIndex]);
  };

  // Tinder-Style Wisch-Handler
  const handleTouchStart = (e) => {
    if (isAnimating) return;
    const touch = e.targetTouches[0];
    setTouchStart(touch.clientX);
    setTouchEnd(touch.clientY); // Y-Position für Scroll-Erkennung speichern
  };

  const handleTouchMove = (e) => {
    if (!touchStart || isAnimating) return;
    
    const touch = e.targetTouches[0];
    const currentX = touch.clientX;
    const currentY = touch.clientY;
    const deltaX = currentX - touchStart;
    const deltaY = currentY - (touchEnd || currentY);
    
    // Nur als Swipe werten wenn horizontale Bewegung DEUTLICH größer als vertikale
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 1.5 && Math.abs(deltaX) > 30;
    
    if (isHorizontalSwipe) {
      // Horizontales Wischen - Animation aktivieren
      if (!isSwiping) {
        setIsSwiping(true);
      }
      setCurrentSwipeDistance(deltaX);
      // Scrollen verhindern während Swipe
      e.preventDefault();
    } else if (!isSwiping) {
      // Vertikales Scrollen - Swipe nicht aktivieren
      return;
    }
  };

  const handleTouchEnd = () => {
    // IMMER zur Mitte zurückkehren wenn kein echter Swipe stattfand
    if (!isSwiping) {
      setCurrentSwipeDistance(0);
      setTouchStart(0);
      setTouchEnd(0);
      return;
    }
    
    const minSwipeDistance = 100;
    const allItems = isNotificationMode ? notificationList : [...kaltkontakte, ...teampartnerList, ...kundenList];
    
    setIsSwiping(false);
    
    // Prüfen ob Wisch weit genug ist
    if (Math.abs(currentSwipeDistance) > minSwipeDistance) {
      
      if (currentSwipeDistance < 0 && modalIndex < allItems.length - 1) {
        // Nach links gewischt - zur nächsten Karte
        setIsAnimating(true);
        setCurrentSwipeDistance(-1000); // Alte Karte nach links raus
        
        setTimeout(() => {
          // Daten zur nächsten Karte ändern
          navigateModal(1);
          
          // Transition deaktivieren und neue Karte sofort rechts positionieren
          setSkipTransition(true);
          requestAnimationFrame(() => {
            setCurrentSwipeDistance(1000); // Neue Karte rechts (ohne Animation!)
            
            requestAnimationFrame(() => {
              // Transition wieder aktivieren
              setSkipTransition(false);
              
              requestAnimationFrame(() => {
                setCurrentSwipeDistance(0); // Zur Mitte animieren
              });
            });
          });
          
          // Sicherheits-Timeout zum Zurücksetzen
          setTimeout(() => {
            setIsAnimating(false);
            setSkipTransition(false);
          }, 250);
        }, 200);
        
      } else if (currentSwipeDistance > 0 && modalIndex > 0) {
        // Nach rechts gewischt - zur vorherigen Karte
        setIsAnimating(true);
        setCurrentSwipeDistance(1000); // Alte Karte nach rechts raus
        
        setTimeout(() => {
          // Daten zur vorherigen Karte ändern
          navigateModal(-1);
          
          // Transition deaktivieren und neue Karte sofort links positionieren
          setSkipTransition(true);
          requestAnimationFrame(() => {
            setCurrentSwipeDistance(-1000); // Neue Karte links (ohne Animation!)
            
            requestAnimationFrame(() => {
              // Transition wieder aktivieren
              setSkipTransition(false);
              
              requestAnimationFrame(() => {
                setCurrentSwipeDistance(0); // Zur Mitte animieren
              });
            });
          });
          
          // Sicherheits-Timeout zum Zurücksetzen
          setTimeout(() => {
            setIsAnimating(false);
            setSkipTransition(false);
          }, 250);
        }, 200);
        
      } else {
        // Nicht weit genug oder am Rand - zurückschnappen
        setCurrentSwipeDistance(0);
        setIsAnimating(false);
      }
    } else {
      // Zurück zur Mitte schnappen
      setCurrentSwipeDistance(0);
      setIsAnimating(false);
    }
    
    setTouchStart(0);
    setTouchEnd(0);
    setIsSwiping(false);
  };

  const handleButtonNavigation = (direction) => {
    if (isAnimating) return;
    
    const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
    
    // Grenzen prüfen
    if (direction === 1 && modalIndex >= allItems.length - 1) return;
    if (direction === -1 && modalIndex <= 0) return;
    
    setIsAnimating(true);
    
    // direction 1 = weiter (nach links wischen)
    // direction -1 = zurück (nach rechts wischen)
    setCurrentSwipeDistance(direction === 1 ? -1000 : 1000);
    
    setTimeout(() => {
      // Daten ändern
      navigateModal(direction);
      
      // Transition deaktivieren und neue Karte sofort auf der gegenüberliegenden Seite positionieren
      setSkipTransition(true);
      requestAnimationFrame(() => {
        // Neue Karte von der anderen Seite
        setCurrentSwipeDistance(direction === 1 ? 1000 : -1000);
        
        requestAnimationFrame(() => {
          // Transition wieder aktivieren
          setSkipTransition(false);
          
          requestAnimationFrame(() => {
            setCurrentSwipeDistance(0); // Zur Mitte animieren
          });
        });
      });
      
      // Sicherheits-Timeout zum Zurücksetzen
      setTimeout(() => {
        setIsAnimating(false);
        setSkipTransition(false);
      }, 250);
    }, 200);
  };

  // Teampartner für Linien-Dropdown filtern
  const filteredForLinie = teampartner.filter(tp => 
    tp.typ === "teampartner" && 
    tp.name.toLowerCase().includes(linieSearch.toLowerCase()) &&
    tp.id !== editingId // Sich selbst ausschließen
  );

  const kaltkontakte = filteredTeampartner.filter(tp => tp.typ === "kaltkontakt");
  const teampartnerList = filteredTeampartner.filter(tp => tp.typ === "teampartner");
  const kundenList = filteredTeampartner.filter(tp => tp.typ === "kunde");

  // Kunden-Suche Funktion
  const handleKundenSuche = () => {
    if (!kundenSuche.trim()) return;
    
    // Durch alle Listen suchen
    const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
    const found = allItems.find(item => 
      item.name.toLowerCase().includes(kundenSuche.toLowerCase())
    );
    
    if (found) {
      // Modal mit gefundenem Item öffnen
      const index = allItems.indexOf(found);
      setModalIndex(index);
      setSelectedTeampartner(found);
      setShowDetailModal(true);
      setKundenSuche(""); // Suchfeld leeren
    } else {
      toast.error("Kein Kontakt mit diesem Namen gefunden");
    }
  };
  
  // Kaltkontakt Termin Follow-up Handler
  const handleKaltkontaktTerminFollow = (kaltkontakt) => {
    setSelectedKaltkontakt(kaltkontakt);
    setShowKaltkontaktModal(true);
  };
  
  const handleKaltkontaktEntscheidung = async (action) => {
    if (action === 'tp' || action === 'kunde') {
      // Speichere den gewählten Typ und zeige Frage-Modal
      setSelectedKaltkontaktTyp(action);
      setShowKaltkontaktModal(false);
      setShowKaltkontaktFrageModal(true);
    } else {
      // Keines von beidem - zeige Sub-Modal mit Wizard (Datum → Uhrzeit → Zuletzt → Verlauf → Thema)
      setKaltkontaktAction('nein');
      setShowKaltkontaktModal(false);
      setNeuerTerminDatum("");
      setNeuerTerminUhrzeit("10:00");
      setKkSubStep(1);
      setKkLetzterOption("heute");
      setKkLetzterCustom("");
      setKkThemaUhrzeitMode("aktuell");
      setKkThemaManuelleUhrzeit("");
      setKkNeuesThema("");
      setKkGespraechsFreitext(selectedKaltkontakt?.naechstes_thema || ""); // Altes Thema vorausfüllen
      setShowKaltkontaktSubModal(true);
    }
  };
  
  const handleKaltkontaktUeberspringen = async () => {
    try {
      const updateData = {
        typ: selectedKaltkontaktTyp === 'tp' ? 'teampartner' : 'kunde',
        stufe: selectedKaltkontaktTyp === 'tp' ? 'TP' : 'keine',
        befoerderungs_datum: new Date().toISOString().split('T')[0]
      };
      await axios.put(`${API}/api/teampartner/${selectedKaltkontakt.id}`, updateData);
      
      // Zeige Willkommens-Celebration
      setWelcomeData({
        name: selectedKaltkontakt.name,
        typ: updateData.typ
      });
      setShowWelcomeCelebration(true);
      
      toast.success(`Als ${selectedKaltkontaktTyp === 'tp' ? 'Teampartner' : 'Kunde'} befördert!`);
      setShowKaltkontaktFrageModal(false);
      setSelectedKaltkontakt(null);
      setSelectedKaltkontaktTyp(null);
      fetchTeampartner();
    } catch (error) {
      toast.error("Fehler beim Befördern");
    }
  };
  
  const handleKaltkontaktDetailsHinzufuegen = () => {
    // Berechne Einnahmegespräch-Datum (heute + 5 Tage)
    const einnahmeTermin = new Date();
    einnahmeTermin.setDate(einnahmeTermin.getDate() + 5);
    const einnahmeTerminStr = einnahmeTermin.toISOString().split('T')[0];
    
    // Initialisiere Formular mit existierenden Daten
    setFormData({
      ...selectedKaltkontakt,
      typ: selectedKaltkontaktTyp === 'tp' ? 'teampartner' : 'kunde',
      stufe: selectedKaltkontaktTyp === 'tp' ? 'TP' : 'keine',
      befoerderungs_datum: new Date().toISOString().split('T')[0],
      naechster_termin: einnahmeTerminStr,
      thema: "Einnahmegespräch",
      einnahmegespraech_datum: selectedKaltkontakt.einnahmegespraech_datum || ""
    });
    
    setShowKaltkontaktFrageModal(false);
    setShowKaltkontaktDetailsModal(true);
  };
  
  const handleKaltkontaktDetailsSpeichern = async () => {
    try {
      const response = await axios.put(`${API}/api/teampartner/${selectedKaltkontakt.id}`, formData);
      const updatedTP = response.data;
      
      // Zeige Willkommens-Celebration
      setWelcomeData({
        name: selectedKaltkontakt.name,
        typ: formData.typ
      });
      setShowWelcomeCelebration(true);
      
      toast.success(`Als ${selectedKaltkontaktTyp === 'tp' ? 'Teampartner' : 'Kunde'} befördert und Details gespeichert!`);
      
      // ERST alle Kaltkontakt Modals schließen
      setShowKaltkontaktDetailsModal(false);
      setShowKaltkontaktFrageModal(false);
      setShowKaltkontaktModal(false);
      setShowKaltkontaktSubModal(false);
      setSelectedKaltkontakt(null);
      setSelectedKaltkontaktTyp(null);
      
      // DANN Detail-Modal öffnen
      setSelectedTeampartner(updatedTP);
      setShowDetailModal(true);
      
      // Lade Daten im Hintergrund neu
      fetchTeampartner();
    } catch (error) {
      toast.error("Fehler beim Speichern");
    }
  };
  
  const handleKaltkontaktSubFinalize = async () => {
    try {
      const combined = `${neuerTerminDatum}T${neuerTerminUhrzeit}`;
      const today = new Date().toISOString().split('T')[0];
      const letzterVal = kkLetzterOption === "heute" ? today
        : kkLetzterOption === "custom" ? kkLetzterCustom : null;
      
      const updateData = { naechster_termin: combined, naechstes_thema: kkNeuesThema };
      if (letzterVal) updateData.letzter_termin = letzterVal;

      // Altes Thema archivieren (oder Freitext wenn kein altes Thema)
      const themaToArchive = selectedKaltkontakt?.naechstes_thema?.trim() || kkGespraechsFreitext?.trim();
      if (kkThemaUhrzeitMode !== "nein" && themaToArchive && letzterVal) {
        const res = await axios.get(`${API}/api/teampartner/${selectedKaltkontakt.id}`);
        const vergangeneThemen = res.data.vergangene_themen || [];
        const now = new Date();
        const uhrzeitPart = kkThemaUhrzeitMode === "aktuell"
          ? `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`
          : (kkThemaManuelleUhrzeit || "12:00");
        vergangeneThemen.push({ datum: `${neuerTerminDatum}T${uhrzeitPart}`, thema: themaToArchive });
        updateData.vergangene_themen = vergangeneThemen;
      }

      await axios.put(`${API}/api/teampartner/${selectedKaltkontakt.id}`, updateData);
      toast.success("Termin gespeichert");
      setShowKaltkontaktSubModal(false);
      setSelectedKaltkontakt(null);
      fetchTeampartner();
    } catch (error) {
      toast.error("Fehler beim Speichern");
    }
  };

  const handleKaltkontaktSubAction = async (subAction) => {
    try {
      if (subAction === 'pausieren') {
        await axios.put(`${API}/api/teampartner/${selectedKaltkontakt.id}`, { pausiert: true });
        toast.success("Kontakt pausiert");
        setShowKaltkontaktSubModal(false);
        setSelectedKaltkontakt(null);
        fetchTeampartner();
      } else if (subAction === 'loeschen') {
        if (window.confirm(`${selectedKaltkontakt.name} wirklich löschen?`)) {
          await axios.delete(`${API}/api/teampartner/${selectedKaltkontakt.id}`);
          toast.success("Kontakt gelöscht");
          setShowKaltkontaktSubModal(false);
          setSelectedKaltkontakt(null);
          fetchTeampartner();
        }
      }
    } catch (error) {
      toast.error("Fehler bei der Aktion");
    }
  };

  // Erweiterte Such-Filter Logik
  const applyErweiterteSucheFilter = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    const filter = erweiterteSucheFilter;
    
    return data.filter(tp => {
      // Überspringe ungültige Objekte
      if (!tp || !tp.id) return false;
      // Name-Filter
      if (filter.name && !tp.name.toLowerCase().includes(filter.name.toLowerCase())) {
        return false;
      }
      
      // Typ-Filter (Kontakt = kaltkontakt)
      if (filter.typen.length > 0 && !filter.typen.includes(tp.typ)) {
        return false;
      }
      
      // Stufe-Filter
      if (filter.stufen.length > 0 && !filter.stufen.includes(tp.stufe)) {
        return false;
      }
      
      // Linie-Filter
      if (filter.linie && filter.linie !== "alle" && tp.linie !== filter.linie) {
        return false;
      }
      
      // Thematik-Filter
      if (filter.thematik.length > 0) {
        if (!tp.thematik || !tp.thematik.some(t => filter.thematik.includes(t))) {
          return false;
        }
      }
      
      // Produkte im Abo Filter
      if (filter.produkte_im_abo.length > 0) {
        if (!tp.im_abo || !tp.im_abo.some(p => filter.produkte_im_abo.includes(p))) {
          return false;
        }
      }
      
      // Veranstaltungen Filter
      if (filter.veranstaltungen.length > 0) {
        if (!tp.online_live_veranstaltungen || !tp.online_live_veranstaltungen.some(v => filter.veranstaltungen.includes(v))) {
          return false;
        }
      }
      
      // Termin-Status Filter
      if (filter.termin_status !== "alle") {
        if (!tp.naechster_termin) return false;
        
        const now = new Date();
        const futureDate = new Date(tp.naechster_termin);
        const diffTime = futureDate - now;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        
        if (filter.termin_status === "ueberfaellig") {
          if (diffTime >= 0) return false; // Nicht überfällig
        } else if (filter.termin_status === "heute") {
          if (diffDays !== 0) return false; // Nicht heute
        } else if (filter.termin_status === "bald_1_3") {
          if (diffDays < 1 || diffDays > 3) return false;
        } else if (filter.termin_status === "bald_4_7") {
          if (diffDays < 4 || diffDays > 7) return false;
        } else if (filter.termin_status === "zukuenftig") {
          if (diffDays <= 7) return false;
        }
      }
      
      // Kontakt-Status Filter (basierend auf letzter_termin)
      if (filter.kontakt_status !== "alle") {
        if (!tp.letzter_termin) return false;
        
        const heute = new Date();
        const letzterKontakt = new Date(tp.letzter_termin);
        const diffMs = heute - letzterKontakt;
        const diffTage = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        
        // Kritisch: >60 Tage
        if (filter.kontakt_status === "kritisch" && diffTage <= 60) {
          return false;
        }
        // Warnung: 31-60 Tage
        if (filter.kontakt_status === "warnung" && (diffTage < 31 || diffTage > 60)) {
          return false;
        }
        // Aktuell: <=30 Tage
        if (filter.kontakt_status === "aktuell" && diffTage > 30) {
          return false;
        }
      }
      
      // Actionpack-Filter
      if (filter.actionpack.length > 0) {
        if (!tp.actionpack || !filter.actionpack.includes(tp.actionpack)) {
          return false;
        }
      }
      
      // Cellreset-Filter
      if (filter.cellreset.length > 0) {
        const cellresetValue = tp.cellreset_gemacht || "nein";
        if (!filter.cellreset.includes(cellresetValue)) {
          return false;
        }
      }
      
      // Noch nicht kontaktiert Filter (nur für Kaltkontakte)
      if (filter.noch_nicht_kontaktiert) {
        if (tp.typ !== "kaltkontakt" || tp.kontaktiert) {
          return false;
        }
      }
      
      return true;
    });
  };

  // Zurücksetzen der erweiterten Such-Filter
  const resetErweiterteSucheFilter = () => {
    setErweiterteSucheFilter({
      name: "",
      typen: [],
      stufen: [],
      linie: "",
      thematik: [],
      produkte_im_abo: [],
      veranstaltungen: [],
      termin_status: "alle",
      kontakt_status: "alle",
      actionpack: [],
      cellreset: [],
      noch_nicht_kontaktiert: false
    });
  };

  // Sortierlogik
  const sortData = (data) => {
    const sorted = [...data];
    
    switch(datenSortMode) {
      case "id":
        // Standard - keine Sortierung, original Reihenfolge
        return sorted;
        
      case "name":
        return sorted.sort((a, b) => a.name.localeCompare(b.name));
        
      case "termin":
        // Nach nächstem Termin sortieren - aktuellste zuerst
        return sorted.sort((a, b) => {
          const dateA = a.naechster_termin ? new Date(a.naechster_termin) : new Date(9999, 11, 31);
          const dateB = b.naechster_termin ? new Date(b.naechster_termin) : new Date(9999, 11, 31);
          return dateA - dateB;
        });
        
      case "kontaktiert_neu":
        // Kürzlich kontaktiert zuerst (neueste zuerst); ohne Datum → ganz unten
        return sorted.sort((a, b) => {
          const dateA = a.letzter_termin ? new Date(a.letzter_termin).getTime() : -Infinity;
          const dateB = b.letzter_termin ? new Date(b.letzter_termin).getTime() : -Infinity;
          return dateB - dateA; // Absteigend
        });

      case "kontaktiert_alt":
        // Schon lange kein Kontakt zuerst (älteste zuerst); ohne Datum → ganz oben
        return sorted.sort((a, b) => {
          const dateA = a.letzter_termin ? new Date(a.letzter_termin).getTime() : -Infinity;
          const dateB = b.letzter_termin ? new Date(b.letzter_termin).getTime() : -Infinity;
          return dateA - dateB; // Aufsteigend
        });
        
      case "nicht_kontaktiert":
        // Noch nicht kontaktiert zuerst (kontaktiert === false)
        return sorted.sort((a, b) => {
          const aKontaktiert = a.kontaktiert === true ? 1 : 0;
          const bKontaktiert = b.kontaktiert === true ? 1 : 0;
          return aKontaktiert - bKontaktiert;
        });
        
      case "schulden":
        // Nach Schuldenfälligkeit - nächste Fälligkeit zuerst
        return sorted.sort((a, b) => {
          // Finde früheste offene Schuld für Person A
          const schuldenA = alleSchulden.filter(s => 
            s.status === "offen" && 
            (s.teampartner_id === a.id || s.name === a.name)
          );
          const minDateA = schuldenA.length > 0 
            ? Math.min(...schuldenA.map(s => new Date(s.faelligkeitsdatum).getTime()))
            : new Date(9999, 11, 31).getTime();
          
          // Finde früheste offene Schuld für Person B
          const schuldenB = alleSchulden.filter(s => 
            s.status === "offen" && 
            (s.teampartner_id === b.id || s.name === b.name)
          );
          const minDateB = schuldenB.length > 0 
            ? Math.min(...schuldenB.map(s => new Date(s.faelligkeitsdatum).getTime()))
            : new Date(9999, 11, 31).getTime();
          
          return minDateA - minDateB;
        });
        
      default:
        return sorted;
    }
  };

  // Sortierte Listen
  const sortedKaltkontakte = sortData(kaltkontakte);
  const sortedTeampartner = sortData(teampartnerList);
  const sortedKunden = sortData(kundenList);

  // Helper: Format "10" oder "10(1)" wenn pausierte/gekündigte vorhanden
  // Kontakt gilt als "pausiert" wenn Feld pausiert === true
  const formatCount = (list) => {
    const total = list.length;
    const paused = list.filter(t => t?.pausiert === true).length;
    return paused > 0 ? `${total}(${paused})` : `${total}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Interactive Tour - ganz oben! */}
      <InteractiveTour 
        user={user}
        manualStart={showTourManual}
        onComplete={() => {
          if (user) {
            setUser({...user, tour_completed: true});
          }
          setShowTourManual(false);
        }} 
      />

      {/* Zu erledigen Modal */}
      <ZuErledigienModal
        isOpen={showZuErledigienModal}
        onClose={() => { setShowZuErledigienModal(false); setZuErledigienTarget(null); }}
        onSave={handleSaveZuErledigienTask}
        contactName={zuErledigienTarget?.name}
        contactId={zuErledigienTarget?.id}
        contactTyp={zuErledigienTarget?.typ}
      />
      
      {/* Header + Tabs - alles zusammen sticky */}
      <div className="bg-white border-b border-slate-200 shadow-sm sticky top-0 z-50">
        {/* Header Section */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">
            <div className="flex items-center justify-between gap-3 flex-1 min-w-0">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg md:text-2xl font-bold text-slate-800 truncate">Teampartner</h1>
                <p className="text-slate-500 text-xs md:text-sm">Teampartner & Neue Kontakte verwalten</p>
              </div>
              {/* Logo rechts neben der Überschrift - immer sichtbar */}
              <Link to="/main-hub" title="Zu Mein Business">
                <img 
                  src="/burningteam-logo.png" 
                  alt="BurningTeam" 
                  className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover shadow-md hover:shadow-lg transition-shadow cursor-pointer flex-shrink-0"
                />
              </Link>
            </div>
            
            <div className="flex gap-2 items-center flex-shrink-0">
              <Link to="/main-hub">
                <Button 
                  variant="outline"
                  size="sm"
                  className="border-slate-300 hover:bg-slate-50"
                >
                  <ArrowLeft className="w-4 h-4 mr-1" />
                  <span className="hidden sm:inline text-xs">Zurück</span>
                </Button>
              </Link>
              {/* Mini-Wochenkalender Button – mit Badge für heutige Termine */}
              <div className="relative">
                <Button
                  onClick={() => { setWeekModalDate(new Date()); setShowWeekModal(true); setShowTodosPanel(false); }}
                  variant="outline"
                  size="sm"
                  className="border-emerald-300 hover:bg-emerald-50"
                  title="Kalender"
                >
                  <CalendarDays className="w-4 h-4 text-emerald-600" />
                </Button>
                {(() => {
                  const bn = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
                  const ts = `${bn.getFullYear()}-${String(bn.getMonth()+1).padStart(2,'0')}-${String(bn.getDate()).padStart(2,'0')}`;
                  const nt = `${String(bn.getHours()).padStart(2,'0')}:${String(bn.getMinutes()).padStart(2,'0')}`;
                  const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
                  const cnt = apts.filter(a => { if (a.done || a.date !== ts) return false; const t = a.endTime || a.startTime || '23:59'; return t >= nt; }).length;
                  return cnt > 0 ? <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold z-10">{cnt}</span> : null;
                })()}
              </div>
              {/* Anrufliste / Warteliste */}
              <Button
                onClick={() => setShowWarteliste(true)}
                variant="outline"
                size="sm"
                className="border-blue-300 hover:bg-blue-50"
                title="Anrufliste"
              >
                <ListOrdered className="w-4 h-4 text-blue-600" />
              </Button>
              <Button 
                onClick={() => setShowTourManual(true)}
                variant="outline"
                size="sm"
                className="border-emerald-300 hover:bg-emerald-50"
                title="Kunden-Bereich Tour starten"
                data-tour="info-button-kunden"
              >
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </Button>
              <Button 
                onClick={() => setShowNachrichten(true)}
                variant="outline" 
                size="sm"
                className="border-slate-300 hover:bg-slate-50 relative"
              >
                <Bell className="w-4 h-4" />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                    {unreadCount}
                  </span>
                )}
              </Button>
              <Link to="/settings">
                <Button 
                  variant="outline" 
                  size="sm"
                  className="border-slate-300 hover:bg-slate-50"
                >
                  <SettingsIcon className="w-4 h-4 mr-1" />
                  <span className="hidden sm:inline text-xs">Profil</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 border-t border-slate-100">
          {/* Haupt-Tabs */}
          <div className="flex gap-2 border-b border-slate-200 overflow-x-auto scrollbar-hide">
            <button
              onClick={() => {
                setActiveTab("daten");
                window.scrollTo(0, 0);
              }}
              className={`px-4 py-2 font-semibold transition-colors whitespace-nowrap text-sm ${
                activeTab === "daten"
                  ? "border-b-2 border-emerald-600 text-emerald-600"
                  : "text-slate-600 hover:text-slate-800"
              }`}
            >
              Daten
            </button>
            <button
              data-tour="tab-suche"
              onClick={() => {
                setActiveTab("suche");
                window.scrollTo(0, 0);
              }}
              className={`px-4 py-2 font-semibold transition-colors whitespace-nowrap text-sm ${
                activeTab === "suche"
                  ? "border-b-2 border-emerald-600 text-emerald-600"
                  : "text-slate-600 hover:text-slate-800"
              }`}
            >
              Suche
            </button>
            <button
              data-tour="tab-schulden"
              onClick={() => {
                setActiveTab("schulden");
                window.scrollTo(0, 0);
              }}
              className={`px-4 py-2 font-semibold transition-colors whitespace-nowrap text-sm ${
                activeTab === "schulden"
                  ? "border-b-2 border-emerald-600 text-emerald-600"
                  : "text-slate-600 hover:text-slate-800"
              }`}
            >
              Schulden
            </button>
          </div>
          
          {/* Filter-Tabs für Daten */}
          {activeTab === "daten" && (
            <div className="flex gap-1.5 py-2 overflow-x-auto scrollbar-hide">
              <button
                onClick={() => setDatenFilterMode("ich")}
                className={`px-3 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  datenFilterMode === "ich"
                    ? "bg-blue-600 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Ich
              </button>
              <button
                onClick={() => setDatenFilterMode("alle")}
                className={`px-3 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  datenFilterMode === "alle"
                    ? "bg-emerald-600 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Alle
              </button>
              <button
                onClick={() => setDatenFilterMode("kaltkontakt")}
                className={`px-3 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  datenFilterMode === "kaltkontakt"
                    ? "bg-emerald-600 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Neuer Kontakt
              </button>
              <button
                onClick={() => setDatenFilterMode("teampartner")}
                className={`px-3 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  datenFilterMode === "teampartner"
                    ? "bg-emerald-600 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                TP
              </button>
              <button
                onClick={() => setDatenFilterMode("kunde")}
                className={`px-3 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  datenFilterMode === "kunde"
                    ? "bg-emerald-600 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Kunde
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">

        {/* Tab Content */}
        {activeTab === "daten" && (
          <div>
            {/* Actions Bar - kompakt */}
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-3 mb-4">
              <div className="flex flex-col gap-2 w-full lg:w-auto">
                {/* Sortier-Dropdown - eigene Zeile */}
                <div className="flex items-center gap-2">
                  <label className="text-xs font-medium text-slate-700 whitespace-nowrap">Sortieren:</label>
                  <select
                    value={datenSortMode}
                    onChange={(e) => setDatenSortMode(e.target.value)}
                    className="px-2.5 py-1.5 text-xs border border-slate-300 rounded-md bg-white hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                  >
                    <option value="id">ID</option>
                    <option value="name">Name</option>
                    <option value="termin">Nächster Termin</option>
                    <option value="kontaktiert_neu">Kürzlich kontaktiert</option>
                    <option value="kontaktiert_alt">Länger kein Kontakt</option>
                    <option value="nicht_kontaktiert">Noch nicht Kontaktiert</option>
                    <option value="schulden">Schuldenfälligkeit</option>
                  </select>
                </div>
                
                {/* View Buttons + Suchfeld - in einer Zeile */}
                <div className="flex items-center gap-2">
                  {/* View Buttons */}
                  <div className="flex gap-1.5">
                    <Button
                      onClick={() => {
                        // Open modal starting with first teampartner
                        if (teampartnerList.length > 0) {
                          const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
                          const firstTeampartnerIndex = allItems.findIndex(item => item.typ === "teampartner");
                          if (firstTeampartnerIndex >= 0) {
                            setModalIndex(firstTeampartnerIndex);
                            setSelectedTeampartner(allItems[firstTeampartnerIndex]);
                            setShowDetailModal(true);
                          }
                        } else {
                          toast.info("Keine Teampartner vorhanden");
                        }
                      }}
                      variant="outline"
                      size="sm"
                      title="Einzelansicht ab erstem Teampartner"
                      className="border-purple-300 text-purple-700 hover:bg-purple-50 text-xs px-2 py-1"
                    >
                      👁️
                    </Button>
                    <Button
                      onClick={() => setViewMode("kachel")}
                      variant={viewMode === "kachel" ? "default" : "outline"}
                      size="sm"
                      title="Kacheln"
                      className="text-xs px-2 py-1"
                    >
                      <LayoutGrid className="w-3.5 h-3.5" />
                    </Button>
                    <Button
                      onClick={() => setViewMode("list")}
                      variant={viewMode === "list" ? "default" : "outline"}
                      size="sm"
                      title="Liste"
                      className="text-xs px-2 py-1"
                    >
                      <List className="w-3.5 h-3.5" />
                    </Button>
                  </div>

                  {/* Kunden-Suchfeld - kleiner */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Kunden Suche"
                      value={kundenSuche}
                      onChange={(e) => setKundenSuche(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleKundenSuche();
                        }
                      }}
                      className="px-2 py-1.5 pr-7 text-xs border border-slate-300 rounded-md bg-white placeholder-slate-400 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 w-32"
                    />
                    <button
                      onClick={handleKundenSuche}
                      className="absolute right-1.5 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                      title="Suchen"
                    >
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              
              <Button
                data-tour="kontakt-hinzufuegen-button"
                onClick={() => {
                  setEditingId(null);
                  setShowForm(!showForm);
                }}
                size="sm"
                className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-xs px-3 py-1.5"
              >
                <Plus className="w-3.5 h-3.5 mr-1.5" />
                Kontakt hinzufügen
              </Button>
            </div>

            {/* Form */}
            {showForm && (
              <div ref={formRef} className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-slate-200">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-bold text-slate-800">
                    {editingId ? "Bearbeiten" : "Neu erstellen"}
                  </h3>
                  <Button variant="ghost" size="sm" onClick={resetForm}>
                    <X className="w-4 h-4" />
                  </Button>
                </div>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  {/* Basis-Felder: Name und Typ (immer sichtbar) */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="name">Name *</Label>
                      <Input
                        id="name"
                        data-field="name"
                        value={formData.name}
                        onChange={(e) => setFormData(prev => ({...prev, name: e.target.value}))}
                        required
                        placeholder="Name des Kontakts"
                      />
                    </div>
                    
                    <div data-field="typ">
                      <Label htmlFor="typ">Typ *</Label>
                      <select
                        id="typ"
                        value={formData.typ}
                        onChange={(e) => setFormData(prev => ({...prev, typ: e.target.value}))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-md"
                        disabled={editingId !== null}
                      >
                        <option value="kaltkontakt">Neuer Kontakt</option>
                        <option value="teampartner">Teampartner</option>
                        <option value="kunde">Kunde</option>
                      </select>
                      <p className="text-xs text-slate-500 mt-1">
                        {formData.typ === "kaltkontakt" && "Neuer Kontakt → Stufe 'keine'"}
                        {formData.typ === "teampartner" && "Teampartner → Stufe 'TP'"}
                        {formData.typ === "kunde" && "Kunde → Stufe 'Kunde'"}
                      </p>
                    </div>
                  </div>

                  {/* Telefonnummer (nur lokal gespeichert) */}
                  <div>
                    <Label htmlFor="localPhone">Telefonnummer</Label>
                    <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2 mb-2">
                      <span className="text-base leading-none flex-shrink-0">📱</span>
                      <span className="text-xs text-amber-800">Wird nur auf diesem Gerät gespeichert – nicht in der Cloud.</span>
                    </div>
                    <div className="flex gap-2">
                      <Input
                        id="localPhone"
                        type="tel"
                        value={localPhone}
                        onChange={(e) => setLocalPhone(e.target.value)}
                        placeholder="Telefonnummer eingeben..."
                        className="flex-1"
                        data-testid="add-local-phone-input"
                      />
                      <button
                        type="button"
                        onClick={pickPhoneFromContactBook}
                        className="px-3 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-700 text-xs font-medium flex items-center gap-1.5 border border-blue-200 flex-shrink-0"
                        data-testid="add-local-phone-from-book"
                        title="Aus Telefonbuch auswählen"
                      >
                        <Users2 className="w-4 h-4" />
                        <span className="hidden sm:inline">Telefonbuch</span>
                      </button>
                    </div>
                  </div>

                  {/* Kontaktiert-Option nur für Kaltkontakte */}
                  {formData.typ === "kaltkontakt" && (
                    <div className="p-3 bg-amber-50 rounded-lg border border-amber-200" data-field="kontaktiert" data-value={formData.kontaktiert}>
                      <Label>Kontaktiert?</Label>
                      <div className="flex gap-4 mt-2">
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="kontaktiert"
                            value="ja"
                            checked={formData.kontaktiert === true}
                            onChange={() => setFormData(prev => ({...prev, kontaktiert: true}))}
                            className="border-slate-300"
                            data-kontaktiert-ja="true"
                          />
                          <span className="text-sm text-slate-700 font-medium">Ja</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="kontaktiert"
                            value="nein"
                            checked={formData.kontaktiert === false}
                            onChange={() => setFormData(prev => ({...prev, kontaktiert: false}))}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700 font-medium">Nein</span>
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Termin-Felder */}
                  <div className="space-y-3">
                    <div data-field="naechster-termin">
                      <Label htmlFor="naechster_termin">
                        {formData.typ === "kaltkontakt" 
                          ? (formData.kontaktiert === false ? "Erste Kontaktaufnahme" : "Erster Termin")
                          : "Nächster Termin"}
                      </Label>
                      <button
                        type="button"
                        id="naechster_termin"
                        onClick={openDateTimePicker}
                        className="w-full text-left px-3 py-2 rounded-md border-2 border-dashed border-emerald-400 bg-emerald-50 hover:bg-emerald-100 text-emerald-800 font-medium transition-colors flex items-center gap-2 cursor-pointer"
                      >
                        <span className="text-lg">📅</span>
                        <span>
                          {formData.naechster_termin ? (() => {
                            const dt = new Date(formData.naechster_termin);
                            return `${dt.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })} um ${dt.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })} Uhr`;
                          })() : "Klicken um Datum & Uhrzeit zu wählen"}
                        </span>
                        <span className="ml-auto text-xs text-emerald-600 font-normal">Klicken →</span>
                      </button>
                    </div>

                    {/* Nächstes Thema – direkt nach Nächster Termin */}
                    <div data-field="naechstes-thema-inline">
                      <div className="flex items-center justify-between mb-1">
                        <Label htmlFor="naechstes_thema_termin">Nächstes Thema</Label>
                        {editingId && (
                          <button
                            type="button"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/api/teampartner/${editingId}`);
                                const kontakt = response.data;
                                setVergangeneThemenData(kontakt.vergangene_themen || []);
                                setVergangeneThemenKontaktName(kontakt.name);
                                setShowVergangeneThemenModal(true);
                              } catch (error) {
                                toast.error("Fehler beim Laden");
                              }
                            }}
                            className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
                          >
                            <History className="w-3 h-3" />
                            Vergangene Themen
                          </button>
                        )}
                      </div>
                      <Input
                        id="naechstes_thema_termin"
                        value={formData.naechstes_thema}
                        onChange={(e) => setFormData(prev => ({...prev, naechstes_thema: e.target.value}))}
                        placeholder="Thema für nächsten Termin"
                      />
                    </div>

                    {/* Zuletzt kontaktiert */}
                    {((formData.typ === "kaltkontakt" && formData.kontaktiert === true) || 
                      (formData.typ === "teampartner" || formData.typ === "kunde")) && (
                      <div data-field="zuletzt-kontaktiert">
                        <Label htmlFor="letzter_termin">Zuletzt kontaktiert</Label>
                        <Input
                          id="letzter_termin"
                          type="date"
                          max={new Date().toISOString().split('T')[0]}
                          value={formData.letzter_termin}
                          onChange={(e) => setFormData(prev => ({...prev, letzter_termin: e.target.value}))}
                        />
                      </div>
                    )}
                  </div>

                  {/* Linie: nur bei Teampartner oder Kunde */}
                  {(formData.typ === "teampartner" || formData.typ === "kunde") && (
                    <div className="relative" data-field="linie">
                      <Label htmlFor="linie">Linie</Label>
                      <div className="relative">
                        <Input
                          id="linie"
                          value={formData.linie === "erstlinie" ? "Erstlinie" : linieSearch}
                          onChange={(e) => {
                            setLinieSearch(e.target.value);
                            setShowLinieDropdown(true);
                            if (e.target.value === "") {
                              setFormData(prev => ({...prev, linie: "erstlinie"}));
                            }
                          }}
                          onFocus={() => setShowLinieDropdown(true)}
                          placeholder="Tippen um zu suchen..."
                          autoComplete="off"
                        />
                        
                        {showLinieDropdown && (
                          <div className="absolute z-50 w-full mt-1 bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                            <button
                              type="button"
                              onClick={() => {
                                setFormData(prev => ({...prev, linie: "erstlinie"}));
                                setLinieSearch("");
                                setShowLinieDropdown(false);
                              }}
                              className="w-full px-4 py-2 text-left hover:bg-emerald-50 border-b border-slate-200 font-semibold text-emerald-700"
                            >
                              ✓ Erstlinie
                            </button>
                            
                            {filteredForLinie.length > 0 ? (
                              filteredForLinie.map(tp => (
                                <button
                                  key={tp.id}
                                  type="button"
                                  onClick={() => {
                                    setFormData(prev => ({...prev, linie: tp.id}));
                                    setLinieSearch(tp.name);
                                    setShowLinieDropdown(false);
                                  }}
                                  className="w-full px-4 py-2 text-left hover:bg-slate-50 border-b border-slate-100 last:border-0"
                                >
                                  <div className="flex justify-between items-center">
                                    <span className="font-medium text-slate-800">{tp.name}</span>
                                    <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-1 rounded">
                                      {tp.stufe}
                                    </span>
                                  </div>
                                </button>
                              ))
                            ) : (
                              <div className="px-4 py-3 text-sm text-slate-500 text-center">
                                Keine Teampartner gefunden
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <p className="text-xs text-slate-500 mt-1">
                        {formData.linie === "erstlinie" ? "Erstlinie ausgewählt" : `Ausgewählt: ${linieSearch || "..."}`}
                      </p>
                    </div>
                  )}
                  
                  {/* Teampartner/Kunde geworden? - nur für Kaltkontakte nach Kontakt */}
                  {formData.typ === "kaltkontakt" && formData.kontaktiert === true && (
                    <div className="mb-4 p-3 bg-emerald-50 rounded-lg border border-emerald-200" data-field="tp-kunde-geworden" data-value={formData.tp_kunde_geworden}>
                      <Label>Teampartner/Kunde geworden?</Label>
                      <div className="flex gap-4 mt-2">
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="tp_kunde_geworden"
                            value="teampartner"
                            checked={formData.tp_kunde_geworden === "teampartner"}
                            data-tp-teampartner="true"
                            onChange={() => {
                              const befoerderungsdatum = new Date().toISOString().split('T')[0];
                              setFormData({
                                ...formData, 
                                tp_kunde_geworden: "teampartner",
                                typ: "teampartner",
                                stufe: "TP",
                                befoerderungs_datum: befoerderungsdatum
                              });
                            }}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700 font-medium">✅ Teampartner</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="tp_kunde_geworden"
                            value="kunde"
                            checked={formData.tp_kunde_geworden === "kunde"}
                            onChange={() => {
                              const befoerderungsdatum = new Date().toISOString().split('T')[0];
                              setFormData({
                                ...formData, 
                                tp_kunde_geworden: "kunde",
                                typ: "kunde",
                                stufe: "keine",
                                befoerderungs_datum: befoerderungsdatum
                              });
                            }}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700 font-medium">✅ Kunde</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="tp_kunde_geworden"
                            value="nein"
                            checked={formData.tp_kunde_geworden === "nein" || formData.tp_kunde_geworden === false || formData.tp_kunde_geworden === null}
                            onChange={() => setFormData(prev => ({...prev, tp_kunde_geworden: "nein"}))}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700 font-medium">❌ Nein</span>
                        </label>
                      </div>
                      {formData.tp_kunde_geworden === "teampartner" && (
                        <p className="text-xs text-emerald-600 mt-2">
                          ✅ Wird automatisch zu Teampartner befördert und Betreuungs-Countdown startet!
                        </p>
                      )}
                      {formData.tp_kunde_geworden === "kunde" && (
                        <p className="text-xs text-blue-600 mt-2">
                          ✅ Wird automatisch zu Kunde befördert!
                        </p>
                      )}
                    </div>
                  )}
                  
                  {/* Wrapper für Tour-Spotlight um alle drei Felder */}
                  <div data-field="notizen-aufgaben-gruppe">
                    <div data-field="noch-zu-erledigen">
                      <Label>Noch zu erledigen</Label>
                      <KontaktTaskList
                        tasks={normalizeNochZuErledigen(formData.noch_zu_erledigen)}
                        isEditMode={true}
                        onToggle={(taskId) => setFormData(prev => ({ ...prev, noch_zu_erledigen: normalizeNochZuErledigen(prev.noch_zu_erledigen).map(t => t.id === taskId ? { ...t, done: !t.done } : t) }))}
                        onDelete={(taskId) => setFormData(prev => ({ ...prev, noch_zu_erledigen: normalizeNochZuErledigen(prev.noch_zu_erledigen).filter(t => t.id !== taskId) }))}
                        onAdd={() => handleOpenZuErledigienModal(editingId, formData.name, formData.typ, true)}
                      />
                    </div>
                    
                    <div data-field="notizen">
                      <Label htmlFor="notizen">Notizen</Label>
                      <textarea
                        id="notizen"
                        value={formData.notizen}
                        onChange={(e) => setFormData(prev => ({...prev, notizen: e.target.value}))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-md min-h-[100px]"
                        placeholder="Zusätzliche Notizen..."
                      />
                    </div>
                  </div>
                  
                  {/* Phase 4: Thematik & Produkte */}
                  <div className="border-t border-slate-200 pt-4 mt-4" data-field="thematik-produkte">
                    <h3 className="text-lg font-semibold text-slate-800 mb-4">Thematik & Produkte</h3>
                    
                    {/* Thematik Mehrfachauswahl */}
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <Label>Thematik (Mehrfachauswahl)</Label>
                        <button
                          type="button"
                          onClick={() => setShowThematikManager(true)}
                          className="text-xs text-blue-600 hover:text-blue-700 underline font-semibold"
                        >
                          ⚙️ Liste bearbeiten
                        </button>
                      </div>
                      <div className="border border-slate-300 rounded-md p-3 max-h-64 overflow-y-auto bg-slate-50">
                        {THEMATIK_OPTIONEN.length === 0 ? (
                          <p className="text-sm text-slate-500 text-center py-4">
                            Keine Thematiken verfügbar. Klicke auf "Liste bearbeiten" um welche hinzuzufügen.
                          </p>
                        ) : (
                          <div className="space-y-1">
                            {THEMATIK_OPTIONEN.map(thema => (
                              <label key={thema} className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-2 rounded">
                                <input
                                  type="checkbox"
                                  checked={formData.thematik.includes(thema)}
                                  onChange={() => toggleThematik(thema)}
                                  className="rounded border-slate-300 flex-shrink-0"
                                />
                                <span className="text-sm text-slate-700">{thema}</span>
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    
                    {/* Eigenes Thema nur für diesen Kontakt */}
                    <div className="mb-4">
                      <Label htmlFor="neues_thema">Eigenes Thema (nur für diesen Kontakt)</Label>
                      <div className="flex gap-2">
                        <Input
                          id="neues_thema"
                          value={neuesThema}
                          onChange={(e) => setNeuesThema(e.target.value)}
                          placeholder="z.B. Rückenschmerzen"
                          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addEigenesThema())}
                        />
                        <Button type="button" onClick={addEigenesThema} variant="outline" size="sm">
                          + Hinzufügen
                        </Button>
                      </div>
                      <p className="text-xs text-slate-500 mt-1">
                        Wird nicht zur globalen Liste hinzugefügt
                      </p>
                    </div>
                    
                    {/* Ausgewählte Thematiken anzeigen */}
                    {formData.thematik.length > 0 && (
                      <div className="mb-4 p-3 bg-purple-50 rounded-lg border border-purple-200">
                        <p className="text-xs font-semibold text-purple-700 mb-2">Ausgewählt ({formData.thematik.length}):</p>
                        <div className="flex flex-wrap gap-1">
                          {formData.thematik.map(thema => (
                            <span key={thema} className="px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs flex items-center gap-1">
                              {thema}
                              <button
                                type="button"
                                onClick={() => toggleThematik(thema)}
                                className="text-purple-600 hover:text-purple-800 font-bold"
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Produkte nur für Teampartner und Kunden anzeigen */}
                    {formData.typ !== "kaltkontakt" && (
                      <>
                        {/* Produkte im Abo */}
                        <div className="mb-4">
                          <Label>Produkte im Abo</Label>
                          <div className="border border-slate-300 rounded-md p-3 max-h-48 overflow-y-auto bg-slate-50">
                            <div className="space-y-1">
                              {/* Konzept 1 - Fest an erster Stelle */}
                              <label className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                                <input
                                  type="checkbox"
                                  checked={formData.im_abo.includes("konzept-1")}
                                  onChange={() => toggleProduktAbo("konzept-1")}
                                  className="rounded border-slate-300"
                                />
                                <span className="text-sm text-slate-700 font-semibold">Konzept 1</span>
                              </label>
                              
                              {/* Dynamische Produkte aus der Datenbank */}
                              {produkte.length === 0 ? (
                                <p className="text-sm text-slate-500 pt-2">Keine weiteren Produkte verfügbar</p>
                              ) : (
                                produkte.map(produkt => (
                                  <label key={produkt.id} className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                                    <input
                                      type="checkbox"
                                      checked={formData.im_abo.includes(produkt.id)}
                                      onChange={() => toggleProduktAbo(produkt.id)}
                                      className="rounded border-slate-300"
                                    />
                                    <span className="text-sm text-slate-700">{produkt.name}</span>
                                  </label>
                                ))
                              )}
                            </div>
                          </div>
                        </div>
                        
                        {/* Produktempfehlungen */}
                        <div className="mb-4">
                          <Label>Produktempfehlungen</Label>
                          <p className="text-xs text-slate-500 mb-2">Nur Produkte, die nicht im Abo sind</p>
                          <div className="border border-slate-300 rounded-md p-3 max-h-48 overflow-y-auto bg-slate-50">
                            <div className="space-y-1">
                              {/* Konzept 1 - wenn nicht im Abo */}
                              {!formData.im_abo.includes("konzept-1") && (
                                <label className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                                  <input
                                    type="checkbox"
                                    checked={formData.produktempfehlung.includes("konzept-1")}
                                    onChange={() => toggleProduktEmpfehlung("konzept-1")}
                                    className="rounded border-slate-300"
                                  />
                                  <span className="text-sm text-slate-700 font-semibold">Konzept 1</span>
                                </label>
                              )}
                              
                              {/* Dynamische Produkte */}
                              {produkte.filter(p => !formData.im_abo.includes(p.id)).length === 0 && formData.im_abo.includes("konzept-1") ? (
                                <p className="text-sm text-slate-500">Alle Produkte sind bereits im Abo</p>
                              ) : (
                                produkte
                                  .filter(p => !formData.im_abo.includes(p.id))
                                  .map(produkt => (
                                    <label key={produkt.id} className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                                      <input
                                        type="checkbox"
                                        checked={formData.produktempfehlung.includes(produkt.id)}
                                        onChange={() => toggleProduktEmpfehlung(produkt.id)}
                                        className="rounded border-slate-300"
                                      />
                                      <span className="text-sm text-slate-700">{produkt.name}</span>
                                    </label>
                                  ))
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    
                    {/* Online/Live Veranstaltung - Mehrfachauswahl */}
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <Label>Online/Live Veranstaltung (Mehrfachauswahl)</Label>
                        <button
                          type="button"
                          onClick={() => setShowVeranstaltungManager(true)}
                          className="text-xs text-blue-600 hover:text-blue-700 underline font-semibold"
                        >
                          ⚙️ Liste bearbeiten
                        </button>
                      </div>
                      <div className="border border-slate-300 rounded-md p-2 max-h-48 overflow-y-auto bg-slate-50">
                        <div className="grid grid-cols-2 gap-1">
                          {VERANSTALTUNG_OPTIONEN.map(veranstaltung => (
                            <label key={veranstaltung} className="flex items-center space-x-1.5 cursor-pointer hover:bg-slate-100 p-1.5 rounded text-xs">
                              <input
                                type="checkbox"
                                checked={formData.online_live_veranstaltungen.includes(veranstaltung)}
                                onChange={() => {
                                  const current = formData.online_live_veranstaltungen;
                                  if (current.includes(veranstaltung)) {
                                    setFormData({
                                      ...formData,
                                      online_live_veranstaltungen: current.filter(v => v !== veranstaltung)
                                    });
                                  } else {
                                    setFormData({
                                      ...formData,
                                      online_live_veranstaltungen: [...current, veranstaltung]
                                    });
                                  }
                                }}
                                className="rounded border-slate-300 flex-shrink-0"
                              />
                              <span className="text-slate-700">{veranstaltung}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                    
                    {/* Ausgewählte Veranstaltungen anzeigen */}
                    {formData.online_live_veranstaltungen.length > 0 && (
                      <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                        <p className="text-xs font-semibold text-blue-700 mb-2">Ausgewählt ({formData.online_live_veranstaltungen.length}):</p>
                        <div className="flex flex-wrap gap-1">
                          {formData.online_live_veranstaltungen.map(veranstaltung => (
                            <span key={veranstaltung} className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs flex items-center gap-1">
                              {veranstaltung}
                              <button
                                type="button"
                                onClick={() => {
                                  setFormData({
                                    ...formData,
                                    online_live_veranstaltungen: formData.online_live_veranstaltungen.filter(v => v !== veranstaltung)
                                  });
                                }}
                                className="text-blue-600 hover:text-blue-800 font-bold"
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {/* Phase 5: Betreuungssystem - nur für Teampartner und Kunden */}
                  {formData.typ !== "kaltkontakt" && (
                    <div className="border-t border-slate-200 pt-4 mt-4">
                      <h3 className="text-lg font-semibold text-slate-800 mb-4" data-field="betreuungssystem-header">Betreuungssystem</h3>
                      
                      {/* Einschreibe Datum - immer sichtbar für TP/Kunden */}
                      <div className="mb-4 p-3 bg-indigo-50 rounded-lg border border-indigo-200" data-field="einschreibedatum">
                        <label className="block text-sm font-semibold text-indigo-800 mb-2">📅 Einschreibe Datum</label>
                        <input
                          type="date"
                          value={formData.befoerderungs_datum}
                          onChange={(e) => setFormData(prev => ({...prev, befoerderungs_datum: e.target.value}))}
                          className="w-full px-3 py-2 text-sm border border-indigo-300 rounded-md bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        />
                        {/* Nächstes Paket Berechnung */}
                        {formData.befoerderungs_datum && (() => {
                          const { nextRenewal, completedCycles, daysLeft } = calculateNextPackage(formData.befoerderungs_datum);
                          return (
                            <div className="mt-2 p-2 bg-teal-50 rounded border border-teal-200">
                              <p className="text-sm text-teal-800">
                                <strong>📦 Nächstes Paket:</strong>{' '}
                                {nextRenewal.toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' })}
                                <span className={`ml-2 font-semibold ${daysLeft <= 7 ? 'text-orange-600' : 'text-teal-600'}`}>
                                  • {daysLeft === 0 ? 'Heute fällig!' : daysLeft === 1 ? 'Morgen fällig!' : `in ${daysLeft} Tagen`}
                                </span>
                                {completedCycles > 0 && <span className="ml-2 text-xs text-teal-500">({completedCycles + 1}. Zyklus)</span>}
                              </p>
                            </div>
                          );
                        })()}
                        </div>
                      
                      {/* Follow-up Checkboxen */}
                      <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200" data-field="followups" data-field-betreuung="true">
                        <p className="text-sm font-semibold text-blue-800 mb-2">Follow-up Status</p>
                        <div className="space-y-2">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.einnahmegespraech_erledigt}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setFormData({
                                  ...formData, 
                                  einnahmegespraech_erledigt: isChecked,
                                  einnahmegespraech_datum: isChecked && !formData.einnahmegespraech_datum 
                                    ? new Date().toISOString().split('T')[0] 
                                    : formData.einnahmegespraech_datum
                                });
                              }}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">3-5 Tage Einnahmegespräch erledigt</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.followup_3_5_erledigt}
                              onChange={(e) => setFormData(prev => ({...prev, followup_3_5_erledigt: e.target.checked}))}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">7 Tage Follow-up erledigt</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.followup_14_erledigt}
                              onChange={(e) => setFormData(prev => ({...prev, followup_14_erledigt: e.target.checked}))}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">14 Tage Follow-up erledigt</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.followup_30_erledigt}
                              onChange={(e) => setFormData(prev => ({...prev, followup_30_erledigt: e.target.checked}))}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">21 Tage Follow-up erledigt</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.followup_28_erledigt}
                              onChange={(e) => setFormData(prev => ({...prev, followup_28_erledigt: e.target.checked}))}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">28 Tage Follow-up erledigt</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.paket_erinnerung_erledigt}
                              onChange={(e) => setFormData(prev => ({...prev, paket_erinnerung_erledigt: e.target.checked}))}
                              className="rounded border-slate-300"
                            />
                            <span className="text-sm text-slate-700">⏳ Paket Erinnerung erledigt</span>
                          </label>
                        </div>
                      </div>
                      
                      {/* Cellreset gemacht? */}
                      <div className="mb-4" data-field="cellreset">
                        <Label>Cellreset gemacht?</Label>
                        <div className="flex gap-3 mt-2 flex-wrap">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="cellreset_gemacht"
                              value="ja"
                              checked={formData.cellreset_gemacht === "ja"}
                              onChange={(e) => setFormData(prev => ({...prev, cellreset_gemacht: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Ja</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="cellreset_gemacht"
                              value="interesse"
                              checked={formData.cellreset_gemacht === "interesse"}
                              onChange={(e) => setFormData(prev => ({...prev, cellreset_gemacht: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Interesse</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="cellreset_gemacht"
                              value="nein"
                              checked={formData.cellreset_gemacht === "nein"}
                              onChange={(e) => setFormData(prev => ({...prev, cellreset_gemacht: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Nein</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="cellreset_gemacht"
                              value="nicht_beendet"
                              checked={formData.cellreset_gemacht === "nicht_beendet"}
                              onChange={(e) => setFormData(prev => ({...prev, cellreset_gemacht: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Nicht beendet</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Actionpack genutzt? - separat, für alle TP/Kunde */}
                  {formData.typ !== "kaltkontakt" && (
                    <div className="border-t border-slate-200 pt-4 mt-4" data-field="actionpack">
                      <h3 className="text-lg font-semibold text-slate-800 mb-4">Actionpack</h3>
                      <div className="mb-4">
                        <Label>Actionpack genutzt?</Label>
                        <div className="flex gap-4 mt-2">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="actionpack"
                              value="ja"
                              checked={formData.actionpack === "ja"}
                              onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Ja</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="actionpack"
                              value="nein"
                              checked={formData.actionpack === "nein"}
                              onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Nein</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="actionpack"
                              value="interesse"
                              checked={formData.actionpack === "interesse"}
                              onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700">Interesse</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Pausieren - nur beim Bearbeiten */}
                  {editingId && (
                    <div className="border-t border-slate-200 pt-4 mt-4">
                      <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                        <Label className="text-orange-800 font-semibold">Kontakt pausieren/kündigen?</Label>
                        <p className="text-sm text-orange-600 mb-3">Pausierte Kontakte werden ausgeblendet und nicht in Benachrichtigungen angezeigt.</p>
                        <div className="flex gap-4">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="pausieren"
                              value="ja"
                              checked={formData.pausiert === true}
                              onChange={() => setFormData(prev => ({...prev, pausiert: true}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700 font-medium">Ja, pausieren</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="pausieren"
                              value="nein"
                              checked={formData.pausiert === false}
                              onChange={() => setFormData(prev => ({...prev, pausiert: false}))}
                              className="border-slate-300"
                            />
                            <span className="text-sm text-slate-700 font-medium">Nein</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  <div className="flex gap-3">
                    <Button type="submit" className="bg-emerald-600 hover:bg-emerald-700" data-tour="speichern-button">
                      {editingId ? "Aktualisieren" : "Erstellen"}
                    </Button>
                    <Button type="button" variant="outline" onClick={resetForm}>
                      Abbrechen
                    </Button>
                  </div>
                </form>
              </div>
            )}

            {loading ? (
              <div className="text-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto"></div>
                <p className="text-slate-600 mt-4">Lädt...</p>
              </div>
            ) : (
              <>
                {/* "Ich" Tab - Eigene Kachel im gewohnten Design */}
                {datenFilterMode === "ich" && user && (
                  <div className="mb-6">
                    <h2 className="text-lg font-bold text-slate-800 mb-3 flex items-center">
                      <UserCheck className="w-4 h-4 mr-2 text-blue-600" />
                      Mein Profil
                    </h2>
                    
                    {/* Bearbeitungsmodus Badge */}
                    {isIchEditMode && (
                      <div className="mb-4 p-3 bg-yellow-50 border-2 border-yellow-400 rounded-lg shadow-md">
                        <div className="flex items-center justify-center gap-2">
                          <span className="text-lg">✏️</span>
                          <span className="font-bold text-yellow-800">Bearbeitungsmodus</span>
                        </div>
                        <p className="text-xs text-yellow-600 text-center mt-1">Klicken Sie auf ein Feld zum Bearbeiten</p>
                      </div>
                    )}
                    
                    {/* Kachel im gewohnten Design mit blauem Rand */}
                    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-2 border-blue-400 hover:border-blue-500 overflow-hidden group max-w-md">
                      {/* Top colored stripe - blau für "Ich" */}
                      <div className="h-2 bg-gradient-to-r from-blue-500 to-blue-600"></div>
                      
                      <div className="p-4">
                        {/* Header mit Name & Status */}
                        <div className="flex items-start justify-between mb-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                              <h3 className="font-bold text-slate-800 text-lg truncate">
                                {user.full_name || user.username}
                              </h3>
                              <span className={`px-2 py-0.5 text-xs font-bold rounded-full ${
                                (teampartnerList.length + kundenList.length) >= 5
                                  ? "bg-purple-200 text-purple-800"
                                  : "bg-emerald-200 text-emerald-800"
                              }`}>
                                {(teampartnerList.length + kundenList.length) >= 5 ? "M" : "TP"}
                              </span>
                            </div>
                            <p className="text-xs text-slate-500 mt-0.5">
                              👤 {(teampartnerList.length + kundenList.length) >= 5 ? "Manager" : "Teampartner"}
                            </p>
                          </div>
                        </div>
                        
                        {/* Content */}
                        <div className="space-y-2">
                          {/* Schulden Bilanz */}
                          {(() => {
                            const erhalten = alleSchulden.filter(s => s.richtung === "erhalten_von" && s.status === "offen").reduce((sum, s) => sum + s.betrag, 0);
                            const schulde = alleSchulden.filter(s => s.richtung === "schulde_ich" && s.status === "offen").reduce((sum, s) => sum + s.betrag, 0);
                            const bilanz = erhalten - schulde;
                            
                            return (
                              <div className={`flex items-start gap-2 p-2 rounded-lg border ${bilanz >= 0 ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
                                <span className="text-base">{bilanz >= 0 ? '💰' : '💸'}</span>
                                <div className="flex-1">
                                  <p className="text-xs font-medium text-slate-600">Schulden Bilanz</p>
                                  <p className={`text-sm font-semibold ${bilanz >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                                    {bilanz >= 0 ? '+' : ''}{bilanz.toFixed(2)} €
                                  </p>
                                </div>
                              </div>
                            );
                          })()}
                          
                          {/* Noch zu erledigen */}
                          <div className="flex items-start gap-2 p-2 rounded-lg border border-slate-200">
                            <span className="text-base">📝</span>
                            <div className="flex-1">
                              <p className="text-xs text-slate-500 font-medium mb-1.5">Zu erledigen</p>
                              <KontaktTaskList
                                tasks={normalizeNochZuErledigen(isIchEditMode ? tempIchData?.noch_zu_erledigen : user.noch_zu_erledigen)}
                                isEditMode={isIchEditMode}
                                onToggle={(taskId) => handleToggleKontaktTask(user.id, 'ich', taskId)}
                                onDelete={(taskId) => {
                                  if (isIchEditMode) setTempIchData(prev => ({ ...prev, noch_zu_erledigen: normalizeNochZuErledigen(prev?.noch_zu_erledigen).filter(t => t.id !== taskId) }));
                                  else handleDeleteKontaktTask(user.id, 'ich', taskId);
                                }}
                                onAdd={() => handleOpenZuErledigienModal(user.id, user.name, 'ich', isIchEditMode)}
                              />
                            </div>
                          </div>
                          
                          {/* Notizen */}
                          {((isIchEditMode ? tempIchData?.notizen : user.notizen) || isIchEditMode) && (
                            <div 
                              className={`flex items-start gap-2 bg-slate-50 p-2 rounded-lg ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                              onClick={isIchEditMode ? () => handleOpenIchFieldEdit('notizen', 'Notizen', 'textarea') : undefined}
                            >
                              <span className="text-base">💭</span>
                              <div className="flex-1">
                                <p className="text-xs text-slate-500 font-medium">Notizen</p>
                                <p className="text-xs text-slate-600 line-clamp-2">
                                  {(isIchEditMode ? tempIchData?.notizen : user.notizen) || <span className="text-slate-400 italic">-</span>}
                                </p>
                              </div>
                            </div>
                          )}
                          
                          {/* Muss ich probieren */}
                          <div 
                            className={`flex items-start gap-2 p-2 rounded-lg border border-amber-200 bg-amber-50 ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                            onClick={isIchEditMode ? () => handleOpenIchFieldEdit('empfehlungen', 'Muss ich probieren', 'multi-select', produkte.map(p => p.name)) : undefined}
                          >
                            <span className="text-base">🎯</span>
                            <div className="flex-1">
                              <p className="text-xs text-slate-500 font-medium">Muss ich probieren</p>
                              {((isIchEditMode ? tempIchData?.empfehlungen : user.empfehlungen) || []).length > 0 ? (
                                <div className="flex flex-wrap gap-1 mt-1">
                                  {(isIchEditMode ? tempIchData?.empfehlungen : user.empfehlungen).map((emp, idx) => (
                                    <span key={idx} className="px-2 py-0.5 bg-amber-200 text-amber-800 rounded text-xs">
                                      {emp}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-xs text-slate-400 italic">-</p>
                              )}
                            </div>
                          </div>
                          
                          {/* Produkte im Abo */}
                          <div 
                            className={`flex items-start gap-2 p-2 rounded-lg border border-emerald-200 bg-emerald-50 ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                            onClick={isIchEditMode ? () => handleOpenIchFieldEdit('produkte_im_abo', 'Produkte im Abo', 'multi-select', produkte.map(p => p.name)) : undefined}
                          >
                            <span className="text-base">📦</span>
                            <div className="flex-1">
                              <p className="text-xs text-slate-500 font-medium">Produkte im Abo</p>
                              {((isIchEditMode ? tempIchData?.produkte_im_abo : user.produkte_im_abo) || []).length > 0 ? (
                                <div className="flex flex-wrap gap-1 mt-1">
                                  {(isIchEditMode ? tempIchData?.produkte_im_abo : user.produkte_im_abo).map((prod, idx) => (
                                    <span key={idx} className="px-2 py-0.5 bg-emerald-200 text-emerald-800 rounded text-xs">
                                      {prod}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-xs text-slate-400 italic">-</p>
                              )}
                            </div>
                          </div>
                          
                          {/* Veranstaltungen */}
                          <div 
                            className={`flex items-start gap-2 p-2 rounded-lg border border-purple-200 bg-purple-50 ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                            onClick={isIchEditMode ? () => handleOpenIchFieldEdit('online_live_veranstaltungen', 'Veranstaltungen', 'multi-select', VERANSTALTUNG_OPTIONEN) : undefined}
                          >
                            <span className="text-base">🎪</span>
                            <div className="flex-1">
                              <p className="text-xs text-slate-500 font-medium">Veranstaltungen</p>
                              {((isIchEditMode ? tempIchData?.online_live_veranstaltungen : user.online_live_veranstaltungen) || []).length > 0 ? (
                                <div className="flex flex-wrap gap-1 mt-1">
                                  {(isIchEditMode ? tempIchData?.online_live_veranstaltungen : user.online_live_veranstaltungen).map((ver, idx) => (
                                    <span key={idx} className="px-2 py-0.5 bg-purple-200 text-purple-800 rounded text-xs">
                                      {ver}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-xs text-slate-400 italic">-</p>
                              )}
                            </div>
                          </div>
                          
                          {/* Cellreset & Actionpack */}
                          <div className="grid grid-cols-2 gap-2">
                            {/* Cellreset */}
                            <div 
                              className={`flex items-center gap-2 p-2 rounded-lg border ${
                                (isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "ja" ? "bg-green-50 border-green-200" :
                                (isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "nicht_beendet" ? "bg-orange-50 border-orange-200" :
                                (isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "interesse" ? "bg-amber-50 border-amber-200" :
                                "bg-slate-50 border-slate-200"
                              } ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                              onClick={isIchEditMode ? () => handleOpenIchFieldEdit('cellreset_gemacht', 'Cellreset', 'select', [
                                { value: 'ja', label: '✅ Ja' },
                                { value: 'nein', label: '❌ Nein' },
                                { value: 'nicht_beendet', label: '⏸️ Nicht beendet' },
                                { value: 'interesse', label: '🤔 Interesse' }
                              ]) : undefined}
                            >
                              <span className="text-base">🔄</span>
                              <div>
                                <p className="text-xs text-slate-500 font-medium">Cellreset</p>
                                <p className="text-xs font-semibold">
                                  {(isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "ja" ? "✅ Ja" :
                                   (isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "nicht_beendet" ? "⏸️ Nicht beendet" :
                                   (isIchEditMode ? tempIchData?.cellreset_gemacht : user.cellreset_gemacht) === "interesse" ? "🤔 Interesse" :
                                   "❌ Nein"}
                                </p>
                              </div>
                            </div>
                            
                            {/* Actionpack */}
                            <div 
                              className={`flex items-center gap-2 p-2 rounded-lg border ${
                                (isIchEditMode ? tempIchData?.actionpack : user.actionpack) === "ja" ? "bg-green-50 border-green-200" :
                                (isIchEditMode ? tempIchData?.actionpack : user.actionpack) === "interesse" ? "bg-amber-50 border-amber-200" :
                                "bg-slate-50 border-slate-200"
                              } ${isIchEditMode ? 'cursor-pointer hover:bg-yellow-100 border-2 border-dashed border-yellow-400' : ''}`}
                              onClick={isIchEditMode ? () => handleOpenIchFieldEdit('actionpack', 'Actionpack', 'select', [
                                { value: 'ja', label: '✅ Ja' },
                                { value: 'nein', label: '❌ Nein' },
                                { value: 'interesse', label: '🤔 Interesse' }
                              ]) : undefined}
                            >
                              <span className="text-base">🎁</span>
                              <div>
                                <p className="text-xs text-slate-500 font-medium">Actionpack</p>
                                <p className="text-xs font-semibold">
                                  {(isIchEditMode ? tempIchData?.actionpack : user.actionpack) === "ja" ? "✅ Ja" :
                                   (isIchEditMode ? tempIchData?.actionpack : user.actionpack) === "interesse" ? "🤔 Interesse" :
                                   "❌ Nein"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Downline Info */}
                        <div 
                          className="mt-3 p-2 bg-blue-50 rounded-lg border border-blue-200 cursor-pointer hover:bg-blue-100 transition-colors"
                          onClick={handleMyDownlineTreeClick}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-semibold text-blue-700">📊 Downline</span>
                              <span className="text-xs text-blue-600">
                                {teampartnerList.length + kundenList.length} Gesamt ({teampartnerList.length} TP, {kundenList.length} Kunden)
                              </span>
                            </div>
                            <span className="text-blue-500">→</span>
                          </div>
                        </div>
                        
                        {/* Buttons */}
                        <div className="mt-4 flex gap-2">
                          {!isIchEditMode ? (
                            <button
                              onClick={handleStartIchEdit}
                              className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-semibold text-sm hover:from-blue-600 hover:to-blue-700 transition-all flex items-center justify-center gap-2"
                            >
                              <Edit3 className="w-4 h-4" />
                              Bearbeiten
                            </button>
                          ) : (
                            <>
                              <button
                                onClick={handleCancelIchEdit}
                                className="flex-1 px-4 py-2 text-sm text-slate-600 hover:text-slate-800 font-medium border border-slate-300 rounded-lg hover:bg-slate-50"
                              >
                                Abbrechen
                              </button>
                              <button
                                onClick={handleSaveIchEdit}
                                className="flex-1 px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium"
                              >
                                Speichern
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Kachel & Liste Views - mit Filter */}
                {datenFilterMode !== "ich" && (
                  <>
                    {/* Neue Kontakte Section */}
                    {(datenFilterMode === "alle" || datenFilterMode === "kaltkontakt") && (
                      <div className="mb-6">
                        <h2 className="text-lg font-bold text-slate-800 mb-3 flex items-center">
                          <Users className="w-4 h-4 mr-2 text-slate-600" />
                          Neue Kontakte ({formatCount(sortedKaltkontakte)})
                        </h2>
                        
                        {sortedKaltkontakte.length === 0 ? (
                          <div className="bg-slate-100 rounded-lg p-6 text-center">
                            <p className="text-slate-600 text-sm">Keine neuen Kontakte vorhanden</p>
                          </div>
                        ) : viewMode === "kachel" ? (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {sortedKaltkontakte.map(tp => (
                              <div key={tp.id} onClick={() => handleCardClick(tp)} className="cursor-pointer">
                                <TeampartnerCard tp={tp} produkte={produkte} alleSchulden={alleSchulden} onEdit={handleEdit} onDelete={handleDelete} onPromote={null} onShowVergangeneThemen={async (tp) => {
                                  // Hole frische Daten vom Server
                                  try {
                                    const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
                                    setVergangeneThemenData(response.data.vergangene_themen || []);
                                  } catch (error) {
                                    setVergangeneThemenData(tp.vergangene_themen || []);
                                  }
                                  setVergangeneThemenKontaktName(tp.name);
                                  setShowVergangeneThemenModal(true);
                                }} onOpenZuErledigen={handleOpenZuErledigienModal} onToggleTask={handleToggleKontaktTask} onDeleteTask={handleDeleteKontaktTask} onBetreuungClick={handleOpenBetreuungsModal} onPayPerson={handlePayPerson} onShowTeilzahlungHistorie={handleShowTeilzahlungHistorie} />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <TeampartnerTable data={sortedKaltkontakte} onEdit={handleEdit} onDelete={handleDelete} />
                        )}
                      </div>
                    )}

                    {/* Teampartner Section */}
                    {(datenFilterMode === "alle" || datenFilterMode === "teampartner") && (
                      <div className="mb-6">
                        <h2 className="text-lg font-bold text-slate-800 mb-3 flex items-center">
                          <UserCheck className="w-4 h-4 mr-2 text-emerald-600" />
                          Teampartner ({formatCount(sortedTeampartner)})
                        </h2>
                        
                        {sortedTeampartner.length === 0 ? (
                          <div className="bg-emerald-50 rounded-lg p-6 text-center border border-emerald-200">
                            <p className="text-emerald-700 text-sm">Keine aktiven Teampartner vorhanden</p>
                          </div>
                        ) : viewMode === "kachel" ? (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {sortedTeampartner.map(tp => (
                              <div key={tp.id} onClick={() => handleCardClick(tp)} className="cursor-pointer">
                                <TeampartnerCard tp={tp} produkte={produkte} alleSchulden={alleSchulden} onEdit={handleEdit} onDelete={handleDelete} onPromote={handlePromote} onShowVergangeneThemen={async (tp) => {
                                  // Hole frische Daten vom Server
                                  try {
                                    const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
                                    setVergangeneThemenData(response.data.vergangene_themen || []);
                                  } catch (error) {
                                    setVergangeneThemenData(tp.vergangene_themen || []);
                                  }
                                  setVergangeneThemenKontaktName(tp.name);
                                  setShowVergangeneThemenModal(true);
                                }} onOpenZuErledigen={handleOpenZuErledigienModal} onToggleTask={handleToggleKontaktTask} onDeleteTask={handleDeleteKontaktTask} onBetreuungClick={handleOpenBetreuungsModal} onPayPerson={handlePayPerson} onShowTeilzahlungHistorie={handleShowTeilzahlungHistorie} />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <TeampartnerTable data={sortedTeampartner} onEdit={handleEdit} onDelete={handleDelete} />
                        )}
                      </div>
                    )}

                    {/* Kunden Section */}
                    {(datenFilterMode === "alle" || datenFilterMode === "kunde") && (
                      <div>
                        <h2 className="text-lg font-bold text-slate-800 mb-3 flex items-center">
                          <Users className="w-4 h-4 mr-2 text-blue-600" />
                          Kunden ({formatCount(sortedKunden)})
                        </h2>
                        
                        {sortedKunden.length === 0 ? (
                          <div className="bg-blue-50 rounded-lg p-6 text-center border border-blue-200">
                            <p className="text-blue-700 text-sm">Keine Kunden vorhanden</p>
                          </div>
                        ) : viewMode === "kachel" ? (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {sortedKunden.map(tp => (
                              <div key={tp.id} onClick={() => handleCardClick(tp)} className="cursor-pointer">
                                <TeampartnerCard tp={tp} produkte={produkte} alleSchulden={alleSchulden} onEdit={handleEdit} onDelete={handleDelete} onPromote={null} onShowVergangeneThemen={async (tp) => {
                                  // Hole frische Daten vom Server
                                  try {
                                    const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
                                    setVergangeneThemenData(response.data.vergangene_themen || []);
                                  } catch (error) {
                                    setVergangeneThemenData(tp.vergangene_themen || []);
                                  }
                                  setVergangeneThemenKontaktName(tp.name);
                                  setShowVergangeneThemenModal(true);
                                }} onOpenZuErledigen={handleOpenZuErledigienModal} onToggleTask={handleToggleKontaktTask} onDeleteTask={handleDeleteKontaktTask} onBetreuungClick={handleOpenBetreuungsModal} onPayPerson={handlePayPerson} onShowTeilzahlungHistorie={handleShowTeilzahlungHistorie} />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <TeampartnerTable data={sortedKunden} onEdit={handleEdit} onDelete={handleDelete} />
                        )}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        )}

        {activeTab === "suche" && (
          <div>
            {/* Namen-Suchfeld separat */}
            <div className="bg-white rounded-xl shadow-lg p-4 border border-slate-200 mb-4">
              <label className="block text-sm font-semibold text-slate-700 mb-2">🔍 Schnellsuche nach Name</label>
              <input
                type="text"
                value={erweiterteSucheFilter.name}
                onChange={(e) => setErweiterteSucheFilter({...erweiterteSucheFilter, name: e.target.value})}
                placeholder="Name eingeben..."
                className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-base"
              />
            </div>

            {/* Filter-Bereich */}
            <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 border border-slate-200 mb-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-slate-800">⚙️ Erweiterte Filter</h2>
                <button
                  onClick={() => setSuchFilterCollapsed(!suchFilterCollapsed)}
                  className="md:hidden text-slate-600 hover:text-slate-800"
                >
                  {suchFilterCollapsed ? "Filter anzeigen" : "Filter ausblenden"}
                </button>
              </div>
              
              <div className={`${suchFilterCollapsed ? 'hidden md:block' : 'block'} space-y-4`}>

                {/* Typ */}
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Typ</label>
                  <div className="flex flex-wrap gap-3">
                    {[
                      { value: "kaltkontakt", label: "Kontakt" },
                      { value: "teampartner", label: "Teampartner" },
                      { value: "kunde", label: "Kunde" }
                    ].map(typ => (
                      <label key={typ.value} className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={erweiterteSucheFilter.typen.includes(typ.value)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setErweiterteSucheFilter({
                                ...erweiterteSucheFilter,
                                typen: [...erweiterteSucheFilter.typen, typ.value]
                              });
                            } else {
                              setErweiterteSucheFilter({
                                ...erweiterteSucheFilter,
                                typen: erweiterteSucheFilter.typen.filter(t => t !== typ.value)
                              });
                            }
                          }}
                          className="rounded border-slate-300"
                        />
                        <span className="text-sm text-slate-700">{typ.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Stufe */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Stufe</label>
                    <select
                      multiple
                      value={erweiterteSucheFilter.stufen}
                      onChange={(e) => {
                        const selected = Array.from(e.target.selectedOptions, option => option.value);
                        setErweiterteSucheFilter({...erweiterteSucheFilter, stufen: selected});
                      }}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      size="4"
                    >
                      {["keine", "TP", "M", "SM", "MM", "IMM", "VP", "EVP", "P", "SP", "GP", "PP", "CL"].map(stufe => (
                        <option key={stufe} value={stufe}>{stufe}</option>
                      ))}
                    </select>
                    <p className="text-xs text-slate-500 mt-1">Mehrfachauswahl mit Strg/Cmd</p>
                  </div>

                  {/* Linie */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Linie</label>
                    <select
                      value={erweiterteSucheFilter.linie}
                      onChange={(e) => setErweiterteSucheFilter({...erweiterteSucheFilter, linie: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Alle</option>
                      <option value="erstlinie">Erstlinie</option>
                      {teampartner.filter(t => t.typ === 'teampartner').map(t => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Thematik */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Thematik</label>
                    <select
                      multiple
                      value={erweiterteSucheFilter.thematik}
                      onChange={(e) => {
                        const selected = Array.from(e.target.selectedOptions, option => option.value);
                        setErweiterteSucheFilter({...erweiterteSucheFilter, thematik: selected});
                      }}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      size="4"
                    >
                      {[...DEFAULT_THEMATIK_OPTIONEN, ...customThematikOptionen].map(thema => (
                        <option key={thema} value={thema}>{thema}</option>
                      ))}
                    </select>
                    <p className="text-xs text-slate-500 mt-1">Mehrfachauswahl mit Strg/Cmd</p>
                  </div>

                  {/* Produkte im Abo */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Produkte im Abo</label>
                    <select
                      multiple
                      value={erweiterteSucheFilter.produkte_im_abo}
                      onChange={(e) => {
                        const selected = Array.from(e.target.selectedOptions, option => option.value);
                        setErweiterteSucheFilter({...erweiterteSucheFilter, produkte_im_abo: selected});
                      }}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      size="4"
                    >
                      <option value="konzept-1">Konzept 1</option>
                      {produkte.map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                    <p className="text-xs text-slate-500 mt-1">Mehrfachauswahl mit Strg/Cmd</p>
                  </div>
                </div>

                {/* Veranstaltungen */}
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Veranstaltungen</label>
                  <select
                    multiple
                    value={erweiterteSucheFilter.veranstaltungen}
                    onChange={(e) => {
                      const selected = Array.from(e.target.selectedOptions, option => option.value);
                      setErweiterteSucheFilter({...erweiterteSucheFilter, veranstaltungen: selected});
                    }}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    size="3"
                  >
                    {[...DEFAULT_VERANSTALTUNG_OPTIONEN, ...customVeranstaltungOptionen].map(v => (
                      <option key={v} value={v}>{v}</option>
                    ))}
                  </select>
                  <p className="text-xs text-slate-500 mt-1">Mehrfachauswahl mit Strg/Cmd</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Termin-Status */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">Termin-Status</label>
                    <div className="space-y-2">
                      {[
                        { value: "alle", label: "Alle" },
                        { value: "ueberfaellig", label: "🔴 Überfällig" },
                        { value: "heute", label: "🔵 Heute" },
                        { value: "bald_1_3", label: "🟠 Bald (1-3 Tage)" },
                        { value: "bald_4_7", label: "🟡 In 4-7 Tagen" },
                        { value: "zukuenftig", label: "🟢 Zukünftig (>7 Tage)" }
                      ].map(status => (
                        <label key={status.value} className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="termin_status"
                            value={status.value}
                            checked={erweiterteSucheFilter.termin_status === status.value}
                            onChange={(e) => setErweiterteSucheFilter({...erweiterteSucheFilter, termin_status: e.target.value})}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700">{status.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Kontakt-Status */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">Kontakt-Status</label>
                    <div className="space-y-2">
                      {[
                        { value: "alle", label: "Alle" },
                        { value: "kritisch", label: "🔴 Kritisch (>60 Tage)" },
                        { value: "warnung", label: "🟡 Warnung (>30 Tage)" },
                        { value: "aktuell", label: "🟢 Aktuell (<30 Tage)" }
                      ].map(status => (
                        <label key={status.value} className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="radio"
                            name="kontakt_status"
                            value={status.value}
                            checked={erweiterteSucheFilter.kontakt_status === status.value}
                            onChange={(e) => setErweiterteSucheFilter({...erweiterteSucheFilter, kontakt_status: e.target.value})}
                            className="border-slate-300"
                          />
                          <span className="text-sm text-slate-700">{status.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Actionpack */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">Actionpack</label>
                    <div className="space-y-2">
                      {[
                        { value: "ja", label: "Ja" },
                        { value: "nein", label: "Nein" },
                        { value: "interesse", label: "Interesse" }
                      ].map(option => (
                        <label key={option.value} className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={erweiterteSucheFilter.actionpack.includes(option.value)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setErweiterteSucheFilter({
                                  ...erweiterteSucheFilter,
                                  actionpack: [...erweiterteSucheFilter.actionpack, option.value]
                                });
                              } else {
                                setErweiterteSucheFilter({
                                  ...erweiterteSucheFilter,
                                  actionpack: erweiterteSucheFilter.actionpack.filter(a => a !== option.value)
                                });
                              }
                            }}
                            className="rounded border-slate-300"
                          />
                          <span className="text-sm text-slate-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Cellreset */}
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">Cellreset</label>
                    <div className="space-y-2">
                      {[
                        { value: "ja", label: "Ja" },
                        { value: "nein", label: "Nein" },
                        { value: "nicht_beendet", label: "Nicht beendet" }
                      ].map(option => (
                        <label key={option.value} className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={erweiterteSucheFilter.cellreset.includes(option.value)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setErweiterteSucheFilter({
                                  ...erweiterteSucheFilter,
                                  cellreset: [...erweiterteSucheFilter.cellreset, option.value]
                                });
                              } else {
                                setErweiterteSucheFilter({
                                  ...erweiterteSucheFilter,
                                  cellreset: erweiterteSucheFilter.cellreset.filter(c => c !== option.value)
                                });
                              }
                            }}
                            className="rounded border-slate-300"
                          />
                          <span className="text-sm text-slate-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  
                  {/* Noch nicht kontaktiert */}
                  <div>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={erweiterteSucheFilter.noch_nicht_kontaktiert}
                        onChange={(e) => setErweiterteSucheFilter({...erweiterteSucheFilter, noch_nicht_kontaktiert: e.target.checked})}
                        className="rounded border-slate-300"
                      />
                      <span className="text-sm font-semibold text-slate-700">❌ Noch nicht kontaktierte Kontakte</span>
                    </label>
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex gap-3 pt-4 border-t border-slate-200">
                  <button
                    onClick={resetErweiterteSucheFilter}
                    className="px-4 py-2 bg-slate-300 hover:bg-slate-400 text-slate-800 rounded-lg font-semibold transition-colors"
                  >
                    🔄 Zurücksetzen
                  </button>
                </div>
              </div>
            </div>

            {/* Ergebnisse */}
            <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 border border-slate-200">
              {(() => {
                const gefiltert = applyErweiterteSucheFilter(teampartner || []);
                return (
                  <>
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-lg font-bold text-slate-800">
                        📊 {gefiltert.length} Ergebnis{gefiltert.length !== 1 ? 'se' : ''} gefunden
                      </h3>
                      <div className="flex gap-2">
                        <button
                          onClick={() => setViewMode("kachel")}
                          className={`px-3 py-1.5 rounded-lg transition-colors ${
                            viewMode === "kachel"
                              ? "bg-emerald-600 text-white"
                              : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                          }`}
                        >
                          Kachel
                        </button>
                        <button
                          onClick={() => setViewMode("list")}
                          className={`px-3 py-1.5 rounded-lg transition-colors ${
                            viewMode === "list"
                              ? "bg-emerald-600 text-white"
                              : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                          }`}
                        >
                          Liste
                        </button>
                      </div>
                    </div>

                    {gefiltert.length === 0 ? (
                      <div className="text-center py-12">
                        <p className="text-slate-500 text-lg">Keine Ergebnisse gefunden</p>
                        <p className="text-slate-400 text-sm mt-2">Versuche andere Filter-Einstellungen</p>
                      </div>
                    ) : (
                      <>
                        {viewMode === "kachel" ? (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {gefiltert.filter(tp => tp && tp.id).map(tp => (
                              <TeampartnerCard
                                key={tp.id}
                                tp={tp}
                                onEdit={(tp) => openDetailInEditMode(tp)}
                                onDelete={handleDelete}
                                onDetail={() => {
                                  setSelectedTeampartner(tp);
                                  setShowDetailModal(true);
                                }}
                                alleSchulden={alleSchulden || []}
                                onShowVergangeneThemen={async (tp) => {
                                  // Hole frische Daten vom Server
                                  try {
                                    const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
                                    setVergangeneThemenData(response.data.vergangene_themen || []);
                                  } catch (error) {
                                    setVergangeneThemenData(tp.vergangene_themen || []);
                                  }
                                  setVergangeneThemenKontaktName(tp.name);
                                  setShowVergangeneThemenModal(true);
                                }}
                                onOpenZuErledigen={handleOpenZuErledigienModal}
                                onToggleTask={handleToggleKontaktTask}
                                onDeleteTask={handleDeleteKontaktTask}
                                onPayPerson={handlePayPerson}
                                onShowTeilzahlungHistorie={handleShowTeilzahlungHistorie}
                              />
                            ))}
                          </div>
                        ) : (
                          <TeampartnerTable
                            data={gefiltert.filter(tp => tp && tp.id)}
                            onEdit={(tp) => openDetailInEditMode(tp)}
                            onDelete={handleDelete}
                            onDetail={(tp) => {
                              setSelectedTeampartner(tp);
                              setShowDetailModal(true);
                            }}
                            alleSchulden={alleSchulden || []}
                          />
                        )}
                      </>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        )}

        {activeTab === "schulden" && (
          <div className="bg-white rounded-xl shadow-lg p-4 md:p-8 border border-slate-200">
            {/* Überschrift in eigener Zeile */}
            <div className="mb-4">
              <h2 className="text-xl md:text-2xl font-bold text-slate-800">💰 Schulden-Verwaltung</h2>
            </div>
            
            {/* Buttons/Tabs - responsive Layout */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6">
              <div className="flex gap-2">
                {/* View Toggle Buttons */}
                <div className="flex border border-slate-300 rounded-lg overflow-hidden">
                  <button
                    onClick={() => setSchuldenViewMode("grid")}
                    className={`p-2 ${schuldenViewMode === "grid" ? "bg-blue-600 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`}
                    title="Kachelansicht"
                    data-testid="schulden-view-grid"
                  >
                    <LayoutGrid className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => setSchuldenViewMode("list")}
                    className={`p-2 ${schuldenViewMode === "list" ? "bg-blue-600 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`}
                    title="Listenansicht"
                    data-testid="schulden-view-list"
                  >
                    <List className="w-5 h-5" />
                  </button>
                </div>

                {/* Sort Toggle Button */}
                <button
                  onClick={() => setSchuldenSortMode(m => m === "faelligkeit" ? "default" : "faelligkeit")}
                  data-testid="schulden-sort-toggle"
                  title={schuldenSortMode === "faelligkeit" ? "Sortierung: Fälligkeit ↑ (klicken zum Zurücksetzen)" : "Nach Fälligkeit sortieren"}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-lg border text-sm font-medium transition-colors ${
                    schuldenSortMode === "faelligkeit"
                      ? "bg-amber-500 text-white border-amber-500 hover:bg-amber-600"
                      : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"
                  }`}
                >
                  <ArrowUpDown className="w-4 h-4" />
                  <span className="hidden sm:inline">{schuldenSortMode === "faelligkeit" ? "Fälligkeit ↑" : "Sortieren"}</span>
                </button>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  onClick={() => setShowBezahlteSchulden(true)}
                  variant="outline"
                  className="border-slate-300 text-sm"
                >
                  📜 Vergangene Schulden
                </Button>
                <Button
                  onClick={() => {
                  setSchuldenFormData({
                    name: "",
                    teampartner_id: "",
                    use_custom_name: false,
                    richtung: "erhalten_von",
                    beschreibung: "",
                    betrag: "",
                    zuschlag_prozent: 15,
                    produkt_id: "",
                    produkt_name: "",
                    price_category: "",
                    rechnung_id: "",
                    rechnung_nummer: "",
                    schulden_datum: new Date().toISOString().split('T')[0],
                    faelligkeitsdatum: ""
                  });
                  setShowSchuldenModal(true);
                }}
                className="bg-emerald-600 hover:bg-emerald-700 text-sm"
              >
                <Plus className="w-4 h-4 mr-1 sm:mr-2" />
                <span className="hidden sm:inline">Schulden hinzufügen</span>
                <span className="sm:hidden">Hinzufügen</span>
              </Button>
            </div>
            </div>

            {/* Gesamtübersicht */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              {(() => {
                const erhalten = alleSchulden.filter(s => s.richtung === "erhalten_von" && s.status === "offen").reduce((s, p) => s + p.betrag, 0);
                const schulde = alleSchulden.filter(s => s.richtung === "schulde_ich" && s.status === "offen").reduce((s, p) => s + p.betrag, 0);
                const bilanz = erhalten - schulde;
                
                return (
                  <>
                    <div className="bg-green-50 border-2 border-green-300 rounded-lg p-4">
                      <p className="text-sm text-green-700 font-medium">Kunden schulden mir</p>
                      <p className="text-2xl font-bold text-green-800 mt-2">{erhalten.toFixed(2)} €</p>
                    </div>
                    
                    <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4">
                      <p className="text-sm text-red-700 font-medium">Ich schulde Kunden</p>
                      <p className="text-2xl font-bold text-red-800 mt-2">{schulde.toFixed(2)} €</p>
                    </div>
                    
                    <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-4">
                      <p className="text-sm text-blue-700 font-medium">Bilanz</p>
                      <p className={`text-2xl font-bold mt-2 ${bilanz >= 0 ? 'text-green-800' : 'text-red-800'}`}>
                        {bilanz >= 0 ? '+' : ''}{bilanz.toFixed(2)} €
                      </p>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* Schulden-Liste pro Person */}
            {alleSchulden.filter(s => s.status === "offen").length === 0 ? (
              <div className="text-center py-12 text-slate-500">
                <p className="text-lg">Noch keine Schulden eingetragen</p>
                <p className="text-sm mt-2">Klicken Sie auf "Schulden hinzufügen" um einen Eintrag zu erstellen</p>
              </div>
            ) : schuldenViewMode === "grid" ? (
              <div className="space-y-4">
                {(() => {
                  // Gruppiere nach Name
                  const grouped = {};
                  alleSchulden.filter(s => s.status === "offen").forEach(s => {
                    if (!grouped[s.name]) {
                      grouped[s.name] = [];
                    }
                    grouped[s.name].push(s);
                  });

                  // Sortier-Modus anwenden auf Personen-Blöcke
                  let personEntries = Object.entries(grouped);
                  if (schuldenSortMode === "faelligkeit") {
                    personEntries = personEntries.sort(([, a], [, b]) => {
                      const ea = a.map(x => x.faelligkeitsdatum).filter(Boolean).sort()[0] || "9999-99-99";
                      const eb = b.map(x => x.faelligkeitsdatum).filter(Boolean).sort()[0] || "9999-99-99";
                      return ea.localeCompare(eb);
                    });
                  }

                  return personEntries.map(([name, schulden]) => {
                  const erhalten = schulden.filter(s => s.richtung === "erhalten_von").reduce((sum, p) => sum + p.betrag, 0);
                  const schulde = schulden.filter(s => s.richtung === "schulde_ich").reduce((sum, p) => sum + p.betrag, 0);
                  const bilanz = erhalten - schulde;

                  // Berechne gesamt bezahlt (inkl. Teilzahlungen) für diese Person
                  const gesamtBezahlt = alleSchulden
                    .filter(s => s.name === name)
                    .reduce((sum, p) => {
                      const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
                      if (p.status === "bezahlt" && tz === 0) return sum + p.betrag;
                      return sum + tz;
                    }, 0);

                  // Gesamt-Fälligkeit (früheste aller Posten oder "ohne Fälligkeit")
                  const faellIDatesISO = schulden
                    .map(s => s.faelligkeitsdatum)
                    .filter(d => d);
                  const earliestFaell = faellIDatesISO.length > 0
                    ? faellIDatesISO.sort()[0]
                    : null;
                  const allSameFaell = faellIDatesISO.length > 0 && faellIDatesISO.every(d => d === faellIDatesISO[0]);

                  // Hole TP-Status falls vorhanden
                  const tpInfo = schulden[0]?.teampartner_id ? teampartner.find(tp => tp.id === schulden[0].teampartner_id) : null;

                  return (
                    <div key={name} className="border border-slate-300 rounded-lg p-3 md:p-5 bg-slate-50">
                      {/* Header - Name und Bilanz */}
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1 flex-wrap">
                            <h3 className="text-base md:text-lg font-bold text-slate-800">{name}</h3>
                            {tpInfo && (
                              <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-emerald-100 text-emerald-700">
                                TP
                              </span>
                            )}
                          </div>
                          <div className="text-xs md:text-sm text-slate-600 space-y-0.5">
                            {erhalten > 0 && (
                              <p>Schuldet mir: <span className="font-semibold text-green-700">{erhalten.toFixed(2)} €</span></p>
                            )}
                            {schulde > 0 && (
                              <p>Ich schulde: <span className="font-semibold text-red-700">{schulde.toFixed(2)} €</span></p>
                            )}
                            {earliestFaell && (
                              <p className="text-xs">
                                Fällig: <span className="font-semibold text-slate-700">
                                  {new Date(earliestFaell).toLocaleDateString('de-DE')}
                                </span>
                                {!allSameFaell && <span className="text-slate-400 ml-1">(früheste)</span>}
                              </p>
                            )}
                            {!earliestFaell && (
                              <p className="text-xs text-slate-400 italic">Keine Fälligkeit gesetzt</p>
                            )}
                          </div>
                          {gesamtBezahlt > 0 && (
                            <p className="text-xs text-slate-500 mt-1">
                              Bereits bezahlt: <span className="font-semibold">{gesamtBezahlt.toFixed(2)} €</span> von <span className="font-semibold">{(erhalten + schulde).toFixed(2)} €</span>
                            </p>
                          )}
                        </div>
                        <div className={`text-base md:text-xl font-bold px-2 md:px-3 py-1 rounded flex-shrink-0 ml-2 ${bilanz >= 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                          {bilanz >= 0 ? '+' : ''}{bilanz.toFixed(2)} €
                        </div>
                      </div>
                      
                      {/* Buttons */}
                      <div className="flex flex-wrap gap-2 mb-3">
                        {/* Globaler "Bezahlt"-Button für alle offenen Schulden dieser Person */}
                        {schulden.some(p => p.status !== "bezahlt") && (
                          <Button
                            size="sm"
                            data-testid={`person-pay-${name}`}
                            onClick={() => {
                              const offenePosten = schulden.filter(p => p.status !== "bezahlt");
                              const total = offenePosten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
                              const bezahlt = offenePosten.reduce((s, p) => {
                                const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
                                return s + tz;
                              }, 0);
                              setPaymentTarget({ type: 'person', posten: offenePosten, name, total, bezahlt });
                              setPaymentAmount("");
                              setPaymentNotiz("");
                              setPaymentMode("full");
                              setShowPaymentModal(true);
                            }}
                            className="bg-green-600 hover:bg-green-700 text-xs whitespace-nowrap"
                          >
                            ✓ Bezahlt
                          </Button>
                        )}

                        {/* Teilzahlungs-Historie-Button */}
                        {schulden.some(p => (p.teilzahlungen || []).length > 0) && (
                          <Button
                            size="sm"
                            variant="outline"
                            data-testid={`person-history-${name}`}
                            onClick={() => {
                              setTeilzahlungHistorieTarget({ name, posten: schulden });
                              setShowTeilzahlungHistorie(true);
                            }}
                            className="text-xs whitespace-nowrap border-amber-300 text-amber-700 hover:bg-amber-50"
                          >
                            <History className="w-3.5 h-3.5 mr-1" />
                            Teilzahlungen
                          </Button>
                        )}

                        {/* Schulden hinzufügen Button für diese Person */}
                        <Button
                          size="sm"
                          onClick={() => {
                            const firstPosten = schulden[0];
                            const tpInfo = firstPosten?.teampartner_id ? teampartner.find(tp => tp.id === firstPosten.teampartner_id) : null;
                            
                            setSchuldenFormData({
                              name: name,
                              teampartner_id: tpInfo ? tpInfo.id : "",
                              use_custom_name: !tpInfo, // true wenn kein TP, false wenn TP
                              richtung: "erhalten_von",
                              beschreibung: "",
                              betrag: "",
                              zuschlag_prozent: 15,
                              produkt_id: "",
                              produkt_name: "",
                              price_category: "",
                              rechnung_id: "",
                              rechnung_nummer: "",
                              schulden_datum: new Date().toISOString().split('T')[0],
                              faelligkeitsdatum: ""
                            });
                            setSchuldenModalSchritt(1);
                            setShowSchuldenModal(true);
                          }}
                          className="bg-blue-600 hover:bg-blue-700 text-xs whitespace-nowrap"
                        >
                          + Neue Schulden
                        </Button>
                      </div>

                      {/* Offene Posten - gruppiert nach Gesamtschuld (gruppe_id oder 10-Min Zeitfenster) */}
                      <div className="space-y-4">
                        {(() => {
                          // Gruppierung berechnen:
                          // 1) Alle Posten mit gleicher gruppe_id → 1 Gesamtschuld
                          // 2) Alte Posten ohne gruppe_id → nach erstellt_am in 10-Min-Buckets
                          const subgroups = [];
                          const seenGroupIds = new Map(); // gruppe_id → index in subgroups
                          const sortedSchulden = [...schulden].sort((a, b) => (a.erstellt_am || '').localeCompare(b.erstellt_am || ''));
                          sortedSchulden.forEach(p => {
                            if (p.gruppe_id) {
                              if (seenGroupIds.has(p.gruppe_id)) {
                                subgroups[seenGroupIds.get(p.gruppe_id)].posten.push(p);
                              } else {
                                seenGroupIds.set(p.gruppe_id, subgroups.length);
                                subgroups.push({ gruppe_id: p.gruppe_id, posten: [p] });
                              }
                            } else {
                              // Ohne gruppe_id: in letzte subgroup einfügen wenn erstellt_am < 10 Min
                              const last = subgroups[subgroups.length - 1];
                              const lastTime = last?.posten?.[last.posten.length - 1]?.erstellt_am;
                              const thisTime = p.erstellt_am;
                              if (last && !last.gruppe_id && lastTime && thisTime &&
                                  Math.abs(new Date(thisTime) - new Date(lastTime)) < 10 * 60 * 1000) {
                                last.posten.push(p);
                              } else {
                                subgroups.push({ gruppe_id: null, posten: [p] });
                              }
                            }
                          });

                          return subgroups.map((sg, sgIdx) => {
                            const sgTotal = sg.posten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
                            const sgBezahlt = sg.posten.reduce((s, p) => {
                              const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
                              if (p.status === "bezahlt" && tz === 0) return s + p.betrag;
                              return s + tz;
                            }, 0);
                            const sgFaell = sg.posten[0]?.faelligkeitsdatum;
                            const sgDatum = sg.posten[0]?.schulden_datum;
                            const sgHatTeilzahlungen = sg.posten.some(p => (p.teilzahlungen || []).length > 0);
                            return { sg, sgIdx, sgTotal, sgBezahlt, sgFaell, sgDatum, sgHatTeilzahlungen };
                          }).sort((a, b) => {
                            if (schuldenSortMode !== "faelligkeit") return 0;
                            const af = a.sgFaell || "9999-99-99";
                            const bf = b.sgFaell || "9999-99-99";
                            return af.localeCompare(bf);
                          }).map(({ sg, sgIdx, sgTotal, sgBezahlt, sgFaell, sgDatum, sgHatTeilzahlungen }) => {
                            // Fälligkeits-Status für farbige Badge
                            let faellBadgeClass = "bg-slate-100 text-slate-600 border-slate-200";
                            let faellPrefix = "Fällig";
                            if (sgFaell) {
                              const today = new Date(); today.setHours(0, 0, 0, 0);
                              const fdate = new Date(sgFaell); fdate.setHours(0, 0, 0, 0);
                              if (fdate < today) {
                                faellBadgeClass = "bg-red-100 text-red-700 border-red-200";
                                faellPrefix = "Überfällig";
                              } else if (fdate.getTime() === today.getTime()) {
                                faellBadgeClass = "bg-orange-100 text-orange-700 border-orange-200";
                                faellPrefix = "Heute fällig";
                              } else {
                                faellBadgeClass = "bg-emerald-50 text-emerald-700 border-emerald-200";
                              }
                            }
                            return (
                              <div key={sg.gruppe_id || `time-${sgIdx}`}
                                className="border-2 border-slate-200 rounded-xl p-3 bg-white shadow-sm">
                                {/* Schuld-Header */}
                                <div className="flex items-start justify-between gap-2 pb-2 mb-2 border-b border-slate-100 flex-wrap">
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap mb-1.5">
                                      <span className="text-xs font-bold text-slate-700 uppercase tracking-wide">
                                        {sg.posten[0]?.gruppe_name ? (
                                          <>📄 Rechnung {sg.posten[0].gruppe_name}</>
                                        ) : (
                                          <>Schuld {sgIdx + 1}</>
                                        )} <span className="text-slate-400 font-normal normal-case">· {sg.posten.length} {sg.posten[0]?.gruppe_name ? 'Positionen' : (sg.posten.length === 1 ? 'Posten' : 'Posten')}</span>
                                      </span>
                                      <button type="button"
                                        data-testid={`subgroup-edit-${sg.gruppe_id || sgIdx}`}
                                        onClick={() => {
                                          setGroupEditData({
                                            name: name,
                                            faelligkeitsdatum: sgFaell || "",
                                            ids: sg.posten.map(p => p.id),
                                          });
                                          setShowGroupEditModal(true);
                                        }}
                                        className="text-xs text-slate-400 hover:text-blue-600" title="Fälligkeit dieser Schuld ändern">
                                        ✎
                                      </button>
                                    </div>
                                    {/* Farbige Badges: Erstellt + Fällig */}
                                    <div className="flex items-center gap-1.5 flex-wrap">
                                      {sgDatum && (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-blue-50 text-blue-700 border border-blue-200">
                                          📅 Erstellt: {new Date(sgDatum).toLocaleDateString('de-DE')}
                                        </span>
                                      )}
                                      {sgFaell ? (
                                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium border ${faellBadgeClass}`}>
                                          ⏰ {faellPrefix}: {new Date(sgFaell).toLocaleDateString('de-DE')}
                                        </span>
                                      ) : (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-slate-50 text-slate-400 border border-slate-200 italic">
                                          ⏰ Keine Fälligkeit
                                        </span>
                                      )}
                                      {sgHatTeilzahlungen && (
                                        <button type="button"
                                          data-testid={`subgroup-history-${sg.gruppe_id || sgIdx}`}
                                          onClick={() => {
                                            setTeilzahlungHistorieTarget({ name, posten: sg.posten });
                                            setShowTeilzahlungHistorie(true);
                                          }}
                                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100 transition-colors">
                                          <History className="w-3 h-3" /> Teilzahlungen
                                        </button>
                                      )}
                                      {hasErspanis(sg.posten) && (
                                        <button type="button"
                                          data-testid={`subgroup-pdf-${sg.gruppe_id || sgIdx}`}
                                          onClick={() => {
                                            downloadErspanisPdf({
                                              kundenName: name,
                                              posten: sg.posten,
                                              datum: sg.posten[0]?.schulden_datum || new Date().toISOString(),
                                              firmenName: userCompanyName,
                                            });
                                          }}
                                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 transition-colors"
                                          title="Ersparnis-PDF herunterladen">
                                          <FileText className="w-3 h-3" /> PDF
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="text-right">
                                      <p className="text-sm font-bold text-slate-800">{sgTotal.toFixed(2)} €</p>
                                      {sgBezahlt > 0 && (
                                        <p className="text-xs text-emerald-600">{sgBezahlt.toFixed(2)} € bezahlt</p>
                                      )}
                                    </div>
                                    {sg.posten.some(p => p.status !== "bezahlt") && (
                                      <Button size="sm"
                                        data-testid={`subgroup-pay-${sg.gruppe_id || sgIdx}`}
                                        onClick={() => {
                                          setPaymentTarget({ type: 'group', posten: sg.posten, name, total: sgTotal, bezahlt: sgBezahlt });
                                          setPaymentAmount("");
                                          setPaymentNotiz("");
                                          setPaymentMode("full");
                                          setShowPaymentModal(true);
                                        }}
                                        className="bg-green-600 hover:bg-green-700 text-xs">
                                        ✓ Bezahlt
                                      </Button>
                                    )}
                                  </div>
                                </div>

                                {/* Einzelposten der Schuld */}
                                <div className="space-y-2">
                                  {sg.posten.map(posten => (
                          <div key={posten.id} className={`flex flex-col md:flex-row md:items-center md:justify-between p-4 rounded-lg gap-3 ${
                            posten.richtung === "erhalten_von" ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"
                          }`}>
                            <div className="flex-1">
                              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 mb-2">
                                <span className="text-sm text-slate-500">Wegen:</span>
                                <p className="text-lg font-bold text-slate-800">
                                  {posten.produkt_name || posten.beschreibung}
                                </p>
                                {posten.menge && (
                                  <span className="inline-flex items-center px-2 py-0.5 rounded-md text-sm font-bold bg-indigo-100 text-indigo-700 border border-indigo-300">
                                    Menge: {posten.menge}x
                                  </span>
                                )}
                                <button type="button"
                                  data-testid={`posten-edit-${posten.id}`}
                                  onClick={() => {
                                    setPostenEditData({
                                      id: posten.id,
                                      produkt_name: posten.produkt_name || "",
                                      beschreibung: posten.beschreibung || "",
                                    });
                                    setShowPostenEditModal(true);
                                  }}
                                  className="text-xs text-slate-400 hover:text-blue-600" title="Name/Beschreibung bearbeiten">
                                  ✎
                                </button>
                              </div>
                              {posten.produkt_name && posten.beschreibung && (
                                <p className="text-sm text-slate-600 sm:ml-16 mb-1">→ {posten.beschreibung}</p>
                              )}
                              {posten.rechnung_nummer && (
                                <div className="text-xs text-slate-500">Rechnung #{posten.rechnung_nummer}</div>
                              )}
                            </div>
                            <div className="flex items-center justify-between md:justify-end gap-3 pt-2 md:pt-0 border-t md:border-t-0 border-slate-200">
                              <span className="text-lg font-bold text-slate-800">{posten.betrag.toFixed(2)} €</span>
                              <div className="flex items-center gap-2">
                                <Button
                                  size="sm"
                                  onClick={async () => {
                                    try {
                                      await axios.put(`${API}/api/schulden/${posten.id}/bezahlt`);
                                      toast.success("Als bezahlt markiert");
                                      loadSchulden();
                                    } catch (error) {
                                      toast.error("Fehler beim Aktualisieren");
                                    }
                                  }}
                                  className="bg-green-600 hover:bg-green-700 text-xs"
                                >
                                  ✓ Bezahlt
                                </Button>
                                <button
                                  onClick={async () => {
                                    if (window.confirm("Schulden-Posten wirklich löschen?")) {
                                      try {
                                        await axios.delete(`${API}/api/schulden/${posten.id}`);
                                        toast.success("Posten gelöscht");
                                        loadSchulden();
                                      } catch (error) {
                                        toast.error("Fehler beim Löschen");
                                      }
                                    }
                                  }}
                                  className="text-red-500 hover:text-red-700"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          </div>
                                  ))}
                                </div>
                              </div>
                            );
                          });
                        })()}
                      </div>
                    </div>
                  );
                });
              })()}
              </div>
            ) : (
              /* Listenansicht - Kompakte Blöcke mit gruppe_id-Gruppierung */
              <div className="space-y-3 md:space-y-4">
                {alleSchulden.filter(s => s.status === "offen").length === 0 ? (
                  <div className="text-center py-12 text-slate-500">
                    <p className="text-lg">Noch keine Schulden eingetragen</p>
                    <p className="text-sm mt-2">Klicken Sie auf "Schulden hinzufügen" um einen Eintrag zu erstellen</p>
                  </div>
                ) : (
                  (() => {
                    // Gruppiere nach Name
                    const grouped = {};
                    alleSchulden.filter(s => s.status === "offen").forEach(s => {
                      if (!grouped[s.name]) grouped[s.name] = [];
                      grouped[s.name].push(s);
                    });

                    // Sortierung anwenden
                    let personEntries = Object.entries(grouped);
                    if (schuldenSortMode === "faelligkeit") {
                      personEntries = personEntries.sort(([, a], [, b]) => {
                        const ea = a.map(x => x.faelligkeitsdatum).filter(Boolean).sort()[0] || "9999-99-99";
                        const eb = b.map(x => x.faelligkeitsdatum).filter(Boolean).sort()[0] || "9999-99-99";
                        return ea.localeCompare(eb);
                      });
                    }

                    return personEntries.map(([name, schulden]) => {
                      const erhalten = schulden.filter(s => s.richtung === "erhalten_von").reduce((sum, p) => sum + p.betrag, 0);
                      const schulde = schulden.filter(s => s.richtung === "schulde_ich").reduce((sum, p) => sum + p.betrag, 0);
                      const bilanz = erhalten - schulde;
                      const tpInfo = schulden[0]?.teampartner_id ? teampartner.find(tp => tp.id === schulden[0].teampartner_id) : null;

                      // Subgroups berechnen (gleiche Logik wie Grid)
                      const subgroups = [];
                      const seenGroupIds = new Map();
                      const sortedSchulden = [...schulden].sort((a, b) => (a.erstellt_am || '').localeCompare(b.erstellt_am || ''));
                      sortedSchulden.forEach(p => {
                        if (p.gruppe_id) {
                          if (seenGroupIds.has(p.gruppe_id)) {
                            subgroups[seenGroupIds.get(p.gruppe_id)].posten.push(p);
                          } else {
                            seenGroupIds.set(p.gruppe_id, subgroups.length);
                            subgroups.push({ gruppe_id: p.gruppe_id, posten: [p] });
                          }
                        } else {
                          const last = subgroups[subgroups.length - 1];
                          const lastTime = last?.posten?.[last.posten.length - 1]?.erstellt_am;
                          const thisTime = p.erstellt_am;
                          if (last && !last.gruppe_id && lastTime && thisTime &&
                              Math.abs(new Date(thisTime) - new Date(lastTime)) < 10 * 60 * 1000) {
                            last.posten.push(p);
                          } else {
                            subgroups.push({ gruppe_id: null, posten: [p] });
                          }
                        }
                      });

                      const enrichedSubgroups = subgroups.map((sg, sgIdx) => {
                        const sgTotal = sg.posten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
                        const sgBezahlt = sg.posten.reduce((s, p) => {
                          const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
                          if (p.status === "bezahlt" && tz === 0) return s + p.betrag;
                          return s + tz;
                        }, 0);
                        const sgFaell = sg.posten[0]?.faelligkeitsdatum;
                        const sgDatum = sg.posten[0]?.schulden_datum;
                        const sgHatTeilzahlungen = sg.posten.some(p => (p.teilzahlungen || []).length > 0);
                        return { sg, sgIdx, sgTotal, sgBezahlt, sgFaell, sgDatum, sgHatTeilzahlungen };
                      }).sort((a, b) => {
                        if (schuldenSortMode !== "faelligkeit") return 0;
                        const af = a.sgFaell || "9999-99-99";
                        const bf = b.sgFaell || "9999-99-99";
                        return af.localeCompare(bf);
                      });

                      return (
                        <div key={name} className="border border-slate-300 rounded-lg overflow-hidden bg-white">
                          {/* Personen-Header */}
                          <div className="bg-slate-100 px-3 py-2.5 border-b border-slate-300 flex items-center justify-between gap-2 flex-wrap">
                            <div className="flex items-center gap-2 flex-wrap min-w-0">
                              <h3 className="text-base font-bold text-slate-800 truncate">{name}</h3>
                              {tpInfo && (
                                <span className="px-1.5 py-0.5 text-[10px] font-semibold rounded bg-emerald-100 text-emerald-700">TP</span>
                              )}
                              <span className="text-xs text-slate-500">· {schulden.length} Posten / {enrichedSubgroups.length} Schuld{enrichedSubgroups.length !== 1 ? 'en' : ''}</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                              {schulden.some(p => (p.teilzahlungen || []).length > 0) && (
                                <button
                                  data-testid={`person-history-list-${name}`}
                                  onClick={() => {
                                    setTeilzahlungHistorieTarget({ name, posten: schulden });
                                    setShowTeilzahlungHistorie(true);
                                  }}
                                  className="inline-flex items-center gap-1 px-2 py-1 rounded text-[11px] font-medium border border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100"
                                >
                                  <History className="w-3 h-3" /> TZ
                                </button>
                              )}
                              <button
                                data-testid={`person-pay-list-${name}`}
                                onClick={() => {
                                  const offenePosten = schulden.filter(p => p.status !== "bezahlt");
                                  const total = offenePosten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
                                  const bezahlt = offenePosten.reduce((s, p) => {
                                    const tz = (p.teilzahlungen || []).reduce((a, t) => a + (parseFloat(t.betrag) || 0), 0);
                                    return s + tz;
                                  }, 0);
                                  setPaymentTarget({ type: 'person', posten: offenePosten, name, total, bezahlt });
                                  setPaymentAmount("");
                                  setPaymentNotiz("");
                                  setPaymentMode("full");
                                  setShowPaymentModal(true);
                                }}
                                className="px-2 py-1 rounded text-[11px] font-semibold bg-green-600 hover:bg-green-700 text-white"
                              >
                                ✓ Bezahlt
                              </button>
                              <span className={`text-sm font-bold px-2 py-0.5 rounded ${bilanz >= 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                {bilanz >= 0 ? '+' : ''}{bilanz.toFixed(2)} €
                              </span>
                            </div>
                          </div>

                          {/* Kompakte Schuld-Zeilen */}
                          <div className="divide-y divide-slate-100">
                            {enrichedSubgroups.map(({ sg, sgIdx, sgTotal, sgBezahlt, sgFaell, sgDatum, sgHatTeilzahlungen }) => {
                              let faellBadgeClass = "bg-slate-100 text-slate-600 border-slate-200";
                              let faellPrefix = "Fällig";
                              if (sgFaell) {
                                const today = new Date(); today.setHours(0, 0, 0, 0);
                                const fdate = new Date(sgFaell); fdate.setHours(0, 0, 0, 0);
                                if (fdate < today) { faellBadgeClass = "bg-red-100 text-red-700 border-red-200"; faellPrefix = "Überfällig"; }
                                else if (fdate.getTime() === today.getTime()) { faellBadgeClass = "bg-orange-100 text-orange-700 border-orange-200"; faellPrefix = "Heute"; }
                                else { faellBadgeClass = "bg-emerald-50 text-emerald-700 border-emerald-200"; }
                              }
                              return (
                                <div key={sg.gruppe_id || `lst-${sgIdx}`} className="px-3 py-2">
                                  <div className="flex items-center justify-between gap-2 flex-wrap">
                                    <div className="flex items-center gap-2 flex-wrap min-w-0 flex-1">
                                      <span className="text-[11px] font-bold text-slate-700 uppercase tracking-wide whitespace-nowrap">
                                        {sg.posten[0]?.gruppe_name ? (
                                          <>📄 {sg.posten[0].gruppe_name}</>
                                        ) : (
                                          <>Schuld {sgIdx + 1}</>
                                        )}
                                      </span>
                                      <span className="text-xs text-slate-500">· {sg.posten.length}×</span>
                                      {sgDatum && (
                                        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-50 text-blue-700 border border-blue-200">
                                          📅 {new Date(sgDatum).toLocaleDateString('de-DE')}
                                        </span>
                                      )}
                                      {sgFaell ? (
                                        <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium border ${faellBadgeClass}`}>
                                          ⏰ {faellPrefix}: {new Date(sgFaell).toLocaleDateString('de-DE')}
                                        </span>
                                      ) : (
                                        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] italic text-slate-400 border border-slate-200">
                                          ⏰ keine Fälligkeit
                                        </span>
                                      )}
                                      <button type="button"
                                        data-testid={`subgroup-edit-list-${sg.gruppe_id || sgIdx}`}
                                        onClick={() => {
                                          setGroupEditData({ name: name, faelligkeitsdatum: sgFaell || "", ids: sg.posten.map(p => p.id) });
                                          setShowGroupEditModal(true);
                                        }}
                                        className="text-slate-400 hover:text-blue-600 text-xs" title="Fälligkeit ändern">
                                        ✎
                                      </button>
                                      {sgHatTeilzahlungen && (
                                        <button type="button"
                                          onClick={() => {
                                            setTeilzahlungHistorieTarget({ name, posten: sg.posten });
                                            setShowTeilzahlungHistorie(true);
                                          }}
                                          className="inline-flex items-center gap-0.5 text-[10px] text-amber-700 hover:text-amber-900">
                                          <History className="w-3 h-3" />
                                        </button>
                                      )}
                                      {hasErspanis(sg.posten) && (
                                        <button type="button"
                                          onClick={() => {
                                            downloadErspanisPdf({
                                              kundenName: name,
                                              posten: sg.posten,
                                              datum: sg.posten[0]?.schulden_datum || new Date().toISOString(),
                                              firmenName: userCompanyName,
                                            });
                                          }}
                                          className="inline-flex items-center gap-0.5 text-[10px] text-emerald-700 hover:text-emerald-900"
                                          title="Ersparnis-PDF herunterladen">
                                          <FileText className="w-3 h-3" />
                                        </button>
                                      )}
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <div className="text-right">
                                        <span className="text-sm font-bold text-slate-800">{sgTotal.toFixed(2)} €</span>
                                        {sgBezahlt > 0 && <span className="text-[10px] text-emerald-600 ml-1">(-{sgBezahlt.toFixed(2)})</span>}
                                      </div>
                                      {sg.posten.some(p => p.status !== "bezahlt") && (
                                        <button
                                          data-testid={`subgroup-pay-list-${sg.gruppe_id || sgIdx}`}
                                          onClick={() => {
                                            setPaymentTarget({ type: 'group', posten: sg.posten, name, total: sgTotal, bezahlt: sgBezahlt });
                                            setPaymentAmount("");
                                            setPaymentNotiz("");
                                            setPaymentMode("full");
                                            setShowPaymentModal(true);
                                          }}
                                          className="px-2 py-1 rounded text-[11px] font-semibold bg-green-600 hover:bg-green-700 text-white">
                                          ✓
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  {/* Posten-Details dünn darunter */}
                                  <div className="mt-1 pl-2 space-y-0.5">
                                    {sg.posten.map(posten => (
                                      <div key={posten.id} className={`flex items-center justify-between gap-2 text-xs px-2 py-1 rounded ${posten.richtung === "erhalten_von" ? "bg-green-50" : "bg-red-50"}`}>
                                        <div className="flex items-center gap-2 min-w-0 flex-1">
                                          <span className="truncate font-medium text-slate-700">{posten.produkt_name || posten.beschreibung}</span>
                                          {posten.menge && (
                                            <span className="px-1.5 py-0.5 rounded text-[11px] font-bold bg-indigo-100 text-indigo-700 border border-indigo-300 whitespace-nowrap">Menge: {posten.menge}x</span>
                                          )}
                                          {posten.rechnung_nummer && <span className="text-slate-400 text-[10px]">#{posten.rechnung_nummer}</span>}
                                        </div>
                                        <div className="flex items-center gap-2 whitespace-nowrap">
                                          <span className="font-semibold text-slate-800">{posten.betrag.toFixed(2)} €</span>
                                          <button onClick={async () => {
                                            if (window.confirm("Posten löschen?")) {
                                              try { await axios.delete(`${API}/api/schulden/${posten.id}`); toast.success("Gelöscht"); loadSchulden(); }
                                              catch { toast.error("Fehler"); }
                                            }
                                          }} className="text-red-400 hover:text-red-600">
                                            <Trash2 className="w-3 h-3" />
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          {/* Footer: Neue Schulden */}
                          <div className="bg-slate-50 px-3 py-2 border-t border-slate-200">
                            <Button
                              size="sm"
                              onClick={() => {
                                setSchuldenFormData({
                                  name: name, teampartner_id: tpInfo ? tpInfo.id : "", use_custom_name: !tpInfo,
                                  richtung: "erhalten_von", beschreibung: "", betrag: "", zuschlag_prozent: 15,
                                  produkt_id: "", produkt_name: "", price_category: "", rechnung_id: "",
                                  rechnung_nummer: "", schulden_datum: new Date().toISOString().split('T')[0], faelligkeitsdatum: ""
                                });
                                setSchuldenModalSchritt(1);
                                setShowSchuldenModal(true);
                              }}
                              className="bg-blue-600 hover:bg-blue-700 text-xs"
                            >
                              + Neue Schulden
                            </Button>
                          </div>
                        </div>
                      );
                    });
                  })()
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Thematik-Manager Modal */}
      {showThematikManager && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-800">Thematik-Liste verwalten</h3>
              <button
                onClick={() => setShowThematikManager(false)}
                className="text-slate-400 hover:text-slate-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <p className="text-sm text-slate-600 mb-4">
              Diese Themen stehen bei allen Kontakten zur Auswahl. Standard-Themen können nicht gelöscht werden.
            </p>
            
            {/* Neue Thematik hinzufügen */}
            <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <Label htmlFor="neue_globale_thematik" className="text-blue-800">Neue Thematik hinzufügen</Label>
              <div className="flex gap-2 mt-2">
                <Input
                  id="neue_globale_thematik"
                  value={neueGlobaleThematik}
                  onChange={(e) => setNeueGlobaleThematik(e.target.value)}
                  placeholder="z.B. Rückenschmerzen"
                  onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addGlobaleThematik())}
                  className="bg-white"
                />
                <Button type="button" onClick={addGlobaleThematik} className="bg-blue-600 hover:bg-blue-700">
                  + Hinzufügen
                </Button>
              </div>
            </div>
            
            {/* Liste aller Thematiken */}
            <div className="space-y-2">
              <h4 className="font-semibold text-slate-700 mb-2">Alle Thematiken ({THEMATIK_OPTIONEN.length}):</h4>
              <div className="grid grid-cols-1 gap-2 max-h-96 overflow-y-auto">
                {THEMATIK_OPTIONEN.map(thema => {
                  const isDefault = DEFAULT_THEMATIK_OPTIONEN.includes(thema);
                  return (
                    <div
                      key={thema}
                      className={`flex items-center justify-between p-3 rounded-lg border ${
                        isDefault 
                          ? 'bg-slate-50 border-slate-200' 
                          : 'bg-blue-50 border-blue-200'
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-slate-700">{thema}</span>
                        {!isDefault && (
                          <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full">
                            Eigene
                          </span>
                        )}
                      </div>
                      {!isDefault && (
                        <button
                          onClick={() => removeGlobaleThematik(thema)}
                          className="text-red-500 hover:text-red-700 text-sm font-bold"
                        >
                          Löschen
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            
            <div className="flex justify-end mt-6">
              <Button
                onClick={() => setShowThematikManager(false)}
                className="bg-emerald-600 hover:bg-emerald-700"
              >
                Fertig
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Veranstaltungs-Manager Modal */}
      {showVeranstaltungManager && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-800">Veranstaltungs-Liste verwalten</h3>
              <button
                onClick={() => setShowVeranstaltungManager(false)}
                className="text-slate-400 hover:text-slate-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <p className="text-sm text-slate-600 mb-4">
              Diese Veranstaltungen stehen bei allen Kontakten zur Auswahl. Standard-Veranstaltungen können nicht gelöscht werden.
            </p>
            
            {/* Neue Veranstaltung hinzufügen */}
            <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <Label className="text-blue-800">Neue Veranstaltung hinzufügen</Label>
              <div className="flex gap-2 mt-2">
                <Input
                  value={neueGlobaleThematik}
                  onChange={(e) => setNeueGlobaleThematik(e.target.value)}
                  placeholder="z.B. Workshop XYZ"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (neueGlobaleThematik.trim() && !VERANSTALTUNG_OPTIONEN.includes(neueGlobaleThematik.trim())) {
                        const newOptions = [...customVeranstaltungOptionen, neueGlobaleThematik.trim()];
                        setCustomVeranstaltungOptionen(newOptions);
                        userStorage.setItem('customVeranstaltungOptionen', JSON.stringify(newOptions));
                        setNeueGlobaleThematik("");
                        toast.success("Veranstaltung hinzugefügt");
                      }
                    }
                  }}
                  className="bg-white"
                />
                <Button
                  type="button"
                  onClick={() => {
                    if (neueGlobaleThematik.trim() && !VERANSTALTUNG_OPTIONEN.includes(neueGlobaleThematik.trim())) {
                      const newOptions = [...customVeranstaltungOptionen, neueGlobaleThematik.trim()];
                      setCustomVeranstaltungOptionen(newOptions);
                      userStorage.setItem('customVeranstaltungOptionen', JSON.stringify(newOptions));
                      setNeueGlobaleThematik("");
                      toast.success("Veranstaltung hinzugefügt");
                    }
                  }}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  + Hinzufügen
                </Button>
              </div>
            </div>
            
            {/* Liste aller Veranstaltungen */}
            <div className="space-y-2">
              <h4 className="font-semibold text-slate-700 mb-2">Alle Veranstaltungen ({VERANSTALTUNG_OPTIONEN.length}):</h4>
              <div className="grid grid-cols-1 gap-2 max-h-96 overflow-y-auto">
                {VERANSTALTUNG_OPTIONEN.map(veranstaltung => {
                  const isDefault = DEFAULT_VERANSTALTUNG_OPTIONEN.includes(veranstaltung);
                  return (
                    <div
                      key={veranstaltung}
                      className={`flex items-center justify-between p-3 rounded-lg border ${
                        isDefault 
                          ? 'bg-slate-50 border-slate-200' 
                          : 'bg-blue-50 border-blue-200'
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-slate-700">{veranstaltung}</span>
                        {!isDefault && (
                          <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full">
                            Eigene
                          </span>
                        )}
                      </div>
                      {!isDefault && (
                        <button
                          onClick={() => {
                            const newOptions = customVeranstaltungOptionen.filter(v => v !== veranstaltung);
                            setCustomVeranstaltungOptionen(newOptions);
                            userStorage.setItem('customVeranstaltungOptionen', JSON.stringify(newOptions));
                            toast.success("Veranstaltung gelöscht");
                          }}
                          className="text-red-500 hover:text-red-700 text-sm font-bold"
                        >
                          Löschen
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            
            <div className="flex justify-end mt-6">
              <Button
                onClick={() => setShowVeranstaltungManager(false)}
                className="bg-emerald-600 hover:bg-emerald-700"
              >
                Fertig
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Datum & Uhrzeit Picker Modal */}
      {showDateTimePicker && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[95] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" data-tour="termin-wizard-container">
            {/* Farbiger Header */}
            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex justify-between items-center">
              <div>
                <p className="text-emerald-100 text-xs font-medium uppercase tracking-wider mb-0.5">{dtIsErsterTermin ? "Erster Termin" : "Nächster Termin"}</p>
                <h3 className="text-white text-lg font-bold">
                  {dateTimeStep === 1 ? "Datum & Uhrzeit"
                    : dateTimeStep === 3 ? "Kontakt hergestellt?"
                    : dateTimeStep === 4 ? "Zuletzt kontaktiert?"
                    : dateTimeStep === 5 ? "Gesprächsverlauf"
                    : "Nächstes Thema"}
                </h3>
              </div>
              <button onClick={handleDateTimeCancel} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10">
                <X className="w-5 h-5" />
              </button>
            </div>
            {/* Fortschrittsbalken – bei TP/Kunde wird Schritt 3 (Kontakt-Frage) übersprungen */}
            <div className="flex">
              {(() => {
                const _typ = naechsterTerminModalIsDetail ? tempEditData?.typ : formData.typ;
                const _skip = _typ === 'teampartner' || _typ === 'kunde';
                const _kontaktiertFalse = (naechsterTerminModalIsDetail ? tempEditData?.kontaktiert : formData.kontaktiert) === false;
                const steps = (!_skip && _kontaktiertFalse) ? [1,3,4,5,6] : [1,4,5,6];
                return steps.map((s, i) => (
                  <div key={i} className={`h-1 flex-1 transition-colors ${dateTimeStep >= s ? 'bg-emerald-500' : 'bg-slate-200'}`} />
                ));
              })()}
            </div>

            <div className="p-6 space-y-4">

            {/* Schritt 1: Datum & Uhrzeit (kombiniert) */}
            {dateTimeStep === 1 && (
              <div className="space-y-4">
                <div data-tour="termin-wizard-datum-feld">
                  <label className="block text-sm font-medium text-slate-600 mb-1">Datum</label>
                  <Input type="date" min={new Date().toISOString().split('T')[0]} value={tempDate}
                    onChange={(e) => { setTempDate(e.target.value); setDtOverlapError(""); }}
                    className="text-base h-12" />
                </div>
                <div className="grid grid-cols-2 gap-3" data-tour="termin-wizard-uhrzeit-feld">
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1">Von</label>
                    <Input type="time" value={dtStartTime}
                      onChange={(e) => {
                        const v = e.target.value;
                        setDtStartTime(v);
                        if (v) {
                          const h = parseInt(v.split(':')[0]);
                          const m = v.split(':')[1];
                          setDtEndTime(`${String(Math.min(h + 1, 23)).padStart(2, '0')}:${m}`);
                        }
                        setDtOverlapError("");
                      }}
                      className="text-base h-12" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1">Bis</label>
                    <Input type="time" value={dtEndTime}
                      onChange={(e) => { setDtEndTime(e.target.value); setDtOverlapError(""); }}
                      className="text-base h-12" />
                    {dtEndTime && dtStartTime && dtEndTime <= dtStartTime && (
                      <p className="text-red-500 text-xs mt-1">Endzeit muss nach Startzeit sein</p>
                    )}
                  </div>
                </div>
                {dtOverlapError && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                    <p className="text-red-600 text-sm font-medium">⚠ Terminkonflikt!</p>
                    <p className="text-red-500 text-xs mt-1">{dtOverlapError}</p>
                  </div>
                )}
                {/* Mini-Kalender Vorschau Button */}
                <button
                  type="button"
                  data-tour="termin-wizard-kalender-vorschau"
                  onClick={() => {
                    if (tempDate) setWeekModalDate(new Date(tempDate + 'T12:00:00'));
                    setShowWeekModal(true);
                    setShowTodosPanel(false);
                  }}
                  className="flex items-center gap-2 text-sm text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-200 transition-all"
                >
                  <CalendarDays className="w-4 h-4" />
                  <span>Kalender-Vorschau</span>
                </button>
                <div className="flex gap-3">
                  <Button onClick={handleDateTimeCancel} variant="outline" className="flex-1 h-11">Abbrechen</Button>
                  <Button data-tour="termin-wizard-weiter-btn" onClick={handleDateTimeNext} disabled={!tempDate || !dtStartTime || !dtEndTime || (dtEndTime <= dtStartTime)}
                    className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                </div>
              </div>
            )}

            {/* Schritt 3: Kontakt hergestellt? (nur bei kontaktiert=false) */}
            {dateTimeStep === 3 && (
              <div className="space-y-3">
                <p className="text-sm text-slate-500">Hast du mit dieser Person {dtIsErsterTermin ? "schon" : "inzwischen"} Kontakt aufgenommen?</p>
                {[
                  { val: "ja", icon: "✅", label: "Ja, Kontakt wurde hergestellt", sub: "Kontaktiert? wird auf Ja gesetzt", color: "emerald" },
                  { val: "nein", icon: "⏳", label: "Nein, noch kein Kontakt", sub: "Bleibt unverändert", color: "slate" }
                ].map(opt => (
                  <label key={opt.val} onClick={() => setDtWurdeKontaktiert(opt.val)}
                    className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${dtWurdeKontaktiert === opt.val ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`}>
                    <span className="text-2xl">{opt.icon}</span>
                    <div className="flex-1">
                      <p className="font-semibold text-slate-800">{opt.label}</p>
                      <p className="text-xs text-slate-400 mt-0.5">{opt.sub}</p>
                    </div>
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${dtWurdeKontaktiert === opt.val ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300'}`}>
                      {dtWurdeKontaktiert === opt.val && <div className="w-2 h-2 rounded-full bg-white" />}
                    </div>
                  </label>
                ))}
                <div className="flex gap-3 pt-1">
                  <Button onClick={() => setDateTimeStep(1)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                  <Button disabled={!dtWurdeKontaktiert}
                    onClick={() => {
                      if (dtWurdeKontaktiert === "ja") {
                        setFormData(prev => ({ ...prev, kontaktiert: true }));
                        if (naechsterTerminModalIsDetail) setTempEditData(prev => ({ ...prev, kontaktiert: true }));
                        setDateTimeStep(4);
                      }
                      else setDateTimeStep(6); // Nein → kein Zuletzt kontaktiert, kein Verlauf
                    }}
                    className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                </div>
              </div>
            )}

            {/* Schritt 4: Zuletzt kontaktiert */}
            {dateTimeStep === 4 && (
              <div className="space-y-3" data-tour="termin-wizard-zuletzt-kontaktiert">
                <p className="text-sm text-slate-500">Wann wurde zuletzt Kontakt aufgenommen?</p>
                {[
                  { val: "heute", icon: "📅", label: `Heute (${new Date().toLocaleDateString('de-DE')})`, sub: "Wird als heutiges Datum gesetzt" },
                  { val: "custom", icon: "🗓️", label: "Anderes Datum wählen", sub: "", dataTour: "termin-wizard-anderes-datum" },
                  { val: "nein", icon: "⏭️", label: "Nicht aktualisieren", sub: "Datum bleibt unverändert" }
                ].map(opt => (
                  <label key={opt.val} {...(opt.dataTour ? { 'data-tour': opt.dataTour } : {})} onClick={() => setDtLetzterOption(opt.val)}
                    className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${dtLetzterOption === opt.val ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`}>
                    <span className="text-2xl">{opt.icon}</span>
                    <div className="flex-1">
                      <p className="font-semibold text-slate-800">{opt.label}</p>
                      {opt.sub && <p className="text-xs text-slate-400 mt-0.5">{opt.sub}</p>}
                      {opt.val === "custom" && dtLetzterOption === "custom" && (
                        <Input type="date" max={new Date().toISOString().split('T')[0]} value={dtLetzterCustom} onChange={(e) => { e.stopPropagation(); setDtLetzterCustom(e.target.value); }} className="mt-2 text-sm" />
                      )}
                    </div>
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${dtLetzterOption === opt.val ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300'}`}>
                      {dtLetzterOption === opt.val && <div className="w-2 h-2 rounded-full bg-white" />}
                    </div>
                  </label>
                ))}
                <div className="flex gap-3 pt-1">
                  <Button onClick={() => {
                    const _typ = naechsterTerminModalIsDetail ? tempEditData?.typ : formData.typ;
                    const _skip = _typ === 'teampartner' || _typ === 'kunde';
                    const _kontaktiertFalse = (naechsterTerminModalIsDetail ? tempEditData?.kontaktiert : formData.kontaktiert) === false;
                    setDateTimeStep((!_skip && _kontaktiertFalse) ? 3 : 1);
                  }} variant="outline" className="flex-1 h-11">← Zurück</Button>
                  <Button data-tour="termin-wizard-zuletzt-weiter" disabled={dtLetzterOption === "custom" && !dtLetzterCustom}
                    onClick={() => {
                      if (dtLetzterOption !== "nein") {
                        setDateTimeStep(5);
                      } else {
                        // "Nicht aktualisieren" → altes Thema vorausfüllen
                        setDtNeuesThema(dtAltesThema || "");
                        setDateTimeStep(6);
                      }
                    }}
                    className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                </div>
              </div>
            )}

            {/* Schritt 5: Gesprächsverlauf */}
            {dateTimeStep === 5 && (
              <div className="space-y-3" data-tour="termin-wizard-gespraechsverlauf">
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <p className="text-xs text-slate-400 mb-2 uppercase tracking-wide">Gesprächsthema (bearbeitbar)</p>
                  <Input value={dtAltesThema} onChange={(e) => setDtAltesThema(e.target.value)} placeholder="z.B. Erstgespräch, Produktvorstellung..." className="bg-white" />
                </div>
                <p className="text-sm text-slate-500">Soll dies im <strong>Gesprächsverlauf</strong> gespeichert werden? So weißt du immer, was ihr zuletzt besprochen habt.</p>
                {[
                  { val: "aktuell", icon: "💾", label: "Ja, jetzt speichern", sub: `Aktuelle Uhrzeit (${new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })})` },
                  { val: "manuell", icon: "🕐", label: "Ja, andere Uhrzeit", sub: "Uhrzeit selbst eingeben" },
                  { val: "nein", icon: "✕", label: "Nein, nicht speichern", sub: "" }
                ].map(opt => (
                  <label key={opt.val} onClick={() => setDtThemaUhrzeitMode(opt.val)}
                    className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${dtThemaUhrzeitMode === opt.val ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`}>
                    <span className="text-2xl">{opt.icon}</span>
                    <div className="flex-1">
                      <p className="font-semibold text-slate-800">{opt.label}</p>
                      {opt.sub && <p className="text-xs text-slate-400 mt-0.5">{opt.sub}</p>}
                      {opt.val === "manuell" && dtThemaUhrzeitMode === "manuell" && (
                        <Input type="time" value={dtThemaManuelleUhrzeit} onChange={(e) => { e.stopPropagation(); setDtThemaManuelleUhrzeit(e.target.value); }} className="mt-2 text-sm" />
                      )}
                    </div>
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${dtThemaUhrzeitMode === opt.val ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300'}`}>
                      {dtThemaUhrzeitMode === opt.val && <div className="w-2 h-2 rounded-full bg-white" />}
                    </div>
                  </label>
                ))}
                <div className="flex gap-3 pt-1">
                  <Button onClick={() => setDateTimeStep(4)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                  <Button data-tour="termin-wizard-verlauf-weiter" onClick={() => {
                    if (dtThemaUhrzeitMode !== "nein" && dtAltesThema?.trim()) { setPendingThemaArchiv({ thema: dtAltesThema, datum: tempDate, uhrzeitMode: dtThemaUhrzeitMode, manuelleUhrzeit: dtThemaManuelleUhrzeit }); setFormData(prev => ({ ...prev, naechstes_thema: "" })); if (naechsterTerminModalIsDetail) setTempEditData(prev => ({ ...prev, naechstes_thema: "" })); setDtNeuesThema(""); }
                    else { setPendingThemaArchiv(null); setDtNeuesThema(dtAltesThema); }
                    setDateTimeStep(6);
                  }} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                </div>
              </div>
            )}

            {/* Schritt 6: Nächstes Thema + Termindetails */}
            {dateTimeStep === 6 && (
              <div className="space-y-4" data-tour="termin-wizard-naechstes-thema">
                <p className="text-sm text-slate-500">{dtIsErsterTermin ? "Was ist das Thema für den Termin?" : "Was ist das Thema für den nächsten Termin?"}</p>
                {/* Thema + Farbpunkt nebeneinander */}
                <div className="flex items-center gap-2">
                  <Input data-tour="termin-wizard-naechstes-thema-input" value={dtNeuesThema} onChange={(e) => setDtNeuesThema(e.target.value)} placeholder="z.B. Produktvorstellung, Beratung, Folgegespräch..." className="h-12 flex-1" autoFocus />
                  {/* Farbauswahl für den Kalender-Termin */}
                  <div className="relative flex-shrink-0">
                    <button
                      type="button"
                      onClick={() => setDtShowColorPicker(!dtShowColorPicker)}
                      className={`w-10 h-10 rounded-full ${APPOINTMENT_COLORS[dtColor]?.bg || 'bg-yellow-400'} shadow-md hover:scale-110 transition-all ring-2 ring-white`}
                      title="Farbe für Kalender-Termin wählen"
                    />
                    {dtShowColorPicker && (
                      <div className="absolute right-0 top-12 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-[200]" style={{ minWidth: '140px' }}>
                        <p className="text-xs text-slate-500 mb-2 text-center">Terminfarbe</p>
                        <div className="grid grid-cols-4 gap-2">
                          {COLOR_KEYS.map((colorKey) => (
                            <button
                              key={colorKey}
                              type="button"
                              onClick={() => { setDtColor(colorKey); setDtShowColorPicker(false); }}
                              className={`w-7 h-7 rounded-full transition-all ${APPOINTMENT_COLORS[colorKey]?.bg} ${dtColor === colorKey ? 'ring-2 ring-offset-2 ring-slate-800 scale-110' : 'hover:scale-110'}`}
                              title={colorKey}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Notizen */}
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-1">Notizen (optional)</label>
                  <textarea
                    value={dtNote}
                    onChange={(e) => setDtNote(e.target.value)}
                    placeholder="Zusätzliche Infos zum Termin..."
                    className="w-full p-3 border border-slate-200 rounded-lg text-sm resize-none focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                    rows={2}
                  />
                </div>
                {/* Priorität */}
                <div>
                  <label className="text-sm font-medium text-slate-600">Priorität: {dtPriority}</label>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-green-600 text-xs">Niedrig</span>
                    <input
                      type="range"
                      min="1"
                      max="10"
                      value={dtPriority}
                      onChange={(e) => setDtPriority(parseInt(e.target.value))}
                      className="flex-1 h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-emerald-600"
                    />
                    <span className="text-red-600 text-xs">Hoch</span>
                  </div>
                </div>
                <div className="flex gap-3 pt-1">
                  <Button onClick={() => setDateTimeStep(dtLetzterOption !== "nein" ? 5 : 4)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                  <Button data-tour="termin-wizard-fertig-btn" onClick={() => {
                    const today = new Date().toISOString().split('T')[0];
                    const lVal = dtLetzterOption === "heute" ? today : dtLetzterOption === "custom" ? dtLetzterCustom : null;
                    const updates = {
                      naechstes_thema: dtNeuesThema,
                      ...(lVal ? { letzter_termin: lVal } : {}),
                      ...(dtNote.trim() ? { notizen: dtNote.trim() } : {}),
                    };
                    setFormData(prev => ({ ...prev, ...updates }));
                    if (naechsterTerminModalIsDetail) setTempEditData(prev => ({ ...prev, ...updates }));
                    // Termin für Kalender vorbereiten (verzögertes Speichern)
                    if (tempDate && dtStartTime && dtEndTime) {
                      const contactId = naechsterTerminModalIsDetail ? tempEditData?.id : editingId;
                      const contactName = naechsterTerminModalIsDetail ? tempEditData?.name : formData.name;
                      const contactTyp = naechsterTerminModalIsDetail ? tempEditData?.typ : formData.typ;
                      setPendingCalendarAppointment({
                        id: Date.now(),
                        title: dtNeuesThema.trim() || contactName || "Termin",
                        date: tempDate,
                        startTime: dtStartTime,
                        endTime: dtEndTime,
                        priority: dtPriority,
                        color: dtColor,
                        note: dtNote.trim() || null,
                        done: false,
                        contactRef: contactId
                          ? { id: contactId, typ: contactTyp || 'teampartner', name: contactName }
                          : null,
                      });
                    }
                    setShowDateTimePicker(false); setDateTimeStep(1); setNaechsterTerminModalIsDetail(false); setDtIsErsterTermin(false);
                  }} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold">Fertig ✓</Button>
                </div>
              </div>
            )}

            </div>
          </div>
        </div>
      )}

      {/* Promote Modal */}
      {showPromoteModal && promotingTeampartner && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-800">Beförderung</h3>
              <button
                onClick={() => {
                  setShowPromoteModal(false);
                  setPromotingTeampartner(null);
                }}
                className="text-slate-400 hover:text-slate-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="mb-6">
              <p className="text-slate-600 mb-2">
                <span className="font-semibold">{promotingTeampartner.name}</span> befördern
              </p>
              <p className="text-sm text-slate-500">
                Aktuelle Stufe: <span className="font-semibold text-emerald-600">{promotingTeampartner.stufe}</span>
              </p>
            </div>
            
            <div className="mb-6">
              <Label className="mb-2 block">Neue Stufe wählen:</Label>
              <div className="grid grid-cols-4 gap-2">
                {STUFEN.filter(s => s !== "keine").map(stufe => (
                  <button
                    key={stufe}
                    onClick={() => confirmPromotion(stufe)}
                    className={`px-3 py-2 rounded-lg border-2 font-semibold text-sm transition-all ${
                      stufe === promotingTeampartner.stufe
                        ? "border-emerald-500 bg-emerald-50 text-emerald-700"
                        : "border-slate-200 hover:border-emerald-300 hover:bg-emerald-50 text-slate-700"
                    }`}
                  >
                    {stufe}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={() => {
                  setShowPromoteModal(false);
                  setPromotingTeampartner(null);
                }}
                className="flex-1"
              >
                Abbrechen
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && selectedTeampartner && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[80] p-4" onClick={() => { 
          if (isDetailEditMode) handleCancelDetailEdit();
          setShowDetailModal(false); 
          setIsNotificationMode(false);
          setIsDetailFromSearch(false);
        }}>
          <div 
            className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] flex flex-col overflow-hidden" 
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {/* Scrollbarer Inhalt */}
            <div className="flex-1 overflow-y-auto">
            {/* Modal Header with Navigation */}
            <div className="sticky top-0 bg-white border-b border-slate-200 p-4 rounded-t-2xl z-10">
              {/* Schließen-Button ganz oben */}
              <div className="flex justify-end mb-3">
                <button
                  onClick={() => {
                    if (isDetailEditMode) {
                      handleCancelDetailEdit();
                    }
                    setShowDetailModal(false);
                    setIsNotificationMode(false);
                    setIsDetailFromSearch(false);
                  }}
                  className="text-slate-400 hover:text-slate-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              
              {/* Navigation Buttons darunter - nur außerhalb des Suche-Tabs */}
              {!isDetailFromSearch && (
              <div className="flex justify-between items-center gap-4">
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleButtonNavigation(-1);
                  }}
                  disabled={modalIndex === 0 || isAnimating}
                  variant="outline"
                  size="sm"
                  className="flex-shrink-0"
                >
                  ← Zurück
                </Button>
                
                <div className="text-center flex-1 px-2">
                  <p className="text-sm text-slate-600">
                    <span className="font-bold text-emerald-600">
                      {isNotificationMode 
                        ? `📬 ${selectedTeampartner.name}`
                        : (selectedTeampartner.typ === "kaltkontakt" ? `#NK${selectedTeampartner.displayNummer}` : `#${selectedTeampartner.displayNummer}`)
                      }
                    </span>
                  </p>
                  <p className="text-xs text-slate-500 mt-1">
                    {isNotificationMode
                      ? `${modalIndex + 1} von ${notificationList.length} (Nachrichten)`
                      : (selectedTeampartner.typ === "kaltkontakt" 
                        ? `${selectedTeampartner.displayNummer} von ${kaltkontakte.length} (Neue Kontakte)`
                        : `${selectedTeampartner.displayNummer} von ${teampartnerList.length + kundenList.length} (${selectedTeampartner.typ === "teampartner" ? "Teampartner" : "Kunde"})`)
                    }
                  </p>
                </div>
                
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleButtonNavigation(1);
                  }}
                  disabled={
                    isNotificationMode 
                      ? (modalIndex === (notificationList.length - 1) || isAnimating)
                      : (modalIndex === (kaltkontakte.length + teampartnerList.length + kundenList.length - 1) || isAnimating)
                  }
                  variant="outline"
                  size="sm"
                  className="flex-shrink-0"
                >
                  Weiter →
                </Button>
              </div>
              )}
            </div>
            
            {/* Modal Content - Vergrößerte Karte mit Tinder-Style Wisch-Animation */}
            <div className="p-6 overflow-hidden">
              <div 
                style={{
                  transform: `translateX(${currentSwipeDistance}px) rotate(${currentSwipeDistance * 0.02}deg)`,
                  transition: (isSwiping || skipTransition) ? 'none' : 'transform 0.2s ease-out',
                  opacity: Math.max(0.3, 1 - Math.abs(currentSwipeDistance) / 500)
                }}
              >
              {/* Bearbeitungsmodus Badge - Sticky oben */}
              {isDetailEditMode && (
                <div className="sticky top-0 z-30 mb-4 p-3 bg-yellow-50 border-2 border-yellow-400 rounded-lg shadow-md">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-lg">✏️</span>
                    <span className="font-bold text-yellow-800">Bearbeitungsmodus</span>
                  </div>
                  <p className="text-xs text-yellow-600 text-center mt-1">Klicken Sie auf ein Feld zum Bearbeiten</p>
                </div>
              )}
              
              <TeampartnerCard 
                tp={isDetailEditMode && tempEditData ? tempEditData : selectedTeampartner}
                produkte={produkte}
                alleSchulden={alleSchulden}
                isEditMode={isDetailEditMode}
                defaultExpanded={true}
                showChevron={false}
                onFieldClick={handleOpenFieldEdit}
                customThematikOptionen={customThematikOptionen}
                customVeranstaltungOptionen={customVeranstaltungOptionen}
                tempBezahlteSchulden={tempEditData?.tempBezahlteSchulden || []}
                tempNeueSchulden={tempEditData?.tempNeueSchulden || []}
                onEdit={isDetailEditMode ? null : (tp) => {
                  handleStartDetailEdit(tp);
                }} 
                onDelete={(id) => {
                  setShowDetailModal(false);
                  handleDelete(id);
                }} 
                onPromote={selectedTeampartner.typ === "teampartner" ? (tp) => {
                  setShowDetailModal(false);
                  handlePromote(tp);
                } : null}
                onShowDownlineTree={handleDownlineTreeClick}
                onPauseClick={isDetailEditMode ? () => {
                  const isPaused = tempEditData?.pausiert || false;
                  if (isPaused) {
                    setShowUnpauseModal(true);
                  } else {
                    setShowPauseModal(true);
                  }
                } : null}
                onShowVergangeneThemen={async (tp) => {
                  // Hole frische Daten vom Server
                  try {
                    const response = await axios.get(`${API}/api/teampartner/${tp.id}`);
                    setVergangeneThemenData(response.data.vergangene_themen || []);
                  } catch (error) {
                    setVergangeneThemenData(tp.vergangene_themen || []);
                  }
                  setVergangeneThemenKontaktName(tp.name);
                  setShowVergangeneThemenModal(true);
                }}
                onOpenZuErledigen={handleOpenZuErledigienModal}
                onToggleTask={handleToggleKontaktTask}
                onDeleteTask={handleDeleteKontaktTask}
                onBetreuungClick={handleOpenBetreuungsModal}
                onBetreuungToggle={handleBetreuungToggleDirect}
                onKeineBetreuung={handleKeineBetreuungMehrDirect}
                onPayPerson={handlePayPerson}
                onShowTeilzahlungHistorie={handleShowTeilzahlungHistorie}
              />
              
              </div>
            </div>
            </div>
            
            {/* Button-Leiste unten - Responsive für Desktop/Mobile */}
            {isDetailEditMode && (
              <div className="bg-white border-t-2 border-yellow-400 px-4 md:px-6 py-2.5 pb-14 md:pb-8 flex gap-2 justify-end shadow-lg flex-shrink-0">
                <button
                  onClick={handleCancelDetailEdit}
                  className="px-3 md:px-4 py-1.5 text-sm text-slate-600 hover:text-slate-800 font-medium border border-slate-300 rounded-md hover:bg-slate-50"
                >
                  Abbrechen
                </button>
                <button
                  onClick={() => {
                    setShowDetailModal(false);
                    handleEdit(tempEditData || selectedTeampartner);
                    setIsDetailEditMode(false);
                    setTempEditData(null);
                  }}
                  className="px-3 md:px-4 py-1.5 text-sm text-blue-600 hover:text-blue-800 font-medium border border-blue-300 rounded-md hover:bg-blue-50 whitespace-nowrap"
                >
                  Erweitert
                </button>
                <button
                  onClick={handleSaveDetailEdit}
                  className="px-3 md:px-4 py-1.5 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 font-medium"
                >
                  Speichern
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Beförderungs-Celebration Modal */}
      {showPromotionCelebration && promotionData && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[60] p-4 animate-fade-in">
          <div className="bg-gradient-to-br from-yellow-50 via-white to-green-50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border-4 border-yellow-400 animate-bounce-in">
            <div className="bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-500 p-6 text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                <div className="text-6xl animate-float">🎊</div>
                <div className="text-6xl animate-float" style={{animationDelay: '0.2s'}}>🎉</div>
                <div className="text-6xl animate-float" style={{animationDelay: '0.4s'}}>✨</div>
              </div>
              <h2 className="text-3xl font-bold text-white relative z-10 drop-shadow-lg">
                🎉 Glückwunsch! 🎉
              </h2>
            </div>
            
            <div className="p-8 text-center space-y-6">
              <div className="text-6xl animate-pulse">🎊</div>
              
              <div className="space-y-2">
                <p className="text-2xl font-bold text-slate-800">
                  {promotionData.name}
                </p>
                <p className="text-lg text-slate-600">
                  {promotionData.manual ? 'wurde befördert!' : 'wurde automatisch befördert!'}
                </p>
              </div>
              
              <div className="bg-gradient-to-r from-yellow-100 to-orange-100 rounded-xl p-6 border-2 border-yellow-300">
                <div className="flex items-center justify-center gap-4 text-2xl font-bold">
                  <span className="text-slate-600">{promotionData.from}</span>
                  <span className="text-3xl">→</span>
                  <span className="text-green-600">{promotionData.to}</span>
                </div>
                {promotionData.downline_count && (
                  <p className="text-sm text-slate-600 mt-3">
                    🎯 {promotionData.downline_count} Teampartner/Kunden in der Downline!
                  </p>
                )}
                {promotionData.manual && (
                  <p className="text-sm text-slate-600 mt-3">
                    👤 Manuelle Beförderung
                  </p>
                )}
              </div>
              
              <div className="flex gap-3 text-4xl justify-center">
                <span className="animate-bounce" style={{animationDelay: '0s'}}>🎊</span>
                <span className="animate-bounce" style={{animationDelay: '0.1s'}}>🎉</span>
                <span className="animate-bounce" style={{animationDelay: '0.2s'}}>🎈</span>
                <span className="animate-bounce" style={{animationDelay: '0.3s'}}>✨</span>
                <span className="animate-bounce" style={{animationDelay: '0.4s'}}>🎊</span>
              </div>
              
              <button
                onClick={() => {
                  setShowPromotionCelebration(false);
                  setPromotionData(null);
                }}
                className="w-full py-3 px-6 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Fantastisch! 🚀
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Pause Modal - Kontakt pausieren */}
      {showPauseModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">⏸️</div>
              <h2 className="text-2xl font-bold text-slate-800 mb-3">
                Kontakt pausieren/kündigen?
              </h2>
              <p className="text-slate-600 mb-4">
                Möchten Sie diesen Kontakt pausieren/kündigen? Der Kontakt kann später jederzeit fortgesetzt werden.
              </p>

              {/* Option: Termin & Thema behalten (für Kundenrückgewinnung) */}
              <label className="flex items-start gap-3 p-3 mb-4 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer hover:bg-amber-100 transition-colors text-left">
                <input
                  type="checkbox"
                  checked={pauseKeepTermin}
                  onChange={(e) => setPauseKeepTermin(e.target.checked)}
                  className="mt-1 h-4 w-4 text-amber-600 rounded"
                  data-testid="pause-keep-termin-checkbox"
                />
                <div className="flex-1 text-sm">
                  <span className="font-semibold text-amber-900">Nächster Termin & Thema behalten</span>
                  <p className="text-xs text-amber-700 mt-0.5">Empfohlen für Kundenrückgewinnung. Wenn deaktiviert, werden Termin und Thema beim Pausieren entfernt.</p>
                </div>
              </label>

              <div className="space-y-3">
                <button
                  onClick={async () => {
                    try {
                      const updatedData = {
                        ...tempEditData,
                        pausiert: true,
                        pausiert_datum: new Date().toISOString(),
                        ...(pauseKeepTermin ? {} : {
                          naechster_termin: null,
                          naechstes_thema: "",
                        })
                      };
                      const resp = await axios.put(`${API}/api/teampartner/${selectedTeampartner.id}`, updatedData);
                      toast.success("Kontakt pausiert und gespeichert!");
                      // Demotion-Toast anzeigen, falls Upline zurückgestuft wurde
                      const demo = resp?.data?.auto_demotion;
                      if (demo) {
                        toast.info(`📉 ${demo.name} wurde von ${demo.from} auf ${demo.to} zurückgestuft (nur noch ${demo.downline_count} aktive Downline).`);
                      }
                      setShowPauseModal(false);
                      setIsDetailEditMode(false);
                      setTempEditData(null);
                      setShowDetailModal(false);
                      setPauseKeepTermin(true); // reset for next use
                      fetchTeampartner();
                    } catch (error) {
                      console.error("Error pausing contact:", error);
                      toast.error("Fehler beim Pausieren");
                    }
                  }}
                  data-testid="pause-confirm-button"
                  className="w-full px-4 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                >
                  <span>⏸️</span>
                  <span>Ja, pausieren</span>
                </button>
                <button
                  onClick={() => {
                    setShowPauseModal(false);
                    setPauseKeepTermin(true);
                  }}
                  className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Replace-Appointment Warning Modal – zeigt Warnung bevor Wizard öffnet, wenn zukünftiger Termin schon verlinkt ist */}
      {showReplaceApptWarning && existingApptToReplace && (() => {
        const apptDt = new Date(`${existingApptToReplace.date}T${existingApptToReplace.startTime}:00`);
        const dateLabel = apptDt.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const timeLabel = apptDt.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
        const title = existingApptToReplace.title || 'Termin';
        return (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[95] p-4" data-testid="replace-appt-warn-overlay">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="text-3xl">⚠️</div>
                <h2 className="text-xl font-bold text-slate-800" data-testid="replace-appt-warn-title">Bestehender Termin</h2>
              </div>
              <p className="text-sm text-slate-600 mb-4">
                Für diesen Kontakt existiert bereits ein zukünftiger Kalender-Termin:
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-5">
                <p className="text-sm font-semibold text-amber-900">📅 {title}</p>
                <p className="text-xs text-amber-700 mt-1">{dateLabel} um {timeLabel} Uhr</p>
              </div>
              <p className="text-sm text-slate-600 mb-5">
                Wenn du fortfährst, wird der bestehende Termin durch den neuen ersetzt.
              </p>
              <div className="flex gap-3">
                <button
                  type="button"
                  data-testid="replace-appt-warn-cancel-btn"
                  onClick={() => {
                    setShowReplaceApptWarning(false);
                    setExistingApptToReplace(null);
                  }}
                  className="flex-1 py-2.5 rounded-lg border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-slate-50"
                >
                  Abbrechen
                </button>
                <button
                  type="button"
                  data-testid="replace-appt-warn-confirm-btn"
                  onClick={() => {
                    setShowReplaceApptWarning(false);
                    setExistingApptToReplace(null);
                    openDateTimePickerInternal();
                  }}
                  className="flex-1 py-2.5 rounded-lg bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold"
                >
                  Ersetzen
                </button>
              </div>
            </div>
          </div>
        );
      })()}


      {/* Unpause Modal - wird angezeigt wenn User versucht pausierte Kontakte zu bearbeiten */}
      {showUnpauseModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">▶️</div>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">
                Kontakt ist pausiert
              </h2>
              <p className="text-slate-600 mb-6">
                Dieser Kontakt ist aktuell pausiert. Möchten Sie den Kontakt fortsetzen, um Änderungen vornehmen zu können?
              </p>
              {tempEditData?.pausiert_datum && (
                <p className="text-sm text-slate-500 mb-6">
                  Pausiert seit: {new Date(tempEditData.pausiert_datum).toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              )}
              
              <div className="space-y-3">
                <button
                  onClick={async () => {
                    try {
                      // Unpause und sofort speichern
                      const updatedData = {
                        ...tempEditData,
                        pausiert: false,
                        pausiert_datum: null
                      };
                      
                      // Backend-Update
                      await axios.put(`${API}/api/teampartner/${selectedTeampartner.id}`, updatedData);
                      
                      toast.success("Kontakt fortgesetzt und gespeichert!");
                      
                      // Modal und Bearbeitungsmodus beenden
                      setShowUnpauseModal(false);
                      setIsDetailEditMode(false);
                      setTempEditData(null);
                      setShowDetailModal(false);
                      
                      // Daten neu laden
                      fetchTeampartner();
                    } catch (error) {
                      console.error("Error unpausing contact:", error);
                      toast.error("Fehler beim Fortsetzen");
                    }
                  }}
                  className="w-full px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                >
                  <span>▶️</span>
                  <span>Fortsetzen</span>
                </button>
                <button
                  onClick={() => {
                    setShowUnpauseModal(false);
                  }}
                  className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Kontaktaufnahme erfolgt? */}
      {showKontaktaufnahmeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">📞</div>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">
                Termin vereinbart / Kontaktaufnahme erfolgt?
              </h2>
              <p className="text-slate-600 mb-6">
                Wurde dieser Kontakt bereits kontaktiert oder ein Termin vereinbart?
              </p>
              
              <div className="space-y-3">
                <button
                  onClick={() => {
                    // Ja - setze kontaktiert auf true und öffne Letzter-Termin-Modal
                    if (letzterTerminModalData?.isDetailEdit) {
                      // Detail-Bearbeitungsmodus
                      setTempEditData(prev => ({ ...prev, kontaktiert: true }));
                      setShowKontaktaufnahmeModal(false);
                      setShowLetzterTerminModal(true);
                      toast.success("Kontakt als 'kontaktiert' markiert");
                    } else {
                      // Normales Edit-Formular - übergebe kontaktiert: true an saveCallback
                      setShowKontaktaufnahmeModal(false);
                      // Update saveCallback um kontaktiert: true zu inkludieren
                      const originalCallback = letzterTerminModalData.saveCallback;
                      setLetzterTerminModalData({
                        ...letzterTerminModalData,
                        saveCallback: async (additionalData) => {
                          // Merge kontaktiert: true mit anderen Daten
                          await originalCallback({ ...additionalData, kontaktiert: true });
                        }
                      });
                      setShowLetzterTerminModal(true);
                      toast.success("Kontakt als 'kontaktiert' markiert");
                    }
                  }}
                  className="w-full px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold transition-colors"
                >
                  Ja, Kontaktaufnahme erfolgt
                </button>
                <button
                  onClick={async () => {
                    // Nein - schließe Modal, Letzter-Termin-Modal öffnet sich nicht
                    setShowKontaktaufnahmeModal(false);
                    toast.info("Kontakt bleibt als 'nicht kontaktiert' markiert");
                    
                    // Wenn normales Edit-Formular, führe Submit aus (ohne letzter_termin zu ändern)
                    if (!letzterTerminModalData?.isDetailEdit && letzterTerminModalData?.saveCallback) {
                      // Submit ohne zusätzliche Daten (aber mit dem neuen naechster_termin)
                      await letzterTerminModalData.saveCallback({});
                    }
                    setLetzterTerminModalData(null);
                  }}
                  className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
                >
                  Nein, noch nicht kontaktiert
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Letzter Termin auch ändern? */}
      {/* Kombiniertes Nächster-Termin-Modal (für Detail-Modal Edit-Modus) */}
      {showNaechsterTerminModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[95] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-5">
              <h3 className="text-xl font-bold text-slate-800">Nächster Termin</h3>
              <button onClick={() => setShowNaechsterTerminModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <Label>Datum</Label>
                <Input
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  value={ntmDatum}
                  onChange={(e) => setNtmDatum(e.target.value)}
                  className="text-base"
                />
              </div>
              <div>
                <Label>Uhrzeit</Label>
                <Input
                  type="time"
                  value={ntmUhrzeit}
                  onChange={(e) => setNtmUhrzeit(e.target.value)}
                  className="text-base"
                />
              </div>
              <div className="border-t pt-4">
                <p className="text-sm font-medium text-slate-700 mb-2">Zuletzt kontaktiert aktualisieren?</p>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="ntm_letzter" checked={ntmLetzterOption === "heute"} onChange={() => setNtmLetzterOption("heute")} />
                    <span className="text-sm">Ja, auf heute setzen</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="ntm_letzter" checked={ntmLetzterOption === "custom"} onChange={() => setNtmLetzterOption("custom")} />
                    <span className="text-sm">Eigenes Datum:</span>
                    {ntmLetzterOption === "custom" && (
                      <Input
                        type="date"
                        max={new Date().toISOString().split('T')[0]}
                        value={ntmLetzterCustom}
                        onChange={(e) => setNtmLetzterCustom(e.target.value)}
                        className="text-sm ml-1"
                      />
                    )}
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="ntm_letzter" checked={ntmLetzterOption === "nein"} onChange={() => setNtmLetzterOption("nein")} />
                    <span className="text-sm">Nein, nicht ändern</span>
                  </label>
                </div>
              </div>
              <div className="flex gap-3 pt-2">
                <Button variant="outline" className="flex-1" onClick={() => setShowNaechsterTerminModal(false)}>
                  Abbrechen
                </Button>
                <Button
                  className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white"
                  disabled={!ntmDatum || !ntmUhrzeit}
                  onClick={() => {
                    const combined = `${ntmDatum}T${ntmUhrzeit}`;
                    const today = new Date().toISOString().split('T')[0];
                    const letzterVal = ntmLetzterOption === "heute" ? today
                      : ntmLetzterOption === "custom" ? ntmLetzterCustom
                      : null;
                    if (naechsterTerminModalIsDetail) {
                      setTempEditData(prev => ({
                        ...prev,
                        naechster_termin: combined,
                        ...(letzterVal ? { letzter_termin: letzterVal } : {})
                      }));
                    }
                    setShowNaechsterTerminModal(false);
                  }}
                >
                  Übernehmen
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLetzterTerminModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">📅</div>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">
                Letzter Termin aktualisieren?
              </h2>
              <p className="text-slate-600 mb-6">
                Sie haben den "Nächster Termin" geändert. Möchten Sie auch "Letzter Termin" (Zuletzt kontaktiert) aktualisieren?
              </p>
              
              <div className="space-y-3">
                <button
                  onClick={async () => {
                    // Auf heute setzen - NUR DATUM im Format YYYY-MM-DD in lokaler Zeit
                    const today = new Date();
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, '0');
                    const dd = String(today.getDate()).padStart(2, '0');
                    const hh = String(today.getHours()).padStart(2, '0');
                    const min = String(today.getMinutes()).padStart(2, '0');
                    const heute = `${yyyy}-${mm}-${dd}`;
                    const jetztMitUhrzeit = `${yyyy}-${mm}-${dd}T${hh}:${min}`;
                    
                    // Speichere das alte Thema bevor wir schließen
                    const altesThema = letzterTerminModalData?.isDetailEdit 
                      ? tempEditData?.naechstes_thema 
                      : formData?.naechstes_thema;
                    // Verwende das gewählte Datum (heute) für das Thema
                    const gewaehltesDatum = heute; // Das Datum das der User gewählt hat
                    const kontaktId = letzterTerminModalData?.kontaktId;
                    const kontaktName = letzterTerminModalData?.kontaktName;
                    const isDetailEdit = letzterTerminModalData?.isDetailEdit;
                    const saveCallback = letzterTerminModalData?.saveCallback;
                    
                    setShowLetzterTerminModal(false);
                    setLetzterTerminModalData(null);
                    
                    if (isDetailEdit) {
                      // Detail-Bearbeitungsmodus - nur in tempEditData speichern
                      const updatedData = {
                        ...tempEditData,
                        letzter_termin: heute
                      };
                      setTempEditData(updatedData);
                      toast.success("Letzter Termin auf heute gesetzt");
                    } else {
                      // Normales Edit-Formular - direkt submitten mit letzter_termin
                      if (saveCallback) {
                        await saveCallback({ letzter_termin: heute });
                      }
                    }
                    
                    // Wenn es ein Thema gab, frage ob es gespeichert werden soll
                    if (altesThema && altesThema.trim()) {
                      setThemaSpeichernData({
                        thema: altesThema,
                        datum: gewaehltesDatum, // Das gewählte Datum übernehmen
                        kontaktId: kontaktId,
                        kontaktName: kontaktName,
                        isDetailEdit: isDetailEdit
                      });
                      setShowThemaSpeichernModal(true);
                    }
                  }}
                  className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
                >
                  Ja, auf heute setzen
                </button>
                
                <div className="bg-slate-50 p-3 rounded-lg">
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Oder eigenes Datum wählen:
                  </label>
                  <input
                    type="date"
                    value={customLetzterTerminDatum}
                    max={new Date().toISOString().split('T')[0]}
                    onChange={(e) => setCustomLetzterTerminDatum(e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 mb-2"
                  />
                  <button
                    onClick={async () => {
                      if (!customLetzterTerminDatum) {
                        toast.error("Bitte wählen Sie ein Datum");
                        return;
                      }
                      
                      // Validierung: Datum darf nicht in der Zukunft liegen
                      const selectedDate = new Date(customLetzterTerminDatum);
                      const heute = new Date();
                      heute.setHours(0, 0, 0, 0);
                      
                      if (selectedDate > heute) {
                        toast.error("Das Datum darf nicht in der Zukunft liegen");
                        return;
                      }
                      
                      // Verwende das Datum direkt (ist bereits im Format YYYY-MM-DD)
                      const customDate = customLetzterTerminDatum;
                      
                      // Speichere das alte Thema bevor wir schließen
                      const altesThema = letzterTerminModalData?.isDetailEdit 
                        ? tempEditData?.naechstes_thema 
                        : formData?.naechstes_thema;
                      // Verwende das gewählte custom Datum für das Thema
                      const gewaehltesDatum = customDate;
                      const kontaktId = letzterTerminModalData?.kontaktId;
                      const kontaktName = letzterTerminModalData?.kontaktName;
                      const isDetailEdit = letzterTerminModalData?.isDetailEdit;
                      const saveCallback = letzterTerminModalData?.saveCallback;
                      
                      setShowLetzterTerminModal(false);
                      setLetzterTerminModalData(null);
                      setCustomLetzterTerminDatum("");
                      
                      if (isDetailEdit) {
                        // Detail-Bearbeitungsmodus - nur in tempEditData speichern
                        const updatedData = {
                          ...tempEditData,
                          letzter_termin: customDate
                        };
                        setTempEditData(updatedData);
                        toast.success("Letzter Termin aktualisiert");
                      } else {
                        // Normales Edit-Formular - direkt submitten mit letzter_termin
                        if (saveCallback) {
                          await saveCallback({ letzter_termin: customDate });
                        }
                      }
                      
                      // Wenn es ein Thema gab, frage ob es gespeichert werden soll
                      if (altesThema && altesThema.trim()) {
                        setThemaSpeichernData({
                          thema: altesThema,
                          datum: gewaehltesDatum, // Das gewählte custom Datum übernehmen
                          kontaktId: kontaktId,
                          kontaktName: kontaktName,
                          isDetailEdit: isDetailEdit
                        });
                        setShowThemaSpeichernModal(true);
                      }
                    }}
                    className="w-full px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold transition-colors"
                  >
                    Dieses Datum übernehmen
                  </button>
                </div>
                
                <button
                  onClick={() => {
                    setShowLetzterTerminModal(false);
                    setLetzterTerminModalData(null);
                    setCustomLetzterTerminDatum("");
                  }}
                  className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
                >
                  Nein, nicht ändern
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Thema speichern Modal */}
      {showThemaSpeichernModal && themaSpeichernData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[95] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">📋</div>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">
                Thema speichern?
              </h2>
              <p className="text-slate-600 mb-4">
                Möchten Sie das besprochene Thema für <strong>{themaSpeichernData.kontaktName}</strong> archivieren?
              </p>
              <div className="bg-slate-50 p-3 rounded-lg mb-4 text-left">
                <p className="text-sm text-slate-500 mb-1">Thema:</p>
                <p className="text-slate-800 font-medium">{themaSpeichernData.thema}</p>
                <p className="text-xs text-slate-400 mt-2">
                  Datum: {themaSpeichernData.datum ? (() => {
                    const d = new Date(themaSpeichernData.datum);
                    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
                  })() : 'Nicht verfügbar'}
                </p>
              </div>
              
              {/* Uhrzeit Auswahl */}
              <div className="bg-blue-50 p-3 rounded-lg mb-6 text-left">
                <p className="text-sm font-semibold text-slate-700 mb-2">Uhrzeit für das Thema:</p>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="uhrzeitMode"
                      checked={themaSpeichernUhrzeitMode === "aktuell"}
                      onChange={() => setThemaSpeichernUhrzeitMode("aktuell")}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm">Aktuelle Uhrzeit ({new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })})</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="uhrzeitMode"
                      checked={themaSpeichernUhrzeitMode === "manuell"}
                      onChange={() => setThemaSpeichernUhrzeitMode("manuell")}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm">Andere Uhrzeit</span>
                  </label>
                  {themaSpeichernUhrzeitMode === "manuell" && (
                    <input
                      type="time"
                      value={themaSpeichernManuelleUhrzeit}
                      onChange={(e) => setThemaSpeichernManuelleUhrzeit(e.target.value)}
                      className="w-full mt-2 px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  )}
                </div>
              </div>
              
              <div className="space-y-3">
                <button
                  onClick={async () => {
                    try {
                      // Bestimme die finale Uhrzeit
                      let finalDatum = themaSpeichernData.datum;
                      if (finalDatum) {
                        const datumPart = finalDatum.split('T')[0];
                        let uhrzeitPart;
                        if (themaSpeichernUhrzeitMode === "aktuell") {
                          const now = new Date();
                          uhrzeitPart = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                        } else {
                          uhrzeitPart = themaSpeichernManuelleUhrzeit || "12:00";
                        }
                        finalDatum = `${datumPart}T${uhrzeitPart}`;
                      }
                      
                      // Lade aktuellen Kontakt
                      const response = await axios.get(`${API}/api/teampartner/${themaSpeichernData.kontaktId}`);
                      const kontakt = response.data;
                      
                      // Füge neues Thema zur History hinzu
                      const vergangeneThemen = kontakt.vergangene_themen || [];
                      vergangeneThemen.push({
                        datum: finalDatum,
                        thema: themaSpeichernData.thema
                      });
                      
                      // Speichere vergangene Themen und lösche das aktuelle Thema
                      await axios.put(`${API}/api/teampartner/${themaSpeichernData.kontaktId}`, {
                        vergangene_themen: vergangeneThemen,
                        naechstes_thema: "" // Altes Thema löschen da es archiviert wurde
                      });
                      
                      toast.success("Thema wurde archiviert");
                      
                      // Aktualisiere die Daten sofort, damit die Liste aktuell ist
                      await fetchTeampartner();
                      
                      // Aktualisiere selectedTeampartner wenn das Detail-Modal offen ist
                      const kontaktId = themaSpeichernData.kontaktId;
                      if (selectedTeampartner && selectedTeampartner.id === kontaktId) {
                        try {
                          const updatedResponse = await axios.get(`${API}/api/teampartner/${kontaktId}`);
                          setSelectedTeampartner(updatedResponse.data);
                          
                          // WICHTIG: Auch tempEditData aktualisieren wenn im Edit-Modus
                          if (isDetailEditMode) {
                            setTempEditData(updatedResponse.data);
                          }
                        } catch (e) {
                          console.error("Fehler beim Aktualisieren:", e);
                        }
                      }
                      
                      // Öffne Modal für neues Thema
                      setShowThemaSpeichernModal(false);
                      setThemaSpeichernData(null);
                      setThemaSpeichernUhrzeitMode("aktuell");
                      setThemaSpeichernManuelleUhrzeit("");
                      
                      setNeuesThemaKontaktId(kontaktId);
                      setNeuesThemaText("");
                      setShowNeuesThemaModal(true);
                      
                    } catch (error) {
                      console.error("Fehler beim Speichern des Themas:", error);
                      toast.error("Fehler beim Speichern");
                      setShowThemaSpeichernModal(false);
                      setThemaSpeichernData(null);
                      setThemaSpeichernUhrzeitMode("aktuell");
                      setThemaSpeichernManuelleUhrzeit("");
                    }
                  }}
                  className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
                >
                  Ja, Thema archivieren
                </button>
                
                <button
                  onClick={() => {
                    // Nicht archivieren aber trotzdem nach neuem Thema fragen
                    const kontaktId = themaSpeichernData.kontaktId;
                    setShowThemaSpeichernModal(false);
                    setThemaSpeichernData(null);
                    setThemaSpeichernUhrzeitMode("aktuell");
                    setThemaSpeichernManuelleUhrzeit("");
                    
                    setNeuesThemaKontaktId(kontaktId);
                    setNeuesThemaText("");
                    setShowNeuesThemaModal(true);
                  }}
                  className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
                >
                  Nein, verwerfen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Vergangene Themen Modal */}
      {showVergangeneThemenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[95] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full max-h-[80vh] flex flex-col">
            <div className="p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                  📋 Vergangene Themen
                </h2>
                <button
                  onClick={() => {
                    setShowVergangeneThemenModal(false);
                    setVergangeneThemenData([]);
                    setVergangeneThemenKontaktName("");
                  }}
                  className="text-slate-400 hover:text-slate-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              {vergangeneThemenKontaktName && (
                <p className="text-slate-600 mt-1">für {vergangeneThemenKontaktName}</p>
              )}
            </div>
            
            <div className="flex-1 overflow-y-auto p-6">
              {vergangeneThemenData.length === 0 ? (
                <div className="text-center py-8 text-slate-500">
                  <div className="text-4xl mb-3">📭</div>
                  <p>Keine vergangenen Themen vorhanden</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {vergangeneThemenData
                    .sort((a, b) => new Date(b.datum) - new Date(a.datum))
                    .map((item, index) => (
                      <div key={index} className="bg-slate-50 rounded-lg p-4 border border-slate-200">
                        <div className="flex items-start justify-between gap-3">
                          <div className="flex-1">
                            <p className="text-slate-800">{item.thema}</p>
                            <p className="text-xs text-slate-500 mt-2">
                              {item.datum ? new Date(item.datum).toLocaleString('de-DE', { 
                                day: '2-digit', month: '2-digit', year: 'numeric', 
                                hour: '2-digit', minute: '2-digit' 
                              }) : 'Datum unbekannt'}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
            
            <div className="p-4 border-t border-slate-200">
              <button
                onClick={() => {
                  setShowVergangeneThemenModal(false);
                  setVergangeneThemenData([]);
                  setVergangeneThemenKontaktName("");
                }}
                className="w-full px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold transition-colors"
              >
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Neues Thema eingeben Modal */}
      {showNeuesThemaModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[96] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="text-center">
              <div className="text-5xl mb-4">📝</div>
              <h2 className="text-xl font-bold text-slate-800 mb-4">
                Neues Thema für nächsten Termin?
              </h2>
              <p className="text-slate-600 mb-4 text-sm">
                Möchten Sie ein neues Thema für den nächsten Termin eintragen?
              </p>
              
              <div className="mb-6">
                <textarea
                  value={neuesThemaText}
                  onChange={(e) => setNeuesThemaText(e.target.value)}
                  placeholder="Neues Thema eingeben (optional)"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 resize-none"
                  rows={3}
                />
              </div>
              
              <div className="space-y-3">
                <button
                  onClick={async () => {
                    const kontaktId = neuesThemaKontaktId;
                    console.log("NeuesThemaModal: kontaktId =", kontaktId);
                    console.log("NeuesThemaModal: neuesThemaText =", neuesThemaText);
                    console.log("NeuesThemaModal: selectedTeampartner =", selectedTeampartner?.id);
                    console.log("NeuesThemaModal: isDetailEditMode =", isDetailEditMode);
                    
                    if (neuesThemaText.trim()) {
                      try {
                        await axios.put(`${API}/api/teampartner/${kontaktId}`, {
                          naechstes_thema: neuesThemaText.trim()
                        });
                        toast.success("Neues Thema gespeichert");
                        console.log("NeuesThemaModal: Thema gespeichert auf Server");
                      } catch (error) {
                        console.error("Fehler:", error);
                        toast.error("Fehler beim Speichern");
                        return; // Bei Fehler abbrechen
                      }
                    }
                    
                    // Schließe Modal
                    setShowNeuesThemaModal(false);
                    setNeuesThemaKontaktId(null);
                    setNeuesThemaText("");
                    
                    // Aktualisiere die Daten
                    console.log("NeuesThemaModal: Rufe fetchTeampartner auf...");
                    await fetchTeampartner();
                    
                    // Aktualisiere selectedTeampartner und tempEditData
                    console.log("NeuesThemaModal: Prüfe ob selectedTeampartner aktualisiert werden soll");
                    console.log("NeuesThemaModal: selectedTeampartner?.id =", selectedTeampartner?.id, "kontaktId =", kontaktId);
                    
                    if (selectedTeampartner && selectedTeampartner.id === kontaktId) {
                      try {
                        console.log("NeuesThemaModal: Hole frische Daten vom Server...");
                        const response = await axios.get(`${API}/api/teampartner/${kontaktId}`);
                        console.log("NeuesThemaModal: Frische Daten erhalten:", response.data.naechstes_thema);
                        
                        setSelectedTeampartner(response.data);
                        
                        // WICHTIG: Auch tempEditData aktualisieren wenn im Edit-Modus
                        if (isDetailEditMode) {
                          console.log("NeuesThemaModal: Aktualisiere tempEditData im Edit-Modus");
                          setTempEditData(response.data);
                        }
                      } catch (error) {
                        console.error("Fehler beim Aktualisieren:", error);
                      }
                    } else {
                      console.log("NeuesThemaModal: selectedTeampartner nicht gefunden oder ID stimmt nicht überein");
                    }
                  }}
                  className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
                >
                  {neuesThemaText.trim() ? "Thema speichern" : "Ohne Thema fortfahren"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Willkommens-Celebration Modal für neue Kunden/Teampartner */}
      {showWelcomeCelebration && welcomeData && (() => {
        // 11 verschiedene Nachrichten für Kunden
        const kundenMessages = [
          "Exzellent! Weiter so mit der tollen Arbeit!",
          "Großartig! Ein weiterer zufriedener Kunde!",
          "Fantastisch! Deine harte Arbeit zahlt sich aus!",
          "Sensationell! Das ist der Weg zum Erfolg!",
          "Wunderbar! Dein Engagement trägt Früchte!",
          "Hervorragend! Du bist auf dem richtigen Weg!",
          "Beeindruckend! Deine Professionalität überzeugt!",
          "Perfekt! So wird Geschichte geschrieben!",
          "Genial! Du machst das absolut fantastisch!",
          "Spitze! Ein weiterer Meilenstein erreicht!",
          "Brillant! Dein Erfolg ist wohlverdient! 🌟"
        ];
        
        // 11 verschiedene Nachrichten für Teampartner
        const teampartnerMessages = [
          "Fantastisch! Dein Team wächst!",
          "Sensationell! Ein neuer Star im Team!",
          "Großartig! Gemeinsam seid ihr unschlagbar!",
          "Wunderbar! Dein Netzwerk wird stärker!",
          "Beeindruckend! Die Erfolgsgeschichte geht weiter!",
          "Hervorragend! Deine Führung zeigt Wirkung!",
          "Perfekt! Zusammen erreicht ihr mehr!",
          "Genial! Das Team wird immer stärker!",
          "Spitze! Ein weiteres Mitglied der Erfolgsfamilie!",
          "Fantastisch! Die Teampower steigt!",
          "Einfach T(H)uhen – und schon ist ein neuer Teampartner ins Team geschlüpft! 🐔"
        ];
        
        // Wähle zufällige Nachricht basierend auf Typ
        const messages = welcomeData.typ === 'kunde' ? kundenMessages : teampartnerMessages;
        const randomMessage = messages[Math.floor(Math.random() * messages.length)];
        
        return (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[200] p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden transform animate-bounce-in">
              <div className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 p-6 text-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                  <div className="text-6xl animate-float">🎊</div>
                  <div className="text-6xl animate-float" style={{animationDelay: '0.2s'}}>🎉</div>
                  <div className="text-6xl animate-float" style={{animationDelay: '0.4s'}}>✨</div>
                  <div className="text-6xl animate-float" style={{animationDelay: '0.6s'}}>🎈</div>
                </div>
                <h2 className="text-3xl font-bold text-white relative z-10 drop-shadow-lg">
                  🎉 Herzlich Willkommen! 🎉
                </h2>
              </div>
              
              <div className="p-8 text-center space-y-6">
                <div className="text-7xl animate-bounce">
                  {welcomeData.typ === 'kunde' ? '🌟' : '🚀'}
                </div>
                
                <div className="space-y-3">
                  <p className="text-3xl font-bold text-slate-800">
                    {welcomeData.name}
                  </p>
                  <p className="text-xl text-slate-600 font-semibold">
                    {welcomeData.typ === 'kunde' 
                      ? 'ist jetzt Kunde!' 
                      : 'ist jetzt Teampartner!'}
                  </p>
                </div>
                
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border-2 border-purple-300">
                  <p className="text-lg font-bold text-purple-700 mb-2">
                    {welcomeData.typ === 'kunde' 
                      ? '🎯 Ein neuer Kunde ist an Bord!' 
                      : '🚀 Ein neues Teammitglied ist dabei!'}
                  </p>
                  <p className="text-sm text-slate-600">
                    {randomMessage}
                  </p>
                </div>
                
                <div className="flex gap-3 text-5xl justify-center">
                  <span className="animate-bounce" style={{animationDelay: '0s'}}>🎊</span>
                  <span className="animate-bounce" style={{animationDelay: '0.1s'}}>🎉</span>
                  <span className="animate-bounce" style={{animationDelay: '0.2s'}}>🎈</span>
                  <span className="animate-bounce" style={{animationDelay: '0.3s'}}>✨</span>
                  <span className="animate-bounce" style={{animationDelay: '0.4s'}}>💫</span>
                </div>
                
                <button
                  onClick={() => {
                    setShowWelcomeCelebration(false);
                    setWelcomeData(null);
                  }}
                  className="w-full py-3 px-6 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                >
                  🎉 Weiter geht's!
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Nachrichten-Center Modal */}
      {showNachrichten && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-center p-6 border-b border-slate-200">
              <div>
                <h2 className="text-2xl font-bold text-slate-800">📬 Nachrichten-Center</h2>
                <p className="text-sm text-slate-500 mt-1">
                  {unreadCount} {unreadCount === 1 ? 'Benachrichtigung' : 'Benachrichtigungen'}
                </p>
              </div>
              <button
                onClick={() => setShowNachrichten(false)}
                className="text-slate-400 hover:text-slate-600 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="flex-1 overflow-y-auto p-6">
              {notifications.length === 0 ? (
                <div className="text-center py-12">
                  <Bell className="w-16 h-16 text-slate-300 mx-auto mb-4" />
                  <p className="text-slate-500 text-lg">Keine Benachrichtigungen</p>
                  <p className="text-slate-400 text-sm mt-2">Alle Tasks sind erledigt! 🎉</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {notifications.map((notif) => {
                    const getPriorityStyles = (priority) => {
                      switch(priority) {
                        case "critical":
                          return "bg-red-50 border-red-600 hover:bg-red-100";
                        case "high_red":
                          return "bg-red-50 border-red-600 hover:bg-red-100";
                        case "high":
                          return "bg-orange-50 border-orange-500 hover:bg-orange-100";
                        case "high_blue":
                          return "bg-blue-50 border-blue-500 hover:bg-blue-100";
                        case "warning":
                          return "bg-yellow-50 border-yellow-500 hover:bg-yellow-100";
                        case "medium_orange":
                          return "bg-orange-50 border-orange-500 hover:bg-orange-100";
                        case "medium":
                          return "bg-blue-50 border-blue-500 hover:bg-blue-100";
                        case "success":
                          return "bg-green-50 border-green-500 hover:bg-green-100";
                        default:
                          return "bg-slate-50 border-slate-400 hover:bg-slate-100";
                      }
                    };

                    return (
                      <div
                        key={notif.id}
                        className={`p-4 rounded-lg border-l-4 transition-all ${getPriorityStyles(notif.priority)} cursor-pointer`}
                        onClick={() => {
                          // Spezialbehandlung für Kaltkontakt Termin Follow-up
                          if (notif.type === 'kaltkontakt_termin_follow') {
                            console.log('Kaltkontakt Termin Follow-up geklickt', notif);
                            const kk = teampartner.find(t => t.id === notif.teampartner_id);
                            console.log('Gefundener Kaltkontakt:', kk);
                            if (kk) {
                              // Direkt Modal öffnen ohne Nachrichtencenter zu schließen
                              handleKaltkontaktTerminFollow(kk);
                              // Dann Nachrichtencenter schließen
                              setTimeout(() => setShowNachrichten(false), 50);
                            } else {
                              console.error('Kaltkontakt nicht gefunden! ID:', notif.teampartner_id);
                              toast.error("Kontakt nicht gefunden");
                            }
                            return;
                          }
                          
                          setShowNachrichten(false);
                          
                          const allItems = [...kaltkontakte, ...teampartnerList, ...kundenList];
                          
                          // Filtere Beförderungen aus (promotion_* Typen)
                          const relevantNotifications = notifications.filter(n => 
                            n.teampartner_id && !n.type?.startsWith('promotion')
                          );
                          
                          // Erstelle Set der eindeutigen Person-IDs
                          const uniquePersonIds = new Set();
                          relevantNotifications.forEach(n => {
                            if (n.teampartner_id) {
                              uniquePersonIds.add(n.teampartner_id);
                            }
                          });
                          
                          // Finde alle Personen mit diesen IDs
                          const personenMitBenachrichtigungen = Array.from(uniquePersonIds)
                            .map(id => allItems.find(t => t.id === id))
                            .filter(t => t);
                          
                          // Speichere in localStorage
                          userStorage.setItem('pendingNotificationOpen', JSON.stringify({
                            teampartnerId: notif.teampartner_id,
                            notificationIds: Array.from(uniquePersonIds)
                          }));
                          
                          // Prüfe ob wir bereits auf der Kunden-Seite sind
                          const currentPath = window.location.pathname;
                          
                          if (currentPath === '/kunden') {
                            // Bereits auf Kunden-Seite - direkt Modal öffnen
                            const tp = allItems.find(t => t.id === notif.teampartner_id);
                            if (tp && personenMitBenachrichtigungen.length > 0) {
                              setNotificationList(personenMitBenachrichtigungen);
                              const index = personenMitBenachrichtigungen.findIndex(item => item.id === tp.id);
                              setModalIndex(index >= 0 ? index : 0);
                              setSelectedTeampartner(tp);
                              setIsNotificationMode(true);
                              setShowDetailModal(true);
                            }
                            userStorage.removeItem('pendingNotificationOpen');
                          } else {
                            // Auf anderer Seite - navigiere zu Kunden
                            navigate('/kunden');
                          }
                        }}
                      >
                        <div className="flex items-start justify-between gap-4">
                          <div className="flex-1">
                            <p className="font-semibold text-slate-800">{notif.title}</p>
                            <p className="text-sm text-slate-600 mt-1">{notif.message}</p>
                            <p className="text-xs text-slate-500 mt-2 font-medium">{notif.person}</p>
                            {notif.termin_thema && (
                              <p className="text-xs text-slate-400 mt-1">Thema: {notif.termin_thema}</p>
                            )}
                          </div>
                          <div className="flex flex-col gap-2">
                            <button
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  // API-Call zum Backend
                                  await axios.post(`${API}/api/nachrichten/dismiss/${notif.id}`);
                                  // Entferne lokal
                                  setNotifications(notifications.filter(n => n.id !== notif.id));
                                  setUnreadCount(prev => Math.max(0, prev - 1));
                                } catch (error) {
                                  console.error("Fehler beim Verwerfen:", error);
                                }
                              }}
                              className="text-slate-400 hover:text-slate-600 text-xs underline"
                              title="Verwerfen"
                            >
                              Verwerfen
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            
            {notifications.length > 0 && (
              <div className="border-t border-slate-200 p-4 bg-slate-50">
                <button
                  onClick={async () => {
                    try {
                      // API-Call zum Backend
                      await axios.post(`${API}/api/nachrichten/dismiss-all`);
                      // Entferne lokal
                      setNotifications([]);
                      setUnreadCount(0);
                    } catch (error) {
                      console.error("Fehler beim Markieren:", error);
                    }
                  }}
                  className="w-full py-2 px-4 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg transition-colors text-sm font-medium"
                >
                  Alle als gelesen markieren
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Downline-Tree Modal - Organigramm-Stil */}
      {showDownlineTreeModal && downlineTree && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-2 md:p-4">
          <div 
            className="bg-white rounded-xl shadow-2xl w-[98vw] max-w-[95vw] h-[95vh] overflow-hidden flex flex-col relative"
            onTouchStart={handleDownlineTreeTouchStart}
            onTouchMove={handleDownlineTreeTouchMove}
            onTouchEnd={handleDownlineTreeTouchEnd}
          >
            <div className="flex justify-between items-center px-4 py-4 border-b border-slate-200 bg-gradient-to-r from-blue-50 to-indigo-50 flex-shrink-0 relative">
              <div className="flex-1 min-w-0 mr-4">
                <h2 className="text-xl md:text-2xl font-bold text-slate-800 truncate">🌳 Downline: {selectedTPForDownline?.name || 'Struktur'}</h2>
                <p className="text-xs md:text-sm text-slate-500 mt-1 hidden sm:block">
                  Organigramm der gesamten Linienstruktur
                </p>
              </div>
              
              {/* Zoom Controls */}
              <div className="flex items-center gap-2 flex-shrink-0">
                <div className="flex items-center gap-1 md:gap-2 bg-white rounded-lg border border-slate-300 px-2 md:px-3 py-1.5">
                  <button
                    onClick={() => setDownlineZoom(Math.max(0.2, downlineZoom - 0.1))}
                    className="text-slate-600 hover:text-slate-800 transition-colors p-1"
                    disabled={downlineZoom <= 0.2}
                  >
                    <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7" />
                    </svg>
                  </button>
                  <span className="text-xs md:text-sm font-medium text-slate-700 min-w-[2.5rem] text-center">
                    {Math.round(downlineZoom * 100)}%
                  </span>
                  <button
                    onClick={() => setDownlineZoom(Math.min(2, downlineZoom + 0.1))}
                    className="text-slate-600 hover:text-slate-800 transition-colors p-1"
                    disabled={downlineZoom >= 2}
                  >
                    <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                  </button>
                  <button
                    onClick={() => setDownlineZoom(1)}
                    className="text-xs text-slate-600 hover:text-slate-800 transition-colors px-1.5 md:px-2 py-1 rounded hover:bg-slate-100 hidden sm:block"
                  >
                    100%
                  </button>
                </div>
                
                <button
                  onClick={() => {
                    setShowDownlineTreeModal(false);
                    setDownlineTree(null);
                    setSelectedTPForDownline(null);
                    setDownlineZoom(1);
                  }}
                  className="text-slate-400 hover:text-slate-600 transition-colors p-1 flex-shrink-0"
                >
                  <X className="w-5 h-5 md:w-6 md:h-6" />
                </button>
              </div>
            </div>
            
            <div 
              ref={downlineScrollRef}
              className="flex-1 overflow-auto p-4 md:p-6 bg-gradient-to-br from-slate-50 to-blue-50"
            >
              {downlineTreeLoading ? (
                <div className="flex items-center justify-center py-12">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                </div>
              ) : (
                <div 
                  className="flex justify-center min-w-max transition-transform duration-200"
                  style={{ transform: `scale(${downlineZoom})`, transformOrigin: 'top center' }}
                >
                  <TreeNode node={downlineTree} level={0} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Feld-Edit-Modal für Inline-Bearbeitung */}
      {showFieldEditModal && currentEditField && (
        <FieldEditModal
          field={currentEditField}
          onSave={handleSaveFieldEdit}
          onCancel={() => {
            setShowFieldEditModal(false);
            setCurrentEditField(null);
          }}
          onOpenThematikManager={() => setShowThematikManager(true)}
          onOpenVeranstaltungManager={() => setShowVeranstaltungManager(true)}
          customThematikOptionen={customThematikOptionen}
          customVeranstaltungOptionen={customVeranstaltungOptionen}
          veranstaltungOptionen={VERANSTALTUNG_OPTIONEN}
        />
      )}

      {/* Modal: "Ich" Tab Feld bearbeiten */}
      {showIchFieldEditModal && currentIchEditField && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-lg font-bold text-slate-800">
                ✏️ {currentIchEditField.label}
              </h3>
              <button
                onClick={() => {
                  setShowIchFieldEditModal(false);
                  setCurrentIchEditField(null);
                }}
                className="text-slate-400 hover:text-slate-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Textarea für Text-Felder */}
            {currentIchEditField.type === 'textarea' && (
              <textarea
                className="w-full border rounded-lg p-3 text-sm min-h-[120px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={currentIchEditField.value || ''}
                onChange={(e) => setCurrentIchEditField(prev => ({ ...prev, value: e.target.value }))}
                placeholder={`${currentIchEditField.label} eingeben...`}
              />
            )}
            
            {/* Select für Auswahl-Felder */}
            {currentIchEditField.type === 'select' && currentIchEditField.options && (
              <div className="space-y-2">
                {currentIchEditField.options.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => setCurrentIchEditField(prev => ({ ...prev, value: opt.value }))}
                    className={`w-full p-3 text-left rounded-lg border-2 transition-colors ${
                      currentIchEditField.value === opt.value
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-slate-200 hover:border-slate-300'
                    }`}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
            
            {/* Multi-Select für Listen */}
            {currentIchEditField.type === 'multi-select' && currentIchEditField.options && (
              <div>
                {/* Liste bearbeiten Button für Veranstaltungen */}
                {currentIchEditField.name === 'online_live_veranstaltungen' && (
                  <button
                    onClick={() => {
                      setShowIchFieldEditModal(false);
                      setShowVeranstaltungManager(true);
                    }}
                    className="w-full mb-3 px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 font-medium flex items-center justify-center gap-2"
                  >
                    <SettingsIcon className="w-4 h-4" />
                    ⚙️ Liste bearbeiten
                  </button>
                )}
                <div className="space-y-2 max-h-[300px] overflow-y-auto">
                  {currentIchEditField.options.map((opt) => {
                    const isSelected = (currentIchEditField.value || []).includes(opt);
                    return (
                      <button
                        key={opt}
                        onClick={() => {
                          const currentValues = currentIchEditField.value || [];
                          const newValues = isSelected
                            ? currentValues.filter(v => v !== opt)
                            : [...currentValues, opt];
                          setCurrentIchEditField(prev => ({ ...prev, value: newValues }));
                        }}
                        className={`w-full p-3 text-left rounded-lg border-2 transition-colors flex items-center gap-2 ${
                          isSelected
                            ? 'border-blue-500 bg-blue-50'
                            : 'border-slate-200 hover:border-slate-300'
                        }`}
                      >
                        <span className={`w-5 h-5 rounded border-2 flex items-center justify-center ${isSelected ? 'bg-blue-500 border-blue-500' : 'border-slate-300'}`}>
                          {isSelected && <Check className="w-3 h-3 text-white" />}
                        </span>
                        {opt}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            
            {/* Buttons */}
            <div className="flex gap-2 mt-4">
              <button
                onClick={() => {
                  setShowIchFieldEditModal(false);
                  setCurrentIchEditField(null);
                }}
                className="flex-1 px-4 py-2 text-sm text-slate-600 hover:text-slate-800 font-medium border border-slate-300 rounded-lg hover:bg-slate-50"
              >
                Abbrechen
              </button>
              <button
                onClick={() => handleSaveIchField(currentIchEditField.value)}
                className="flex-1 px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
              >
                Übernehmen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Schulden bezahlen - Auswahl */}
      {showSchuldenBezahlenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full p-6">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-lg font-bold text-slate-800">
                💰 Schulden bezahlen
              </h3>
              <button
                onClick={() => {
                  setShowSchuldenBezahlenModal(false);
                  setSchuldenZumBezahlen([]);
                }}
                className="text-slate-400 hover:text-slate-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {schuldenZumBezahlen.length === 1 ? (
              // Nur eine Schuld - direkt bezahlen
              <div className="mb-6">
                <p className="text-sm text-slate-600 mb-4">Soll diese Schuld als bezahlt markiert werden?</p>
                <div className="p-3 bg-purple-50 rounded-lg border border-purple-200">
                  <p className="text-sm font-semibold text-slate-800">
                    {schuldenZumBezahlen[0].produkt_name || schuldenZumBezahlen[0].beschreibung}
                  </p>
                  <p className="text-xs text-slate-600 mt-1">
                    {schuldenZumBezahlen[0].betrag.toFixed(2)} € • {schuldenZumBezahlen[0].richtung === "erhalten_von" ? "Schuldet mir" : "Ich schulde"}
                  </p>
                </div>
              </div>
            ) : (
              // Mehrere Schulden - Auswahl
              <div className="mb-6">
                <p className="text-sm text-slate-600 mb-3">Wählen Sie die Schulden aus, die bezahlt wurden:</p>
                <div className="space-y-2 max-h-80 overflow-y-auto">
                  {schuldenZumBezahlen.map((schuld, idx) => (
                    <label 
                      key={schuld.id || idx} 
                      className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={schuld.selected || false}
                        onChange={(e) => {
                          const updated = [...schuldenZumBezahlen];
                          updated[idx].selected = e.target.checked;
                          setSchuldenZumBezahlen(updated);
                        }}
                        className="w-5 h-5 text-green-600 border-slate-300 rounded"
                      />
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-slate-800">
                          {schuld.produkt_name || schuld.beschreibung}
                        </p>
                        <div className="flex items-center gap-2 text-xs text-slate-600 mt-1">
                          <span>{schuld.betrag.toFixed(2)} €</span>
                          <span>•</span>
                          <span className={schuld.richtung === "erhalten_von" ? "text-green-600" : "text-red-600"}>
                            {schuld.richtung === "erhalten_von" ? "Schuldet mir" : "Ich schulde"}
                          </span>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            )}
            
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowSchuldenBezahlenModal(false);
                  setSchuldenZumBezahlen([]);
                }}
                className="px-4 py-2 text-slate-600 hover:text-slate-800 font-medium"
              >
                Abbrechen
              </button>
              {schuldenZumBezahlen.length === 1 ? (
                <button
                  onClick={() => {
                    // Markiere temporär als bezahlt (wird erst beim Speichern umgesetzt)
                    setTempEditData(prev => {
                      const updated = { ...prev };
                      if (!updated.tempBezahlteSchulden) {
                        updated.tempBezahlteSchulden = [];
                      }
                      updated.tempBezahlteSchulden.push(schuldenZumBezahlen[0].id);
                      return updated;
                    });
                    toast.success("Wird beim Speichern als bezahlt markiert");
                    setShowSchuldenBezahlenModal(false);
                    setSchuldenZumBezahlen([]);
                  }}
                  className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium"
                >
                  ✓ Bezahlt
                </button>
              ) : (
                <>
                  <button
                    onClick={() => {
                      const selected = schuldenZumBezahlen.filter(s => s.selected);
                      if (selected.length === 0) {
                        toast.error("Bitte wählen Sie mindestens eine Schuld aus");
                        return;
                      }
                      // Markiere temporär als bezahlt
                      setTempEditData(prev => {
                        const updated = { ...prev };
                        if (!updated.tempBezahlteSchulden) {
                          updated.tempBezahlteSchulden = [];
                        }
                        selected.forEach(schuld => {
                          if (!updated.tempBezahlteSchulden.includes(schuld.id)) {
                            updated.tempBezahlteSchulden.push(schuld.id);
                          }
                        });
                        return updated;
                      });
                      toast.success(`${selected.length} Schuld(en) werden beim Speichern als bezahlt markiert`);
                      setShowSchuldenBezahlenModal(false);
                      setSchuldenZumBezahlen([]);
                    }}
                    className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium"
                  >
                    ✓ Ausgewählte bezahlen
                  </button>
                  <button
                    onClick={() => {
                      // Markiere alle temporär als bezahlt
                      setTempEditData(prev => {
                        const updated = { ...prev };
                        if (!updated.tempBezahlteSchulden) {
                          updated.tempBezahlteSchulden = [];
                        }
                        schuldenZumBezahlen.forEach(schuld => {
                          if (!updated.tempBezahlteSchulden.includes(schuld.id)) {
                            updated.tempBezahlteSchulden.push(schuld.id);
                          }
                        });
                        return updated;
                      });
                      toast.success("Alle Schulden werden beim Speichern als bezahlt markiert");
                      setShowSchuldenBezahlenModal(false);
                      setSchuldenZumBezahlen([]);
                    }}
                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium"
                  >
                    ✓ Alle bezahlen
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal: Bezahlte Schulden */}
      {showBezahlteSchulden && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-6xl w-full max-h-[85vh] overflow-hidden flex flex-col">
            {/* Header - kompakt */}
            <div className="flex justify-between items-center px-4 py-3 border-b border-slate-200 bg-slate-50">
              <div>
                <h2 className="text-lg font-bold text-slate-800">📜 Vergangene Schulden</h2>
                <p className="text-xs text-slate-500">Alle bezahlten Schulden</p>
              </div>
              <button
                onClick={() => {
                  setShowBezahlteSchulden(false);
                  setBezahlteSchuldenSearch(""); // Suche zurücksetzen beim Schließen
                }}
                className="text-slate-400 hover:text-slate-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Suchfeld & Sort Buttons */}
            <div className="px-4 py-3 border-b border-slate-200 space-y-3">
              {/* Suchfeld - kompakt */}
              <div className="relative max-w-md">
                <input
                  type="text"
                  placeholder="Nach Name suchen..."
                  value={bezahlteSchuldenSearch}
                  onChange={(e) => setBezahlteSchuldenSearch(e.target.value)}
                  className="w-full px-3 py-1.5 pl-9 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <svg 
                  className="absolute left-2.5 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                {bezahlteSchuldenSearch && (
                  <button
                    onClick={() => setBezahlteSchuldenSearch("")}
                    className="absolute right-2.5 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  >
                    <X className="w-3.5 h-3.5" />
                  </button>
                )}
              </div>
              
              {/* Sort Buttons - kompakt */}
              <div className="flex gap-2 flex-wrap">
                <button
                  onClick={() => setSortBezahlteBy("bezahlt_am")}
                  className={`px-3 py-1.5 rounded-lg text-xs font-medium ${ sortBezahlteBy === "bezahlt_am" ? "bg-blue-600 text-white" : "bg-slate-200 text-slate-700 hover:bg-slate-300" }`}
                >
                  Nach Bezahldatum sortieren
                </button>
                <button
                  onClick={() => setSortBezahlteBy("name")}
                  className={`px-3 py-1.5 rounded-lg text-xs font-medium ${ sortBezahlteBy === "name" ? "bg-slate-200 text-slate-700 hover:bg-slate-300" : "bg-blue-600 text-white" }`}
                >
                  Nach Name sortieren
                </button>
              </div>
            </div>
            
            {/* Gruppierte Karten-Darstellung */}
            <div className="flex-1 overflow-y-auto p-4">
              <div className="space-y-4">
                {(() => {
                  // Filter bezahlte Schulden und nach Name durchsuchen
                  let bezahlte = alleSchulden.filter(s => s.status === "bezahlt");
                  
                  // Suchfilter anwenden
                  if (bezahlteSchuldenSearch.trim()) {
                    const searchLower = bezahlteSchuldenSearch.toLowerCase().trim();
                    bezahlte = bezahlte.filter(s => 
                      s.name.toLowerCase().includes(searchLower)
                    );
                  }
                  
                  if (bezahlte.length === 0) {
                    return (
                      <div className="text-center py-12 text-slate-500">
                        {bezahlteSchuldenSearch.trim() ? (
                          <>
                            <p className="text-lg">Keine Ergebnisse gefunden</p>
                            <p className="text-sm mt-2">Versuchen Sie einen anderen Suchbegriff</p>
                          </>
                        ) : (
                          <p className="text-lg">Noch keine bezahlten Schulden</p>
                        )}
                      </div>
                    );
                  }
                  
                  // Gruppiere zuerst nach Name
                  const byName = {};
                  bezahlte.forEach(s => {
                    if (!byName[s.name]) byName[s.name] = [];
                    byName[s.name].push(s);
                  });

                  let personEntries = Object.entries(byName);
                  if (sortBezahlteBy === "name") {
                    personEntries = personEntries.sort((a, b) => a[0].localeCompare(b[0]));
                  } else {
                    // neueste bezahlte zuerst
                    personEntries = personEntries.sort(([, a], [, b]) => {
                      const la = a.map(x => x.bezahlt_am || '').sort().reverse()[0] || '';
                      const lb = b.map(x => x.bezahlt_am || '').sort().reverse()[0] || '';
                      return lb.localeCompare(la);
                    });
                  }

                  return personEntries.map(([pname, personSchulden]) => {
                    const tpInfo = personSchulden[0]?.teampartner_id ? teampartner.find(tp => tp.id === personSchulden[0].teampartner_id) : null;
                    const gesamt = personSchulden.reduce((s, p) => s + (p.richtung === "schulde_ich" ? -p.betrag : p.betrag), 0);

                    // Subgroups (gruppe_id, Fallback: erstellt_am 10-Min-Buckets)
                    const subgroups = [];
                    const seenGroupIds = new Map();
                    const sorted = [...personSchulden].sort((a, b) => (a.erstellt_am || '').localeCompare(b.erstellt_am || ''));
                    sorted.forEach(p => {
                      if (p.gruppe_id) {
                        if (seenGroupIds.has(p.gruppe_id)) {
                          subgroups[seenGroupIds.get(p.gruppe_id)].posten.push(p);
                        } else {
                          seenGroupIds.set(p.gruppe_id, subgroups.length);
                          subgroups.push({ gruppe_id: p.gruppe_id, posten: [p] });
                        }
                      } else {
                        const last = subgroups[subgroups.length - 1];
                        const lastTime = last?.posten?.[last.posten.length - 1]?.erstellt_am;
                        const thisTime = p.erstellt_am;
                        if (last && !last.gruppe_id && lastTime && thisTime &&
                            Math.abs(new Date(thisTime) - new Date(lastTime)) < 10 * 60 * 1000) {
                          last.posten.push(p);
                        } else {
                          subgroups.push({ gruppe_id: null, posten: [p] });
                        }
                      }
                    });

                    return (
                      <div key={pname} className="border border-slate-300 rounded-lg p-3 md:p-5 bg-slate-50">
                        {/* Header - Name + Gesamt */}
                        <div className="flex justify-between items-start mb-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                              <h3 className="text-base md:text-lg font-bold text-slate-800">{pname}</h3>
                              {tpInfo && (
                                <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-emerald-100 text-emerald-700">TP</span>
                              )}
                              <span className="text-xs text-slate-500">{personSchulden.length} Posten · {subgroups.length} Schuld{subgroups.length !== 1 ? 'en' : ''}</span>
                            </div>
                          </div>
                          <div className={`text-base md:text-xl font-bold px-2 md:px-3 py-1 rounded flex-shrink-0 ml-2 ${gesamt >= 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {gesamt >= 0 ? '+' : ''}{gesamt.toFixed(2)} €
                          </div>
                        </div>

                        {/* Schuld-Blöcke */}
                        <div className="space-y-4">
                          {subgroups.map((sg, sgIdx) => {
                            const sgTotal = sg.posten.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
                            const sgDatum = sg.posten[0]?.schulden_datum;
                            const sgFaell = sg.posten[0]?.faelligkeitsdatum;
                            const sgBezahltAm = sg.posten.map(p => p.bezahlt_am).filter(Boolean).sort().reverse()[0];
                            const sgHatTeilzahlungen = sg.posten.some(p => (p.teilzahlungen || []).length > 0);
                            return (
                              <div key={sg.gruppe_id || `archiv-${sgIdx}`} className="border-2 border-slate-200 rounded-xl p-3 bg-white shadow-sm">
                                {/* Schuld-Header */}
                                <div className="flex items-start justify-between gap-2 pb-2 mb-2 border-b border-slate-100 flex-wrap">
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap mb-1.5">
                                      <span className="text-xs font-bold text-slate-700 uppercase tracking-wide">
                                        {sg.posten[0]?.gruppe_name ? (
                                          <>📄 Rechnung {sg.posten[0].gruppe_name}</>
                                        ) : (
                                          <>Schuld {sgIdx + 1}</>
                                        )} <span className="text-slate-400 font-normal normal-case">· {sg.posten.length} {sg.posten[0]?.gruppe_name ? 'Positionen' : 'Posten'}</span>
                                      </span>
                                    </div>
                                    {/* Badges: Erstellt + Fällig + Bezahlt am */}
                                    <div className="flex items-center gap-1.5 flex-wrap">
                                      {sgDatum && (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-blue-50 text-blue-700 border border-blue-200">
                                          📅 Erstellt: {new Date(sgDatum).toLocaleDateString('de-DE')}
                                        </span>
                                      )}
                                      {sgFaell && (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-slate-50 text-slate-600 border border-slate-200">
                                          ⏰ Fällig: {new Date(sgFaell).toLocaleDateString('de-DE')}
                                        </span>
                                      )}
                                      {sgBezahltAm && (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200">
                                          ✓ Bezahlt: {new Date(sgBezahltAm).toLocaleDateString('de-DE')}
                                        </span>
                                      )}
                                      {sgHatTeilzahlungen && (
                                        <button type="button"
                                          onClick={() => {
                                            setTeilzahlungHistorieTarget({ name: pname, posten: sg.posten });
                                            setShowTeilzahlungHistorie(true);
                                          }}
                                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100">
                                          <History className="w-3 h-3" /> Teilzahlungen
                                        </button>
                                      )}
                                      {hasErspanis(sg.posten) && (
                                        <button type="button"
                                          onClick={() => {
                                            downloadErspanisPdf({
                                              kundenName: pname,
                                              posten: sg.posten,
                                              datum: sg.posten[0]?.schulden_datum || new Date().toISOString(),
                                              firmenName: userCompanyName,
                                            });
                                          }}
                                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100"
                                          title="Ersparnis-PDF herunterladen">
                                          <FileText className="w-3 h-3" /> PDF
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="text-right">
                                      <p className="text-sm font-bold text-slate-800">{sgTotal.toFixed(2)} €</p>
                                    </div>
                                    {sg.posten.length > 1 && (
                                      <button
                                        onClick={async () => {
                                          if (window.confirm(`Alle ${sg.posten.length} Posten dieser Schuld löschen?`)) {
                                            try {
                                              await Promise.all(sg.posten.map(p => axios.delete(`${API}/api/schulden/${p.id}`)));
                                              toast.success("Alle gelöscht");
                                              loadSchulden();
                                            } catch { toast.error("Fehler"); }
                                          }
                                        }}
                                        className="px-2 py-1 text-[11px] text-red-600 hover:bg-red-50 rounded border border-red-200">
                                        🗑️
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {/* Einzelposten */}
                                <div className="space-y-2">
                                  {sg.posten.map(s => (
                                    <div key={s.id} className={`flex items-center justify-between gap-2 p-3 rounded-lg ${s.richtung === "erhalten_von" ? "bg-green-50 border border-green-100" : "bg-red-50 border border-red-100"}`}>
                                      <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 flex-wrap">
                                          <p className="text-sm font-medium text-slate-800">{s.produkt_name || s.beschreibung}</p>
                                          {s.menge && (
                                            <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-bold bg-indigo-100 text-indigo-700 border border-indigo-300">Menge: {s.menge}x</span>
                                          )}
                                        </div>
                                        {s.produkt_name && s.beschreibung && (
                                          <p className="text-xs text-slate-500 mt-0.5">{s.beschreibung}</p>
                                        )}
                                        {s.rechnung_nummer && (
                                          <p className="text-[10px] text-slate-400 mt-0.5">#{s.rechnung_nummer}</p>
                                        )}
                                      </div>
                                      <div className="flex items-center gap-2 whitespace-nowrap">
                                        <span className="text-sm font-bold text-slate-800">{s.betrag.toFixed(2)} €</span>
                                        <button
                                          onClick={async () => {
                                            if (window.confirm(`Diese bezahlte Schuld wirklich löschen?`)) {
                                              try { await axios.delete(`${API}/api/schulden/${s.id}`); toast.success("Gelöscht"); loadSchulden(); }
                                              catch { toast.error("Fehler"); }
                                            }
                                          }}
                                          className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded">
                                          <Trash2 className="w-4 h-4" />
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Betreuungs-Modal */}
      {showBetreuungsModal && betreuungsContact && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4"
          onClick={() => setShowBetreuungsModal(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-5 text-white flex justify-between items-start">
              <div>
                <h2 className="text-lg font-bold">📋 Betreuung</h2>
                <p className="text-sm text-indigo-200 mt-0.5">{betreuungsContact.name}</p>
              </div>
              <button type="button" onClick={() => setShowBetreuungsModal(false)} className="text-white/70 hover:text-white text-xl font-bold">✕</button>
            </div>

            {/* Follow-up Liste */}
            <div className="p-5 space-y-2">
              {[
                { field: 'einnahmegespraech_erledigt', label: '3-5 Tage Einnahmegespräch', icon: '1️⃣' },
                { field: 'followup_3_5_erledigt', label: '7 Tage Follow-up', icon: '2️⃣' },
                { field: 'followup_14_erledigt', label: '14 Tage Follow-up', icon: '3️⃣' },
                { field: 'followup_30_erledigt', label: '21 Tage Follow-up', icon: '4️⃣' },
                { field: 'followup_28_erledigt', label: '28 Tage Follow-up', icon: '5️⃣' },
                { field: 'paket_erinnerung_erledigt', label: 'Paket Erinnerung', icon: '📦' },
              ].map(({ field, label, icon }) => (
                <button
                  key={field}
                  type="button"
                  onClick={() => handleBetreuungToggle(field)}
                  className={`w-full flex items-center gap-3 p-3 rounded-xl border-2 transition-all ${
                    betreuungsContact[field]
                      ? 'bg-green-50 border-green-300 text-green-800'
                      : 'bg-slate-50 border-slate-200 text-slate-700 hover:border-indigo-300 hover:bg-indigo-50'
                  }`}
                >
                  <span className="text-xl">{betreuungsContact[field] ? '✅' : icon}</span>
                  <span className="text-sm font-medium flex-1 text-left">{label}</span>
                  {betreuungsContact[field] && <span className="text-xs text-green-600 font-semibold">Erledigt</span>}
                </button>
              ))}

              {/* Trennlinie + "Keine Betreuung mehr" Button */}
              <div className="pt-3 border-t border-slate-200">
                <button
                  type="button"
                  onClick={handleKeineBetreuungMehr}
                  className="w-full py-3 px-4 bg-red-50 border-2 border-red-200 text-red-700 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors"
                >
                  Keine Betreuung mehr
                </button>
                <p className="text-xs text-slate-400 text-center mt-2">Markiert alle verbleibenden Schritte als erledigt</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Schulden-Modal - Mehrstufig */}
      {showSchuldenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[120] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-start p-6 border-b border-slate-200">
              <div className="flex-1 pr-8">
                <h2 className="text-2xl font-bold text-slate-800">💰 Schulden hinzufügen</h2>
                <p className="text-sm text-slate-500 mt-1">Schritt {schuldenModalSchritt} von 2</p>
              </div>
              <button
                onClick={() => {
                  setShowSchuldenModal(false);
                  setSchuldenModalSchritt(1);
                  setInvoiceItemsForSchulden(null);
                  setSchuldenFromInventory(false);
                }}
                className="text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="flex-1 overflow-y-auto p-6">
              {schuldenModalSchritt === 1 ? (
                /* ===== SCHRITT 1: Person & Richtung ===== */
                <div className="space-y-6">
                  {/* Name: Dropdown oder Freie Eingabe */}
                  <div>
                    <Label>Person *</Label>
                    <div className="flex items-center gap-2 mb-2">
                      <input
                        type="checkbox"
                        id="use_custom_name"
                        checked={schuldenFormData.use_custom_name}
                        onChange={(e) => setSchuldenFormData({
                          ...schuldenFormData, 
                          use_custom_name: e.target.checked,
                          teampartner_id: "",
                          name: ""
                        })}
                        className="border-slate-300"
                      />
                      <label htmlFor="use_custom_name" className="text-sm text-slate-600">
                        Freier Name (nicht in Kunden-Liste)
                      </label>
                    </div>
                    
                    {schuldenFormData.use_custom_name ? (
                      <Input
                        value={schuldenFormData.name}
                        onChange={(e) => setSchuldenFormData({...schuldenFormData, name: e.target.value})}
                        placeholder="Name eingeben..."
                        required
                      />
                    ) : (
                      <select
                        value={schuldenFormData.teampartner_id}
                        onChange={(e) => {
                          const selected = teampartner.find(tp => tp.id === e.target.value);
                          setSchuldenFormData({
                            ...schuldenFormData,
                            teampartner_id: e.target.value,
                            name: selected ? selected.name : ""
                          });
                        }}
                        className="w-full border border-slate-300 rounded-lg p-2"
                        required
                      >
                        <option value="">Bitte wählen...</option>
                        {teampartner.map(tp => (
                          <option key={tp.id} value={tp.id}>{tp.name}</option>
                        ))}
                      </select>
                    )}
                  </div>

                  {/* Richtung */}
                  <div>
                    <Label>Richtung *</Label>
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 p-3 border border-slate-300 rounded-lg cursor-pointer hover:bg-slate-50">
                        <input
                          type="radio"
                          name="richtung"
                          value="erhalten_von"
                          checked={schuldenFormData.richtung === "erhalten_von"}
                          onChange={(e) => setSchuldenFormData({...schuldenFormData, richtung: e.target.value})}
                        />
                        <span className="font-medium">
                          {schuldenFormData.name || "Kunde"} schuldet mir
                        </span>
                      </label>
                      <label className="flex items-center gap-2 p-3 border border-slate-300 rounded-lg cursor-pointer hover:bg-slate-50">
                        <input
                          type="radio"
                          name="richtung"
                          value="schulde_ich"
                          checked={schuldenFormData.richtung === "schulde_ich"}
                          onChange={(e) => setSchuldenFormData({...schuldenFormData, richtung: e.target.value})}
                        />
                        <span className="font-medium">
                          Ich schulde {schuldenFormData.name || "Kunde"}
                        </span>
                      </label>
                    </div>
                  </div>

                  {/* Rechnung aus Inventory (optional) */}
                  <div className="border-t border-slate-200 pt-4">
                    <Label className="flex items-center gap-2">
                      📄 Rechnung aus Inventory (optional)
                    </Label>
                    <p className="text-xs text-slate-500 mb-2">Wähle eine Rechnung, um alle Positionen automatisch zu übernehmen</p>
                    {(() => {
                      // Alle Rechnungsnummern, die bereits in Schulden existieren (offen ODER bezahlt)
                      const usedInvoiceNumbers = new Set(
                        alleSchulden
                          .map(s => s.gruppe_name || s.rechnung_nummer)
                          .filter(Boolean)
                      );
                      const verfuegbareRechnungen = rechnungen.filter(r => !usedInvoiceNumbers.has(r.invoice_number));
                      return (
                        <>
                          <select
                            value={selectedRechnungForSchulden}
                            onChange={(e) => setSelectedRechnungForSchulden(e.target.value)}
                            className="w-full border border-slate-300 rounded-lg p-2"
                            data-testid="schulden-step1-rechnung-select"
                          >
                            <option value="">— Keine Rechnung (manuell anlegen) —</option>
                            {verfuegbareRechnungen.map(r => (
                              <option key={r.id} value={r.id}>
                                {r.invoice_number} · {r.customer_name || 'Kleinbetrag'} · {new Date(r.date).toLocaleDateString('de-DE')} · {r.total_brutto.toFixed(2)} €
                              </option>
                            ))}
                          </select>
                          {verfuegbareRechnungen.length === 0 && rechnungen.length > 0 && (
                            <p className="text-xs text-slate-400 italic mt-1">Alle {rechnungen.length} Rechnungen sind bereits in Schulden erfasst.</p>
                          )}
                        </>
                      );
                    })()}
                    {selectedRechnungForSchulden && (() => {
                      const r = rechnungen.find(x => x.id === selectedRechnungForSchulden);
                      if (!r) return null;
                      return (
                        <div className="mt-2 p-2 bg-emerald-50 border border-emerald-200 rounded-lg text-xs">
                          <p className="font-semibold text-emerald-800">✓ {r.items.length} Positionen werden übernommen</p>
                          <p className="text-emerald-700 mt-0.5">Kunde: <strong>{r.customer_name || '(kein Name)'}</strong> · Betrag: <strong>{r.total_brutto.toFixed(2)} €</strong></p>
                          {(!r.customer_name || !r.customer_name.trim()) && (
                            <p className="text-amber-700 mt-1">⚠ Rechnung hat keinen Kundennamen — bitte oben eingeben.</p>
                          )}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="flex justify-end pt-4">
                    <Button
                      onClick={() => {
                        if (!schuldenFormData.name) {
                          // Wenn Rechnung gewählt und hat Kundennamen → übernehmen
                          if (selectedRechnungForSchulden) {
                            const r = rechnungen.find(x => x.id === selectedRechnungForSchulden);
                            if (r && r.customer_name && r.customer_name.trim()) {
                              // Name wird automatisch übernommen - ok
                            } else {
                              toast.error("Bitte Person auswählen oder Kundennamen eingeben");
                              return;
                            }
                          } else {
                            toast.error("Bitte Person auswählen");
                            return;
                          }
                        }

                        // Wenn Rechnung gewählt: Positionen übernehmen & Fälligkeits-Modal öffnen
                        if (selectedRechnungForSchulden) {
                          const r = rechnungen.find(x => x.id === selectedRechnungForSchulden);
                          if (!r) return;
                          const finalName = schuldenFormData.name || r.customer_name || "";
                          const heute = new Date().toISOString().split('T')[0];
                          const rechnungsDatum = r.date || heute;
                          // Fälligkeit: Rechnung + 14 Tage als Default
                          const faelligkeitsDatum = new Date(rechnungsDatum);
                          faelligkeitsDatum.setDate(faelligkeitsDatum.getDate() + 14);
                          const faelligkeitStr = faelligkeitsDatum.toISOString().split('T')[0];

                          const postenArray = r.items.map((item) => ({
                            name: finalName,
                            teampartner_id: schuldenFormData.teampartner_id,
                            use_custom_name: schuldenFormData.use_custom_name,
                            richtung: schuldenFormData.richtung,
                            beschreibung: `Rechnung ${r.invoice_number}`,
                            betrag: parseFloat((item.quantity * item.price_brutto).toFixed(2)),
                            menge: item.quantity || 1,
                            kunde_preis: item.kunde_preis || null,
                            produkt_id: "",
                            produkt_name: item.article,
                            price_category: item.price_category || "",
                            rechnung_id: r.id,
                            rechnung_nummer: r.invoice_number,
                            schulden_datum: rechnungsDatum,
                            faelligkeitsdatum: faelligkeitStr,
                            gruppe_name: r.invoice_number,
                          }));

                          setSchuldenFormData({
                            ...schuldenFormData,
                            name: finalName,
                          });
                          setPendingSchuldenGroup(postenArray);
                          setGruppenFaelligkeit(faelligkeitStr);
                          setShowFaelligkeitModal(true);
                          setSelectedRechnungForSchulden(""); // reset for next
                          return;
                        }

                        setSchuldenModalSchritt(2);
                      }}
                      className="bg-blue-600 hover:bg-blue-700"
                      data-testid="schulden-step1-next-btn"
                    >
                      Weiter →
                    </Button>
                  </div>
                </div>
              ) : (
                /* ===== SCHRITT 2: Details ===== */
                <form onSubmit={(e) => {
                e.preventDefault();
                
                if (isSubmittingSchuld) return;

                // Validierung: Name
                if (!schuldenFormData.name || !schuldenFormData.name.trim()) {
                  toast.error("Bitte Kundennamen eingeben");
                  return;
                }

                // Wenn aktueller Posten leer ist und bereits Posten vorhanden → nur die speichern
                const currentBetrag = parseFloat(schuldenFormData.betrag);
                const aktuellLeer = (!schuldenFormData.betrag || isNaN(currentBetrag) || currentBetrag <= 0)
                  && !schuldenFormData.produkt_id
                  && (!schuldenFormData.beschreibung || schuldenFormData.beschreibung.trim() === ""
                      || schuldenFormData.beschreibung === `Rechnung ${schuldenFormData.rechnung_nummer}`);

                if (aktuellLeer && (pendingSchuldenGroup.length > 0 || invoiceItemsForSchulden)) {
                  // Spezialfall Inventory-Rechnung: einzelne Positionen expandieren (ohne zusätzlichen Posten)
                  if (invoiceItemsForSchulden && invoiceItemsForSchulden.items) {
                    const finalName = schuldenFormData.name.trim();
                    const postenArray = invoiceItemsForSchulden.items.map(item => ({
                      name: finalName,
                      teampartner_id: schuldenFormData.teampartner_id || "",
                      use_custom_name: schuldenFormData.teampartner_id ? false : true,
                      richtung: schuldenFormData.richtung,
                      beschreibung: `Rechnung ${invoiceItemsForSchulden.rechnung_nummer}`,
                      betrag: parseFloat((item.quantity * item.price_brutto).toFixed(2)),
                      menge: item.quantity || 1,
                      kunde_preis: item.kunde_preis || null,
                      produkt_id: "",
                      produkt_name: item.article,
                      price_category: item.price_category || "",
                      rechnung_id: invoiceItemsForSchulden.rechnung_id,
                      rechnung_nummer: invoiceItemsForSchulden.rechnung_nummer,
                      schulden_datum: invoiceItemsForSchulden.schulden_datum,
                      faelligkeitsdatum: schuldenFormData.faelligkeitsdatum || "",
                      gruppe_name: invoiceItemsForSchulden.rechnung_nummer,
                    }));
                    setPendingSchuldenGroup(prev => [...prev, ...postenArray]);
                    setInvoiceItemsForSchulden(null);
                  }
                  setGruppenFaelligkeit(schuldenFormData.faelligkeitsdatum || "");
                  setShowFaelligkeitModal(true);
                  return;
                }

                // Validierung des aktuellen Postens
                if (!schuldenFormData.betrag || parseFloat(schuldenFormData.betrag) <= 0) {
                  toast.error("Bitte einen gültigen Betrag eingeben");
                  return;
                }

                // Spezialfall Inventory-Rechnung: einzelne Positionen expandieren
                if (invoiceItemsForSchulden && invoiceItemsForSchulden.items) {
                  const finalName = schuldenFormData.name.trim();
                  const postenArray = invoiceItemsForSchulden.items.map(item => ({
                    name: finalName,
                    teampartner_id: schuldenFormData.teampartner_id || "",
                    use_custom_name: schuldenFormData.teampartner_id ? false : true,
                    richtung: schuldenFormData.richtung,
                    beschreibung: `Rechnung ${invoiceItemsForSchulden.rechnung_nummer}`,
                    betrag: parseFloat((item.quantity * item.price_brutto).toFixed(2)),
                    menge: item.quantity || 1,
                    kunde_preis: item.kunde_preis || null,
                    produkt_id: "",
                    produkt_name: item.article,
                    price_category: item.price_category || "",
                    rechnung_id: invoiceItemsForSchulden.rechnung_id,
                    rechnung_nummer: invoiceItemsForSchulden.rechnung_nummer,
                    schulden_datum: invoiceItemsForSchulden.schulden_datum,
                    faelligkeitsdatum: schuldenFormData.faelligkeitsdatum || "",
                    gruppe_name: invoiceItemsForSchulden.rechnung_nummer,
                  }));
                  setPendingSchuldenGroup(postenArray);
                  setGruppenFaelligkeit(schuldenFormData.faelligkeitsdatum || "");
                  setShowFaelligkeitModal(true);
                  setInvoiceItemsForSchulden(null);
                  return;
                }
                
                // Aktueller Posten zur Gruppe hinzufügen
                const currentPostGruppeName = schuldenFormData.rechnung_nummer || null;
                const currentPosten = {
                  ...schuldenFormData,
                  betrag: parseFloat(schuldenFormData.betrag),
                  menge: parseInt(schuldenFormData.menge) || 1,
                  gruppe_name: currentPostGruppeName,
                };
                const allPosten = [...pendingSchuldenGroup, currentPosten];
                setPendingSchuldenGroup(allPosten);
                // Fälligkeits-Modal öffnen (mit evtl. vorgegebenem Datum aus Rechnung)
                setGruppenFaelligkeit(schuldenFormData.faelligkeitsdatum || "");
                setShowFaelligkeitModal(true);
              }} className="space-y-4">
                
                {/* Ausgewählte Person & Richtung - Name ist fest wenn aus Schritt 1, editierbar wenn aus Inventory */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3">
                  {schuldenFromInventory ? (
                    <div className="relative">
                      <Label htmlFor="schulden_name_edit" className="text-sm text-slate-600 flex items-center gap-2">
                        Für wen ist diese Schuld?
                        {!schuldenFormData.name && (
                          <span className="text-[10px] text-amber-700 bg-amber-100 px-1.5 py-0.5 rounded">Pflicht</span>
                        )}
                        {schuldenFormData.teampartner_id && (
                          <span className="text-[10px] text-emerald-700 bg-emerald-100 px-1.5 py-0.5 rounded">✓ Zugeordnet</span>
                        )}
                      </Label>
                      <Input
                        id="schulden_name_edit"
                        value={schuldenFormData.name || ""}
                        onChange={(e) => {
                          setSchuldenFormData({
                            ...schuldenFormData,
                            name: e.target.value,
                            teampartner_id: "",
                            use_custom_name: true,
                          });
                        }}
                        onFocus={(e) => e.target.select()}
                        placeholder="z.B. Max Mustermann (suchen oder neu eingeben)"
                        required
                        autoComplete="off"
                        data-testid="schulden-step2-name-input"
                        className="mt-1 font-semibold bg-white"
                      />
                      {/* Autocomplete Dropdown */}
                      {schuldenFormData.name && !schuldenFormData.teampartner_id && (() => {
                        const query = schuldenFormData.name.trim().toLowerCase();
                        if (query.length < 2) return null;
                        const matches = teampartner
                          .filter(tp => tp.name && tp.name.toLowerCase().includes(query))
                          .slice(0, 8);
                        const exactMatch = matches.some(m => m.name.toLowerCase() === query);
                        if (matches.length === 0) {
                          return (
                            <div className="absolute left-0 right-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg z-10 p-2 text-xs text-slate-500">
                              ℹ️ Kein Kunde gefunden — wird als <strong>neuer freier Name</strong> gespeichert.
                            </div>
                          );
                        }
                        return (
                          <div className="absolute left-0 right-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                            {matches.map(tp => (
                              <button
                                key={tp.id}
                                type="button"
                                data-testid={`name-suggestion-${tp.id}`}
                                onClick={() => {
                                  setSchuldenFormData({
                                    ...schuldenFormData,
                                    name: tp.name,
                                    teampartner_id: tp.id,
                                    use_custom_name: false,
                                  });
                                }}
                                className="w-full text-left px-3 py-2 hover:bg-blue-50 flex items-center justify-between gap-2 text-sm border-b border-slate-100 last:border-0"
                              >
                                <span className="font-medium text-slate-800 truncate">{tp.name}</span>
                                <span className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap ${
                                  tp.typ === "teampartner" ? "bg-emerald-100 text-emerald-700" :
                                  tp.typ === "kunde" ? "bg-blue-100 text-blue-700" :
                                  "bg-slate-100 text-slate-600"
                                }`}>
                                  {tp.typ === "teampartner" ? "TP" : tp.typ === "kunde" ? "Kunde" : "Kalt"}
                                </span>
                              </button>
                            ))}
                            {!exactMatch && (
                              <div className="px-3 py-2 bg-slate-50 text-[11px] text-slate-500 border-t border-slate-200">
                                Oder weitertippen, um einen <strong>neuen freien Namen</strong> zu erstellen.
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  ) : (
                    <div>
                      <p className="text-sm text-slate-600">Ausgewählt:</p>
                      <p className="font-bold text-slate-800" data-testid="schulden-step2-name-display">{schuldenFormData.name}</p>
                    </div>
                  )}
                  <p className="text-xs text-slate-600">
                    <span className="font-medium">Richtung:</span>{" "}
                    {schuldenFormData.richtung === "erhalten_von"
                      ? `${schuldenFormData.name || "Kunde"} schuldet mir`
                      : `Ich schulde ${schuldenFormData.name || "Kunde"}`}
                  </p>
                </div>

                {/* Info-Banner: Aktive Rechnungs-Gruppe */}
                {(invoiceItemsForSchulden || schuldenFormData.rechnung_nummer) && (
                  <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded-r-lg p-3 text-xs space-y-1">
                    <p className="font-semibold text-emerald-800 flex items-center gap-2">
                      📄 Rechnungs-Block: {invoiceItemsForSchulden?.rechnung_nummer || schuldenFormData.rechnung_nummer}
                    </p>
                    {invoiceItemsForSchulden ? (
                      <p className="text-emerald-700">
                        {invoiceItemsForSchulden.items.length} Positionen aus der Rechnung werden beim Speichern automatisch erfasst.
                        Du kannst jetzt oben die Rechnungs-Daten als Zusammenfassung eingeben, oder über <strong>"+ Weiteren"</strong> weitere manuelle Posten zur gleichen Rechnung hinzufügen.
                      </p>
                    ) : (
                      <p className="text-emerald-700">
                        Dieser Posten wird dem Rechnungs-Block zugeordnet. Über <strong>"+ Weiteren"</strong> kannst du mehr Posten hinzufügen.
                      </p>
                    )}
                  </div>
                )}

                {/* Tag der Schulden */}
                <div>
                  <Label htmlFor="schulden_datum">Tag der Schulden *</Label>
                  <Input
                    id="schulden_datum"
                    type="date"
                    value={schuldenFormData.schulden_datum}
                    onChange={(e) => setSchuldenFormData({...schuldenFormData, schulden_datum: e.target.value})}
                    max={new Date().toISOString().split('T')[0]}
                    required
                  />
                  <p className="text-xs text-slate-500 mt-1">Wann wurden die Schulden gemacht?</p>
                </div>

                {/* Beschreibung/Grund */}
                <div>
                  <Label htmlFor="schulden_beschreibung">
                    Beschreibung/Grund {!schuldenFormData.produkt_id && pendingSchuldenGroup.length === 0 && !invoiceItemsForSchulden && "*"}
                  </Label>
                  <Input
                    id="schulden_beschreibung"
                    value={schuldenFormData.beschreibung}
                    onChange={(e) => setSchuldenFormData({...schuldenFormData, beschreibung: e.target.value})}
                    placeholder="Wofür ist diese Schuld?"
                  />
                </div>

                {/* Betrag */}
                <div>
                  <Label htmlFor="schulden_betrag">
                    Betrag (€) {pendingSchuldenGroup.length === 0 && !invoiceItemsForSchulden && "*"}
                  </Label>
                  <Input
                    id="schulden_betrag"
                    type="number"
                    step="0.01"
                    min="0"
                    value={schuldenFormData.betrag}
                    onChange={(e) => setSchuldenFormData({...schuldenFormData, betrag: e.target.value})}
                    placeholder="0.00"
                  />
                </div>

                {/* Produkt - nur wenn keine Rechnung gewählt */}
                {!schuldenFormData.rechnung_id && (
                  <div>
                    <Label htmlFor="schulden_produkt">Produkt (optional)</Label>
                    <select
                      id="schulden_produkt"
                      value={schuldenFormData.produkt_id || ""}
                      onChange={(e) => {
                        const produktId = e.target.value;
                        if (produktId && Array.isArray(produkte)) {
                          const produkt = produkte.find(p => p.id === produktId);
                          setSchuldenFormData({
                            ...schuldenFormData, 
                            produkt_id: produktId,
                            produkt_name: produkt ? produkt.name : "",
                            price_category: "",
                            betrag: "",
                            einzelpreis: "",
                            menge: 1,
                            // Rechnung leeren wenn Produkt gewählt
                            rechnung_id: "",
                            rechnung_nummer: ""
                          });
                        } else {
                          setSchuldenFormData({
                            ...schuldenFormData, 
                            produkt_id: "",
                            produkt_name: "",
                            price_category: "",
                            betrag: "",
                            einzelpreis: "",
                            menge: 1
                          });
                        }
                      }}
                      className="w-full px-3 py-2 border border-slate-300 rounded-md"
                    >
                      <option value="">-- Kein Produkt / Freie Eingabe --</option>
                      {Array.isArray(produkte) && produkte.map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Angebot auswählen (nur wenn Produkt ausgewählt) */}
                {schuldenFormData.produkt_id && !schuldenFormData.rechnung_id && (
                  <div>
                    <Label htmlFor="schulden_angebot">Angebot/Preiskategorie *</Label>
                    <select
                      id="schulden_angebot"
                      value={schuldenFormData.price_category || ""}
                      onChange={(e) => {
                        const category = e.target.value;
                        const produkt = produkte.find(p => p.id === schuldenFormData.produkt_id);
                        const basisPreis = produkt ? produkt[category] : 0;
                        const kundePreis = produkt ? (produkt.kunde || 0) : 0;
                        
                        // Berechne Betrag mit Zuschlag × Menge
                        const zuschlagFaktor = 1 + (schuldenFormData.zuschlag_prozent / 100);
                        const menge = parseFloat(schuldenFormData.menge) || 1;
                        const einzelpreisMitZuschlag = basisPreis * zuschlagFaktor;
                        const endBetrag = einzelpreisMitZuschlag * menge;
                        
                        setSchuldenFormData({
                          ...schuldenFormData,
                          price_category: category,
                          einzelpreis: einzelpreisMitZuschlag.toFixed(2),
                          betrag: endBetrag.toFixed(2),
                          kunde_preis: kundePreis,
                        });
                      }}
                      className="w-full px-3 py-2 border border-slate-300 rounded-md"
                      required
                    >
                      <option value="">-- Angebot wählen --</option>
                      <option value="kunde">Kunde</option>
                      <option value="tp">TP</option>
                      <option value="ba">BA</option>
                      <option value="five_plus_one">5+1</option>
                      <option value="ap">AP</option>
                    </select>
                  </div>
                )}

                {/* Menge - nur wenn Produkt + Preiskategorie gewählt */}
                {schuldenFormData.produkt_id && schuldenFormData.price_category && !schuldenFormData.rechnung_id && (
                  <div>
                    <Label htmlFor="schulden_menge">Menge *</Label>
                    <Input
                      id="schulden_menge"
                      type="number"
                      min="1"
                      step="1"
                      value={schuldenFormData.menge}
                      onChange={(e) => {
                        const menge = Math.max(1, parseInt(e.target.value) || 1);
                        const einzelpreis = parseFloat(schuldenFormData.einzelpreis) || 0;
                        const endBetrag = einzelpreis * menge;
                        setSchuldenFormData({
                          ...schuldenFormData,
                          menge: menge,
                          betrag: endBetrag.toFixed(2)
                        });
                      }}
                    />
                    <p className="text-xs text-slate-500 mt-1">
                      {schuldenFormData.menge} × {schuldenFormData.einzelpreis} € = <strong>{schuldenFormData.betrag} €</strong>
                    </p>
                  </div>
                )}

                {/* Zuschlag - nur wenn Produkt und Angebot gewählt */}
                {schuldenFormData.produkt_id && schuldenFormData.price_category && !schuldenFormData.rechnung_id && (
                  <div>
                    <Label htmlFor="schulden_zuschlag">Zuschlag in %</Label>
                    <Input
                      id="schulden_zuschlag"
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      value={schuldenFormData.zuschlag_prozent}
                      onChange={(e) => {
                        const zuschlagProzent = parseFloat(e.target.value) || 0;
                        
                        // Berechne Betrag neu mit neuem Zuschlag × Menge
                        const produkt = produkte.find(p => p.id === schuldenFormData.produkt_id);
                        const basisPreis = produkt ? produkt[schuldenFormData.price_category] : 0;
                        const zuschlagFaktor = 1 + (zuschlagProzent / 100);
                        const menge = parseFloat(schuldenFormData.menge) || 1;
                        const einzelpreisMitZuschlag = basisPreis * zuschlagFaktor;
                        const endBetrag = einzelpreisMitZuschlag * menge;
                        
                        setSchuldenFormData({
                          ...schuldenFormData,
                          zuschlag_prozent: zuschlagProzent,
                          einzelpreis: einzelpreisMitZuschlag.toFixed(2),
                          betrag: endBetrag.toFixed(2)
                        });
                      }}
                      placeholder="15"
                    />
                    <p className="text-xs text-slate-500 mt-1">
                      Standard: 15% | Aktueller Betrag mit Zuschlag: {schuldenFormData.betrag} €
                    </p>
                  </div>
                )}

                {/* Rechnungs-Referenz nur noch read-only anzeigen, wenn gesetzt (aus Inventory) */}
                {schuldenFormData.rechnung_nummer && (
                  <div className="bg-slate-50 border border-slate-200 rounded-lg p-3 text-xs text-slate-600">
                    <span className="font-semibold">📄 Rechnung:</span> {schuldenFormData.rechnung_nummer}
                  </div>
                )}

                {/* Fälligkeitsdatum entfernt - wird jetzt beim finalen Speichern abgefragt (Schritt 3 Modal) */}

                {/* Buttons - Sticky am unteren Modalrand */}
                <div className="sticky bottom-0 -mx-6 px-6 py-3 bg-white border-t border-slate-200 flex gap-3 z-10 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
                  <Button
                    type="button"
                    onClick={() => {
                      setSchuldenModalSchritt(1);
                      setPendingSchuldenGroup([]);
                    }}
                    variant="outline"
                  >
                    ← Zurück
                  </Button>
                  <Button
                    type="submit"
                    disabled={isSubmittingSchuld}
                    className="flex-1 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {(() => {
                      const currentBetrag = parseFloat(schuldenFormData.betrag);
                      const aktuellLeer = (!schuldenFormData.betrag || isNaN(currentBetrag) || currentBetrag <= 0)
                        && !schuldenFormData.produkt_id
                        && (!schuldenFormData.beschreibung || schuldenFormData.beschreibung.trim() === ""
                            || schuldenFormData.beschreibung === `Rechnung ${schuldenFormData.rechnung_nummer}`);
                      const invCount = invoiceItemsForSchulden ? invoiceItemsForSchulden.items.length : 0;
                      const total = pendingSchuldenGroup.length + invCount + (aktuellLeer ? 0 : 1);
                      if (total === 0) return "Speichern";
                      return `Speichern (${total} ${total === 1 ? 'Posten' : 'Posten'})`;
                    })()}
                  </Button>
                  <Button
                    type="button"
                    disabled={isSubmittingSchuld}
                    onClick={() => {
                      // Validierung Name
                      if (!schuldenFormData.name || !schuldenFormData.name.trim()) {
                        toast.error("Bitte Kundennamen eingeben");
                        return;
                      }

                      // Spezialfall Inventory-Rechnung: einzelne Positionen expandieren
                      // und gruppe_name für weitere Posten festhalten
                      if (invoiceItemsForSchulden && invoiceItemsForSchulden.items) {
                        const finalName = schuldenFormData.name.trim();
                        const postenArray = invoiceItemsForSchulden.items.map(item => ({
                          name: finalName,
                          teampartner_id: schuldenFormData.teampartner_id || "",
                          use_custom_name: schuldenFormData.teampartner_id ? false : true,
                          richtung: schuldenFormData.richtung,
                          beschreibung: `Rechnung ${invoiceItemsForSchulden.rechnung_nummer}`,
                          betrag: parseFloat((item.quantity * item.price_brutto).toFixed(2)),
                          menge: item.quantity || 1,
                          kunde_preis: item.kunde_preis || null,
                          produkt_id: "",
                          produkt_name: item.article,
                          price_category: item.price_category || "",
                          rechnung_id: invoiceItemsForSchulden.rechnung_id,
                          rechnung_nummer: invoiceItemsForSchulden.rechnung_nummer,
                          schulden_datum: invoiceItemsForSchulden.schulden_datum,
                          faelligkeitsdatum: schuldenFormData.faelligkeitsdatum || "",
                          gruppe_name: invoiceItemsForSchulden.rechnung_nummer,
                        }));
                        const rechnungsNr = invoiceItemsForSchulden.rechnung_nummer;
                        setPendingSchuldenGroup(prev => [...prev, ...postenArray]);
                        toast.success(`${postenArray.length} Positionen aus Rechnung ${rechnungsNr} übernommen`);
                        // State cleanup: keine weitere Expansion beim nächsten Submit
                        setInvoiceItemsForSchulden(null);
                        // Formular zurücksetzen - Kunde + Rechnungs-Gruppe bleiben
                        setSchuldenFormData({
                          name: schuldenFormData.name,
                          teampartner_id: schuldenFormData.teampartner_id,
                          use_custom_name: schuldenFormData.use_custom_name,
                          richtung: schuldenFormData.richtung,
                          beschreibung: "",
                          betrag: "",
                          menge: 1,
                          einzelpreis: "",
                          zuschlag_prozent: 15,
                          produkt_id: "",
                          produkt_name: "",
                          price_category: "",
                          rechnung_id: "",
                          rechnung_nummer: rechnungsNr, // Rechnungsnummer merken für gruppe_name
                          schulden_datum: new Date().toISOString().split('T')[0],
                          faelligkeitsdatum: ""
                        });
                        return;
                      }

                      // Normaler Fall: ein Posten
                      if (!schuldenFormData.betrag || parseFloat(schuldenFormData.betrag) <= 0) {
                        toast.error("Bitte einen gültigen Betrag eingeben");
                        return;
                      }
                      // Übernimm existierende rechnung_nummer als gruppe_name (falls bereits in einer Rechnungs-Gruppe)
                      const postGruppeName = schuldenFormData.rechnung_nummer || null;
                      const dataToSubmit = {
                        ...schuldenFormData,
                        betrag: parseFloat(schuldenFormData.betrag),
                        menge: parseInt(schuldenFormData.menge) || 1,
                        gruppe_name: postGruppeName,
                      };
                      setPendingSchuldenGroup(prev => [...prev, dataToSubmit]);
                      toast.success(`Posten ${pendingSchuldenGroup.length + 1} hinzugefügt`);
                      setSchuldenFormData({
                        name: schuldenFormData.name,
                        teampartner_id: schuldenFormData.teampartner_id,
                        use_custom_name: schuldenFormData.use_custom_name,
                        richtung: schuldenFormData.richtung,
                        beschreibung: "",
                        betrag: "",
                        menge: 1,
                        einzelpreis: "",
                        zuschlag_prozent: 15,
                        produkt_id: "",
                        produkt_name: "",
                        price_category: "",
                        rechnung_id: "",
                        rechnung_nummer: postGruppeName || "", // Rechnungs-Gruppe beibehalten
                        schulden_datum: new Date().toISOString().split('T')[0],
                        faelligkeitsdatum: ""
                      });
                    }}
                    className="flex-1 bg-blue-600 hover:bg-blue-700"
                  >
                    + Weiteren
                  </Button>
                </div>
              </form>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Fälligkeits-Modal: Gesamt-Fälligkeit für alle Posten der Gruppe (optional) */}
      {showFaelligkeitModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-slate-800">Fälligkeit festlegen</h3>
              <button type="button" onClick={() => setShowFaelligkeitModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <p className="text-sm text-slate-600 mb-4">
              {pendingSchuldenGroup.length} Posten für <strong>{schuldenFormData.name}</strong>
              <br />
              <span className="text-xs text-slate-500">Gesamtsumme: <strong>{pendingSchuldenGroup.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0).toFixed(2)} €</strong></span>
            </p>

            <div className="mb-4">
              <Label>Fälligkeitsdatum (optional)</Label>
              <div className="flex gap-2 flex-wrap mb-2 mt-2">
                {[7, 14, 30, 60].map(days => (
                  <button key={days} type="button"
                    onClick={() => {
                      const d = new Date();
                      d.setDate(d.getDate() + days);
                      setGruppenFaelligkeit(d.toISOString().split('T')[0]);
                    }}
                    className="px-3 py-1 text-xs bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-md font-medium">
                    +{days} Tage
                  </button>
                ))}
                <button type="button"
                  onClick={() => setGruppenFaelligkeit("")}
                  className="px-3 py-1 text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-md font-medium">
                  Ohne
                </button>
              </div>
              <Input type="date"
                value={gruppenFaelligkeit}
                onChange={(e) => setGruppenFaelligkeit(e.target.value)}
                placeholder="Kein Fälligkeitsdatum" />
              <p className="text-xs text-slate-400 mt-1">Leer lassen = Schuld ohne festes Fälligkeitsdatum</p>
            </div>

            <div className="flex gap-3 pt-4 border-t border-slate-200">
              <Button type="button" variant="outline"
                onClick={() => setShowFaelligkeitModal(false)}>
                Abbrechen
              </Button>
              <Button type="button"
                disabled={isSubmittingSchuld}
                onClick={async () => {
                  if (isSubmittingSchuld) return;
                  setIsSubmittingSchuld(true);
                  try {
                    // Alle Posten bekommen die GLEICHE gruppe_id (Gesamtschuld-Zusammenfassung)
                    const gruppeId = crypto.randomUUID ? crypto.randomUUID() : `grp_${Date.now()}_${Math.random()}`;
                    // gruppe_name: aus Rechnung übernommen (alle gleich) oder null
                    const sharedGruppeName = pendingSchuldenGroup[0]?.gruppe_name || null;
                    const promises = pendingSchuldenGroup.map(posten => {
                      const payload = {
                        ...posten,
                        faelligkeitsdatum: gruppenFaelligkeit || "",
                        gruppe_id: gruppeId,
                        gruppe_name: sharedGruppeName,
                      };
                      delete payload.einzelpreis;
                      delete payload.zuschlag_prozent;
                      delete payload.use_custom_name;
                      return axios.post(`${API}/api/schulden`, payload);
                    });
                    await Promise.all(promises);
                    const gespeicherteGruppe = pendingSchuldenGroup.map(p => ({ ...p }));
                    const kundenName = gespeicherteGruppe[0]?.name || "Kunde";
                    toast.success(`Gesamtschuld mit ${pendingSchuldenGroup.length} Posten gespeichert`);
                    setPendingSchuldenGroup([]);
                    setShowFaelligkeitModal(false);
                    setShowSchuldenModal(false);
                    setSchuldenModalSchritt(1);
                    setSchuldenFromInventory(false);
                    setInvoiceItemsForSchulden(null);
                    loadSchulden();

                    // Ersparnis-PDF Success-Modal zeigen, wenn Rabatt vorhanden
                    if (hasErspanis(gespeicherteGruppe)) {
                      setPdfSuccessData({ posten: gespeicherteGruppe, kundenName });
                      setShowPdfSuccessModal(true);
                    }
                  } catch (error) {
                    const errorMsg = error.response?.data?.detail || error.message;
                    toast.error(typeof errorMsg === 'string' ? errorMsg : "Fehler beim Speichern");
                  } finally {
                    setIsSubmittingSchuld(false);
                  }
                }}
                className="flex-1 bg-emerald-600 hover:bg-emerald-700">
                {isSubmittingSchuld ? "Speichere…" : `Alle ${pendingSchuldenGroup.length} speichern`}
              </Button>
            </div>
          </div>
        </div>
      )}


      {/* Kaltkontakt Termin Follow-up Modal */}
      {showKaltkontaktModal && selectedKaltkontakt && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex justify-between items-center">
              <div>
                <p className="text-emerald-100 text-xs font-medium uppercase tracking-wider mb-0.5">Termin Follow-up</p>
                <h3 className="text-white text-lg font-bold">Kontakt eingeschrieben?</h3>
              </div>
              <button type="button" onClick={() => { setShowKaltkontaktModal(false); setSelectedKaltkontakt(null); }} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-slate-600">
                Wie ist der Termin mit <span className="font-semibold text-slate-800">{selectedKaltkontakt.name}</span> gelaufen?
              </p>
              <div className="space-y-3">
                <button type="button" onClick={() => handleKaltkontaktEntscheidung('tp')}
                  className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border-2 font-semibold transition-all bg-emerald-600 hover:bg-emerald-700 text-white border-emerald-600">
                  <span className="text-xl">✅</span><span>Als Teampartner eingeschrieben</span>
                </button>
                <button type="button" onClick={() => handleKaltkontaktEntscheidung('kunde')}
                  className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border-2 font-semibold transition-all bg-blue-600 hover:bg-blue-700 text-white border-blue-600">
                  <span className="text-xl">✅</span><span>Als Kunde eingeschrieben</span>
                </button>
                <button type="button" onClick={() => handleKaltkontaktEntscheidung('nein')}
                  className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border-2 font-semibold transition-all bg-slate-100 hover:bg-slate-200 text-slate-800 border-slate-200">
                  <span className="text-xl">🔄</span><span>Noch nicht eingeschrieben</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Kaltkontakt Frage-Modal (Details hinzufügen?) */}
      {showKaltkontaktFrageModal && selectedKaltkontakt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <h2 className="text-xl font-bold text-slate-800 mb-4">
              📝 Details hinzufügen?
            </h2>
            <p className="text-slate-600 mb-6">
              <span className="font-semibold">{selectedKaltkontakt.name}</span> wird als <span className="font-semibold">{selectedKaltkontaktTyp === 'tp' ? 'Teampartner' : 'Kunde'}</span> eingeschrieben.
            </p>
            <p className="text-sm text-slate-500 mb-6">
              Möchtest du zusätzliche Informationen hinzufügen oder direkt speichern?
            </p>
            
            <div className="space-y-3">
              <button
                onClick={handleKaltkontaktDetailsHinzufuegen}
                className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
              >
                📋 Ja, Details hinzufügen
              </button>
              <button
                onClick={handleKaltkontaktUeberspringen}
                className="w-full px-4 py-3 bg-slate-300 hover:bg-slate-400 text-slate-800 rounded-lg font-semibold transition-colors"
              >
                ⏭️ Überspringen & Speichern
              </button>
            </div>
            
            <button
              onClick={() => {
                setShowKaltkontaktFrageModal(false);
                setSelectedKaltkontakt(null);
                setSelectedKaltkontaktTyp(null);
              }}
              className="w-full mt-4 px-4 py-2 text-slate-600 hover:text-slate-800 text-sm"
            >
              Abbrechen
            </button>
          </div>
        </div>
      )}
      
      {/* Kaltkontakt Sub-Modal (Wizard: Datum → Uhrzeit → Zuletzt → Gesprächsverlauf → Thema) */}
      {showKaltkontaktSubModal && selectedKaltkontakt && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex justify-between items-center">
              <div>
                <p className="text-emerald-100 text-xs font-medium uppercase tracking-wider mb-0.5">Nächster Termin</p>
                <h3 className="text-white text-lg font-bold">
                  {kkSubStep === 1 ? "Datum wählen"
                    : kkSubStep === 2 ? "Uhrzeit wählen"
                    : kkSubStep === 3 ? "Zuletzt kontaktiert?"
                    : kkSubStep === 4 ? "Gesprächsverlauf"
                    : "Nächstes Thema"}
                </h3>
              </div>
              <button type="button" onClick={() => { setShowKaltkontaktSubModal(false); setSelectedKaltkontakt(null); setNeuerTerminDatum(""); }} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10">
                <X className="w-5 h-5" />
              </button>
            </div>
            {/* Fortschrittsbalken */}
            <div className="flex">
              {[1,2,3,4,5].map((s, i) => (
                <div key={i} className={`h-1 flex-1 transition-colors ${kkSubStep >= s ? 'bg-emerald-500' : 'bg-slate-200'}`} />
              ))}
            </div>

            <div className="p-6 space-y-4">

              {/* Schritt 1: Datum */}
              {kkSubStep === 1 && (
                <div className="space-y-4">
                  <Input type="date" min={new Date().toISOString().split('T')[0]} value={neuerTerminDatum} onChange={(e) => setNeuerTerminDatum(e.target.value)} className="text-base h-12" />
                  <div className="flex gap-3">
                    <Button type="button" onClick={() => { setShowKaltkontaktSubModal(false); setShowKaltkontaktModal(true); }} variant="outline" className="flex-1 h-11">← Zurück</Button>
                    <Button type="button" onClick={() => setKkSubStep(2)} disabled={!neuerTerminDatum} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                  </div>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-xs text-slate-400 mb-2">Oder:</p>
                    <div className="space-y-2">
                      <button type="button" onClick={() => handleKaltkontaktSubAction('pausieren')} className="w-full px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors text-sm">⏸️ Kontakt pausieren</button>
                      <button type="button" onClick={() => handleKaltkontaktSubAction('loeschen')} className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors text-sm">🗑️ Kontakt löschen</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Schritt 2: Uhrzeit */}
              {kkSubStep === 2 && (
                <div className="space-y-4">
                  <Input type="time" value={neuerTerminUhrzeit} onChange={(e) => setNeuerTerminUhrzeit(e.target.value)} className="text-base h-12" />
                  <div className="flex gap-3">
                    <Button type="button" onClick={() => setKkSubStep(1)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                    <Button type="button" onClick={() => setKkSubStep(3)} disabled={!neuerTerminUhrzeit} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                  </div>
                </div>
              )}

              {/* Schritt 3: Zuletzt kontaktiert */}
              {kkSubStep === 3 && (
                <div className="space-y-3">
                  <p className="text-sm text-slate-500">Wann wurde zuletzt Kontakt aufgenommen?</p>
                  {[
                    { val: "heute", icon: "📅", label: `Heute (${new Date().toLocaleDateString('de-DE')})`, sub: "Wird als heutiges Datum gesetzt" },
                    { val: "custom", icon: "🗓️", label: "Anderes Datum wählen", sub: "" },
                    { val: "nein", icon: "⏭️", label: "Nicht aktualisieren", sub: "Datum bleibt unverändert" }
                  ].map(opt => (
                    <label key={opt.val} onClick={() => setKkLetzterOption(opt.val)}
                      className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${kkLetzterOption === opt.val ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`}>
                      <span className="text-2xl">{opt.icon}</span>
                      <div className="flex-1">
                        <p className="font-semibold text-slate-800">{opt.label}</p>
                        {opt.sub && <p className="text-xs text-slate-400 mt-0.5">{opt.sub}</p>}
                        {opt.val === "custom" && kkLetzterOption === "custom" && (
                          <Input type="date" max={new Date().toISOString().split('T')[0]} value={kkLetzterCustom} onChange={(e) => { e.stopPropagation(); setKkLetzterCustom(e.target.value); }} className="mt-2 text-sm" />
                        )}
                      </div>
                      <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${kkLetzterOption === opt.val ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300'}`}>
                        {kkLetzterOption === opt.val && <div className="w-2 h-2 rounded-full bg-white" />}
                      </div>
                    </label>
                  ))}
                  <div className="flex gap-3 pt-1">
                    <Button type="button" onClick={() => setKkSubStep(2)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                    <Button type="button" disabled={kkLetzterOption === "custom" && !kkLetzterCustom}
                      onClick={() => {
                        // Gesprächsverlauf überspringen wenn "Nicht aktualisieren"
                        if (kkLetzterOption !== "nein") { setKkSubStep(4); } else { setKkSubStep(5); }
                      }}
                      className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                  </div>
                </div>
              )}

              {/* Schritt 4: Gesprächsverlauf */}
              {kkSubStep === 4 && (
                <div className="space-y-3">
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                    <p className="text-xs text-slate-400 mb-2 uppercase tracking-wide">Gesprächsthema (bearbeitbar)</p>
                    <Input value={kkGespraechsFreitext} onChange={(e) => setKkGespraechsFreitext(e.target.value)} placeholder="z.B. Erstgespräch, Produktvorstellung..." className="bg-white" />
                  </div>
                  <p className="text-sm text-slate-500">Soll dies im <strong>Gesprächsverlauf</strong> gespeichert werden?</p>
                  {[
                    { val: "aktuell", icon: "💾", label: "Ja, jetzt speichern", sub: `Aktuelle Uhrzeit (${new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })})` },
                    { val: "manuell", icon: "🕐", label: "Ja, andere Uhrzeit", sub: "Uhrzeit selbst eingeben" },
                    { val: "nein", icon: "✕", label: "Nein, nicht speichern", sub: "" }
                  ].map(opt => (
                    <label key={opt.val} onClick={() => setKkThemaUhrzeitMode(opt.val)}
                      className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${kkThemaUhrzeitMode === opt.val ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`}>
                      <span className="text-2xl">{opt.icon}</span>
                      <div className="flex-1">
                        <p className="font-semibold text-slate-800">{opt.label}</p>
                        {opt.sub && <p className="text-xs text-slate-400 mt-0.5">{opt.sub}</p>}
                        {opt.val === "manuell" && kkThemaUhrzeitMode === "manuell" && (
                          <Input type="time" value={kkThemaManuelleUhrzeit} onChange={(e) => { e.stopPropagation(); setKkThemaManuelleUhrzeit(e.target.value); }} className="mt-2 text-sm" />
                        )}
                      </div>
                      <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${kkThemaUhrzeitMode === opt.val ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300'}`}>
                        {kkThemaUhrzeitMode === opt.val && <div className="w-2 h-2 rounded-full bg-white" />}
                      </div>
                    </label>
                  ))}
                  <div className="flex gap-3 pt-1">
                    <Button type="button" onClick={() => setKkSubStep(3)} variant="outline" className="flex-1 h-11">← Zurück</Button>
                    <Button type="button" onClick={() => {
                      if (kkThemaUhrzeitMode === "nein") {
                        setKkNeuesThema(selectedKaltkontakt?.naechstes_thema || kkGespraechsFreitext || "");
                      } else {
                        setKkNeuesThema("");
                      }
                      setKkSubStep(5);
                    }} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white">Weiter →</Button>
                  </div>
                </div>
              )}

              {/* Schritt 5: Nächstes Thema */}
              {kkSubStep === 5 && (
                <div className="space-y-4">
                  <p className="text-sm text-slate-500">Was ist das Thema für den nächsten Termin?</p>
                  <Input value={kkNeuesThema} onChange={(e) => setKkNeuesThema(e.target.value)} placeholder="z.B. Produktvorstellung, Beratung, Folgegespräch..." className="h-12" autoFocus />
                  <div className="flex gap-3 pt-1">
                    <Button type="button" onClick={() => {
                      if (kkLetzterOption !== "nein") { setKkSubStep(4); } else { setKkSubStep(3); }
                    }} variant="outline" className="flex-1 h-11">← Zurück</Button>
                    <Button type="button" onClick={handleKaltkontaktSubFinalize} className="flex-1 h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold">Fertig ✓</Button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      )}

      {/* Kaltkontakt Details-Modal */}
      {showKaltkontaktDetailsModal && selectedKaltkontakt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4 overflow-y-auto">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full my-8 p-6">
            <h2 className="text-xl font-bold text-slate-800 mb-4">
              📝 Details für {selectedKaltkontakt.name}
            </h2>
            <p className="text-sm text-slate-500 mb-6">
              Füge zusätzliche Informationen hinzu (optional)
            </p>
            
            <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
              {/* Name (readonly) */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Name</label>
                <input
                  type="text"
                  value={formData.name}
                  readOnly
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-100 text-slate-600"
                />
              </div>

              {/* Typ & Stufe (readonly - automatisch) */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Typ</label>
                  <input
                    type="text"
                    value={formData.typ === 'teampartner' ? 'Teampartner' : 'Kunde'}
                    readOnly
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-100 text-slate-600"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Stufe</label>
                  <input
                    type="text"
                    value={formData.stufe}
                    readOnly
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-100 text-slate-600"
                  />
                </div>
              </div>

              {/* Telefonnummer (lokal) */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">
                  Telefonnummer
                </label>
                <button
                  type="button"
                  onClick={() => {
                    const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
                    setLocalPhone(phones[editingId] || '');
                    setShowLocalPhoneModal(true);
                  }}
                  className="w-full text-left px-3 py-2.5 border border-slate-300 rounded-lg text-sm hover:bg-slate-50 transition-colors flex items-center gap-2"
                >
                  <Phone className="w-4 h-4 text-slate-400 flex-shrink-0" />
                  <span className={localPhone ? 'text-slate-800' : 'text-slate-400'}>
                    {localPhone || 'Telefonnummer hinzufügen...'}
                  </span>
                </button>
              </div>

              {/* Nächster Termin (Einnahmegespräch) */}              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">
                  Nächster Termin (Einnahmegespräch) 💊
                </label>
                <input
                  type="date"
                  value={formData.naechster_termin}
                  onChange={(e) => setFormData(prev => ({...prev, naechster_termin: e.target.value}))}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-slate-500 mt-1">Standard: In 5 Tagen</p>
              </div>

              {/* Thema (fest) */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Thema</label>
                <input
                  type="text"
                  value="Einnahmegespräch"
                  readOnly
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-100 text-slate-600"
                />
              </div>

              {/* Noch zu erledigen */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Noch zu erledigen</label>
                <KontaktTaskList
                  tasks={normalizeNochZuErledigen(formData.noch_zu_erledigen)}
                  isEditMode={true}
                  onToggle={(taskId) => setFormData(prev => ({ ...prev, noch_zu_erledigen: normalizeNochZuErledigen(prev.noch_zu_erledigen).map(t => t.id === taskId ? { ...t, done: !t.done } : t) }))}
                  onDelete={(taskId) => setFormData(prev => ({ ...prev, noch_zu_erledigen: normalizeNochZuErledigen(prev.noch_zu_erledigen).filter(t => t.id !== taskId) }))}
                  onAdd={() => handleOpenZuErledigienModal(editingId, formData.name, formData.typ, true)}
                />
              </div>

              {/* Linie */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Linie</label>
                <select
                  value={formData.linie}
                  onChange={(e) => setFormData(prev => ({...prev, linie: e.target.value}))}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="erstlinie">Erstlinie</option>
                  {teampartner.filter(t => t.typ === 'teampartner').map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
              </div>

              {/* Thematik - Checkboxen */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-semibold text-slate-700">Thematik (Mehrfachauswahl)</label>
                  <button
                    type="button"
                    onClick={() => setShowThematikManager(true)}
                    className="text-xs text-blue-600 hover:text-blue-700 underline font-semibold"
                  >
                    ⚙️ Liste bearbeiten
                  </button>
                </div>
                <div className="border border-slate-300 rounded-lg p-3 max-h-48 overflow-y-auto bg-slate-50">
                  <div className="grid grid-cols-2 gap-1">
                    {[...DEFAULT_THEMATIK_OPTIONEN, ...customThematikOptionen].map(thema => (
                      <label key={thema} className="flex items-center space-x-1.5 cursor-pointer hover:bg-slate-100 p-1.5 rounded text-xs">
                        <input
                          type="checkbox"
                          checked={formData.thematik?.includes(thema) || false}
                          onChange={() => toggleThematik(thema)}
                          className="rounded border-slate-300 flex-shrink-0"
                        />
                        <span className="text-slate-700">{thema}</span>
                      </label>
                    ))}
                  </div>
                </div>
                {formData.thematik?.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {formData.thematik.map(thema => (
                      <span key={thema} className="px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs">
                        {thema}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Im Abo - Checkboxen */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Produkte im Abo</label>
                <div className="border border-slate-300 rounded-lg p-3 max-h-48 overflow-y-auto bg-slate-50">
                  <div className="space-y-1">
                    <label className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                      <input
                        type="checkbox"
                        checked={formData.im_abo?.includes("konzept-1") || false}
                        onChange={() => toggleProduktAbo("konzept-1")}
                        className="rounded border-slate-300"
                      />
                      <span className="text-sm text-slate-700 font-semibold">Konzept 1</span>
                    </label>
                    {produkte.map(produkt => (
                      <label key={produkt.id} className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                        <input
                          type="checkbox"
                          checked={formData.im_abo?.includes(produkt.id) || false}
                          onChange={() => toggleProduktAbo(produkt.id)}
                          className="rounded border-slate-300"
                        />
                        <span className="text-sm text-slate-700">{produkt.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Produktempfehlung - Checkboxen */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Produktempfehlungen</label>
                <div className="border border-slate-300 rounded-lg p-3 max-h-48 overflow-y-auto bg-slate-50">
                  <div className="space-y-1">
                    {!formData.im_abo?.includes("konzept-1") && (
                      <label className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                        <input
                          type="checkbox"
                          checked={formData.produktempfehlung?.includes("konzept-1") || false}
                          onChange={() => toggleProduktEmpfehlung("konzept-1")}
                          className="rounded border-slate-300"
                        />
                        <span className="text-sm text-slate-700 font-semibold">Konzept 1</span>
                      </label>
                    )}
                    {produkte.filter(p => !formData.im_abo?.includes(p.id)).map(produkt => (
                      <label key={produkt.id} className="flex items-center space-x-2 cursor-pointer hover:bg-slate-100 p-1 rounded">
                        <input
                          type="checkbox"
                          checked={formData.produktempfehlung?.includes(produkt.id) || false}
                          onChange={() => toggleProduktEmpfehlung(produkt.id)}
                          className="rounded border-slate-300"
                        />
                        <span className="text-sm text-slate-700">{produkt.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Online/Live Veranstaltungen - Checkboxen */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-semibold text-slate-700">Veranstaltungen</label>
                  <button
                    type="button"
                    onClick={() => setShowVeranstaltungManager(true)}
                    className="text-xs text-blue-600 hover:text-blue-700 underline font-semibold"
                  >
                    ⚙️ Liste bearbeiten
                  </button>
                </div>
                <div className="border border-slate-300 rounded-lg p-3 max-h-48 overflow-y-auto bg-slate-50">
                  <div className="grid grid-cols-2 gap-1">
                    {[...DEFAULT_VERANSTALTUNG_OPTIONEN, ...customVeranstaltungOptionen].map(veranstaltung => (
                      <label key={veranstaltung} className="flex items-center space-x-1.5 cursor-pointer hover:bg-slate-100 p-1.5 rounded text-xs">
                        <input
                          type="checkbox"
                          checked={formData.online_live_veranstaltungen?.includes(veranstaltung) || false}
                          onChange={() => {
                            const current = formData.online_live_veranstaltungen || [];
                            if (current.includes(veranstaltung)) {
                              setFormData({
                                ...formData,
                                online_live_veranstaltungen: current.filter(v => v !== veranstaltung)
                              });
                            } else {
                              setFormData({
                                ...formData,
                                online_live_veranstaltungen: [...current, veranstaltung]
                              });
                            }
                          }}
                          className="rounded border-slate-300 flex-shrink-0"
                        />
                        <span className="text-slate-700">{veranstaltung}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Actionpack */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Actionpack genutzt?</label>
                <div className="flex gap-4">
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="actionpack_modal"
                      value="ja"
                      checked={formData.actionpack === "ja"}
                      onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                      className="border-slate-300"
                    />
                    <span className="text-sm text-slate-700">Ja</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="actionpack_modal"
                      value="nein"
                      checked={formData.actionpack === "nein"}
                      onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                      className="border-slate-300"
                    />
                    <span className="text-sm text-slate-700">Nein</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="actionpack_modal"
                      value="interesse"
                      checked={formData.actionpack === "interesse"}
                      onChange={(e) => setFormData(prev => ({...prev, actionpack: e.target.value}))}
                      className="border-slate-300"
                    />
                    <span className="text-sm text-slate-700">Interesse</span>
                  </label>
                </div>
              </div>

              {/* Notizen */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Notizen</label>
                <textarea
                  value={formData.notizen || ""}
                  onChange={(e) => setFormData(prev => ({...prev, notizen: e.target.value}))}
                  rows="3"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Zusätzliche Notizen..."
                />
              </div>
            </div>
            
            <div className="flex gap-3 mt-6">
              <button
                onClick={handleKaltkontaktDetailsSpeichern}
                className="flex-1 px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold transition-colors"
              >
                💾 Speichern
              </button>
              <button
                onClick={() => {
                  setShowKaltkontaktDetailsModal(false);
                  setSelectedKaltkontakt(null);
                  setSelectedKaltkontaktTyp(null);
                }}
                className="px-4 py-3 bg-slate-300 hover:bg-slate-400 text-slate-800 rounded-lg font-semibold transition-colors"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Pausierung Modal */}
      {showPausierungModal && pausierterKontakt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <h2 className="text-xl font-bold text-slate-800 mb-4">
              ⏸️ Pausierter Kontakt
            </h2>
            <p className="text-slate-600 mb-6">
              <strong>{pausierterKontakt.name}</strong> ist pausiert. Möchten Sie die Pausierung beenden und den Kontakt bearbeiten?
            </p>
            
            <div className="flex gap-3">
              <button
                onClick={handlePausierungBeenden}
                className="flex-1 px-4 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold transition-colors"
              >
                ✅ Pausierung beenden
              </button>
              <button
                onClick={() => {
                  setShowPausierungModal(false);
                  setPausierterKontakt(null);
                }}
                className="px-4 py-3 bg-slate-300 hover:bg-slate-400 text-slate-800 rounded-lg font-semibold transition-colors"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mini-Kalender Modal */}
      {showWeekModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-end sm:items-center justify-center z-[200] p-4" onClick={() => { setShowWeekModal(false); setShowTodosPanel(false); setFocusPopupText(null); }}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden relative flex flex-col h-[520px] max-h-[calc(100dvh-2rem)]" onClick={e => e.stopPropagation()}>

            {/* Fokus-Popup (schwarzer Info-Text beim Tippen) */}
            {focusPopupText && (
              <div
                className="absolute left-4 right-4 bg-slate-900 text-white text-xs p-3 rounded-xl z-20 shadow-2xl"
                style={{ top: '72px' }}
                onClick={() => setFocusPopupText(null)}
              >
                <p className="font-semibold text-emerald-400 mb-1">✦ Fokus</p>
                <p className="leading-relaxed">{focusPopupText}</p>
                <p className="text-slate-400 mt-2 text-[10px]">Tippen zum Schließen</p>
              </div>
            )}

            {/* Header – feste Höhe für beide Modi */}
            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-4 pb-2 pt-1 flex flex-col">

              {/* Zeile 1: X-Button oben rechts */}
              <div className="flex justify-end mb-0.5">
                <button type="button" title="Schließen"
                  onClick={() => { setShowWeekModal(false); setShowTodosPanel(false); setFocusPopupText(null); }}
                  className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors"
                >
                  <X className="w-3 h-3" />
                </button>
              </div>

              {/* Zeile 2: Navigation + Titel */}
              <div className="flex items-center">
                <div className="w-8 flex-shrink-0 flex items-center">
                  {!showTodosPanel ? (
                    <button type="button" className="text-white/80 hover:text-white p-1.5 rounded-lg hover:bg-white/10 transition-colors"
                      onClick={() => { const d = new Date(weekModalDate); d.setDate(d.getDate() - 7); setWeekModalDate(d); }}>
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                  ) : <span className="w-8" />}
                </div>

                <div className="flex-1 text-center min-w-0">
                  {showTodosPanel ? (
                    <p className="text-white font-bold text-sm">Aufgaben</p>
                  ) : (
                    <>
                      <p className="text-white font-bold text-sm leading-tight">Kalender</p>
                      <p className="text-white/70 text-xs leading-tight">
                        {(() => {
                          const d = new Date(weekModalDate);
                          const jan4 = new Date(d.getFullYear(), 0, 4);
                          const sw = new Date(jan4); sw.setDate(jan4.getDate() - (jan4.getDay() || 7) + 1);
                          return `KW ${Math.ceil(((d - sw) / 86400000 + 1) / 7)} / ${d.getFullYear()}`;
                        })()}
                      </p>
                      {(() => {
                        const d = new Date(weekModalDate);
                        const jan4 = new Date(d.getFullYear(), 0, 4);
                        const sw = new Date(jan4); sw.setDate(jan4.getDate() - (jan4.getDay() || 7) + 1);
                        const kw = Math.ceil(((d - sw) / 86400000 + 1) / 7);
                        const wk = `${d.getFullYear()}-W${kw}`;
                        const goals = JSON.parse(userStorage.getItem('zielplanung_week_goals') || '{}');
                        const goal = goals[wk];
                        return goal ? (
                          <p className="text-white/90 text-[11px] mt-0.5 px-2 py-0.5 bg-white/10 rounded-full truncate max-w-[180px] mx-auto" title={goal}>
                            🎯 {goal}
                          </p>
                        ) : null;
                      })()}
                    </>
                  )}
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                  {(() => {
                    if (showTodosPanel) {
                      const berlinNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
                      const todayStr = `${berlinNow.getFullYear()}-${String(berlinNow.getMonth()+1).padStart(2,'0')}-${String(berlinNow.getDate()).padStart(2,'0')}`;
                      const nowTime = `${String(berlinNow.getHours()).padStart(2,'0')}:${String(berlinNow.getMinutes()).padStart(2,'0')}`;
                      const apts = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
                      const upcomingCount = apts.filter(a => {
                        if (a.done || a.date !== todayStr) return false;
                        const t = a.endTime || a.startTime || '23:59';
                        return t >= nowTime;
                      }).length;
                      return (
                        <>
                          <button type="button" title="Zurück zum Kalender"
                            onClick={() => { setShowTodosPanel(false); setTodosPanelRefreshKey(k => k + 1); }}
                            className="w-8 h-8 bg-emerald-800 hover:bg-emerald-900 rounded-lg transition-colors flex items-center justify-center relative flex-shrink-0"
                          >
                            <CalendarDays className="w-4 h-4 text-white" />
                            {upcomingCount > 0 && (
                              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold">{upcomingCount}</span>
                            )}
                          </button>
                          {/* Spacer damit der Button auf gleicher X-Position wie im Kalender-Header ist */}
                          <span className="w-8 flex-shrink-0" />
                        </>
                      );
                    } else {
                      const bn = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
                      const todayKey = `${bn.getFullYear()}-${String(bn.getMonth()+1).padStart(2,'0')}-${String(bn.getDate()).padStart(2,'0')}`;
                      const todayWeekday = bn.getDay() === 0 ? 6 : bn.getDay() - 1;
                      const dailyAll = JSON.parse(userStorage.getItem('zielplanung_daily_todos') || '{}');
                      const weeklyRaw = JSON.parse(userStorage.getItem('zielplanung_weekly_todos') || '[]');
                      const weeklyArr = Array.isArray(weeklyRaw) ? weeklyRaw : Object.values(weeklyRaw).flat();
                      const todayCount = (dailyAll[todayKey] || []).filter(t => !t.done).length
                        + weeklyArr.filter(t => !t.done && t.weekday === todayWeekday).length;
                      return (
                        <button type="button" title="Aufgaben"
                          onClick={() => { setShowTodosPanel(true); setTodosTab('daily'); setTodosPanelRefreshKey(k => k + 1); }}
                          className="w-8 h-8 bg-purple-500 hover:bg-purple-600 rounded-lg transition-colors flex items-center justify-center relative flex-shrink-0"
                        >
                          <ListTodo className="w-4 h-4 text-white" />
                          {todayCount > 0 && (
                            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold">{todayCount}</span>
                          )}
                        </button>
                      );
                    }
                  })()}
                  {!showTodosPanel && (
                    <button type="button" className="text-white/80 hover:text-white p-1.5 rounded-lg hover:bg-white/10 transition-colors"
                      onClick={() => { const d = new Date(weekModalDate); d.setDate(d.getDate() + 7); setWeekModalDate(d); }}>
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* ── TODOS PANEL ── */}
            {showTodosPanel && (
              <div className="flex flex-col flex-1 min-h-0">
                {/* Tab-Leiste mit Aufgaben-Anzahl pro Tab */}
                {(() => {
                  // Anzahl der offenen Todos je Tab berechnen (heute/Woche/Monat).
                  // done-Todos werden NICHT mitgezählt (ähnlich wie Todos-Ansicht).
                  const _bn = new Date();
                  const _todayKey = `${_bn.getFullYear()}-${String(_bn.getMonth()+1).padStart(2,'0')}-${String(_bn.getDate()).padStart(2,'0')}`;
                  let dailyCount = 0, weeklyCount = 0, monthlyCount = 0;
                  try {
                    const daily = JSON.parse(userStorage.getItem('zielplanung_daily_todos') || '{}');
                    dailyCount = (daily[_todayKey] || []).filter(t => !t.done).length;
                  } catch {}
                  try {
                    const rawW = JSON.parse(userStorage.getItem('zielplanung_weekly_todos') || '[]');
                    const arrW = Array.isArray(rawW) ? rawW : Object.values(rawW).flat();
                    weeklyCount = arrW.filter(t => !t.done).length;
                  } catch {}
                  try {
                    const rawM = JSON.parse(userStorage.getItem('zielplanung_monthly_todos') || '[]');
                    const arrM = Array.isArray(rawM) ? rawM : Object.values(rawM).flat();
                    monthlyCount = arrM.filter(t => !t.done).length;
                  } catch {}
                  const counts = { daily: dailyCount, weekly: weeklyCount, monthly: monthlyCount };
                  return (
                    <div className="flex border-b border-slate-200">
                      {[['daily','Heute'],['weekly','Woche'],['monthly','Monat']].map(([id, label]) => (
                        <button key={id} type="button" onClick={() => setTodosTab(id)}
                          data-testid={`minikalender-todos-tab-${id}`}
                          className={`flex-1 py-2 text-xs font-semibold transition-colors flex items-center justify-center gap-1.5 ${todosTab === id ? 'text-purple-700 border-b-2 border-purple-600 bg-purple-50' : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'}`}>
                          <span>{label}</span>
                          {counts[id] > 0 && (
                            <span
                              data-testid={`minikalender-todos-count-${id}`}
                              className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold leading-none ${todosTab === id ? 'bg-purple-600 text-white' : 'bg-slate-200 text-slate-700'}`}
                            >
                              {counts[id]}
                            </span>
                          )}
                        </button>
                      ))}
                    </div>
                  );
                })()}

                {/* Tab-Inhalt – flex-1 damit es den Rest ausfüllt */}
                <div
                  className="flex-1 overflow-y-auto overscroll-contain select-none"
                  key={`${todosTab}-${todosPanelRefreshKey}`}
                  style={{ touchAction: 'pan-y' }}
                  onTouchStart={(e) => {
                    todosSwipeStartX.current = e.targetTouches[0].clientX;
                    todosSwipeDeltaX.current = 0;
                  }}
                  onTouchMove={(e) => {
                    if (todosSwipeStartX.current === null) return;
                    const dx = e.targetTouches[0].clientX - todosSwipeStartX.current;
                    todosSwipeDeltaX.current = dx;
                    if (Math.abs(dx) > 12) e.preventDefault();
                  }}
                  onTouchEnd={() => {
                    const dx = todosSwipeDeltaX.current;
                    todosSwipeStartX.current = null;
                    todosSwipeDeltaX.current = 0;
                    if (Math.abs(dx) < 50) return;
                    const tabs = ['daily', 'weekly', 'monthly'];
                    const currentIdx = tabs.indexOf(todosTab);
                    if (dx < 0 && currentIdx < tabs.length - 1) setTodosTab(tabs[currentIdx + 1]);
                    else if (dx > 0 && currentIdx > 0) setTodosTab(tabs[currentIdx - 1]);
                  }}
                >
                  {(() => {
                    const bn = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
                    const todayKey = `${bn.getFullYear()}-${String(bn.getMonth()+1).padStart(2,'0')}-${String(bn.getDate()).padStart(2,'0')}`;
                    const todayWeekday = bn.getDay() === 0 ? 6 : bn.getDay() - 1; // 0=Mo … 6=So
                    const getWeekNum = (d) => { const u = new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate())); const day=u.getUTCDay()||7; u.setUTCDate(u.getUTCDate()+4-day); const y=new Date(Date.UTC(u.getUTCFullYear(),0,1)); return Math.ceil((((u-y)/86400000)+1)/7); };
                    const currentKW = getWeekNum(bn);

                    const getPriorityColor = (p) => p >= 8 ? 'border-l-red-500 bg-red-50' : p >= 5 ? 'border-l-amber-500 bg-amber-50' : 'border-l-green-500 bg-green-50';
                    const getPriorityBadge = (p) => p >= 8 ? 'bg-red-100 text-red-700' : p >= 5 ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700';
                    const WOCHENTAGE = ['Mo','Di','Mi','Do','Fr','Sa','So'];

                    const renderTodo = (todo) => (
                      <div key={todo.id || Math.random()}
                        className={`p-3 rounded-lg border-l-4 ${getPriorityColor(todo.priority || 5)} ${todo.done ? 'opacity-60' : ''}`}>
                        <div className="flex items-start gap-3">
                          <button type="button"
                            onClick={() => handleTogglePanelTodo(todo)}
                            className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all mt-0.5 ${
                              todo.done ? 'bg-emerald-600 border-emerald-600 text-white' : 'border-slate-300 hover:border-emerald-500'
                            }`}>
                            {todo.done && <Check className="w-4 h-4" />}
                          </button>
                          <div className="flex-1 min-w-0">
                            <p className={`text-sm ${todo.done ? 'line-through text-slate-400' : 'text-slate-700'}`}>{todo.text}</p>
                            {todo.contactRef?.name && (
                              <p className="text-xs text-emerald-600 mt-0.5 flex items-center gap-1">
                                <User className="w-3 h-3" />{todo.contactRef.name}
                              </p>
                            )}
                          </div>
                          <span className={`px-2 py-0.5 rounded text-xs font-medium flex-shrink-0 ${getPriorityBadge(todo.priority || 5)}`}>
                            P{todo.priority || 5}
                          </span>
                        </div>
                      </div>
                    );

                    const renderSection = (title, todos, colorClass) => {
                      if (todos.length === 0) return null;
                      return (
                        <div className="mb-2">
                          <div className={`flex items-center gap-2 mb-1.5 pb-1 border-b ${colorClass === 'purple' ? 'border-purple-200' : colorClass === 'emerald' ? 'border-emerald-200' : 'border-slate-200'}`}>
                            <span className={`text-xs font-bold uppercase tracking-wide ${colorClass === 'purple' ? 'text-purple-600' : colorClass === 'emerald' ? 'text-emerald-600' : 'text-slate-500'}`}>{title}</span>
                            <span className={`text-xs px-1.5 py-0.5 rounded-full ${colorClass === 'purple' ? 'bg-purple-100 text-purple-700' : colorClass === 'emerald' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                              {todos.filter(t => !t.done).length} offen
                            </span>
                          </div>
                          <div className="space-y-1.5 ml-2">{todos.map(renderTodo)}</div>
                        </div>
                      );
                    };

                    // ── HEUTE ──
                    if (todosTab === 'daily') {
                      const all = JSON.parse(userStorage.getItem('zielplanung_daily_todos') || '{}');
                      const todos = (all[todayKey] || []).map(t => ({ ...t, _storageKey: 'zielplanung_daily_todos', _subKey: todayKey }));
                      if (todos.length === 0) return <p className="text-xs text-slate-400 text-center py-8">Keine Aufgaben heute</p>;
                      return <div className="p-3 space-y-1.5">{todos.map(renderTodo)}</div>;
                    }

                    // ── WOCHE ──
                    if (todosTab === 'weekly') {
                      const raw = JSON.parse(userStorage.getItem('zielplanung_weekly_todos') || '[]');
                      const arr = Array.isArray(raw) ? raw : Object.values(raw).flat();
                      const withMeta = arr.map(t => ({ ...t, _storageKey: 'zielplanung_weekly_todos', _subKey: Array.isArray(raw) ? null : Object.keys(raw).find(k => raw[k]?.some(x => x.id === t.id)) || null }));

                      const unassigned = withMeta.filter(t => t.weekday === undefined || t.weekday === null);
                      // Nur ab morgen anzeigen
                      const tomorrowIdx = (todayWeekday + 1) % 7;

                      const sections = [];
                      if (unassigned.length > 0) sections.push(renderSection('Diese Woche', unassigned, 'purple'));
                      // Wochentage ab morgen
                      for (let i = 0; i < 7; i++) {
                        const dayIdx = (tomorrowIdx + i) % 7;
                        const dayTodos = withMeta.filter(t => t.weekday === dayIdx);
                        if (dayTodos.length > 0) {
                          const isToday = dayIdx === todayWeekday;
                          sections.push(renderSection(WOCHENTAGE[dayIdx], dayTodos, isToday ? 'emerald' : 'slate'));
                        }
                      }
                      if (sections.every(s => s === null || s === undefined)) return <p className="text-xs text-slate-400 text-center py-8">Keine Aufgaben diese Woche</p>;
                      return <div className="p-3">{sections}</div>;
                    }

                    // ── MONAT ──
                    const raw = JSON.parse(userStorage.getItem('zielplanung_monthly_todos') || '[]');
                    const arr = Array.isArray(raw) ? raw : Object.values(raw).flat();
                    const withMeta = arr.map(t => ({ ...t, _storageKey: 'zielplanung_monthly_todos', _subKey: Array.isArray(raw) ? null : Object.keys(raw).find(k => raw[k]?.some(x => x.id === t.id)) || null }));

                    const unassigned = withMeta.filter(t => t.weekNum === undefined || t.weekNum === null);
                    const kwNums = [...new Set(withMeta.filter(t => t.weekNum >= currentKW).map(t => t.weekNum))].sort((a,b) => a-b);

                    const sections = [];
                    if (unassigned.length > 0) sections.push(renderSection('Diesen Monat', unassigned, 'purple'));
                    kwNums.forEach(kw => {
                      const kwTodos = withMeta.filter(t => t.weekNum === kw);
                      sections.push(renderSection(`KW ${kw}`, kwTodos, kw === currentKW ? 'emerald' : 'slate'));
                    });
                    if (sections.every(s => s === null || s === undefined)) return <p className="text-xs text-slate-400 text-center py-8">Keine Aufgaben diesen Monat</p>;
                    return <div className="p-3">{sections}</div>;
                  })()}
                </div>
              </div>
            )}

            {/* ── KALENDER ANSICHT ── */}
            {!showTodosPanel && (
              <div
                className="flex-1 overflow-y-auto overscroll-contain divide-y divide-slate-100 select-none"
                onTouchStart={(e) => {
                  weekSwipeStartX.current = e.targetTouches[0].clientX;
                  weekSwipeDeltaX.current = 0;
                }}
                onTouchMove={(e) => {
                  if (weekSwipeStartX.current === null) return;
                  const dx = e.targetTouches[0].clientX - weekSwipeStartX.current;
                  weekSwipeDeltaX.current = dx;
                  // Horizontales Wischen → Scrollen verhindern
                  if (Math.abs(dx) > 12) e.preventDefault();
                }}
                onTouchEnd={() => {
                  const dx = weekSwipeDeltaX.current;
                  weekSwipeStartX.current = null;
                  weekSwipeDeltaX.current = 0;
                  if (Math.abs(dx) < 50) return; // Zu kurz → ignorieren
                  const d = new Date(weekModalDate);
                  d.setDate(d.getDate() + (dx < 0 ? 7 : -7));
                  setWeekModalDate(d);
                }}
                style={{ touchAction: 'pan-y' }}
              >
                {(() => {
                  const d = new Date(weekModalDate);
                  const day = d.getDay() || 7;
                  const monday = new Date(d); monday.setDate(d.getDate() - day + 1);
                  const appointments = JSON.parse(userStorage.getItem('zielplanung_appointments') || '[]');
                  const dayNames = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
                  const berlinNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
                  const today = `${berlinNow.getFullYear()}-${String(berlinNow.getMonth()+1).padStart(2,'0')}-${String(berlinNow.getDate()).padStart(2,'0')}`;
                  const dayFocusAll = JSON.parse(userStorage.getItem('zielplanung_day_focus') || '{}');
                  const getAptBg   = c => ({ blue:'bg-blue-100', purple:'bg-purple-100', cyan:'bg-cyan-100', pink:'bg-pink-100', orange:'bg-orange-100', teal:'bg-teal-100', red:'bg-red-100' }[c] || 'bg-yellow-100');
                  const getAptText = c => ({ blue:'text-blue-700', purple:'text-purple-700', cyan:'text-cyan-700', pink:'text-pink-700', orange:'text-orange-700', teal:'text-teal-700', red:'text-red-700' }[c] || 'text-yellow-700');

                  return dayNames.map((name, i) => {
                    const dayDate = new Date(monday); dayDate.setDate(monday.getDate() + i);
                    const dateStr = `${dayDate.getFullYear()}-${String(dayDate.getMonth()+1).padStart(2,'0')}-${String(dayDate.getDate()).padStart(2,'0')}`;
                    const isToday = dateStr === today;
                    const focusText = dayFocusAll[dateStr];

                    // Normale Termine für diesen Tag
                    const dayApts = appointments
                      .filter(a => !a.done && !a.isMultiDay && a.date === dateStr)
                      .sort((a,b) => (a.startTime||'00:00').localeCompare(b.startTime||'00:00'));

                    // Mehrtagige Termine die diesen Tag beinhalten
                    const multiDayApts = appointments.filter(a => !a.done && a.isMultiDay && a.endDate &&
                      a.date <= dateStr && a.endDate >= dateStr);

                    const allApts = [...dayApts, ...multiDayApts];

                    return (
                      <div key={dateStr} ref={isToday ? weekModalTodayRef : null}>
                        {/* Tages-Header */}
                        <div className={`flex items-center gap-2 px-3 py-2 ${isToday ? 'bg-emerald-50' : 'bg-slate-50'}`}>
                          <span className={`text-xs font-bold w-6 ${isToday ? 'text-emerald-700' : 'text-slate-500'}`}>{name}</span>
                          <span className={`text-xs ${isToday ? 'text-emerald-600 font-semibold' : 'text-slate-400'}`}>{dayDate.getDate()}.{dayDate.getMonth()+1}.</span>
                          {isToday && <span className="text-xs bg-emerald-600 text-white px-1.5 rounded-full">Heute</span>}
                          {/* Fokus-Text als Pill */}
                          {focusText && (
                            <button
                              type="button"
                              onClick={() => setFocusPopupText(focusText)}
                              className="flex-1 text-left text-[10px] italic text-emerald-700 bg-emerald-100 px-1.5 py-0.5 rounded-full min-w-0 max-w-[110px] sm:max-w-[200px] overflow-hidden"
                              title={focusText}
                            >
                              <span className="block line-clamp-2 sm:line-clamp-3">✦ Fokus: {focusText}</span>
                            </button>
                          )}
                          {allApts.length > 0 && <span className="ml-auto text-xs text-slate-400 flex-shrink-0">{allApts.length} Termin{allApts.length !== 1 ? 'e' : ''}</span>}
                        </div>
                        {allApts.length === 0 ? (
                          <p className="text-xs text-slate-300 px-4 py-1">–</p>
                        ) : (
                          <div className="space-y-0.5 px-2 py-1.5">
                            {allApts.map((apt, aptIdx) => {
                              const p = apt.priority || 5;
                              const border = p >= 8 ? 'border-l-red-500' : p >= 5 ? 'border-l-amber-500' : 'border-l-emerald-500';
                              const isMulti = apt.isMultiDay && apt.endDate;
                              const position = isMulti ? (apt.date === dateStr ? 'start' : apt.endDate === dateStr ? 'end' : 'cont') : null;
                              return (
                                <div key={apt.id || aptIdx} className={`flex items-start justify-between gap-2 px-2 py-1.5 border-l-4 ${border} ${getAptBg(apt.color)} rounded-r`}>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-1.5">
                                      <span className={`text-xs font-medium ${getAptText(apt.color)} truncate`}>{apt.title || apt.text}</span>
                                      {isMulti && (
                                        <span className="text-[10px] bg-blue-100 text-blue-700 px-1 rounded flex-shrink-0">
                                          {position === 'start' ? 'Start' : position === 'end' ? 'Ende' : '→'}
                                        </span>
                                      )}
                                    </div>
                                    {isMulti && (
                                      <p className="text-[10px] text-slate-400 mt-0.5">
                                        {apt.date?.split('-').reverse().slice(0,2).join('.')} – {apt.endDate?.split('-').reverse().slice(0,2).join('.')}
                                      </p>
                                    )}
                                    {apt.contactRef?.name && (
                                      <p className="text-[10px] text-emerald-600 flex items-center gap-0.5 mt-0.5">
                                        <User className="w-2.5 h-2.5" />{apt.contactRef.name}
                                      </p>
                                    )}
                                  </div>
                                  {/* Zeit: feste Breite, rechtsbündig, tabellarische Ziffern */}
                                  <span className="text-xs text-slate-500 whitespace-nowrap flex-shrink-0 text-right min-w-[80px]"
                                    style={{fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum"'}}>
                                    {apt.startTime && apt.endTime ? `${apt.startTime} – ${apt.endTime}` : apt.startTime || ''}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  });
                })()}
              </div>
            )}

            {/* Footer – "Zum Kalender" oder "Zu Aufgaben" */}
            <div className="flex-shrink-0 px-4 pb-2 pt-2 border-t border-slate-100">
              {showTodosPanel ? (
                <button type="button"
                  onClick={() => { setShowWeekModal(false); setShowTodosPanel(false); navigate('/zielplanung', { state: { view: 'todos', todosTab: todosTab } }); }}
                  className="w-full py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-semibold text-sm transition-colors flex items-center justify-center gap-2"
                >
                  <ListTodo className="w-4 h-4" />
                  Zu {todosTab === 'daily' ? 'Heute' : todosTab === 'weekly' ? 'Woche' : 'Monat'}
                </button>
              ) : (
                <button type="button"
                  onClick={() => { setShowWeekModal(false); setShowTodosPanel(false); navigate('/zielplanung', { state: { targetDate: weekModalDate.toISOString(), view: 'week' } }); }}
                  className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold text-sm transition-colors flex items-center justify-center gap-2"
                >
                  <CalendarDays className="w-4 h-4" />
                  Zum Kalender (KW {(() => {
                    const d = new Date(weekModalDate);
                    const jan4 = new Date(d.getFullYear(), 0, 4);
                    const sw = new Date(jan4); sw.setDate(jan4.getDate() - (jan4.getDay() || 7) + 1);
                    return Math.ceil(((d - sw) / 86400000 + 1) / 7);
                  })()})
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ANRUFLISTE / WARTELISTE */}
      {showWarteliste && (
        <Warteliste onClose={() => setShowWarteliste(false)} />
      )}

      {/* Lokale Telefonnummer Modal */}
      {showLocalPhoneModal && (
        <div className="fixed inset-0 bg-black/50 flex items-end z-[500]" onClick={() => setShowLocalPhoneModal(false)}>
          <div className="bg-white w-full rounded-t-2xl px-5 pb-10 pt-5 shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="w-10 h-1 bg-slate-200 rounded-full mx-auto mb-4" />
            <h3 className="text-base font-bold text-slate-800 mb-1">Telefonnummer</h3>
            <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2 mb-4">
              <span className="text-base leading-none flex-shrink-0">📱</span>
              <span className="text-xs text-amber-800">Wird nur auf diesem Gerät gespeichert – nicht in der Cloud.</span>
            </div>
            <div className="flex gap-2 mb-4">
              <input
                autoFocus
                type="tel"
                value={localPhone}
                onChange={e => setLocalPhone(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
                    if (localPhone.trim()) phones[editingId] = localPhone.trim();
                    else delete phones[editingId];
                    userStorage.setItem('burningteam_contact_phones', JSON.stringify(phones));
                    setShowLocalPhoneModal(false);
                  }
                }}
                className="flex-1 border border-slate-200 rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Telefonnummer eingeben..."
                data-testid="edit-local-phone-input"
              />
              <button
                type="button"
                onClick={pickPhoneFromContactBook}
                className="px-3 rounded-2xl bg-blue-50 hover:bg-blue-100 text-blue-700 text-xs font-semibold flex items-center gap-1.5 border border-blue-200 flex-shrink-0"
                data-testid="edit-local-phone-from-book"
                title="Aus Telefonbuch auswählen"
              >
                <Users2 className="w-4 h-4" />
                <span className="hidden sm:inline">Buch</span>
              </button>
            </div>
            <div className="flex gap-2">
              <button type="button" onClick={() => setShowLocalPhoneModal(false)}
                className="flex-1 py-3 rounded-2xl border border-slate-200 text-sm text-slate-600 font-medium">
                Abbrechen
              </button>
              <button type="button" onClick={() => {
                const phones = JSON.parse(userStorage.getItem('burningteam_contact_phones') || '{}');
                if (localPhone.trim()) phones[editingId] = localPhone.trim();
                else delete phones[editingId];
                userStorage.setItem('burningteam_contact_phones', JSON.stringify(phones));
                setShowLocalPhoneModal(false);
              }}
                className="flex-1 py-3 rounded-2xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm transition-colors">
                Speichern
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Posten-Edit Modal: Einzelposten Beschreibung/Produktname ändern */}
      {showPostenEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-slate-800">Posten bearbeiten</h3>
              <button type="button" onClick={() => setShowPostenEditModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="space-y-3">
              <div>
                <Label>Produkt-/Titel</Label>
                <Input value={postenEditData.produkt_name}
                  onChange={(e) => setPostenEditData({...postenEditData, produkt_name: e.target.value})}
                  placeholder="z.B. Royal Focus 500g"
                  data-testid="posten-edit-name-input" />
              </div>
              <div>
                <Label>Beschreibung</Label>
                <Input value={postenEditData.beschreibung}
                  onChange={(e) => setPostenEditData({...postenEditData, beschreibung: e.target.value})}
                  placeholder="zusätzliche Details"
                  data-testid="posten-edit-desc-input" />
              </div>
            </div>
            <div className="flex gap-3 pt-5 border-t border-slate-200 mt-5">
              <Button type="button" variant="outline" onClick={() => setShowPostenEditModal(false)}>
                Abbrechen
              </Button>
              <Button type="button"
                data-testid="posten-edit-save-btn"
                onClick={async () => {
                  try {
                    await axios.put(`${API}/api/schulden/group/update`, {
                      ids: [postenEditData.id],
                      produkt_name: postenEditData.produkt_name,
                      beschreibung: postenEditData.beschreibung,
                    });
                    toast.success("Posten aktualisiert");
                    setShowPostenEditModal(false);
                    loadSchulden();
                  } catch (error) {
                    toast.error("Fehler beim Aktualisieren");
                  }
                }}
                className="flex-1 bg-blue-600 hover:bg-blue-700">
                Speichern
              </Button>
            </div>
          </div>
        </div>
      )}


      {/* Group-Edit Modal: Name + Fälligkeit nachträglich ändern */}
      {showGroupEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-slate-800">Fälligkeit ändern</h3>
              <button type="button" onClick={() => setShowGroupEditModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <p className="text-xs text-slate-500 mb-4">Betrifft {groupEditData.ids.length} Posten</p>

            <div className="space-y-3">
              <div>
                <Label>Fälligkeitsdatum</Label>
                <div className="flex gap-2 flex-wrap mb-2 mt-1">
                  {[7, 14, 30, 60].map(days => (
                    <button key={days} type="button"
                      onClick={() => {
                        const d = new Date();
                        d.setDate(d.getDate() + days);
                        setGroupEditData({...groupEditData, faelligkeitsdatum: d.toISOString().split('T')[0]});
                      }}
                      className="px-3 py-1 text-xs bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-md font-medium">
                      +{days} Tage
                    </button>
                  ))}
                  <button type="button"
                    onClick={() => setGroupEditData({...groupEditData, faelligkeitsdatum: ""})}
                    className="px-3 py-1 text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-md font-medium">
                    Ohne
                  </button>
                </div>
                <Input type="date" value={groupEditData.faelligkeitsdatum}
                  onChange={(e) => setGroupEditData({...groupEditData, faelligkeitsdatum: e.target.value})}
                  data-testid="group-edit-date-input" />
              </div>
            </div>

            <div className="flex gap-3 pt-5 border-t border-slate-200 mt-5">
              <Button type="button" variant="outline" onClick={() => setShowGroupEditModal(false)}>
                Abbrechen
              </Button>
              <Button type="button"
                data-testid="group-edit-save-btn"
                onClick={async () => {
                  try {
                    await axios.put(`${API}/api/schulden/group/update`, {
                      ids: groupEditData.ids,
                      faelligkeitsdatum: groupEditData.faelligkeitsdatum || "",
                    });
                    toast.success("Änderungen gespeichert");
                    setShowGroupEditModal(false);
                    loadSchulden();
                  } catch (error) {
                    toast.error("Fehler beim Aktualisieren");
                  }
                }}
                className="flex-1 bg-blue-600 hover:bg-blue-700">
                Speichern
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Payment-Modal: Komplett bezahlt ODER Teilzahlung mit Verlauf */}
      {showPaymentModal && paymentTarget && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-slate-800">Zahlung erfassen</h3>
              <button type="button" onClick={() => setShowPaymentModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="bg-slate-50 rounded-lg p-3 mb-4">
              <p className="text-sm text-slate-700"><strong>{paymentTarget.name}</strong></p>
              <p className="text-xs text-slate-500 mt-1">
                Gesamt: <strong>{paymentTarget.total.toFixed(2)} €</strong>
                {paymentTarget.bezahlt > 0 && (
                  <> · Bezahlt: <strong>{paymentTarget.bezahlt.toFixed(2)} €</strong> · Offen: <strong>{Math.max(0, paymentTarget.total - paymentTarget.bezahlt).toFixed(2)} €</strong></>
                )}
              </p>
            </div>

            <div className="flex gap-2 mb-4">
              <button type="button"
                onClick={() => setPaymentMode("full")}
                data-testid="payment-mode-full"
                className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors ${paymentMode === "full" ? "bg-green-600 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
                ✓ Komplett bezahlt
              </button>
              <button type="button"
                onClick={() => setPaymentMode("partial")}
                data-testid="payment-mode-partial"
                className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors ${paymentMode === "partial" ? "bg-amber-500 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
                € Teilzahlung
              </button>
            </div>

            {paymentMode === "partial" && (
              <div className="mb-4 space-y-3">
                <div>
                  <Label>Betrag (€)</Label>
                  <Input type="number" min="0.01" step="0.01"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    placeholder={`max. ${Math.max(0, paymentTarget.total - paymentTarget.bezahlt).toFixed(2)} €`}
                    data-testid="payment-amount-input" />
                </div>
                <div>
                  <Label className="flex items-center gap-1">
                    Notiz <span className="text-xs text-slate-400 font-normal">(optional)</span>
                  </Label>
                  <Input type="text"
                    value={paymentNotiz}
                    onChange={(e) => setPaymentNotiz(e.target.value)}
                    placeholder="z.B. 'Bar erhalten', 'Teil der Miete' ..."
                    data-testid="payment-notiz-input" />
                </div>
                {paymentTarget.type === 'person' && (
                  <p className="text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1.5">
                    💡 Verteilung: Die günstigste offene Schuld wird zuerst abgebaut.
                  </p>
                )}
              </div>
            )}

            {/* Verlauf der Teilzahlungen */}
            {(() => {
              const history = [];
              paymentTarget.posten.forEach(p => {
                (p.teilzahlungen || []).forEach(t => {
                  history.push({ ...t, posten_beschreibung: p.produkt_name || p.beschreibung, posten_id: p.id });
                });
              });
              history.sort((a, b) => (b.datum || '').localeCompare(a.datum || ''));
              if (history.length === 0) return null;
              return (
                <div className="mb-4 border-t border-slate-200 pt-3">
                  <p className="text-xs font-semibold text-slate-500 mb-2">Verlauf der Teilzahlungen</p>
                  <div className="space-y-1 max-h-40 overflow-y-auto">
                    {history.map((t, i) => (
                      <div key={i} className="flex flex-col text-xs bg-slate-50 rounded px-2 py-1.5">
                        <div className="flex items-center justify-between">
                          <span className="text-slate-600">{new Date(t.datum).toLocaleDateString('de-DE')}</span>
                          <span className="font-semibold text-emerald-700">+{parseFloat(t.betrag).toFixed(2)} €</span>
                        </div>
                        {t.posten_beschreibung && (
                          <span className="text-slate-500 text-[10px] truncate">auf: {t.posten_beschreibung}</span>
                        )}
                        {t.notiz && (
                          <span className="text-slate-700 italic mt-0.5">„{t.notiz}"</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })()}

            <div className="flex gap-3 pt-4 border-t border-slate-200">
              <Button type="button" variant="outline" onClick={() => setShowPaymentModal(false)}>
                Abbrechen
              </Button>
              <Button type="button"
                data-testid="payment-confirm-btn"
                onClick={async () => {
                  try {
                    if (paymentMode === "full") {
                      // Alle offenen Posten als bezahlt markieren
                      const offenePosten = paymentTarget.posten.filter(p => p.status !== "bezahlt");
                      await Promise.all(offenePosten.map(p => axios.put(`${API}/api/schulden/${p.id}/bezahlt`)));
                      toast.success(`${offenePosten.length} Posten komplett bezahlt`);
                    } else {
                      const amount = parseFloat(paymentAmount);
                      if (!amount || amount <= 0) {
                        toast.error("Bitte gültigen Betrag eingeben");
                        return;
                      }
                      // Verteile Betrag auf offene Posten:
                      //  - Person-Level: günstigste offene Schuld zuerst (smart)
                      //  - Group-Level: nach Fälligkeit (FIFO)
                      let remaining = amount;
                      const offenePostenList = paymentTarget.posten
                        .filter(p => p.status !== "bezahlt")
                        .map(p => {
                          const tz = (p.teilzahlungen || []).reduce((s, t) => s + (parseFloat(t.betrag) || 0), 0);
                          return { p, posten_offen: p.betrag - tz };
                        })
                        .filter(x => x.posten_offen > 0);

                      if (paymentTarget.type === 'person') {
                        offenePostenList.sort((a, b) => a.posten_offen - b.posten_offen);
                      } else {
                        offenePostenList.sort((a, b) =>
                          (a.p.faelligkeitsdatum || '9999').localeCompare(b.p.faelligkeitsdatum || '9999')
                        );
                      }

                      const heute = new Date().toISOString().split('T')[0];
                      for (const { p, posten_offen } of offenePostenList) {
                        if (remaining <= 0) break;
                        const teilBetrag = Math.min(remaining, posten_offen);
                        const body = { betrag: teilBetrag, datum: heute };
                        if (paymentNotiz.trim()) body.notiz = paymentNotiz.trim();
                        await axios.put(`${API}/api/schulden/${p.id}/teilzahlung`, body);
                        remaining -= teilBetrag;
                      }
                      toast.success(`Teilzahlung von ${amount.toFixed(2)} € erfasst`);
                    }
                    setShowPaymentModal(false);
                    setPaymentAmount("");
                    setPaymentNotiz("");
                    loadSchulden();
                  } catch (error) {
                    toast.error("Fehler beim Speichern");
                  }
                }}
                className={`flex-1 ${paymentMode === "full" ? "bg-green-600 hover:bg-green-700" : "bg-amber-500 hover:bg-amber-600"}`}>
                {paymentMode === "full" ? "Komplett bezahlt" : "Teilzahlung buchen"}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Teilzahlungs-Historie Modal */}
      {showTeilzahlungHistorie && teilzahlungHistorieTarget && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                <History className="w-5 h-5 text-amber-600" />
                Teilzahlungs-Historie
              </h3>
              <button type="button" onClick={() => setShowTeilzahlungHistorie(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="bg-slate-50 rounded-lg p-3 mb-4">
              <p className="text-sm text-slate-700"><strong>{teilzahlungHistorieTarget.name}</strong></p>
            </div>

            {(() => {
              const history = [];
              teilzahlungHistorieTarget.posten.forEach(p => {
                (p.teilzahlungen || []).forEach((t, tIdx) => {
                  history.push({
                    ...t,
                    posten_id: p.id,
                    posten_label: p.produkt_name || p.beschreibung || 'Posten',
                    posten_betrag: p.betrag,
                    tIdx,
                  });
                });
              });
              history.sort((a, b) => (b.datum || '').localeCompare(a.datum || ''));

              const summe = history.reduce((s, t) => s + (parseFloat(t.betrag) || 0), 0);

              if (history.length === 0) {
                return <p className="text-sm text-slate-500 italic">Noch keine Teilzahlungen erfasst.</p>;
              }

              return (
                <>
                  <div className="mb-3 flex items-center justify-between px-1 text-xs">
                    <span className="text-slate-500">{history.length} Eintrag{history.length !== 1 ? 'e' : ''}</span>
                    <span className="text-slate-700">Summe bezahlt: <strong className="text-emerald-700">{summe.toFixed(2)} €</strong></span>
                  </div>
                  <div className="space-y-2 max-h-[50vh] overflow-y-auto">
                    {history.map((t, i) => (
                      <div key={i} className="border border-slate-200 rounded-lg p-3 bg-white hover:bg-slate-50 transition-colors">
                        <div className="flex items-start justify-between gap-2 mb-1">
                          <div className="flex-1 min-w-0">
                            <p className="text-xs text-slate-500">{new Date(t.datum).toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
                            <p className="text-sm font-medium text-slate-700 truncate mt-0.5">auf: {t.posten_label}</p>
                          </div>
                          <span className="text-base font-bold text-emerald-700 whitespace-nowrap">+{parseFloat(t.betrag).toFixed(2)} €</span>
                        </div>
                        {t.notiz && (
                          <p className="text-xs text-slate-600 italic bg-amber-50 border-l-2 border-amber-300 pl-2 py-1 mt-1">
                            „{t.notiz}"
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              );
            })()}

            <div className="flex gap-3 pt-4 border-t border-slate-200 mt-4">
              <Button type="button" onClick={() => setShowTeilzahlungHistorie(false)} className="flex-1 bg-slate-600 hover:bg-slate-700">
                Schließen
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* PDF-Success-Modal nach Schulden-Speicherung (mit Ersparnis) */}
      {showPdfSuccessModal && pdfSuccessData && (() => {
        const doc = generateErspanisPdf({
          kundenName: pdfSuccessData.kundenName,
          posten: pdfSuccessData.posten,
          datum: pdfSuccessData.posten[0]?.schulden_datum || new Date().toISOString(),
          firmenName: userCompanyName,
        });
        if (!doc) return null;
        const filtered = pdfSuccessData.posten.filter(p => p.price_category && p.price_category !== "kunde" && typeof p.kunde_preis === "number" && p.kunde_preis > 0);
        const sumKunde = filtered.reduce((s, p) => s + (p.kunde_preis || 0) * (parseInt(p.menge) || 1), 0);
        const sumGewaehlt = filtered.reduce((s, p) => s + (parseFloat(p.betrag) || 0), 0);
        const ersparnisAbs = sumKunde - sumGewaehlt;
        const ersparnisProz = sumKunde > 0 ? (ersparnisAbs / sumKunde) * 100 : 0;
        return (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[210] p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" data-testid="pdf-success-modal">
              {/* Header in Emerald */}
              <div className="bg-gradient-to-br from-emerald-500 to-teal-600 px-6 py-5 text-white">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                    <FileText className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-emerald-50 text-xs font-medium uppercase tracking-wider">Schulden gespeichert</p>
                    <h3 className="text-white text-xl font-bold">Ersparnis-PDF bereit</h3>
                  </div>
                </div>
              </div>

              {/* Body */}
              <div className="p-6 space-y-4">
                <p className="text-slate-700 text-sm">
                  Für <strong>{pdfSuccessData.kundenName}</strong> wurde ein PDF mit der Ersparnis-Übersicht erstellt. Gib es deinem Kunden – so sieht er auf einen Blick, wie viel er spart.
                </p>

                {/* Ersparnis-Highlight */}
                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-300 rounded-xl p-4">
                  <p className="text-xs text-emerald-700 font-semibold uppercase tracking-wide mb-1">Ersparnis für Kunde</p>
                  <div className="flex items-baseline gap-3">
                    <span className="text-3xl font-black text-emerald-700">{ersparnisAbs.toFixed(2)} €</span>
                    <span className="text-lg font-bold text-amber-600">-{ersparnisProz.toFixed(1)}%</span>
                  </div>
                  <p className="text-xs text-slate-500 mt-2">
                    Kundenpreis: <span className="line-through">{sumKunde.toFixed(2)} €</span> · Angebotspreis: <strong className="text-emerald-700">{sumGewaehlt.toFixed(2)} €</strong>
                  </p>
                </div>

                <div className="flex gap-3 pt-2">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => { setShowPdfSuccessModal(false); setPdfSuccessData(null); }}
                    data-testid="pdf-success-skip-btn"
                  >
                    Später
                  </Button>
                  <Button
                    type="button"
                    data-testid="pdf-success-download-btn"
                    onClick={() => {
                      downloadErspanisPdf({
                        kundenName: pdfSuccessData.kundenName,
                        posten: pdfSuccessData.posten,
                        datum: pdfSuccessData.posten[0]?.schulden_datum || new Date().toISOString(),
                        firmenName: userCompanyName,
                      });
                      setShowPdfSuccessModal(false);
                      setPdfSuccessData(null);
                    }}
                    className="flex-1 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-semibold"
                  >
                    <FileText className="w-4 h-4 mr-2" /> PDF herunterladen
                  </Button>
                </div>
                <p className="text-[11px] text-center text-slate-400">
                  Du kannst das PDF jederzeit später über den 📄-Button an der Schuld erneut herunterladen.
                </p>
              </div>
            </div>
          </div>
        );
      })()}




    </div>
  );
}

